webpackJsonp(
  [0],
  [
    ,
    function (t, e, n) {
      var i, r, a;
      theOptions = [];
      (a = window),
        (i = [n(20)]),
        void 0 ===
          (r = function (t) {
            return (function (u, a) {
              "use strict";
              var c = {
                  extend: function (t, e) {
                    for (var n in e) t[n] = e[n];
                    return t;
                  },
                  modulo: function (t, e) {
                    return ((t % e) + e) % e;
                  },
                },
                e = Array.prototype.slice;
              (c.makeArray = function (t) {
                return Array.isArray(t)
                  ? t
                  : null == t
                  ? []
                  : "object" == typeof t && "number" == typeof t.length
                  ? e.call(t)
                  : [t];
              }),
                (c.removeFrom = function (t, e) {
                  var n = t.indexOf(e);
                  -1 != n && t.splice(n, 1);
                }),
                (c.getParent = function (t, e) {
                  for (; t.parentNode && t != document.body; )
                    if (((t = t.parentNode), a(t, e))) return t;
                }),
                (c.getQueryElement = function (t) {
                  return "string" == typeof t ? document.querySelector(t) : t;
                }),
                (c.handleEvent = function (t) {
                  var e = "on" + t.type;
                  this[e] && this[e](t);
                }),
                (c.filterFindElements = function (t, i) {
                  var r = [];
                  return (
                    (t = c.makeArray(t)).forEach(function (t) {
                      if (t instanceof HTMLElement)
                        if (i) {
                          a(t, i) && r.push(t);
                          for (
                            var e = t.querySelectorAll(i), n = 0;
                            n < e.length;
                            n++
                          )
                            r.push(e[n]);
                        } else r.push(t);
                    }),
                    r
                  );
                }),
                (c.debounceMethod = function (t, e, i) {
                  i = i || 100;
                  var r = t.prototype[e],
                    a = e + "Timeout";
                  t.prototype[e] = function () {
                    var t = this[a];
                    clearTimeout(t);
                    var e = arguments,
                      n = this;
                    this[a] = setTimeout(function () {
                      r.apply(n, e), delete n[a];
                    }, i);
                  };
                }),
                (c.docReady = function (t) {
                  var e = document.readyState;
                  "complete" == e || "interactive" == e
                    ? setTimeout(t)
                    : document.addEventListener("DOMContentLoaded", t);
                }),
                (c.toDashed = function (t) {
                  return t
                    .replace(/(.)([A-Z])/g, function (t, e, n) {
                      return e + "-" + n;
                    })
                    .toLowerCase();
                });
              var h = u.console;
              return (
                (c.htmlInit = function (s, l) {
                  c.docReady(function () {
                    var t = c.toDashed(l),
                      r = "data-" + t,
                      e = document.querySelectorAll("[" + r + "]"),
                      n = document.querySelectorAll(".js-" + t),
                      i = c.makeArray(e).concat(c.makeArray(n)),
                      a = r + "-options",
                      o = u.jQuery;
                    i.forEach(function (e) {
                      var t,
                        n = e.getAttribute(r) || e.getAttribute(a);
                      try {
                        t = n && JSON.parse(n);
                      } catch (t) {
                        return void (
                          h &&
                          h.error(
                            "Error parsing " +
                              r +
                              " on " +
                              e.className +
                              ": " +
                              t
                          )
                        );
                      }
                      var i = new s(e, t);
                      o && o.data(e, l, i);
                    });
                  });
                }),
                c
              );
            })(a, t);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i;
      (i = function () {
        return (function (n) {
          var i = {};

          function r(t) {
            if (i[t]) return i[t].exports;
            var e = (i[t] = {
              exports: {},
              id: t,
              loaded: !1,
            });
            return (
              n[t].call(e.exports, e, e.exports, r), (e.loaded = !0), e.exports
            );
          }
          return (r.m = n), (r.c = i), (r.p = ""), r(0);
        })([
          function (t, e, n) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
              value: !0,
            }),
              (e.formatToHTML = e.format = e.formatSimple = void 0);
            var i,
              r =
                (i = n(1)) && i.__esModule
                  ? i
                  : {
                      default: i,
                    },
              l = n(2),
              u = function (t) {
                return r.default[t.toUpperCase()];
              },
              c = (e.formatSimple = function (t, e, n) {
                return (0, l.formatDigits)(e, n) + " " + t;
              }),
              h = function (t, e) {
                return "string" == typeof t && (0, l.isNumeric)(e);
              },
              o = (e.format = function (t, e, n, i) {
                if (!h(t, e)) return "";
                var r = u(t);
                if (!r) return c(t, e, n);
                var a = r.symbol || r.uniqSymbol;
                if (i || !a) return c(t.toUpperCase(), e, n);
                var o = void 0 === n ? r.fractionSize : n,
                  s = (0, l.formatDigits)(Math.abs(e), o);
                return (
                  (e < 0 ? "−" : "") +
                  a.template.replace("1", s).replace("$", a.grapheme)
                );
              }),
              s = function (t) {
                var e = t.formattedCurrency;
                return (
                  '<span dir="' +
                  (t.isRTL ? "rtl" : "ltr") +
                  '">' +
                  e +
                  "</span>"
                );
              },
              a = (e.formatToHTML = function () {
                for (var t = arguments.length, e = Array(t), n = 0; n < t; n++)
                  e[n] = arguments[n];
                var i = e[0],
                  r = e[1];
                if (h(i, r)) {
                  var a = o.apply(void 0, e);
                  return s({
                    formattedCurrency: a,
                    isRTL: (function (t) {
                      var e = u(i);
                      if (e) {
                        var n = e.symbol || e.uniqSymbol;
                        return !!n && n.rtl;
                      }
                      return !1;
                    })(),
                  });
                }
                return s({
                  formattedCurrency: "",
                  isRTL: !1,
                });
              });
            e.default = {
              format: o,
              formatSimple: c,
              formatToHTML: a,
            };
          },
          function (t, e) {
            t.exports = {
              AED: {
                name: "UAE Dirham",
                fractionSize: 2,
                symbol: {
                  grapheme: ".د.إ",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: null,
              },
              AFN: {
                name: "Afghani",
                fractionSize: 2,
                symbol: {
                  grapheme: "؋",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: "؋",
                  template: "1 $",
                  rtl: !0,
                },
              },
              ALL: {
                name: "Lek",
                fractionSize: 2,
                symbol: {
                  grapheme: "L",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Lek",
                  template: "$1",
                  rtl: !1,
                },
              },
              AMD: {
                name: "Armenian Dram",
                fractionSize: 2,
                symbol: {
                  grapheme: "դր.",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "դր.",
                  template: "1 $",
                  rtl: !1,
                },
              },
              ANG: {
                name: "Netherlands Antillean Guilder",
                fractionSize: 2,
                symbol: {
                  grapheme: "ƒ",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "NAƒ",
                  template: "$1",
                  rtl: !1,
                },
              },
              AOA: {
                name: "Kwanza",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              ARS: {
                name: "Argentine Peso",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              AUD: {
                name: "Australian Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "A$",
                  template: "$1",
                  rtl: !1,
                },
              },
              AWG: {
                name: "Aruban Florin",
                fractionSize: 2,
                symbol: {
                  grapheme: "ƒ",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Afl",
                  template: "$1",
                  rtl: !1,
                },
              },
              AZN: {
                name: "Azerbaijanian Manat",
                fractionSize: 2,
                symbol: {
                  grapheme: "₼",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₼",
                  template: "$1",
                  rtl: !1,
                },
              },
              BAM: {
                name: "Convertible Mark",
                fractionSize: 2,
                symbol: {
                  grapheme: "KM",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "KM",
                  template: "$1",
                  rtl: !1,
                },
              },
              BBD: {
                name: "Barbados Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              BDT: {
                name: "Taka",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              BGN: {
                name: "Bulgarian Lev",
                fractionSize: 2,
                symbol: {
                  grapheme: "лв",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "лв",
                  template: "$1",
                  rtl: !1,
                },
              },
              BHD: {
                name: "Bahraini Dinar",
                fractionSize: 3,
                symbol: {
                  grapheme: ".د.ب",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".د.ب",
                  template: "1 $",
                  rtl: !0,
                },
              },
              BIF: {
                name: "Burundi Franc",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              BMD: {
                name: "Bermudian Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "BD$",
                  template: "$1",
                  rtl: !1,
                },
              },
              BND: {
                name: "Brunei Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              BOB: {
                name: "Boliviano",
                fractionSize: 2,
                symbol: {
                  grapheme: "Bs.",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Bs.",
                  template: "$1",
                  rtl: !1,
                },
              },
              BOV: {
                name: "Mvdol",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              BRL: {
                name: "Brazilian Real",
                fractionSize: 2,
                symbol: {
                  grapheme: "R$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "R$",
                  template: "$1",
                  rtl: !1,
                },
              },
              BSD: {
                name: "Bahamian Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              BTN: {
                name: "Ngultrum",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              BWP: {
                name: "Pula",
                fractionSize: 2,
                symbol: {
                  grapheme: "P",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "P",
                  template: "$1",
                  rtl: !1,
                },
              },
              BYN: {
                name: "Belarussian Ruble",
                fractionSize: 0,
                symbol: {
                  grapheme: "p.",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "р.",
                  template: "1 $",
                  rtl: !1,
                },
              },
              BYR: {
                name: "Belarussian Ruble",
                fractionSize: 0,
                symbol: {
                  grapheme: "p.",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "р.",
                  template: "1 $",
                  rtl: !1,
                },
              },
              BZD: {
                name: "Belize Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "BZ$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "BZ$",
                  template: "$1",
                  rtl: !1,
                },
              },
              CAD: {
                name: "Canadian Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "CA$",
                  template: "$1",
                  rtl: !1,
                },
              },
              CDF: {
                name: "Congolese Franc",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              CHE: {
                name: "WIR Euro",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              CHF: {
                name: "Swiss Franc",
                fractionSize: 2,
                symbol: {
                  grapheme: "CHF",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "CHF",
                  template: "$1",
                  rtl: !1,
                },
              },
              CHW: {
                name: "WIR Franc",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              CLF: {
                name: "Unidad de Fomento",
                fractionSize: 4,
                symbol: null,
                uniqSymbol: null,
              },
              CLP: {
                name: "Chilean Peso",
                fractionSize: 0,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              CNY: {
                name: "Yuan Renminbi",
                fractionSize: 2,
                symbol: {
                  grapheme: "元",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "元",
                  template: "1 $",
                  rtl: !1,
                },
              },
              COP: {
                name: "Colombian Peso",
                fractionSize: 0,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              COU: {
                name: "Unidad de Valor Real",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              CRC: {
                name: "Cost Rican Colon",
                fractionSize: 2,
                symbol: {
                  grapheme: "₡",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₡",
                  template: "$1",
                  rtl: !1,
                },
              },
              CUC: {
                name: "Peso Convertible",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              CUP: {
                name: "Cuban Peso",
                fractionSize: 2,
                symbol: {
                  grapheme: "$MN",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "$MN",
                  template: "$1",
                  rtl: !1,
                },
              },
              CVE: {
                name: "Cabo Verde Escudo",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              CZK: {
                name: "Czech Koruna",
                fractionSize: 2,
                symbol: {
                  grapheme: "Kč",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Kč",
                  template: "1 $",
                  rtl: !1,
                },
              },
              DJF: {
                name: "Djibouti Franc",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              DKK: {
                name: "Danish Krone",
                fractionSize: 2,
                symbol: {
                  grapheme: "kr",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              DOP: {
                name: "Dominican Peso",
                fractionSize: 2,
                symbol: {
                  grapheme: "RD$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "RD$",
                  template: "$1",
                  rtl: !1,
                },
              },
              DZD: {
                name: "Algerian Dinar",
                fractionSize: 2,
                symbol: {
                  grapheme: ".د.ج",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".د.ج",
                  template: "1 $",
                  rtl: !0,
                },
              },
              EEK: {
                name: "Estonian Kroon",
                fractionSize: 2,
                symbol: {
                  grapheme: "kr",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              EGP: {
                name: "Egyptian Pound",
                fractionSize: 2,
                symbol: {
                  grapheme: "£",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: ".ج.م",
                  template: "1 $",
                  rtl: !0,
                },
              },
              ERN: {
                name: "Nakfa",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              ETB: {
                name: "Ethiopian Birr",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              EUR: {
                name: "Euro",
                fractionSize: 2,
                symbol: {
                  grapheme: "€",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "€",
                  template: "$1",
                  rtl: !1,
                },
              },
              FJD: {
                name: "Fiji Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "FJ$",
                  template: "$1",
                  rtl: !1,
                },
              },
              FKP: {
                name: "Falkland Islands Pound",
                fractionSize: 2,
                symbol: {
                  grapheme: "£",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              GBP: {
                name: "Pound Sterling",
                fractionSize: 2,
                symbol: {
                  grapheme: "£",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "£",
                  template: "$1",
                  rtl: !1,
                },
              },
              GEL: {
                name: "Lari",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              GGP: {
                name: "Guernsey Pound",
                fractionSize: 2,
                symbol: {
                  grapheme: "£",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              GHC: {
                name: "Ghanaian Cedi",
                fractionSize: 2,
                symbol: {
                  grapheme: "¢",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "¢",
                  template: "$1",
                  rtl: !1,
                },
              },
              GHS: {
                name: "Ghan Cedi",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              GIP: {
                name: "Gibraltar Pound",
                fractionSize: 2,
                symbol: {
                  grapheme: "£",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              GMD: {
                name: "Dalasi",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              GNF: {
                name: "Guine Franc",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              GTQ: {
                name: "Quetzal",
                fractionSize: 2,
                symbol: {
                  grapheme: "Q",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Q",
                  template: "$1",
                  rtl: !1,
                },
              },
              GYD: {
                name: "Guyan Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "GY$",
                  template: "$1",
                  rtl: !1,
                },
              },
              HKD: {
                name: "Hong Kong Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "HK$",
                  template: "$1",
                  rtl: !1,
                },
              },
              HNL: {
                name: "Lempira",
                fractionSize: 2,
                symbol: {
                  grapheme: "L",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "L",
                  template: "$1",
                  rtl: !1,
                },
              },
              HRK: {
                name: "Croatian Kuna",
                fractionSize: 2,
                symbol: {
                  grapheme: "kn",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "kn",
                  template: "$1",
                  rtl: !1,
                },
              },
              HTG: {
                name: "Gourde",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              HUF: {
                name: "Forint",
                fractionSize: 0,
                symbol: {
                  grapheme: "Ft",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Ft",
                  template: "$1",
                  rtl: !1,
                },
              },
              IDR: {
                name: "Rupiah",
                fractionSize: 3,
                symbol: {
                  grapheme: "Rp",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Rp",
                  template: "$1",
                  rtl: !1,
                },
              },
              ILS: {
                name: "New Israeli Sheqel",
                fractionSize: 2,
                symbol: {
                  grapheme: "₪",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₪",
                  template: "$1",
                  rtl: !1,
                },
              },
              IMP: {
                name: "Manx Pound",
                fractionSize: 2,
                symbol: {
                  grapheme: "£",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              INR: {
                name: "Indian Rupee",
                fractionSize: 2,
                symbol: {
                  grapheme: "Rs. ",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Rs. ",
                  template: "$1",
                  rtl: !1,
                },
              },
              IQD: {
                name: "Iraqi Dinar",
                fractionSize: 3,
                symbol: {
                  grapheme: ".د.ع",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".د.ع",
                  template: "1 $",
                  rtl: !0,
                },
              },
              IRR: {
                name: "Iranian Rial",
                fractionSize: 2,
                symbol: {
                  grapheme: "﷼",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".ر.ا",
                  template: "1 $",
                  rtl: !0,
                },
              },
              ISK: {
                name: "Iceland Krona",
                fractionSize: 2,
                symbol: {
                  grapheme: "kr",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              JEP: {
                name: "Jersey Pound",
                fractionSize: 2,
                symbol: {
                  grapheme: "£",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              JMD: {
                name: "Jamaican Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "J$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "J$",
                  template: "$1",
                  rtl: !1,
                },
              },
              JOD: {
                name: "Jordanian Dinar",
                fractionSize: 3,
                symbol: {
                  grapheme: ".د.إ",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: null,
              },
              JPY: {
                name: "Yen",
                fractionSize: 0,
                symbol: {
                  grapheme: "¥",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "¥",
                  template: "$1",
                  rtl: !1,
                },
              },
              KES: {
                name: "Kenyan Shilling",
                fractionSize: 2,
                symbol: {
                  grapheme: "KSh",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "KSh",
                  template: "$1",
                  rtl: !1,
                },
              },
              KGS: {
                name: "Som",
                fractionSize: 2,
                symbol: {
                  grapheme: "сом",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "сом",
                  template: "$1",
                  rtl: !1,
                },
              },
              KHR: {
                name: "Riel",
                fractionSize: 2,
                symbol: {
                  grapheme: "៛",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "៛",
                  template: "$1",
                  rtl: !1,
                },
              },
              KMF: {
                name: "Comoro Franc",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              KPW: {
                name: "North Korean Won",
                fractionSize: 0,
                symbol: {
                  grapheme: "₩",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              KRW: {
                name: "Won",
                fractionSize: 0,
                symbol: {
                  grapheme: "₩",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₩",
                  template: "$1",
                  rtl: !1,
                },
              },
              KWD: {
                name: "Kuwaiti Dinar",
                fractionSize: 3,
                symbol: {
                  grapheme: ".د.ك",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".د.ك",
                  template: "1 $",
                  rtl: !0,
                },
              },
              KYD: {
                name: "Cayman Islands Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "CI$",
                  template: "$1",
                  rtl: !1,
                },
              },
              KZT: {
                name: "Tenge",
                fractionSize: 2,
                symbol: {
                  grapheme: "₸",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₸",
                  template: "$1",
                  rtl: !1,
                },
              },
              LAK: {
                name: "Kip",
                fractionSize: 2,
                symbol: {
                  grapheme: "₭",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₭",
                  template: "$1",
                  rtl: !1,
                },
              },
              LBP: {
                name: "Lebanese Pound",
                fractionSize: 2,
                symbol: {
                  grapheme: "£",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: ".ل.ل",
                  template: "1 $",
                  rtl: !0,
                },
              },
              LKR: {
                name: "Sri Lank Rupee",
                fractionSize: 2,
                symbol: {
                  grapheme: "₨",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              LRD: {
                name: "Liberian Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "L$",
                  template: "$1",
                  rtl: !1,
                },
              },
              LSL: {
                name: "Loti",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              LTL: {
                name: "Lithuanian Litas",
                fractionSize: 2,
                symbol: {
                  grapheme: "Lt",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Lt",
                  template: "$1",
                  rtl: !1,
                },
              },
              LVL: {
                name: "Latvian Lats",
                fractionSize: 2,
                symbol: {
                  grapheme: "Ls",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Ls",
                  template: "1 $",
                  rtl: !1,
                },
              },
              LYD: {
                name: "Libyan Dinar",
                fractionSize: 3,
                symbol: {
                  grapheme: ".د.ل",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".د.ل",
                  template: "1 $",
                  rtl: !0,
                },
              },
              MAD: {
                name: "Moroccan Dirham",
                fractionSize: 2,
                symbol: {
                  grapheme: ".د.م",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".د.م",
                  template: "1 $",
                  rtl: !0,
                },
              },
              MDL: {
                name: "Moldovan Leu",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              MGA: {
                name: "Malagasy riary",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              MKD: {
                name: "Denar",
                fractionSize: 2,
                symbol: {
                  grapheme: "ден",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "ден",
                  template: "$1",
                  rtl: !1,
                },
              },
              MMK: {
                name: "Kyat",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              MNT: {
                name: "Tugrik",
                fractionSize: 2,
                symbol: {
                  grapheme: "₮",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₮",
                  template: "$1",
                  rtl: !1,
                },
              },
              MOP: {
                name: "Pataca",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              MRO: {
                name: "Ouguiya",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              MUR: {
                name: "Mauritius Rupee",
                fractionSize: 2,
                symbol: {
                  grapheme: "₨",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              MVR: {
                name: "Rufiyaa",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              MWK: {
                name: "Kwacha",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              MXN: {
                name: "Mexican Peso",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              MXV: {
                name: "Mexican Unidad de Inversion (UDI)",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              MYR: {
                name: "Malaysian Ringgit",
                fractionSize: 2,
                symbol: {
                  grapheme: "RM",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "RM",
                  template: "$1",
                  rtl: !1,
                },
              },
              MZN: {
                name: "Mozambique Metical",
                fractionSize: 2,
                symbol: {
                  grapheme: "MT",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "MT",
                  template: "$1",
                  rtl: !1,
                },
              },
              NAD: {
                name: "Namibi Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "N$",
                  template: "$1",
                  rtl: !1,
                },
              },
              NGN: {
                name: "Naira",
                fractionSize: 2,
                symbol: {
                  grapheme: "₦",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₦",
                  template: "$1",
                  rtl: !1,
                },
              },
              NIO: {
                name: "Cordob Oro",
                fractionSize: 2,
                symbol: {
                  grapheme: "C$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "C$",
                  template: "$1",
                  rtl: !1,
                },
              },
              NOK: {
                name: "Norwegian Krone",
                fractionSize: 2,
                symbol: {
                  grapheme: "kr",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              NPR: {
                name: "Nepalese Rupee",
                fractionSize: 2,
                symbol: {
                  grapheme: "₨",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              NZD: {
                name: "New Zealand Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "NZ$",
                  template: "$1",
                  rtl: !1,
                },
              },
              OMR: {
                name: "Rial Omani",
                fractionSize: 3,
                symbol: {
                  grapheme: "﷼",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".ر.ع",
                  template: "1 $",
                  rtl: !0,
                },
              },
              PAB: {
                name: "Balboa",
                fractionSize: 2,
                symbol: {
                  grapheme: "B/.",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "B/.",
                  template: "$1",
                  rtl: !1,
                },
              },
              PEN: {
                name: "Nuevo Sol",
                fractionSize: 2,
                symbol: {
                  grapheme: "S/.",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "S/.",
                  template: "$1",
                  rtl: !1,
                },
              },
              PGK: {
                name: "Kina",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              PHP: {
                name: "Philippine Peso",
                fractionSize: 2,
                symbol: {
                  grapheme: "₱",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₱",
                  template: "$1",
                  rtl: !1,
                },
              },
              PKR: {
                name: "Pakistan Rupee",
                fractionSize: 2,
                symbol: {
                  grapheme: "₨",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              PLN: {
                name: "Zloty",
                fractionSize: 2,
                symbol: {
                  grapheme: "zł",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "zł",
                  template: "1 $",
                  rtl: !1,
                },
              },
              PYG: {
                name: "Guarani",
                fractionSize: 0,
                symbol: {
                  grapheme: "Gs",
                  template: "1$",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Gs",
                  template: "1$",
                  rtl: !1,
                },
              },
              QAR: {
                name: "Qatari Rial",
                fractionSize: 2,
                symbol: {
                  grapheme: "﷼",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".ر.ق",
                  template: "1 $",
                  rtl: !0,
                },
              },
              RON: {
                name: "New Romanian Leu",
                fractionSize: 2,
                symbol: {
                  grapheme: "lei",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "lei",
                  template: "$1",
                  rtl: !1,
                },
              },
              RSD: {
                name: "Serbian Dinar",
                fractionSize: 2,
                symbol: {
                  grapheme: "Дин.",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Дин.",
                  template: "$1",
                  rtl: !1,
                },
              },
              RUB: {
                name: "Russian Ruble",
                fractionSize: 2,
                symbol: {
                  grapheme: "₽",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₽",
                  template: "1 $",
                  rtl: !1,
                },
              },
              RUR: {
                name: "Russian Ruble",
                fractionSize: 2,
                symbol: {
                  grapheme: "₽",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₽",
                  template: "1 $",
                  rtl: !1,
                },
              },
              RWF: {
                name: "Rwand Franc",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              SAR: {
                name: "Saudi Riyal",
                fractionSize: 2,
                symbol: {
                  grapheme: "﷼",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".ر.س",
                  template: "1 $",
                  rtl: !0,
                },
              },
              SBD: {
                name: "Solomon Islands Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "SI$",
                  template: "$1",
                  rtl: !1,
                },
              },
              SCR: {
                name: "Seychelles Rupee",
                fractionSize: 2,
                symbol: {
                  grapheme: "₨",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              SDG: {
                name: "Sudanese Pound",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              SEK: {
                name: "Swedish Krona",
                fractionSize: 2,
                symbol: {
                  grapheme: "kr",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              SGD: {
                name: "Singapore Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "S$",
                  template: "$1",
                  rtl: !1,
                },
              },
              SHP: {
                name: "Saint Helen Pound",
                fractionSize: 2,
                symbol: {
                  grapheme: "£",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              SLL: {
                name: "Leone",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              SOS: {
                name: "Somali Shilling",
                fractionSize: 2,
                symbol: {
                  grapheme: "S",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "S",
                  template: "$1",
                  rtl: !1,
                },
              },
              SRD: {
                name: "Surinam Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              SSP: {
                name: "South Sudanese Pound",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              STD: {
                name: "Dobra",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              SVC: {
                name: "El Salvador Colon",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "C",
                  template: "$1",
                  rtl: !1,
                },
              },
              SYP: {
                name: "Syrian Pound",
                fractionSize: 2,
                symbol: {
                  grapheme: "£",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: ".ل.س",
                  template: "1 $",
                  rtl: !0,
                },
              },
              SZL: {
                name: "Lilangeni",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              THB: {
                name: "Baht",
                fractionSize: 2,
                symbol: {
                  grapheme: "฿",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "฿",
                  template: "$1",
                  rtl: !1,
                },
              },
              TJS: {
                name: "Somoni",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              TMT: {
                name: "Turkmenistan New Manat",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              TND: {
                name: "Tunisian Dinar",
                fractionSize: 3,
                symbol: {
                  grapheme: ".د.ت",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".د.ت",
                  template: "1 $",
                  rtl: !0,
                },
              },
              TOP: {
                name: "Pa’anga",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              TRL: {
                name: "Turkish Lira",
                fractionSize: 2,
                symbol: {
                  grapheme: "₤",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: null,
              },
              TRY: {
                name: "Turkish Lira",
                fractionSize: 2,
                symbol: {
                  grapheme: "₺",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₺",
                  template: "$1",
                  rtl: !1,
                },
              },
              TTD: {
                name: "Trinidad and Tobago Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "TT$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "TT$",
                  template: "$1",
                  rtl: !1,
                },
              },
              TWD: {
                name: "New Taiwan Dollar",
                fractionSize: 0,
                symbol: {
                  grapheme: "NT$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "NT$",
                  template: "$1",
                  rtl: !1,
                },
              },
              TZS: {
                name: "Tanzanian Shilling",
                fractionSize: 0,
                symbol: {
                  grapheme: "TSh",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "TSh",
                  template: "$1",
                  rtl: !1,
                },
              },
              UAH: {
                name: "Hryvnia",
                fractionSize: 2,
                symbol: {
                  grapheme: "₴",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₴",
                  template: "$1",
                  rtl: !1,
                },
              },
              UGX: {
                name: "Ugand Shilling",
                fractionSize: 0,
                symbol: {
                  grapheme: "USh",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "USh",
                  template: "$1",
                  rtl: !1,
                },
              },
              USD: {
                name: "US Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
              },
              USN: {
                name: "US Dollar (Next day)",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              UYI: {
                name: "Uruguay Peso en Unidades Indexadas (URUIURUI)",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              UYU: {
                name: "Peso Uruguayo",
                fractionSize: 0,
                symbol: {
                  grapheme: "$U",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "$U",
                  template: "$1",
                  rtl: !1,
                },
              },
              UZS: {
                name: "Uzbekistan Sum",
                fractionSize: 2,
                symbol: {
                  grapheme: "so’m",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "so’m",
                  template: "$1",
                  rtl: !1,
                },
              },
              VEF: {
                name: "Bolivar",
                fractionSize: 2,
                symbol: {
                  grapheme: "Bs",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Bs",
                  template: "$1",
                  rtl: !1,
                },
              },
              VND: {
                name: "Dong",
                fractionSize: 0,
                symbol: {
                  grapheme: "₫",
                  template: "1 $",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "₫",
                  template: "1 $",
                  rtl: !1,
                },
              },
              VUV: {
                name: "Vatu",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              WST: {
                name: "Tala",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              XAF: {
                name: "CF Franc BEAC",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              XCD: {
                name: "East Caribbean Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "EC$",
                  template: "$1",
                  rtl: !1,
                },
              },
              XDR: {
                name: "SDR (Special Drawing Right)",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              XOF: {
                name: "CF Franc BCEAO",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              XPF: {
                name: "CFP Franc",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              XSU: {
                name: "Sucre",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              XUA: {
                name: "ADB Unit of Account",
                fractionSize: 0,
                symbol: null,
                uniqSymbol: null,
              },
              YER: {
                name: "Yemeni Rial",
                fractionSize: 2,
                symbol: {
                  grapheme: "﷼",
                  template: "1 $",
                  rtl: !0,
                },
                uniqSymbol: {
                  grapheme: ".ر.ي",
                  template: "1 $",
                  rtl: !0,
                },
              },
              ZAR: {
                name: "Rand",
                fractionSize: 2,
                symbol: {
                  grapheme: "R",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "R",
                  template: "$1",
                  rtl: !1,
                },
              },
              ZMW: {
                name: "Zambian Kwacha",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
              ZWD: {
                name: "Zimbabwe Dollar",
                fractionSize: 2,
                symbol: {
                  grapheme: "Z$",
                  template: "$1",
                  rtl: !1,
                },
                uniqSymbol: {
                  grapheme: "Z$",
                  template: "$1",
                  rtl: !1,
                },
              },
              ZWL: {
                name: "Zimbabwe Dollar",
                fractionSize: 2,
                symbol: null,
                uniqSymbol: null,
              },
            };
          },
          function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
              value: !0,
            });
            var n = (e.numberFormat = function (t, e, n, i) {
              if (isNaN(t) || null == t) return "";
              var r = "string" == typeof i ? i : ",",
                a = t.toFixed(~~e).split("."),
                o = a[0],
                s = a[1] ? "" + (n || ".") + a[1] : "";
              return o.replace(/(\d)(?=(?:\d{3})+$)/g, "$1" + r) + s;
            });
            (e.formatDigits = function (t) {
              var e =
                1 < arguments.length && void 0 !== arguments[1]
                  ? arguments[1]
                  : 2;
              return n(t, e, ".", ",");
            }),
              (e.isNumeric = function (t) {
                return !isNaN(parseFloat(t)) && isFinite(t);
              });
          },
        ]);
      }),
        (t.exports = i());
    },
    function (t, e, n) {
      var i, r, o;
      (o = window),
        (i = [n(4), n(6), n(1), n(21), n(22), n(23)]),
        void 0 ===
          (r = function (t, e, n, i, r, a) {
            return (function (i, t, e, s, n, o, r) {
              "use strict";
              var l = i.jQuery,
                a = i.getComputedStyle,
                u = i.console;

              function c(t, e) {
                for (t = s.makeArray(t); t.length; ) e.appendChild(t.shift());
              }
              var h = 0,
                f = {};

              function d(t, e) {
                var n = s.getQueryElement(t);
                if (n) {
                  if (((this.element = n), this.element.flickityGUID)) {
                    var i = f[this.element.flickityGUID];
                    return i.option(e), i;
                  }
                  l && (this.$element = l(this.element)),
                    (this.options = s.extend({}, this.constructor.defaults)),
                    this.option(e),
                    this._create();
                } else u && u.error("Bad element for Flickity: " + (n || t));
              }
              (d.defaults = {
                accessibility: !0,
                cellAlign: "center",
                freeScrollFriction: 0.075,
                friction: 0.28,
                namespaceJQueryEvents: !0,
                percentPosition: !0,
                resize: !0,
                selectedAttraction: 0.025,
                setGallerySize: !0,
              }),
                (d.createMethods = []);
              var p = d.prototype;
              s.extend(p, t.prototype),
                (p._create = function () {
                  var t = (this.guid = ++h);
                  for (var e in ((this.element.flickityGUID = t),
                  ((f[t] = this).selectedIndex = 0),
                  (this.restingFrames = 0),
                  (this.x = 0),
                  (this.velocity = 0),
                  (this.originSide = this.options.rightToLeft
                    ? "right"
                    : "left"),
                  (this.viewport = document.createElement("div")),
                  (this.viewport.className = "flickity-viewport"),
                  this._createSlider(),
                  (this.options.resize || this.options.watchCSS) &&
                    i.addEventListener("resize", this),
                  this.options.on)) {
                    var n = this.options.on[e];
                    this.on(e, n);
                  }
                  d.createMethods.forEach(function (t) {
                    this[t]();
                  }, this),
                    this.options.watchCSS ? this.watchCSS() : this.activate();
                }),
                (p.option = function (t) {
                  s.extend(this.options, t);
                }),
                (p.activate = function () {
                  if (!this.isActive) {
                    var t;
                    (this.isActive = !0),
                      this.element.classList.add("flickity-enabled"),
                      this.options.rightToLeft &&
                        this.element.classList.add("flickity-rtl"),
                      this.getSize(),
                      c(
                        this._filterFindCellElements(this.element.children),
                        this.slider
                      ),
                      this.viewport.appendChild(this.slider),
                      this.element.appendChild(this.viewport),
                      this.reloadCells(),
                      this.options.accessibility &&
                        ((this.element.tabIndex = 0),
                        this.element.addEventListener("keydown", this)),
                      this.emitEvent("activate");
                    var e = this.options.initialIndex;
                    (t = this.isInitActivated
                      ? this.selectedIndex
                      : void 0 !== e && this.cells[e]
                      ? e
                      : 0),
                      this.select(t, !1, !0),
                      (this.isInitActivated = !0),
                      this.dispatchEvent("ready");
                  }
                }),
                (p._createSlider = function () {
                  var t = document.createElement("div");
                  (t.className = "flickity-slider"),
                    (t.style[this.originSide] = 0),
                    (this.slider = t);
                }),
                (p._filterFindCellElements = function (t) {
                  return s.filterFindElements(t, this.options.cellSelector);
                }),
                (p.reloadCells = function () {
                  (this.cells = this._makeCells(this.slider.children)),
                    this.positionCells(),
                    this._getWrapShiftCells(),
                    this.setGallerySize();
                }),
                (p._makeCells = function (t) {
                  return this._filterFindCellElements(t).map(function (t) {
                    return new n(t, this);
                  }, this);
                }),
                (p.getLastCell = function () {
                  return this.cells[this.cells.length - 1];
                }),
                (p.getLastSlide = function () {
                  return this.slides[this.slides.length - 1];
                }),
                (p.positionCells = function () {
                  this._sizeCells(this.cells), this._positionCells(0);
                }),
                (p._positionCells = function (t) {
                  (t = t || 0),
                    (this.maxCellHeight = (t && this.maxCellHeight) || 0);
                  var e = 0;
                  if (0 < t) {
                    var n = this.cells[t - 1];
                    e = n.x + n.size.outerWidth;
                  }
                  for (var i = this.cells.length, r = t; r < i; r++) {
                    var a = this.cells[r];
                    a.setPosition(e),
                      (e += a.size.outerWidth),
                      (this.maxCellHeight = Math.max(
                        a.size.outerHeight,
                        this.maxCellHeight
                      ));
                  }
                  (this.slideableWidth = e),
                    this.updateSlides(),
                    this._containSlides(),
                    (this.slidesWidth = i
                      ? this.getLastSlide().target - this.slides[0].target
                      : 0);
                }),
                (p._sizeCells = function (t) {
                  t.forEach(function (t) {
                    t.getSize();
                  });
                }),
                (p.updateSlides = function () {
                  if (((this.slides = []), this.cells.length)) {
                    var i = new o(this);
                    this.slides.push(i);
                    var r =
                        "left" == this.originSide
                          ? "marginRight"
                          : "marginLeft",
                      a = this._getCanCellFit();
                    this.cells.forEach(function (t, e) {
                      if (i.cells.length) {
                        var n =
                          i.outerWidth -
                          i.firstMargin +
                          (t.size.outerWidth - t.size[r]);
                        a.call(this, e, n) ||
                          (i.updateTarget(),
                          (i = new o(this)),
                          this.slides.push(i)),
                          i.addCell(t);
                      } else i.addCell(t);
                    }, this),
                      i.updateTarget(),
                      this.updateSelectedSlide();
                  }
                }),
                (p._getCanCellFit = function () {
                  var t = this.options.groupCells;
                  if (!t)
                    return function () {
                      return !1;
                    };
                  if ("number" == typeof t) {
                    var e = parseInt(t, 10);
                    return function (t) {
                      return t % e != 0;
                    };
                  }
                  var n = "string" == typeof t && t.match(/^(\d+)%$/),
                    i = n ? parseInt(n[1], 10) / 100 : 1;
                  return function (t, e) {
                    return e <= (this.size.innerWidth + 1) * i;
                  };
                }),
                (p._init = p.reposition =
                  function () {
                    this.positionCells(), this.positionSliderAtSelected();
                  }),
                (p.getSize = function () {
                  (this.size = e(this.element)),
                    this.setCellAlign(),
                    (this.cursorPosition =
                      this.size.innerWidth * this.cellAlign);
                });
              var m = {
                center: {
                  left: 0.5,
                  right: 0.5,
                },
                left: {
                  left: 0,
                  right: 1,
                },
                right: {
                  right: 0,
                  left: 1,
                },
              };
              return (
                (p.setCellAlign = function () {
                  var t = m[this.options.cellAlign];
                  this.cellAlign = t
                    ? t[this.originSide]
                    : this.options.cellAlign;
                }),
                (p.setGallerySize = function () {
                  if (this.options.setGallerySize) {
                    var t =
                      this.options.adaptiveHeight && this.selectedSlide
                        ? this.selectedSlide.height
                        : this.maxCellHeight;
                    this.viewport.style.height = t + "px";
                  }
                }),
                (p._getWrapShiftCells = function () {
                  if (this.options.wrapAround) {
                    this._unshiftCells(this.beforeShiftCells),
                      this._unshiftCells(this.afterShiftCells);
                    var t = this.cursorPosition,
                      e = this.cells.length - 1;
                    (this.beforeShiftCells = this._getGapCells(t, e, -1)),
                      (t = this.size.innerWidth - this.cursorPosition),
                      (this.afterShiftCells = this._getGapCells(t, 0, 1));
                  }
                }),
                (p._getGapCells = function (t, e, n) {
                  for (var i = []; 0 < t; ) {
                    var r = this.cells[e];
                    if (!r) break;
                    i.push(r), (e += n), (t -= r.size.outerWidth);
                  }
                  return i;
                }),
                (p._containSlides = function () {
                  if (
                    this.options.contain &&
                    !this.options.wrapAround &&
                    this.cells.length
                  ) {
                    var t = this.options.rightToLeft,
                      e = t ? "marginRight" : "marginLeft",
                      n = t ? "marginLeft" : "marginRight",
                      i = this.slideableWidth - this.getLastCell().size[n],
                      r = i < this.size.innerWidth,
                      a = this.cursorPosition + this.cells[0].size[e],
                      o = i - this.size.innerWidth * (1 - this.cellAlign);
                    this.slides.forEach(function (t) {
                      r
                        ? (t.target = i * this.cellAlign)
                        : ((t.target = Math.max(t.target, a)),
                          (t.target = Math.min(t.target, o)));
                    }, this);
                  }
                }),
                (p.dispatchEvent = function (t, e, n) {
                  var i = e ? [e].concat(n) : n;
                  if ((this.emitEvent(t, i), l && this.$element)) {
                    var r = (t += this.options.namespaceJQueryEvents
                      ? ".flickity"
                      : "");
                    if (e) {
                      var a = l.Event(e);
                      (a.type = t), (r = a);
                    }
                    this.$element.trigger(r, n);
                  }
                }),
                (p.select = function (t, e, n) {
                  if (
                    this.isActive &&
                    ((t = parseInt(t, 10)),
                    this._wrapSelect(t),
                    (this.options.wrapAround || e) &&
                      (t = s.modulo(t, this.slides.length)),
                    this.slides[t])
                  ) {
                    var i = this.selectedIndex;
                    (this.selectedIndex = t),
                      this.updateSelectedSlide(),
                      n
                        ? this.positionSliderAtSelected()
                        : this.startAnimation(),
                      this.options.adaptiveHeight && this.setGallerySize(),
                      this.dispatchEvent("select", null, [t]),
                      t != i && this.dispatchEvent("change", null, [t]),
                      this.dispatchEvent("cellSelect");
                  }
                }),
                (p._wrapSelect = function (t) {
                  var e = this.slides.length;
                  if (!(this.options.wrapAround && 1 < e)) return t;
                  var n = s.modulo(t, e),
                    i = Math.abs(n - this.selectedIndex),
                    r = Math.abs(n + e - this.selectedIndex),
                    a = Math.abs(n - e - this.selectedIndex);
                  !this.isDragSelect && r < i
                    ? (t += e)
                    : !this.isDragSelect && a < i && (t -= e),
                    t < 0
                      ? (this.x -= this.slideableWidth)
                      : e <= t && (this.x += this.slideableWidth);
                }),
                (p.previous = function (t, e) {
                  this.select(this.selectedIndex - 1, t, e);
                }),
                (p.next = function (t, e) {
                  this.select(this.selectedIndex + 1, t, e);
                }),
                (p.updateSelectedSlide = function () {
                  var t = this.slides[this.selectedIndex];
                  t &&
                    (this.unselectSelectedSlide(),
                    (this.selectedSlide = t).select(),
                    (this.selectedCells = t.cells),
                    (this.selectedElements = t.getCellElements()),
                    (this.selectedCell = t.cells[0]),
                    (this.selectedElement = this.selectedElements[0]));
                }),
                (p.unselectSelectedSlide = function () {
                  this.selectedSlide && this.selectedSlide.unselect();
                }),
                (p.selectCell = function (t, e, n) {
                  var i = this.queryCell(t);
                  if (i) {
                    var r = this.getCellSlideIndex(i);
                    this.select(r, e, n);
                  }
                }),
                (p.getCellSlideIndex = function (t) {
                  for (var e = 0; e < this.slides.length; e++)
                    if (-1 != this.slides[e].cells.indexOf(t)) return e;
                }),
                (p.getCell = function (t) {
                  for (var e = 0; e < this.cells.length; e++) {
                    var n = this.cells[e];
                    if (n.element == t) return n;
                  }
                }),
                (p.getCells = function (t) {
                  var n = [];
                  return (
                    (t = s.makeArray(t)).forEach(function (t) {
                      var e = this.getCell(t);
                      e && n.push(e);
                    }, this),
                    n
                  );
                }),
                (p.getCellElements = function () {
                  return this.cells.map(function (t) {
                    return t.element;
                  });
                }),
                (p.getParentCell = function (t) {
                  var e = this.getCell(t);
                  return (
                    e ||
                    ((t = s.getParent(t, ".flickity-slider > *")),
                    this.getCell(t))
                  );
                }),
                (p.getAdjacentCellElements = function (t, e) {
                  if (!t) return this.selectedSlide.getCellElements();
                  e = void 0 === e ? this.selectedIndex : e;
                  var n = this.slides.length;
                  if (n <= 1 + 2 * t) return this.getCellElements();
                  for (var i = [], r = e - t; r <= e + t; r++) {
                    var a = this.options.wrapAround ? s.modulo(r, n) : r,
                      o = this.slides[a];
                    o && (i = i.concat(o.getCellElements()));
                  }
                  return i;
                }),
                (p.queryCell = function (t) {
                  return "number" == typeof t
                    ? this.cells[t]
                    : ("string" == typeof t &&
                        (t = this.element.querySelector(t)),
                      this.getCell(t));
                }),
                (p.uiChange = function () {
                  this.emitEvent("uiChange");
                }),
                (p.childUIPointerDown = function (t) {
                  this.emitEvent("childUIPointerDown", [t]);
                }),
                (p.onresize = function () {
                  this.watchCSS(), this.resize();
                }),
                s.debounceMethod(d, "onresize", 150),
                (p.resize = function () {
                  if (this.isActive) {
                    this.getSize(),
                      this.options.wrapAround &&
                        (this.x = s.modulo(this.x, this.slideableWidth)),
                      this.positionCells(),
                      this._getWrapShiftCells(),
                      this.setGallerySize(),
                      this.emitEvent("resize");
                    var t = this.selectedElements && this.selectedElements[0];
                    this.selectCell(t, !1, !0);
                  }
                }),
                (p.watchCSS = function () {
                  this.options.watchCSS &&
                    (-1 != a(this.element, ":after").content.indexOf("flickity")
                      ? this.activate()
                      : this.deactivate());
                }),
                (p.onkeydown = function (t) {
                  var e =
                    document.activeElement &&
                    document.activeElement != this.element;
                  if (this.options.accessibility && !e) {
                    var n = d.keyboardHandlers[t.keyCode];
                    n && n.call(this);
                  }
                }),
                (d.keyboardHandlers = {
                  37: function () {
                    var t = this.options.rightToLeft ? "next" : "previous";
                    this.uiChange(), this[t]();
                  },
                  39: function () {
                    var t = this.options.rightToLeft ? "previous" : "next";
                    this.uiChange(), this[t]();
                  },
                }),
                (p.focus = function () {
                  var t = i.pageYOffset;
                  this.element.focus(),
                    i.pageYOffset != t && i.scrollTo(i.pageXOffset, t);
                }),
                (p.deactivate = function () {
                  this.isActive &&
                    (this.element.classList.remove("flickity-enabled"),
                    this.element.classList.remove("flickity-rtl"),
                    this.unselectSelectedSlide(),
                    this.cells.forEach(function (t) {
                      t.destroy();
                    }),
                    this.element.removeChild(this.viewport),
                    c(this.slider.children, this.element),
                    this.options.accessibility &&
                      (this.element.removeAttribute("tabIndex"),
                      this.element.removeEventListener("keydown", this)),
                    (this.isActive = !1),
                    this.emitEvent("deactivate"));
                }),
                (p.destroy = function () {
                  //this.deactivate(), i.removeEventListener("resize", this), this.emitEvent("destroy"), l && this.$element && l.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete f[this.guid]
                }),
                s.extend(p, r),
                (d.data = function (t) {
                  var e = (t = s.getQueryElement(t)) && t.flickityGUID;
                  return e && f[e];
                }),
                s.htmlInit(d, "flickity"),
                l && l.bridget && l.bridget("flickity", d),
                (d.setJQuery = function (t) {
                  l = t;
                }),
                (d.Cell = n),
                d
              );
            })(o, t, e, n, i, r, a);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r;
      "undefined" != typeof window && window,
        void 0 ===
          (r =
            "function" ==
            typeof (i = function () {
              "use strict";

              function t() {}
              var e = t.prototype;
              return (
                (e.on = function (t, e) {
                  if (t && e) {
                    var n = (this._events = this._events || {}),
                      i = (n[t] = n[t] || []);
                    return -1 == i.indexOf(e) && i.push(e), this;
                  }
                }),
                (e.once = function (t, e) {
                  if (t && e) {
                    this.on(t, e);
                    var n = (this._onceEvents = this._onceEvents || {});
                    return ((n[t] = n[t] || {})[e] = !0), this;
                  }
                }),
                (e.off = function (t, e) {
                  var n = this._events && this._events[t];
                  if (n && n.length) {
                    var i = n.indexOf(e);
                    return -1 != i && n.splice(i, 1), this;
                  }
                }),
                (e.emitEvent = function (t, e) {
                  var n = this._events && this._events[t];
                  if (n && n.length) {
                    (n = n.slice(0)), (e = e || []);
                    for (
                      var i = this._onceEvents && this._onceEvents[t], r = 0;
                      r < n.length;
                      r++
                    ) {
                      var a = n[r];
                      i && i[a] && (this.off(t, a), delete i[a]),
                        a.apply(this, e);
                    }
                    return this;
                  }
                }),
                (e.allOff = function () {
                  delete this._events, delete this._onceEvents;
                }),
                t
              );
            })
              ? i.call(e, n, e, t)
              : i) || (t.exports = r);
    },
    function (t, e, n) {
      var i = n(33);
      t.exports = new i();
    },
    function (t, e, n) {
      var i, r;
      window,
        void 0 ===
          (r =
            "function" ==
            typeof (i = function () {
              "use strict";

              function g(t) {
                var e = parseFloat(t);
                return -1 == t.indexOf("%") && !isNaN(e) && e;
              }
              var n =
                  "undefined" == typeof console
                    ? function () {}
                    : function (t) {
                        console.error(t);
                      },
                y = [
                  "paddingLeft",
                  "paddingRight",
                  "paddingTop",
                  "paddingBottom",
                  "marginLeft",
                  "marginRight",
                  "marginTop",
                  "marginBottom",
                  "borderLeftWidth",
                  "borderRightWidth",
                  "borderTopWidth",
                  "borderBottomWidth",
                ],
                b = y.length;

              function _(t) {
                var e = getComputedStyle(t);
                return (
                  e ||
                    n(
                      "Style returned " +
                        e +
                        ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
                    ),
                  e
                );
              }
              var S,
                w = !1;
              return function (t) {
                if (
                  ((function () {
                    if (!w) {
                      w = !0;
                      var t = document.createElement("div");
                      (t.style.width = "200px"),
                        (t.style.padding = "1px 2px 3px 4px"),
                        (t.style.borderStyle = "solid"),
                        (t.style.borderWidth = "1px 2px 3px 4px"),
                        (t.style.boxSizing = "border-box");
                      var e = document.body || document.documentElement;
                      e.appendChild(t);
                      var n = _(t);
                      (S = 200 == Math.round(g(n.width))), S, e.removeChild(t);
                    }
                  })(),
                  "string" == typeof t && (t = document.querySelector(t)),
                  t && "object" == typeof t && t.nodeType)
                ) {
                  var e = _(t);
                  if ("none" == e.display)
                    return (function () {
                      for (
                        var t = {
                            width: 0,
                            height: 0,
                            innerWidth: 0,
                            innerHeight: 0,
                            outerWidth: 0,
                            outerHeight: 0,
                          },
                          e = 0;
                        e < b;
                        e++
                      )
                        t[y[e]] = 0;
                      return t;
                    })();
                  var n = {};
                  (n.width = t.offsetWidth), (n.height = t.offsetHeight);
                  for (
                    var i = (n.isBorderBox = "border-box" == e.boxSizing),
                      r = 0;
                    r < b;
                    r++
                  ) {
                    var a = y[r],
                      o = e[a],
                      s = parseFloat(o);
                    n[a] = isNaN(s) ? 0 : s;
                  }
                  var l = n.paddingLeft + n.paddingRight,
                    u = n.paddingTop + n.paddingBottom,
                    c = n.marginLeft + n.marginRight,
                    h = n.marginTop + n.marginBottom,
                    f = n.borderLeftWidth + n.borderRightWidth,
                    d = n.borderTopWidth + n.borderBottomWidth,
                    p = i && S,
                    m = g(e.width);
                  !1 !== m && (n.width = m + (p ? 0 : l + f));
                  var v = g(e.height);
                  return (
                    !1 !== v && (n.height = v + (p ? 0 : u + d)),
                    (n.innerWidth = n.width - (l + f)),
                    (n.innerHeight = n.height - (u + d)),
                    (n.outerWidth = n.width + c),
                    (n.outerHeight = n.height + h),
                    n
                  );
                }
              };
            })
              ? i.call(e, n, e, t)
              : i) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r, a;
      (a = window),
        (i = [n(4)]),
        void 0 ===
          (r = function (t) {
            return (function (r, t) {
              "use strict";

              function e() {}
              var n = (e.prototype = Object.create(t.prototype));
              (n.bindStartEvent = function (t) {
                this._bindStartEvent(t, !0);
              }),
                (n.unbindStartEvent = function (t) {
                  this._bindStartEvent(t, !1);
                }),
                (n._bindStartEvent = function (t, e) {
                  var n = (e = void 0 === e || e)
                      ? "addEventListener"
                      : "removeEventListener",
                    i = "mousedown";
                  r.PointerEvent
                    ? (i = "pointerdown")
                    : "ontouchstart" in r && (i = "touchstart"),
                    t[n](i, this);
                }),
                (n.handleEvent = function (t) {
                  var e = "on" + t.type;
                  this[e] && this[e](t);
                }),
                (n.getTouch = function (t) {
                  for (var e = 0; e < t.length; e++) {
                    var n = t[e];
                    if (n.identifier == this.pointerIdentifier) return n;
                  }
                }),
                (n.onmousedown = function (t) {
                  var e = t.button;
                  (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
                }),
                (n.ontouchstart = function (t) {
                  this._pointerDown(t, t.changedTouches[0]);
                }),
                (n.onpointerdown = function (t) {
                  this._pointerDown(t, t);
                }),
                (n._pointerDown = function (t, e) {
                  t.button ||
                    this.isPointerDown ||
                    ((this.isPointerDown = !0),
                    (this.pointerIdentifier =
                      void 0 !== e.pointerId ? e.pointerId : e.identifier),
                    this.pointerDown(t, e));
                }),
                (n.pointerDown = function (t, e) {
                  this._bindPostStartEvents(t),
                    this.emitEvent("pointerDown", [t, e]);
                });
              var i = {
                mousedown: ["mousemove", "mouseup"],
                touchstart: ["touchmove", "touchend", "touchcancel"],
                pointerdown: ["pointermove", "pointerup", "pointercancel"],
              };
              return (
                (n._bindPostStartEvents = function (t) {
                  if (t) {
                    var e = i[t.type];
                    e.forEach(function (t) {
                      r.addEventListener(t, this);
                    }, this),
                      (this._boundPointerEvents = e);
                  }
                }),
                (n._unbindPostStartEvents = function () {
                  this._boundPointerEvents &&
                    (this._boundPointerEvents.forEach(function (t) {
                      r.removeEventListener(t, this);
                    }, this),
                    delete this._boundPointerEvents);
                }),
                (n.onmousemove = function (t) {
                  this._pointerMove(t, t);
                }),
                (n.onpointermove = function (t) {
                  t.pointerId == this.pointerIdentifier &&
                    this._pointerMove(t, t);
                }),
                (n.ontouchmove = function (t) {
                  var e = this.getTouch(t.changedTouches);
                  e && this._pointerMove(t, e);
                }),
                (n._pointerMove = function (t, e) {
                  this.pointerMove(t, e);
                }),
                (n.pointerMove = function (t, e) {
                  this.emitEvent("pointerMove", [t, e]);
                }),
                (n.onmouseup = function (t) {
                  this._pointerUp(t, t);
                }),
                (n.onpointerup = function (t) {
                  t.pointerId == this.pointerIdentifier &&
                    this._pointerUp(t, t);
                }),
                (n.ontouchend = function (t) {
                  var e = this.getTouch(t.changedTouches);
                  e && this._pointerUp(t, e);
                }),
                (n._pointerUp = function (t, e) {
                  this._pointerDone(), this.pointerUp(t, e);
                }),
                (n.pointerUp = function (t, e) {
                  this.emitEvent("pointerUp", [t, e]);
                }),
                (n._pointerDone = function () {
                  this._pointerReset(),
                    this._unbindPostStartEvents(),
                    this.pointerDone();
                }),
                (n._pointerReset = function () {
                  (this.isPointerDown = !1), delete this.pointerIdentifier;
                }),
                (n.pointerDone = function () {}),
                (n.onpointercancel = function (t) {
                  t.pointerId == this.pointerIdentifier &&
                    this._pointerCancel(t, t);
                }),
                (n.ontouchcancel = function (t) {
                  var e = this.getTouch(t.changedTouches);
                  e && this._pointerCancel(t, e);
                }),
                (n._pointerCancel = function (t, e) {
                  this._pointerDone(), this.pointerCancel(t, e);
                }),
                (n.pointerCancel = function (t, e) {
                  this.emitEvent("pointerCancel", [t, e]);
                }),
                (e.getPointerPoint = function (t) {
                  return {
                    x: t.pageX,
                    y: t.pageY,
                  };
                }),
                e
              );
            })(a, t);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r, a;
      (a = window),
        (i = [n(7)]),
        void 0 ===
          (r = function (t) {
            return (function (s, l) {
              "use strict";

              function t(t) {
                this.bindTap(t);
              }
              var e = (t.prototype = Object.create(l.prototype));
              return (
                (e.bindTap = function (t) {
                  t &&
                    (this.unbindTap(),
                    (this.tapElement = t),
                    this._bindStartEvent(t, !0));
                }),
                (e.unbindTap = function () {
                  this.tapElement &&
                    (this._bindStartEvent(this.tapElement, !0),
                    delete this.tapElement);
                }),
                (e.pointerUp = function (t, e) {
                  if (!this.isIgnoringMouseUp || "mouseup" != t.type) {
                    var n = l.getPointerPoint(e),
                      i = this.tapElement.getBoundingClientRect(),
                      r = s.pageXOffset,
                      a = s.pageYOffset;
                    if (
                      (n.x >= i.left + r &&
                        n.x <= i.right + r &&
                        n.y >= i.top + a &&
                        n.y <= i.bottom + a &&
                        this.emitEvent("tap", [t, e]),
                      "mouseup" != t.type)
                    ) {
                      this.isIgnoringMouseUp = !0;
                      var o = this;
                      setTimeout(function () {
                        delete o.isIgnoringMouseUp;
                      }, 400);
                    }
                  }
                }),
                (e.destroy = function () {
                  this.pointerDone(), this.unbindTap();
                }),
                t
              );
            })(a, t);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r, a;
      void 0 ===
        (r =
          "function" ==
          typeof (i = a =
            function () {
              function m() {
                for (var t = 0, e = {}; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var i in n) e[i] = n[i];
                }
                return e;
              }
              return (function t(d) {
                function p(t, e, n) {
                  var i;
                  if ("undefined" != typeof document) {
                    if (1 < arguments.length) {
                      if (
                        "number" ==
                        typeof (n = m(
                          {
                            path: "/",
                          },
                          p.defaults,
                          n
                        )).expires
                      ) {
                        var r = new Date();
                        r.setMilliseconds(
                          r.getMilliseconds() + 864e5 * n.expires
                        ),
                          (n.expires = r);
                      }
                      n.expires = n.expires ? n.expires.toUTCString() : "";
                      try {
                        (i = JSON.stringify(e)), /^[\{\[]/.test(i) && (e = i);
                      } catch (t) {}
                      (e = d.write
                        ? d.write(e, t)
                        : encodeURIComponent(String(e)).replace(
                            /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                            decodeURIComponent
                          )),
                        (t = (t = (t = encodeURIComponent(String(t))).replace(
                          /%(23|24|26|2B|5E|60|7C)/g,
                          decodeURIComponent
                        )).replace(/[\(\)]/g, escape));
                      var a = "";
                      for (var o in n)
                        n[o] &&
                          ((a += "; " + o), !0 !== n[o] && (a += "=" + n[o]));
                      return (document.cookie = t + "=" + e + a);
                    }
                    t || (i = {});
                    for (
                      var s = document.cookie
                          ? document.cookie.split("; ")
                          : [],
                        l = /(%[0-9A-Z]{2})+/g,
                        u = 0;
                      u < s.length;
                      u++
                    ) {
                      var c = s[u].split("="),
                        h = c.slice(1).join("=");
                      this.json || '"' !== h.charAt(0) || (h = h.slice(1, -1));
                      try {
                        var f = c[0].replace(l, decodeURIComponent);
                        if (
                          ((h = d.read
                            ? d.read(h, f)
                            : d(h, f) || h.replace(l, decodeURIComponent)),
                          this.json)
                        )
                          try {
                            h = JSON.parse(h);
                          } catch (t) {}
                        if (t === f) {
                          i = h;
                          break;
                        }
                        t || (i[f] = h);
                      } catch (t) {}
                    }
                    return i;
                  }
                }
                return (
                  ((p.set = p).get = function (t) {
                    return p.call(p, t);
                  }),
                  (p.getJSON = function () {
                    return p.apply(
                      {
                        json: !0,
                      },
                      [].slice.call(arguments)
                    );
                  }),
                  (p.defaults = {}),
                  (p.remove = function (t, e) {
                    p(
                      t,
                      "",
                      m(e, {
                        expires: -1,
                      })
                    );
                  }),
                  (p.withConverter = t),
                  p
                );
              })(function () {});
            })
            ? i.call(e, n, e, t)
            : i) || (t.exports = r),
        (t.exports = a());
    },
    ,
    ,
    ,
    function (t, q, j) {
      (function (D, A) {
        var I;
        (function () {
          var Ha,
            Ka = "Expected a function",
            Za = "__lodash_hash_undefined__",
            Ja = "__lodash_placeholder__",
            Xa = 128,
            Ya = 9007199254740991,
            to = 4294967295,
            eo = [
              ["ary", Xa],
              ["bind", 1],
              ["bindKey", 2],
              ["curry", 8],
              ["curryRight", 16],
              ["flip", 512],
              ["partial", 32],
              ["partialRight", 64],
              ["rearg", 256],
            ],
            no = "[object Arguments]",
            io = "[object Array]",
            ro = "[object Boolean]",
            ao = "[object Date]",
            oo = "[object Error]",
            so = "[object Function]",
            lo = "[object GeneratorFunction]",
            uo = "[object Map]",
            co = "[object Number]",
            ho = "[object Object]",
            fo = "[object RegExp]",
            po = "[object Set]",
            mo = "[object String]",
            vo = "[object Symbol]",
            go = "[object WeakMap]",
            yo = "[object ArrayBuffer]",
            bo = "[object DataView]",
            _o = "[object Float32Array]",
            So = "[object Float64Array]",
            wo = "[object Int8Array]",
            ko = "[object Int16Array]",
            Co = "[object Int32Array]",
            xo = "[object Uint8Array]",
            Eo = "[object Uint8ClampedArray]",
            $o = "[object Uint16Array]",
            To = "[object Uint32Array]",
            Do = /\b__p \+= '';/g,
            Ao = /\b(__p \+=) '' \+/g,
            Io = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
            qo = /&(?:amp|lt|gt|quot|#39);/g,
            jo = /[&<>"']/g,
            zo = RegExp(qo.source),
            Po = RegExp(jo.source),
            Oo = /<%-([\s\S]+?)%>/g,
            Lo = /<%([\s\S]+?)%>/g,
            Bo = /<%=([\s\S]+?)%>/g,
            Mo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            Fo = /^\w*$/,
            Ro =
              /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            No = /[\\^$.*+?()[\]{}|]/g,
            Vo = RegExp(No.source),
            Uo = /^\s+|\s+$/g,
            Wo = /^\s+/,
            Go = /\s+$/,
            Qo = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
            Ho = /\{\n\/\* \[wrapped with (.+)\] \*/,
            Ko = /,? & /,
            Zo = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
            Jo = /\\(\\)?/g,
            Xo = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
            Yo = /\w*$/,
            ts = /^[-+]0x[0-9a-f]+$/i,
            es = /^0b[01]+$/i,
            ns = /^\[object .+?Constructor\]$/,
            is = /^0o[0-7]+$/i,
            rs = /^(?:0|[1-9]\d*)$/,
            as = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
            os = /($^)/,
            ss = /['\n\r\u2028\u2029\\]/g,
            t = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
            e =
              "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
            n = "[" + e + "]",
            i = "[" + t + "]",
            r = "\\d+",
            a = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
            o =
              "[^\\ud800-\\udfff" +
              e +
              r +
              "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
            s = "\\ud83c[\\udffb-\\udfff]",
            l = "[^\\ud800-\\udfff]",
            u = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            c = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            h = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
            f = "(?:" + a + "|" + o + ")",
            d = "(?:" + h + "|" + o + ")",
            p = "(?:" + i + "|" + s + ")?",
            m =
              "[\\ufe0e\\ufe0f]?" +
              p +
              "(?:\\u200d(?:" +
              [l, u, c].join("|") +
              ")[\\ufe0e\\ufe0f]?" +
              p +
              ")*",
            v = "(?:" + ["[\\u2700-\\u27bf]", u, c].join("|") + ")" + m,
            g =
              "(?:" +
              [l + i + "?", i, u, c, "[\\ud800-\\udfff]"].join("|") +
              ")",
            ls = RegExp("['’]", "g"),
            us = RegExp(i, "g"),
            y = RegExp(s + "(?=" + s + ")|" + g + m, "g"),
            cs = RegExp(
              [
                h +
                  "?" +
                  a +
                  "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" +
                  [n, h, "$"].join("|") +
                  ")",
                d +
                  "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" +
                  [n, h + f, "$"].join("|") +
                  ")",
                h + "?" + f + "+(?:['’](?:d|ll|m|re|s|t|ve))?",
                h + "+(?:['’](?:D|LL|M|RE|S|T|VE))?",
                "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
                "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
                r,
                v,
              ].join("|"),
              "g"
            ),
            b = RegExp("[\\u200d\\ud800-\\udfff" + t + "\\ufe0e\\ufe0f]"),
            hs =
              /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
            fs = [
              "Array",
              "Buffer",
              "DataView",
              "Date",
              "Error",
              "Float32Array",
              "Float64Array",
              "Function",
              "Int8Array",
              "Int16Array",
              "Int32Array",
              "Map",
              "Math",
              "Object",
              "Promise",
              "RegExp",
              "Set",
              "String",
              "Symbol",
              "TypeError",
              "Uint8Array",
              "Uint8ClampedArray",
              "Uint16Array",
              "Uint32Array",
              "WeakMap",
              "_",
              "clearTimeout",
              "isFinite",
              "parseInt",
              "setTimeout",
            ],
            ds = -1,
            ps = {};
          (ps[_o] =
            ps[So] =
            ps[wo] =
            ps[ko] =
            ps[Co] =
            ps[xo] =
            ps[Eo] =
            ps[$o] =
            ps[To] =
              !0),
            (ps[no] =
              ps[io] =
              ps[yo] =
              ps[ro] =
              ps[bo] =
              ps[ao] =
              ps[oo] =
              ps[so] =
              ps[uo] =
              ps[co] =
              ps[ho] =
              ps[fo] =
              ps[po] =
              ps[mo] =
              ps[go] =
                !1);
          var ms = {};
          (ms[no] =
            ms[io] =
            ms[yo] =
            ms[bo] =
            ms[ro] =
            ms[ao] =
            ms[_o] =
            ms[So] =
            ms[wo] =
            ms[ko] =
            ms[Co] =
            ms[uo] =
            ms[co] =
            ms[ho] =
            ms[fo] =
            ms[po] =
            ms[mo] =
            ms[vo] =
            ms[xo] =
            ms[Eo] =
            ms[$o] =
            ms[To] =
              !0),
            (ms[oo] = ms[so] = ms[go] = !1);
          var _ = {
              "\\": "\\",
              "'": "'",
              "\n": "n",
              "\r": "r",
              "\u2028": "u2028",
              "\u2029": "u2029",
            },
            vs = parseFloat,
            gs = parseInt,
            S = "object" == typeof D && D && D.Object === Object && D,
            w =
              "object" == typeof self && self && self.Object === Object && self,
            ys = S || w || Function("return this")(),
            k = "object" == typeof q && q && !q.nodeType && q,
            C = k && "object" == typeof A && A && !A.nodeType && A,
            bs = C && C.exports === k,
            x = bs && S.process,
            E = (function () {
              try {
                return (
                  (C && C.require && C.require("util").types) ||
                  (x && x.binding && x.binding("util"))
                );
              } catch (t) {}
            })(),
            _s = E && E.isArrayBuffer,
            Ss = E && E.isDate,
            ws = E && E.isMap,
            ks = E && E.isRegExp,
            Cs = E && E.isSet,
            xs = E && E.isTypedArray;

          function Es(t, e, n) {
            switch (n.length) {
              case 0:
                return t.call(e);
              case 1:
                return t.call(e, n[0]);
              case 2:
                return t.call(e, n[0], n[1]);
              case 3:
                return t.call(e, n[0], n[1], n[2]);
            }
            return t.apply(e, n);
          }

          function $s(t, e, n, i) {
            for (var r = -1, a = null == t ? 0 : t.length; ++r < a; ) {
              var o = t[r];
              e(i, o, n(o), t);
            }
            return i;
          }

          function Ts(t, e) {
            for (
              var n = -1, i = null == t ? 0 : t.length;
              ++n < i && !1 !== e(t[n], n, t);

            );
            return t;
          }

          function Ds(t, e) {
            for (var n = -1, i = null == t ? 0 : t.length; ++n < i; )
              if (!e(t[n], n, t)) return !1;
            return !0;
          }

          function As(t, e) {
            for (
              var n = -1, i = null == t ? 0 : t.length, r = 0, a = [];
              ++n < i;

            ) {
              var o = t[n];
              e(o, n, t) && (a[r++] = o);
            }
            return a;
          }

          function Is(t, e) {
            return !(null == t || !t.length) && -1 < Fs(t, e, 0);
          }

          function qs(t, e, n) {
            for (var i = -1, r = null == t ? 0 : t.length; ++i < r; )
              if (n(e, t[i])) return !0;
            return !1;
          }

          function js(t, e) {
            for (
              var n = -1, i = null == t ? 0 : t.length, r = Array(i);
              ++n < i;

            )
              r[n] = e(t[n], n, t);
            return r;
          }

          function zs(t, e) {
            for (var n = -1, i = e.length, r = t.length; ++n < i; )
              t[r + n] = e[n];
            return t;
          }

          function Ps(t, e, n, i) {
            var r = -1,
              a = null == t ? 0 : t.length;
            for (i && a && (n = t[++r]); ++r < a; ) n = e(n, t[r], r, t);
            return n;
          }

          function Os(t, e, n, i) {
            var r = null == t ? 0 : t.length;
            for (i && r && (n = t[--r]); r--; ) n = e(n, t[r], r, t);
            return n;
          }

          function Ls(t, e) {
            for (var n = -1, i = null == t ? 0 : t.length; ++n < i; )
              if (e(t[n], n, t)) return !0;
            return !1;
          }
          var $ = Us("length");

          function Bs(t, i, e) {
            var r;
            return (
              e(t, function (t, e, n) {
                if (i(t, e, n)) return (r = e), !1;
              }),
              r
            );
          }

          function Ms(t, e, n, i) {
            for (var r = t.length, a = n + (i ? 1 : -1); i ? a-- : ++a < r; )
              if (e(t[a], a, t)) return a;
            return -1;
          }

          function Fs(t, e, a) {
            return e == e
              ? (function (t, e, n) {
                  for (var i = a - 1, r = t.length; ++i < r; )
                    if (t[i] === e) return i;
                  return -1;
                })(t, e)
              : Ms(t, Ns, a);
          }

          function Rs(t, e, n, i) {
            for (var r = n - 1, a = t.length; ++r < a; )
              if (i(t[r], e)) return r;
            return -1;
          }

          function Ns(t) {
            return t != t;
          }

          function Vs(t, e) {
            var n = null == t ? 0 : t.length;
            return n ? Gs(t, e) / n : NaN;
          }

          function Us(e) {
            return function (t) {
              return null == t ? Ha : t[e];
            };
          }

          function T(e) {
            return function (t) {
              return null == e ? Ha : e[t];
            };
          }

          function Ws(t, i, r, a, e) {
            return (
              e(t, function (t, e, n) {
                r = a ? ((a = !1), t) : i(r, t, e, n);
              }),
              r
            );
          }

          function Gs(t, e) {
            for (var n, i = -1, r = t.length; ++i < r; ) {
              var a = e(t[i]);
              a !== Ha && (n = n === Ha ? a : n + a);
            }
            return n;
          }

          function Qs(t, e) {
            for (var n = -1, i = Array(t); ++n < t; ) i[n] = e(n);
            return i;
          }

          function Hs(e) {
            return function (t) {
              return e(t);
            };
          }

          function Ks(e, t) {
            return js(t, function (t) {
              return e[t];
            });
          }

          function Zs(t, e) {
            return t.has(e);
          }

          function Js(t, e) {
            for (var n = -1, i = t.length; ++n < i && -1 < Fs(e, t[n], 0); );
            return n;
          }

          function Xs(t, e) {
            for (var n = t.length; n-- && -1 < Fs(e, t[n], 0); );
            return n;
          }
          var Ys = T({
              À: "A",
              Á: "A",
              Â: "A",
              Ã: "A",
              Ä: "A",
              Å: "A",
              à: "a",
              á: "a",
              â: "a",
              ã: "a",
              ä: "a",
              å: "a",
              Ç: "C",
              ç: "c",
              Ð: "D",
              ð: "d",
              È: "E",
              É: "E",
              Ê: "E",
              Ë: "E",
              è: "e",
              é: "e",
              ê: "e",
              ë: "e",
              Ì: "I",
              Í: "I",
              Î: "I",
              Ï: "I",
              ì: "i",
              í: "i",
              î: "i",
              ï: "i",
              Ñ: "N",
              ñ: "n",
              Ò: "O",
              Ó: "O",
              Ô: "O",
              Õ: "O",
              Ö: "O",
              Ø: "O",
              ò: "o",
              ó: "o",
              ô: "o",
              õ: "o",
              ö: "o",
              ø: "o",
              Ù: "U",
              Ú: "U",
              Û: "U",
              Ü: "U",
              ù: "u",
              ú: "u",
              û: "u",
              ü: "u",
              Ý: "Y",
              ý: "y",
              ÿ: "y",
              Æ: "Ae",
              æ: "ae",
              Þ: "Th",
              þ: "th",
              ß: "ss",
              Ā: "A",
              Ă: "A",
              Ą: "A",
              ā: "a",
              ă: "a",
              ą: "a",
              Ć: "C",
              Ĉ: "C",
              Ċ: "C",
              Č: "C",
              ć: "c",
              ĉ: "c",
              ċ: "c",
              č: "c",
              Ď: "D",
              Đ: "D",
              ď: "d",
              đ: "d",
              Ē: "E",
              Ĕ: "E",
              Ė: "E",
              Ę: "E",
              Ě: "E",
              ē: "e",
              ĕ: "e",
              ė: "e",
              ę: "e",
              ě: "e",
              Ĝ: "G",
              Ğ: "G",
              Ġ: "G",
              Ģ: "G",
              ĝ: "g",
              ğ: "g",
              ġ: "g",
              ģ: "g",
              Ĥ: "H",
              Ħ: "H",
              ĥ: "h",
              ħ: "h",
              Ĩ: "I",
              Ī: "I",
              Ĭ: "I",
              Į: "I",
              İ: "I",
              ĩ: "i",
              ī: "i",
              ĭ: "i",
              į: "i",
              ı: "i",
              Ĵ: "J",
              ĵ: "j",
              Ķ: "K",
              ķ: "k",
              ĸ: "k",
              Ĺ: "L",
              Ļ: "L",
              Ľ: "L",
              Ŀ: "L",
              Ł: "L",
              ĺ: "l",
              ļ: "l",
              ľ: "l",
              ŀ: "l",
              ł: "l",
              Ń: "N",
              Ņ: "N",
              Ň: "N",
              Ŋ: "N",
              ń: "n",
              ņ: "n",
              ň: "n",
              ŋ: "n",
              Ō: "O",
              Ŏ: "O",
              Ő: "O",
              ō: "o",
              ŏ: "o",
              ő: "o",
              Ŕ: "R",
              Ŗ: "R",
              Ř: "R",
              ŕ: "r",
              ŗ: "r",
              ř: "r",
              Ś: "S",
              Ŝ: "S",
              Ş: "S",
              Š: "S",
              ś: "s",
              ŝ: "s",
              ş: "s",
              š: "s",
              Ţ: "T",
              Ť: "T",
              Ŧ: "T",
              ţ: "t",
              ť: "t",
              ŧ: "t",
              Ũ: "U",
              Ū: "U",
              Ŭ: "U",
              Ů: "U",
              Ű: "U",
              Ų: "U",
              ũ: "u",
              ū: "u",
              ŭ: "u",
              ů: "u",
              ű: "u",
              ų: "u",
              Ŵ: "W",
              ŵ: "w",
              Ŷ: "Y",
              ŷ: "y",
              Ÿ: "Y",
              Ź: "Z",
              Ż: "Z",
              Ž: "Z",
              ź: "z",
              ż: "z",
              ž: "z",
              Ĳ: "IJ",
              ĳ: "ij",
              Œ: "Oe",
              œ: "oe",
              ŉ: "'n",
              ſ: "s",
            }),
            tl = T({
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&#39;",
            });

          function el(t) {
            return "\\" + _[t];
          }

          function nl(t) {
            return b.test(t);
          }

          function il(t) {
            var n = -1,
              i = Array(t.size);
            return (
              t.forEach(function (t, e) {
                i[++n] = [e, t];
              }),
              i
            );
          }

          function rl(e, n) {
            return function (t) {
              return e(n(t));
            };
          }

          function al(t, e) {
            for (var n = -1, i = t.length, r = 0, a = []; ++n < i; ) {
              var o = t[n];
              (o !== e && o !== Ja) || ((t[n] = Ja), (a[r++] = n));
            }
            return a;
          }

          function ol(t, e) {
            return "__proto__" == e ? Ha : t[e];
          }

          function sl(t) {
            var e = -1,
              n = Array(t.size);
            return (
              t.forEach(function (t) {
                n[++e] = t;
              }),
              n
            );
          }

          function ll(t) {
            return nl(t)
              ? (function (t) {
                  for (var e = (y.lastIndex = 0); y.test(t); ) ++e;
                  return e;
                })(t)
              : $(t);
          }

          function ul(t) {
            return nl(t) ? t.match(y) || [] : t.split("");
          }
          var cl = T({
              "&amp;": "&",
              "&lt;": "<",
              "&gt;": ">",
              "&quot;": '"',
              "&#39;": "'",
            }),
            hl = (function t(e) {
              var n,
                T = (e =
                  null == e ? ys : hl.defaults(ys.Object(), e, hl.pick(ys, fs)))
                  .Array,
                i = e.Date,
                r = e.Error,
                v = e.Function,
                a = e.Math,
                k = e.Object,
                g = e.RegExp,
                c = e.String,
                D = e.TypeError,
                o = T.prototype,
                s = v.prototype,
                h = k.prototype,
                l = e["__core-js_shared__"],
                u = s.toString,
                C = h.hasOwnProperty,
                f = 0,
                d = (n = /[^.]+$/.exec((l && l.keys && l.keys.IE_PROTO) || ""))
                  ? "Symbol(src)_1." + n
                  : "",
                p = h.toString,
                m = u.call(k),
                y = ys._,
                b = g(
                  "^" +
                    u
                      .call(C)
                      .replace(No, "\\$&")
                      .replace(
                        /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                        "$1.*?"
                      ) +
                    "$"
                ),
                _ = bs ? e.Buffer : Ha,
                S = e.Symbol,
                w = e.Uint8Array,
                x = _ ? _.allocUnsafe : Ha,
                E = rl(k.getPrototypeOf, k),
                $ = k.create,
                A = h.propertyIsEnumerable,
                I = o.splice,
                q = S ? S.isConcatSpreadable : Ha,
                j = S ? S.iterator : Ha,
                z = S ? S.toStringTag : Ha,
                P = (function () {
                  try {
                    var t = zn(k, "defineProperty");
                    return t({}, "", {}), t;
                  } catch (t) {}
                })(),
                O = e.clearTimeout !== ys.clearTimeout && e.clearTimeout,
                L = i && i.now !== ys.Date.now && i.now,
                B = e.setTimeout !== ys.setTimeout && e.setTimeout,
                M = a.ceil,
                F = a.floor,
                R = k.getOwnPropertySymbols,
                N = _ ? _.isBuffer : Ha,
                V = e.isFinite,
                U = o.join,
                W = rl(k.keys, k),
                G = a.max,
                Q = a.min,
                H = i.now,
                K = e.parseInt,
                Z = a.random,
                J = o.reverse,
                X = zn(e, "DataView"),
                Y = zn(e, "Map"),
                tt = zn(e, "Promise"),
                et = zn(e, "Set"),
                nt = zn(e, "WeakMap"),
                it = zn(k, "create"),
                rt = nt && new nt(),
                at = {},
                ot = si(X),
                st = si(Y),
                lt = si(tt),
                ut = si(et),
                ct = si(nt),
                ht = S ? S.prototype : Ha,
                ft = ht ? ht.valueOf : Ha,
                dt = ht ? ht.toString : Ha;

              function pt(t) {
                if (Cr(t) && !dr(t) && !(t instanceof yt)) {
                  if (t instanceof gt) return t;
                  if (C.call(t, "__wrapped__")) return li(t);
                }
                return new gt(t);
              }
              var mt = (function () {
                function n() {}
                return function (t) {
                  if (!kr(t)) return {};
                  if ($) return $(t);
                  n.prototype = t;
                  var e = new n();
                  return (n.prototype = Ha), e;
                };
              })();

              function vt() {}

              function gt(t, e) {
                (this.__wrapped__ = t),
                  (this.__actions__ = []),
                  (this.__chain__ = !!e),
                  (this.__index__ = 0),
                  (this.__values__ = Ha);
              }

              function yt(t) {
                (this.__wrapped__ = t),
                  (this.__actions__ = []),
                  (this.__dir__ = 1),
                  (this.__filtered__ = !1),
                  (this.__iteratees__ = []),
                  (this.__takeCount__ = to),
                  (this.__views__ = []);
              }

              function bt(t) {
                var e = -1,
                  n = null == t ? 0 : t.length;
                for (this.clear(); ++e < n; ) {
                  var i = t[e];
                  this.set(i[0], i[1]);
                }
              }

              function _t(t) {
                var e = -1,
                  n = null == t ? 0 : t.length;
                for (this.clear(); ++e < n; ) {
                  var i = t[e];
                  this.set(i[0], i[1]);
                }
              }

              function St(t) {
                var e = -1,
                  n = null == t ? 0 : t.length;
                for (this.clear(); ++e < n; ) {
                  var i = t[e];
                  this.set(i[0], i[1]);
                }
              }

              function wt(t) {
                var e = -1,
                  n = null == t ? 0 : t.length;
                for (this.__data__ = new St(); ++e < n; ) this.add(t[e]);
              }

              function kt(t) {
                var e = (this.__data__ = new _t(t));
                this.size = e.size;
              }

              function Ct(t, e) {
                var n = dr(t),
                  i = !n && fr(t),
                  r = !n && !i && gr(t),
                  a = !n && !i && !r && qr(t),
                  o = n || i || r || a,
                  s = o ? Qs(t.length, c) : [],
                  l = s.length;
                for (var u in t)
                  (!e && !C.call(t, u)) ||
                    (o &&
                      ("length" == u ||
                        (r && ("offset" == u || "parent" == u)) ||
                        (a &&
                          ("buffer" == u ||
                            "byteLength" == u ||
                            "byteOffset" == u)) ||
                        Rn(u, l))) ||
                    s.push(u);
                return s;
              }

              function xt(t) {
                var e = t.length;
                return e ? t[be(0, e - 1)] : Ha;
              }

              function Et(t, e, n) {
                ((n === Ha || ur(t[e], n)) && (n !== Ha || e in t)) ||
                  It(t, e, n);
              }

              function $t(t, e, n) {
                var i = t[e];
                (C.call(t, e) && ur(i, n) && (n !== Ha || e in t)) ||
                  It(t, e, n);
              }

              function Tt(t, e) {
                for (var n = t.length; n--; ) if (ur(t[n][0], e)) return n;
                return -1;
              }

              function Dt(t, i, r, a) {
                return (
                  Bt(t, function (t, e, n) {
                    i(a, t, r(t), n);
                  }),
                  a
                );
              }

              function At(t, e) {
                return t && Xe(e, ta(e), t);
              }

              function It(t, e, n) {
                "__proto__" == e && P
                  ? P(t, e, {
                      configurable: !0,
                      enumerable: !0,
                      value: n,
                      writable: !0,
                    })
                  : (t[e] = n);
              }

              function qt(t, e) {
                for (
                  var n = -1, i = e.length, r = T(i), a = null == t;
                  ++n < i;

                )
                  r[n] = a ? Ha : Kr(t, e[n]);
                return r;
              }

              function jt(t, e, n) {
                return (
                  t == t &&
                    (n !== Ha && (t = t <= n ? t : n),
                    e !== Ha && (t = e <= t ? t : e)),
                  t
                );
              }

              function zt(n, i, r, t, e, a) {
                var o,
                  s = 1 & i,
                  l = 2 & i,
                  u = 4 & i;
                if ((r && (o = e ? r(n, t, e, a) : r(n)), o !== Ha)) return o;
                if (!kr(n)) return n;
                var c,
                  h,
                  f,
                  d,
                  p,
                  m,
                  v,
                  g,
                  y = dr(n);
                if (y) {
                  if (
                    ((v = (m = n).length),
                    (g = new m.constructor(v)),
                    v &&
                      "string" == typeof m[0] &&
                      C.call(m, "index") &&
                      ((g.index = m.index), (g.input = m.input)),
                    (o = g),
                    !s)
                  )
                    return Je(n, o);
                } else {
                  var b = Ln(n),
                    _ = b == so || b == lo;
                  if (gr(n)) return We(n, s);
                  if (b == ho || b == no || (_ && !e)) {
                    if (((o = l || _ ? {} : Mn(n)), !s))
                      return l
                        ? ((f = n),
                          (d = (p = o) && Xe(n, ea(n), p)),
                          Xe(f, On(f), d))
                        : ((h = At(o, (c = n))), Xe(c, Pn(c), h));
                  } else {
                    if (!ms[b]) return e ? n : {};
                    o = (function (t, e, n) {
                      var i,
                        r,
                        a,
                        o,
                        s,
                        l = t.constructor;
                      switch (e) {
                        case yo:
                          return Ge(t);
                        case ro:
                        case ao:
                          return new l(+t);
                        case bo:
                          return (
                            (o = t),
                            (s = n ? Ge(o.buffer) : o.buffer),
                            new o.constructor(s, o.byteOffset, o.byteLength)
                          );
                        case _o:
                        case So:
                        case wo:
                        case ko:
                        case Co:
                        case xo:
                        case Eo:
                        case $o:
                        case To:
                          return Qe(t, n);
                        case uo:
                          return new l();
                        case co:
                        case mo:
                          return new l(t);
                        case fo:
                          return (
                            ((a = new (r = t).constructor(
                              r.source,
                              Yo.exec(r)
                            )).lastIndex = r.lastIndex),
                            a
                          );
                        case po:
                          return new l();
                        case vo:
                          return (i = t), ft ? k(ft.call(i)) : {};
                      }
                    })(n, b, s);
                  }
                }
                a || (a = new kt());
                var S = a.get(n);
                if (S) return S;
                if ((a.set(n, o), Dr(n)))
                  return (
                    n.forEach(function (t) {
                      o.add(zt(t, i, r, t, n, a));
                    }),
                    o
                  );
                if (xr(n))
                  return (
                    n.forEach(function (t, e) {
                      o.set(e, zt(t, i, r, e, n, a));
                    }),
                    o
                  );
                var w = y ? Ha : (u ? (l ? $n : En) : l ? ea : ta)(n);
                return (
                  Ts(w || n, function (t, e) {
                    w && (t = n[(e = t)]), $t(o, e, zt(t, i, r, e, n, a));
                  }),
                  o
                );
              }

              function Pt(t, e, n) {
                var i = n.length;
                if (null == t) return !i;
                for (t = k(t); i--; ) {
                  var r = n[i],
                    a = e[r],
                    o = t[r];
                  if ((o === Ha && !(r in t)) || !a(o)) return !1;
                }
                return !0;
              }

              function Ot(t, e, n) {
                if ("function" != typeof t) throw new D(Ka);
                return Xn(function () {
                  t.apply(Ha, n);
                }, e);
              }

              function Lt(t, e, n, i) {
                var r = -1,
                  a = Is,
                  o = !0,
                  s = t.length,
                  l = [],
                  u = e.length;
                if (!s) return l;
                n && (e = js(e, Hs(n))),
                  i
                    ? ((a = qs), (o = !1))
                    : 200 <= e.length && ((a = Zs), (o = !1), (e = new wt(e)));
                t: for (; ++r < s; ) {
                  var c = t[r],
                    h = null == n ? c : n(c);
                  if (((c = i || 0 !== c ? c : 0), o && h == h)) {
                    for (var f = u; f--; ) if (e[f] === h) continue t;
                    l.push(c);
                  } else a(e, h, i) || l.push(c);
                }
                return l;
              }
              (pt.templateSettings = {
                escape: Oo,
                evaluate: Lo,
                interpolate: Bo,
                variable: "",
                imports: {
                  _: pt,
                },
              }),
                ((pt.prototype = vt.prototype).constructor = pt),
                ((gt.prototype = mt(vt.prototype)).constructor = gt),
                ((yt.prototype = mt(vt.prototype)).constructor = yt),
                (bt.prototype.clear = function () {
                  (this.__data__ = it ? it(null) : {}), (this.size = 0);
                }),
                (bt.prototype.delete = function (t) {
                  var e = this.has(t) && delete this.__data__[t];
                  return (this.size -= e ? 1 : 0), e;
                }),
                (bt.prototype.get = function (t) {
                  var e = this.__data__;
                  if (it) {
                    var n = e[t];
                    return n === Za ? Ha : n;
                  }
                  return C.call(e, t) ? e[t] : Ha;
                }),
                (bt.prototype.has = function (t) {
                  var e = this.__data__;
                  return it ? e[t] !== Ha : C.call(e, t);
                }),
                (bt.prototype.set = function (t, e) {
                  var n = this.__data__;
                  return (
                    (this.size += this.has(t) ? 0 : 1),
                    (n[t] = it && e === Ha ? Za : e),
                    this
                  );
                }),
                (_t.prototype.clear = function () {
                  (this.__data__ = []), (this.size = 0);
                }),
                (_t.prototype.delete = function (t) {
                  var e = this.__data__,
                    n = Tt(e, t);
                  return !(
                    n < 0 ||
                    (n == e.length - 1 ? e.pop() : I.call(e, n, 1),
                    --this.size,
                    0)
                  );
                }),
                (_t.prototype.get = function (t) {
                  var e = this.__data__,
                    n = Tt(e, t);
                  return n < 0 ? Ha : e[n][1];
                }),
                (_t.prototype.has = function (t) {
                  return -1 < Tt(this.__data__, t);
                }),
                (_t.prototype.set = function (t, e) {
                  var n = this.__data__,
                    i = Tt(n, t);
                  return (
                    i < 0 ? (++this.size, n.push([t, e])) : (n[i][1] = e), this
                  );
                }),
                (St.prototype.clear = function () {
                  (this.size = 0),
                    (this.__data__ = {
                      hash: new bt(),
                      map: new (Y || _t)(),
                      string: new bt(),
                    });
                }),
                (St.prototype.delete = function (t) {
                  var e = qn(this, t).delete(t);
                  return (this.size -= e ? 1 : 0), e;
                }),
                (St.prototype.get = function (t) {
                  return qn(this, t).get(t);
                }),
                (St.prototype.has = function (t) {
                  return qn(this, t).has(t);
                }),
                (St.prototype.set = function (t, e) {
                  var n = qn(this, t),
                    i = n.size;
                  return n.set(t, e), (this.size += n.size == i ? 0 : 1), this;
                }),
                (wt.prototype.add = wt.prototype.push =
                  function (t) {
                    return this.__data__.set(t, Za), this;
                  }),
                (wt.prototype.has = function (t) {
                  return this.__data__.has(t);
                }),
                (kt.prototype.clear = function () {
                  (this.__data__ = new _t()), (this.size = 0);
                }),
                (kt.prototype.delete = function (t) {
                  var e = this.__data__,
                    n = e.delete(t);
                  return (this.size = e.size), n;
                }),
                (kt.prototype.get = function (t) {
                  return this.__data__.get(t);
                }),
                (kt.prototype.has = function (t) {
                  return this.__data__.has(t);
                }),
                (kt.prototype.set = function (t, e) {
                  var n = this.__data__;
                  if (n instanceof _t) {
                    var i = n.__data__;
                    if (!Y || i.length < 199)
                      return i.push([t, e]), (this.size = ++n.size), this;
                    n = this.__data__ = new St(i);
                  }
                  return n.set(t, e), (this.size = n.size), this;
                });
              var Bt = en(Gt),
                Mt = en(Qt, !0);

              function Ft(t, i) {
                var r = !0;
                return (
                  Bt(t, function (t, e, n) {
                    return (r = !!i(t, e, n));
                  }),
                  r
                );
              }

              function Rt(t, e, n) {
                for (var i = -1, r = t.length; ++i < r; ) {
                  var a = t[i],
                    o = e(a);
                  if (null != o && (s === Ha ? o == o && !Ir(o) : n(o, s)))
                    var s = o,
                      l = a;
                }
                return l;
              }

              function Nt(t, i) {
                var r = [];
                return (
                  Bt(t, function (t, e, n) {
                    i(t, e, n) && r.push(t);
                  }),
                  r
                );
              }

              function Vt(t, e, n, i, r) {
                var a = -1,
                  o = t.length;
                for (n || (n = Fn), r || (r = []); ++a < o; ) {
                  var s = t[a];
                  0 < e && n(s)
                    ? 1 < e
                      ? Vt(s, e - 1, n, i, r)
                      : zs(r, s)
                    : i || (r[r.length] = s);
                }
                return r;
              }
              var Ut = nn(),
                Wt = nn(!0);

              function Gt(t, e) {
                return t && Ut(t, e, ta);
              }

              function Qt(t, e) {
                return t && Wt(t, e, ta);
              }

              function Ht(e, t) {
                return As(t, function (t) {
                  return _r(e[t]);
                });
              }

              function Kt(t, e) {
                for (var n = 0, i = (e = Re(e, t)).length; null != t && n < i; )
                  t = t[oi(e[n++])];
                return n && n == i ? t : Ha;
              }

              function Zt(t, e, n) {
                var i = e(t);
                return dr(t) ? i : zs(i, n(t));
              }

              function Jt(t) {
                return null == t
                  ? t === Ha
                    ? "[object Undefined]"
                    : "[object Null]"
                  : z && z in k(t)
                  ? (function (t) {
                      var e = C.call(t, z),
                        n = t[z];
                      try {
                        t[z] = Ha;
                        var i = !0;
                      } catch (t) {}
                      var r = p.call(t);
                      return i && (e ? (t[z] = n) : delete t[z]), r;
                    })(t)
                  : ((e = t), p.call(e));
                var e;
              }

              function Xt(t, e) {
                return e < t;
              }

              function Yt(t, e) {
                return null != t && C.call(t, e);
              }

              function te(t, e) {
                return null != t && e in k(t);
              }

              function ee(t, e, n) {
                for (
                  var i = n ? qs : Is,
                    r = t[0].length,
                    a = t.length,
                    o = a,
                    s = T(a),
                    l = 1 / 0,
                    u = [];
                  o--;

                ) {
                  var c = t[o];
                  o && e && (c = js(c, Hs(e))),
                    (l = Q(c.length, l)),
                    (s[o] =
                      !n && (e || (120 <= r && 120 <= c.length))
                        ? new wt(o && c)
                        : Ha);
                }
                c = t[0];
                var h = -1,
                  f = s[0];
                t: for (; ++h < r && u.length < l; ) {
                  var d = c[h],
                    p = e ? e(d) : d;
                  if (
                    ((d = n || 0 !== d ? d : 0), !(f ? Zs(f, p) : i(u, p, n)))
                  ) {
                    for (o = a; --o; ) {
                      var m = s[o];
                      if (!(m ? Zs(m, p) : i(t[o], p, n))) continue t;
                    }
                    f && f.push(p), u.push(d);
                  }
                }
                return u;
              }

              function ne(t, e, n) {
                var i = null == (t = Zn(t, (e = Re(e, t)))) ? t : t[oi(bi(e))];
                return null == i ? Ha : Es(i, t, n);
              }

              function ie(t) {
                return Cr(t) && Jt(t) == no;
              }

              function re(t, e, n, i, r) {
                return (
                  t === e ||
                  (null == t || null == e || (!Cr(t) && !Cr(e))
                    ? t != t && e != e
                    : (function (t, e, n, i, r, a) {
                        var o = dr(t),
                          s = dr(e),
                          h = o ? io : Ln(t),
                          l = s ? io : Ln(e),
                          u = (h = h == no ? ho : h) == ho,
                          c = (l = l == no ? ho : l) == ho,
                          f = h == l;
                        if (f && gr(t)) {
                          if (!gr(e)) return !1;
                          u = !(o = !0);
                        }
                        if (f && !u)
                          return (
                            a || (a = new kt()),
                            o || qr(t)
                              ? Cn(t, e, n, i, r, a)
                              : (function (t, e, n, i, r, a, o) {
                                  switch (h) {
                                    case bo:
                                      if (
                                        t.byteLength != e.byteLength ||
                                        t.byteOffset != e.byteOffset
                                      )
                                        return !1;
                                      (t = t.buffer), (e = e.buffer);
                                    case yo:
                                      return !(
                                        t.byteLength != e.byteLength ||
                                        !a(new w(t), new w(e))
                                      );
                                    case ro:
                                    case ao:
                                    case co:
                                      return ur(+t, +e);
                                    case oo:
                                      return (
                                        t.name == e.name &&
                                        t.message == e.message
                                      );
                                    case fo:
                                    case mo:
                                      return t == e + "";
                                    case uo:
                                      var s = il;
                                    case po:
                                      var l = 1 & i;
                                      if (
                                        (s || (s = sl), t.size != e.size && !l)
                                      )
                                        return !1;
                                      var u = o.get(t);
                                      if (u) return u == e;
                                      (i |= 2), o.set(t, e);
                                      var c = Cn(s(t), s(e), i, r, a, o);
                                      return o.delete(t), c;
                                    case vo:
                                      if (ft) return ft.call(t) == ft.call(e);
                                  }
                                  return !1;
                                })(t, e, 0, n, i, r, a)
                          );
                        if (!(1 & n)) {
                          var d = u && C.call(t, "__wrapped__"),
                            p = c && C.call(e, "__wrapped__");
                          if (d || p) {
                            var m = d ? t.value() : t,
                              v = p ? e.value() : e;
                            return a || (a = new kt()), r(m, v, n, i, a);
                          }
                        }
                        return (
                          !!f &&
                          (a || (a = new kt()),
                          (function (t, e, n, i, r, a) {
                            var o = 1 & n,
                              s = En(t),
                              l = s.length;
                            if (l != En(e).length && !o) return !1;
                            for (var u = l; u--; ) {
                              var c = s[u];
                              if (!(o ? c in e : C.call(e, c))) return !1;
                            }
                            var h = a.get(t);
                            if (h && a.get(e)) return h == e;
                            var f = !0;
                            a.set(t, e), a.set(e, t);
                            for (var d = o; ++u < l; ) {
                              var p = t[(c = s[u])],
                                m = e[c];
                              if (i)
                                var v = o
                                  ? i(m, p, c, e, t, a)
                                  : i(p, m, c, t, e, a);
                              if (
                                !(v === Ha ? p === m || r(p, m, n, i, a) : v)
                              ) {
                                f = !1;
                                break;
                              }
                              d || (d = "constructor" == c);
                            }
                            if (f && !d) {
                              var g = t.constructor,
                                y = e.constructor;
                              g != y &&
                                "constructor" in t &&
                                "constructor" in e &&
                                !(
                                  "function" == typeof g &&
                                  g instanceof g &&
                                  "function" == typeof y &&
                                  y instanceof y
                                ) &&
                                (f = !1);
                            }
                            return a.delete(t), a.delete(e), f;
                          })(t, e, n, i, r, a))
                        );
                      })(t, e, n, i, re, r))
                );
              }

              function ae(t, e, n, i) {
                var r = n.length,
                  a = r,
                  o = !i;
                if (null == t) return !a;
                for (t = k(t); r--; ) {
                  var s = n[r];
                  if (o && s[2] ? s[1] !== t[s[0]] : !(s[0] in t)) return !1;
                }
                for (; ++r < a; ) {
                  var l = (s = n[r])[0],
                    u = t[l],
                    c = s[1];
                  if (o && s[2]) {
                    if (u === Ha && !(l in t)) return !1;
                  } else {
                    var h = new kt();
                    if (i) var f = i(u, c, l, t, e, h);
                    if (!(f === Ha ? re(c, u, 3, i, h) : f)) return !1;
                  }
                }
                return !0;
              }

              function oe(t) {
                return (
                  !(!kr(t) || (d && d in t)) && (_r(t) ? b : ns).test(si(t))
                );
              }

              function se(t) {
                return "function" == typeof t
                  ? t
                  : null == t
                  ? Ea
                  : "object" == typeof t
                  ? dr(t)
                    ? fe(t[0], t[1])
                    : he(t)
                  : Pa(t);
              }

              function le(t) {
                if (!Gn(t)) return W(t);
                var e = [];
                for (var n in k(t))
                  C.call(t, n) && "constructor" != n && e.push(n);
                return e;
              }

              function ue(t, e) {
                return t < e;
              }

              function ce(t, i) {
                var r = -1,
                  a = mr(t) ? T(t.length) : [];
                return (
                  Bt(t, function (t, e, n) {
                    a[++r] = i(t, e, n);
                  }),
                  a
                );
              }

              function he(e) {
                var n = jn(e);
                return 1 == n.length && n[0][2]
                  ? Hn(n[0][0], n[0][1])
                  : function (t) {
                      return t === e || ae(t, e, n);
                    };
              }

              function fe(n, i) {
                return Vn(n) && Qn(i)
                  ? Hn(oi(n), i)
                  : function (t) {
                      var e = Kr(t, n);
                      return e === Ha && e === i ? Zr(t, n) : re(i, e, 3);
                    };
              }

              function de(i, r, a, o, s) {
                i !== r &&
                  Ut(
                    r,
                    function (t, e) {
                      if (kr(t))
                        s || (s = new kt()),
                          (function (t, e, n, i, r, a, o) {
                            var s = ol(t, n),
                              l = ol(e, n),
                              u = o.get(l);
                            if (u) Et(t, n, u);
                            else {
                              var c = a ? a(s, l, n + "", t, e, o) : Ha,
                                h = c === Ha;
                              if (h) {
                                var f = dr(l),
                                  d = !f && gr(l),
                                  p = !f && !d && qr(l);
                                (c = l),
                                  f || d || p
                                    ? dr(s)
                                      ? (c = s)
                                      : vr(s)
                                      ? (c = Je(s))
                                      : d
                                      ? (c = We(l, !(h = !1)))
                                      : p
                                      ? (c = Qe(l, !(h = !1)))
                                      : (c = [])
                                    : $r(l) || fr(l)
                                    ? fr((c = s))
                                      ? (c = Fr(s))
                                      : (!kr(s) || (i && _r(s))) && (c = Mn(l))
                                    : (h = !1);
                              }
                              h && (o.set(l, c), r(c, l, i, a, o), o.delete(l)),
                                Et(t, n, c);
                            }
                          })(i, r, e, a, de, o, s);
                      else {
                        var n = o ? o(ol(i, e), t, e + "", i, r, s) : Ha;
                        n === Ha && (n = t), Et(i, e, n);
                      }
                    },
                    ea
                  );
              }

              function pe(t, e) {
                var n = t.length;
                if (n) return Rn((e += e < 0 ? n : 0), n) ? t[e] : Ha;
              }

              function me(t, i, r) {
                var a = -1;
                return (
                  (i = js(i.length ? i : [Ea], Hs(In()))),
                  (function (t, e) {
                    var n = t.length;
                    for (
                      t.sort(function (t, e) {
                        return (function (t, e, n) {
                          for (
                            var i = -1,
                              r = t.criteria,
                              a = e.criteria,
                              o = r.length,
                              s = n.length;
                            ++i < o;

                          ) {
                            var l = He(r[i], a[i]);
                            if (l) {
                              if (s <= i) return l;
                              var u = n[i];
                              return l * ("desc" == u ? -1 : 1);
                            }
                          }
                          return t.index - e.index;
                        })(t, e, r);
                      });
                      n--;

                    )
                      t[n] = t[n].value;
                    return t;
                  })(
                    ce(t, function (e, t, n) {
                      return {
                        criteria: js(i, function (t) {
                          return t(e);
                        }),
                        index: ++a,
                        value: e,
                      };
                    })
                  )
                );
              }

              function ve(t, e, n) {
                for (var i = -1, r = e.length, a = {}; ++i < r; ) {
                  var o = e[i],
                    s = Kt(t, o);
                  n(s, o) && we(a, Re(o, t), s);
                }
                return a;
              }

              function ge(t, e, n, i) {
                var r = i ? Rs : Fs,
                  a = -1,
                  o = e.length,
                  s = t;
                for (t === e && (e = Je(e)), n && (s = js(t, Hs(n))); ++a < o; )
                  for (
                    var l = 0, u = e[a], c = n ? n(u) : u;
                    -1 < (l = r(s, c, l, i));

                  )
                    s !== t && I.call(s, l, 1), I.call(t, l, 1);
                return t;
              }

              function ye(t, e) {
                for (var n = t ? e.length : 0, i = n - 1; n--; ) {
                  var r = e[n];
                  if (n == i || r !== a) {
                    var a = r;
                    Rn(r) ? I.call(t, r, 1) : je(t, r);
                  }
                }
                return t;
              }

              function be(t, e) {
                return t + F(Z() * (e - t + 1));
              }

              function _e(t, e) {
                var n = "";
                if (!t || e < 1 || Ya < e) return n;
                for (; e % 2 && (n += t), (e = F(e / 2)) && (t += t), e; );
                return n;
              }

              function Se(t, e) {
                return Yn(Kn(t, e, Ea), t + "");
              }

              function we(t, e, n, i) {
                if (!kr(t)) return t;
                for (
                  var r = -1, a = (e = Re(e, t)).length, o = a - 1, s = t;
                  null != s && ++r < a;

                ) {
                  var l = oi(e[r]),
                    u = n;
                  if (r != o) {
                    var c = s[l];
                    (u = i ? i(c, l, s) : Ha) === Ha &&
                      (u = kr(c) ? c : Rn(e[r + 1]) ? [] : {});
                  }
                  $t(s, l, u), (s = s[l]);
                }
                return t;
              }
              var ke = rt
                  ? function (t, e) {
                      return rt.set(t, e), t;
                    }
                  : Ea,
                Ce = P
                  ? function (t, e) {
                      return P(t, "toString", {
                        configurable: !0,
                        enumerable: !1,
                        value: ka(e),
                        writable: !0,
                      });
                    }
                  : Ea;

              function xe(t, e, n) {
                var i = -1,
                  r = t.length;
                e < 0 && (e = r < -e ? 0 : r + e),
                  (n = r < n ? r : n) < 0 && (n += r),
                  (r = n < e ? 0 : (n - e) >>> 0),
                  (e >>>= 0);
                for (var a = T(r); ++i < r; ) a[i] = t[i + e];
                return a;
              }

              function Ee(t, i) {
                var r;
                return (
                  Bt(t, function (t, e, n) {
                    return !(r = i(t, e, n));
                  }),
                  !!r
                );
              }

              function $e(t, e, n) {
                var i = 0,
                  r = null == t ? i : t.length;
                if ("number" == typeof e && e == e && r <= 2147483647) {
                  for (; i < r; ) {
                    var a = (i + r) >>> 1,
                      o = t[a];
                    null !== o && !Ir(o) && (n ? o <= e : o < e)
                      ? (i = a + 1)
                      : (r = a);
                  }
                  return r;
                }
                return Te(t, e, Ea, n);
              }

              function Te(t, e, n, i) {
                e = n(e);
                for (
                  var r = 0,
                    a = null == t ? 0 : t.length,
                    o = e != e,
                    s = null === e,
                    l = Ir(e),
                    u = e === Ha;
                  r < a;

                ) {
                  var c = F((r + a) / 2),
                    h = n(t[c]),
                    f = h !== Ha,
                    d = null === h,
                    p = h == h,
                    m = Ir(h);
                  if (o) var v = i || p;
                  else
                    v = u
                      ? p && (i || f)
                      : s
                      ? p && f && (i || !d)
                      : l
                      ? p && f && !d && (i || !m)
                      : !d && !m && (i ? h <= e : h < e);
                  v ? (r = c + 1) : (a = c);
                }
                return Q(a, 4294967294);
              }

              function De(t, e) {
                for (var n = -1, i = t.length, r = 0, a = []; ++n < i; ) {
                  var o = t[n],
                    s = e ? e(o) : o;
                  if (!n || !ur(s, l)) {
                    var l = s;
                    a[r++] = 0 === o ? 0 : o;
                  }
                }
                return a;
              }

              function Ae(t) {
                return "number" == typeof t ? t : Ir(t) ? NaN : +t;
              }

              function Ie(t) {
                if ("string" == typeof t) return t;
                if (dr(t)) return js(t, Ie) + "";
                if (Ir(t)) return dt ? dt.call(t) : "";
                var e = t + "";
                return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
              }

              function qe(t, e, n) {
                var i = -1,
                  r = Is,
                  a = t.length,
                  o = !0,
                  s = [],
                  l = s;
                if (n) (o = !1), (r = qs);
                else if (200 <= a) {
                  var u = e ? null : yn(t);
                  if (u) return sl(u);
                  (o = !1), (r = Zs), (l = new wt());
                } else l = e ? [] : s;
                t: for (; ++i < a; ) {
                  var c = t[i],
                    h = e ? e(c) : c;
                  if (((c = n || 0 !== c ? c : 0), o && h == h)) {
                    for (var f = l.length; f--; ) if (l[f] === h) continue t;
                    e && l.push(h), s.push(c);
                  } else r(l, h, n) || (l !== s && l.push(h), s.push(c));
                }
                return s;
              }

              function je(t, e) {
                return (
                  null == (t = Zn(t, (e = Re(e, t)))) || delete t[oi(bi(e))]
                );
              }

              function ze(t, e, n, i) {
                return we(t, e, n(Kt(t, e)), i);
              }

              function Pe(t, e, n, i) {
                for (
                  var r = t.length, a = i ? r : -1;
                  (i ? a-- : ++a < r) && e(t[a], a, t);

                );
                return n
                  ? xe(t, i ? 0 : a, i ? a + 1 : r)
                  : xe(t, i ? a + 1 : 0, i ? r : a);
              }

              function Oe(t, e) {
                var n = t;
                return (
                  n instanceof yt && (n = n.value()),
                  Ps(
                    e,
                    function (t, e) {
                      return e.func.apply(e.thisArg, zs([t], e.args));
                    },
                    n
                  )
                );
              }

              function Le(t, e, n) {
                var i = t.length;
                if (i < 2) return i ? qe(t[0]) : [];
                for (var r = -1, a = T(i); ++r < i; )
                  for (var o = t[r], s = -1; ++s < i; )
                    s != r && (a[r] = Lt(a[r] || o, t[s], e, n));
                return qe(Vt(a, 1), e, n);
              }

              function Be(t, e, n) {
                for (
                  var i = -1, r = t.length, a = e.length, o = {};
                  ++i < r;

                ) {
                  var s = i < a ? e[i] : Ha;
                  n(o, t[i], s);
                }
                return o;
              }

              function Me(t) {
                return vr(t) ? t : [];
              }

              function Fe(t) {
                return "function" == typeof t ? t : Ea;
              }

              function Re(t, e) {
                return dr(t) ? t : Vn(t, e) ? [t] : ai(Rr(t));
              }
              var Ne = Se;

              function Ve(t, e, n) {
                var i = t.length;
                return (n = n === Ha ? i : n), !e && i <= n ? t : xe(t, e, n);
              }
              var Ue =
                O ||
                function (t) {
                  return ys.clearTimeout(t);
                };

              function We(t, e) {
                if (e) return t.slice();
                var n = t.length,
                  i = x ? x(n) : new t.constructor(n);
                return t.copy(i), i;
              }

              function Ge(t) {
                var e = new t.constructor(t.byteLength);
                return new w(e).set(new w(t)), e;
              }

              function Qe(t, e) {
                var n = e ? Ge(t.buffer) : t.buffer;
                return new t.constructor(n, t.byteOffset, t.length);
              }

              function He(t, e) {
                if (t !== e) {
                  var n = t !== Ha,
                    i = null === t,
                    r = t == t,
                    a = Ir(t),
                    o = e !== Ha,
                    s = null === e,
                    l = e == e,
                    u = Ir(e);
                  if (
                    (!s && !u && !a && e < t) ||
                    (a && o && l && !s && !u) ||
                    (i && o && l) ||
                    (!n && l) ||
                    !r
                  )
                    return 1;
                  if (
                    (!i && !a && !u && t < e) ||
                    (u && n && r && !i && !a) ||
                    (s && n && r) ||
                    (!o && r) ||
                    !l
                  )
                    return -1;
                }
                return 0;
              }

              function Ke(t, e, n, i) {
                for (
                  var r = -1,
                    a = t.length,
                    o = n.length,
                    s = -1,
                    l = e.length,
                    u = G(a - o, 0),
                    c = T(l + u),
                    h = !i;
                  ++s < l;

                )
                  c[s] = e[s];
                for (; ++r < o; ) (h || r < a) && (c[n[r]] = t[r]);
                for (; u--; ) c[s++] = t[r++];
                return c;
              }

              function Ze(t, e, n, i) {
                for (
                  var r = -1,
                    a = t.length,
                    o = -1,
                    s = n.length,
                    l = -1,
                    u = e.length,
                    c = G(a - s, 0),
                    h = T(c + u),
                    f = !i;
                  ++r < c;

                )
                  h[r] = t[r];
                for (var d = r; ++l < u; ) h[d + l] = e[l];
                for (; ++o < s; ) (f || r < a) && (h[d + n[o]] = t[r++]);
                return h;
              }

              function Je(t, e) {
                var n = -1,
                  i = t.length;
                for (e || (e = T(i)); ++n < i; ) e[n] = t[n];
                return e;
              }

              function Xe(t, e, n, i) {
                var r = !n;
                n || (n = {});
                for (var a = -1, o = e.length; ++a < o; ) {
                  var s = e[a],
                    l = i ? i(n[s], t[s], s, n, t) : Ha;
                  l === Ha && (l = t[s]), r ? It(n, s, l) : $t(n, s, l);
                }
                return n;
              }

              function Ye(r, a) {
                return function (t, e) {
                  var n = dr(t) ? $s : Dt,
                    i = a ? a() : {};
                  return n(t, r, In(e, 2), i);
                };
              }

              function tn(s) {
                return Se(function (t, e) {
                  var n = -1,
                    i = e.length,
                    r = 1 < i ? e[i - 1] : Ha,
                    a = 2 < i ? e[2] : Ha;
                  for (
                    r = 3 < s.length && "function" == typeof r ? (i--, r) : Ha,
                      a && Nn(e[0], e[1], a) && ((r = i < 3 ? Ha : r), (i = 1)),
                      t = k(t);
                    ++n < i;

                  ) {
                    var o = e[n];
                    o && s(t, o, n, r);
                  }
                  return t;
                });
              }

              function en(a, o) {
                return function (t, e) {
                  if (null == t) return t;
                  if (!mr(t)) return a(t, e);
                  for (
                    var n = t.length, i = o ? n : -1, r = k(t);
                    (o ? i-- : ++i < n) && !1 !== e(r[i], i, r);

                  );
                  return t;
                };
              }

              function nn(l) {
                return function (t, e, n) {
                  for (var i = -1, r = k(t), a = n(t), o = a.length; o--; ) {
                    var s = a[l ? o : ++i];
                    if (!1 === e(r[s], s, r)) break;
                  }
                  return t;
                };
              }

              function rn(r) {
                return function (t) {
                  var e = nl((t = Rr(t))) ? ul(t) : Ha,
                    n = e ? e[0] : t.charAt(0),
                    i = e ? Ve(e, 1).join("") : t.slice(1);
                  return n[r]() + i;
                };
              }

              function an(e) {
                return function (t) {
                  return Ps(_a(fa(t).replace(ls, "")), e, "");
                };
              }

              function on(i) {
                return function () {
                  var t = arguments;
                  switch (t.length) {
                    case 0:
                      return new i();
                    case 1:
                      return new i(t[0]);
                    case 2:
                      return new i(t[0], t[1]);
                    case 3:
                      return new i(t[0], t[1], t[2]);
                    case 4:
                      return new i(t[0], t[1], t[2], t[3]);
                    case 5:
                      return new i(t[0], t[1], t[2], t[3], t[4]);
                    case 6:
                      return new i(t[0], t[1], t[2], t[3], t[4], t[5]);
                    case 7:
                      return new i(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                  }
                  var e = mt(i.prototype),
                    n = i.apply(e, t);
                  return kr(n) ? n : e;
                };
              }

              function sn(o) {
                return function (t, e, n) {
                  var i = k(t);
                  if (!mr(t)) {
                    var r = In(e, 3);
                    (t = ta(t)),
                      (e = function (t) {
                        return r(i[t], t, i);
                      });
                  }
                  var a = o(t, e, n);
                  return -1 < a ? i[r ? t[a] : a] : Ha;
                };
              }

              function ln(l) {
                return xn(function (r) {
                  var a = r.length,
                    t = a,
                    e = gt.prototype.thru;
                  for (l && r.reverse(); t--; ) {
                    var n = r[t];
                    if ("function" != typeof n) throw new D(Ka);
                    if (e && !o && "wrapper" == Dn(n)) var o = new gt([], !0);
                  }
                  for (t = o ? t : a; ++t < a; ) {
                    var i = Dn((n = r[t])),
                      s = "wrapper" == i ? Tn(n) : Ha;
                    o =
                      s && Un(s[0]) && 424 == s[1] && !s[4].length && 1 == s[9]
                        ? o[Dn(s[0])].apply(o, s[3])
                        : 1 == n.length && Un(n)
                        ? o[i]()
                        : o.thru(n);
                  }
                  return function () {
                    var t = arguments,
                      e = t[0];
                    if (o && 1 == t.length && dr(e)) return o.plant(e).value();
                    for (var n = 0, i = a ? r[n].apply(this, t) : e; ++n < a; )
                      i = r[n].call(this, i);
                    return i;
                  };
                });
              }

              function un(u, c, h, f, d, p, m, v, g, y) {
                var b = c & Xa,
                  _ = 1 & c,
                  S = 2 & c,
                  w = 24 & c,
                  k = 512 & c,
                  C = S ? Ha : on(u);
                return function t() {
                  for (var e = arguments.length, n = T(e), i = e; i--; )
                    n[i] = arguments[i];
                  if (w)
                    var r = An(t),
                      a = (function (t, e) {
                        for (var n = t.length, i = 0; n--; ) t[n] === e && ++i;
                        return i;
                      })(n, r);
                  if (
                    (f && (n = Ke(n, f, d, w)),
                    p && (n = Ze(n, p, m, w)),
                    (e -= a),
                    w && e < y)
                  ) {
                    var o = al(n, r);
                    return vn(u, c, un, t.placeholder, h, n, o, v, g, y - e);
                  }
                  var s = _ ? h : this,
                    l = S ? s[u] : u;
                  return (
                    (e = n.length),
                    v
                      ? (n = (function (t, e) {
                          for (
                            var n = t.length, i = Q(e.length, n), r = Je(t);
                            i--;

                          ) {
                            var a = e[i];
                            t[i] = Rn(a, n) ? r[a] : Ha;
                          }
                          return t;
                        })(n, v))
                      : k && 1 < e && n.reverse(),
                    b && g < e && (n.length = g),
                    this &&
                      this !== ys &&
                      this instanceof t &&
                      (l = C || on(l)),
                    l.apply(s, n)
                  );
                };
              }

              function cn(o, s) {
                return function (t, e) {
                  return (
                    (n = t),
                    (i = o),
                    (r = s(e)),
                    (a = {}),
                    Gt(n, function (t, e, n) {
                      i(a, r(t), e, n);
                    }),
                    a
                  );
                  var n, i, r, a;
                };
              }

              function hn(i, r) {
                return function (t, e) {
                  var n;
                  if (t === Ha && e === Ha) return r;
                  if ((t !== Ha && (n = t), e !== Ha)) {
                    if (n === Ha) return e;
                    "string" == typeof t || "string" == typeof e
                      ? ((t = Ie(t)), (e = Ie(e)))
                      : ((t = Ae(t)), (e = Ae(e))),
                      (n = i(t, e));
                  }
                  return n;
                };
              }

              function fn(i) {
                return xn(function (t) {
                  return (
                    (t = js(t, Hs(In()))),
                    Se(function (e) {
                      var n = this;
                      return i(t, function (t) {
                        return Es(t, n, e);
                      });
                    })
                  );
                });
              }

              function dn(t, e) {
                var n = (e = e === Ha ? " " : Ie(e)).length;
                if (n < 2) return n ? _e(e, t) : e;
                var i = _e(e, M(t / ll(e)));
                return nl(e) ? Ve(ul(i), 0, t).join("") : i.slice(0, t);
              }

              function pn(i) {
                return function (t, e, n) {
                  return (
                    n && "number" != typeof n && Nn(t, e, n) && (e = n = Ha),
                    (t = Or(t)),
                    e === Ha ? ((e = t), (t = 0)) : (e = Or(e)),
                    (function (t, e, n, i) {
                      for (
                        var r = -1, a = G(M((e - t) / (n || 1)), 0), o = T(a);
                        a--;

                      )
                        (o[i ? a : ++r] = t), (t += n);
                      return o;
                    })(t, e, (n = n === Ha ? (t < e ? 1 : -1) : Or(n)), i)
                  );
                };
              }

              function mn(n) {
                return function (t, e) {
                  return (
                    ("string" == typeof t && "string" == typeof e) ||
                      ((t = Mr(t)), (e = Mr(e))),
                    n(t, e)
                  );
                };
              }

              function vn(t, e, n, i, r, a, o, s, l, u) {
                var c = 8 & e;
                (e |= c ? 32 : 64), 4 & (e &= ~(c ? 64 : 32)) || (e &= -4);
                var h = [
                    t,
                    e,
                    r,
                    c ? a : Ha,
                    c ? o : Ha,
                    c ? Ha : a,
                    c ? Ha : o,
                    s,
                    l,
                    u,
                  ],
                  f = n.apply(Ha, h);
                return Un(t) && Jn(f, h), (f.placeholder = i), ti(f, t, e);
              }

              function gn(t) {
                var i = a[t];
                return function (t, e) {
                  if (((t = Mr(t)), (e = null == e ? 0 : Q(Lr(e), 292)))) {
                    var n = (Rr(t) + "e").split("e");
                    return +(
                      (n = (Rr(i(n[0] + "e" + (+n[1] + e))) + "e").split(
                        "e"
                      ))[0] +
                      "e" +
                      (+n[1] - e)
                    );
                  }
                  return i(t);
                };
              }
              var yn =
                et && 1 / sl(new et([, -0]))[1] == 1 / 0
                  ? function (t) {
                      return new et(t);
                    }
                  : Ia;

              function bn(o) {
                return function (t) {
                  var e,
                    n,
                    i,
                    r,
                    a = Ln(t);
                  return a == uo
                    ? il(t)
                    : a == po
                    ? ((n = t),
                      (i = -1),
                      (r = Array(n.size)),
                      n.forEach(function (t) {
                        r[++i] = [t, t];
                      }),
                      r)
                    : js(o((e = t)), function (t) {
                        return [t, e[t]];
                      });
                };
              }

              function _n(t, e, n, i, r, a, o, s) {
                var l = 2 & e;
                if (!l && "function" != typeof t) throw new D(Ka);
                var u = i ? i.length : 0;
                if (
                  (u || ((e &= -97), (i = r = Ha)),
                  (o = o === Ha ? o : G(Lr(o), 0)),
                  (s = s === Ha ? s : Lr(s)),
                  (u -= r ? r.length : 0),
                  64 & e)
                ) {
                  var c = i,
                    h = r;
                  i = r = Ha;
                }
                var f,
                  d,
                  p,
                  m,
                  v,
                  g,
                  y,
                  b,
                  _,
                  S,
                  w,
                  k,
                  C,
                  x = l ? Ha : Tn(t),
                  E = [t, e, n, i, r, c, h, a, o, s];
                if (
                  (x &&
                    (function (t, e) {
                      var n = t[1],
                        i = e[1],
                        r = n | i,
                        a = r < 131,
                        o =
                          (i == Xa && 8 == n) ||
                          (i == Xa && 256 == n && t[7].length <= e[8]) ||
                          (384 == i && e[7].length <= e[8] && 8 == n);
                      if (!a && !o) return;
                      1 & i && ((t[2] = e[2]), (r |= 1 & n ? 0 : 4));
                      var s = e[3];
                      if (s) {
                        var l = t[3];
                        (t[3] = l ? Ke(l, s, e[4]) : s),
                          (t[4] = l ? al(t[3], Ja) : e[4]);
                      }
                      (s = e[5]) &&
                        ((l = t[5]),
                        (t[5] = l ? Ze(l, s, e[6]) : s),
                        (t[6] = l ? al(t[5], Ja) : e[6])),
                        (s = e[7]) && (t[7] = s),
                        i & Xa && (t[8] = null == t[8] ? e[8] : Q(t[8], e[8])),
                        null == t[9] && (t[9] = e[9]),
                        (t[0] = e[0]),
                        (t[1] = r);
                    })(E, x),
                  (t = E[0]),
                  (e = E[1]),
                  (n = E[2]),
                  (i = E[3]),
                  (r = E[4]),
                  !(s = E[9] =
                    E[9] === Ha ? (l ? 0 : t.length) : G(E[9] - u, 0)) &&
                    24 & e &&
                    (e &= -25),
                  e && 1 != e)
                )
                  $ =
                    8 == e || 16 == e
                      ? ((w = e),
                        (k = s),
                        (C = on((S = t))),
                        function t() {
                          for (
                            var e = arguments.length,
                              n = T(e),
                              i = e,
                              r = An(t);
                            i--;

                          )
                            n[i] = arguments[i];
                          var a =
                            e < 3 && n[0] !== r && n[e - 1] !== r
                              ? []
                              : al(n, r);
                          return (e -= a.length) < k
                            ? vn(
                                S,
                                w,
                                un,
                                t.placeholder,
                                Ha,
                                n,
                                a,
                                Ha,
                                Ha,
                                k - e
                              )
                            : Es(
                                this && this !== ys && this instanceof t
                                  ? C
                                  : S,
                                this,
                                n
                              );
                        })
                      : (32 != e && 33 != e) || r.length
                      ? un.apply(Ha, E)
                      : ((g = n),
                        (y = i),
                        (b = 1 & e),
                        (_ = on((v = t))),
                        function t() {
                          for (
                            var e = -1,
                              n = arguments.length,
                              i = -1,
                              r = y.length,
                              a = T(r + n),
                              o =
                                this && this !== ys && this instanceof t
                                  ? _
                                  : v;
                            ++i < r;

                          )
                            a[i] = y[i];
                          for (; n--; ) a[i++] = arguments[++e];
                          return Es(o, b ? g : this, a);
                        });
                else
                  var $ =
                    ((d = n),
                    (p = 1 & e),
                    (m = on((f = t))),
                    function t() {
                      return (
                        this && this !== ys && this instanceof t ? m : f
                      ).apply(p ? d : this, arguments);
                    });
                return ti((x ? ke : Jn)($, E), t, e);
              }

              function Sn(t, e, n, i) {
                return t === Ha || (ur(t, h[n]) && !C.call(i, n)) ? e : t;
              }

              function wn(t, e, n, i, r, a) {
                return (
                  kr(t) &&
                    kr(e) &&
                    (a.set(e, t), de(t, e, Ha, wn, a), a.delete(e)),
                  t
                );
              }

              function kn(t) {
                return $r(t) ? Ha : t;
              }

              function Cn(t, e, n, i, r, a) {
                var o = 1 & n,
                  s = t.length,
                  l = e.length;
                if (s != l && !(o && s < l)) return !1;
                var u = a.get(t);
                if (u && a.get(e)) return u == e;
                var c = -1,
                  h = !0,
                  f = 2 & n ? new wt() : Ha;
                for (a.set(t, e), a.set(e, t); ++c < s; ) {
                  var d = t[c],
                    p = e[c];
                  if (i) var m = o ? i(p, d, c, e, t, a) : i(d, p, c, t, e, a);
                  if (m !== Ha) {
                    if (m) continue;
                    h = !1;
                    break;
                  }
                  if (f) {
                    if (
                      !Ls(e, function (t, e) {
                        if (!Zs(f, e) && (d === t || r(d, t, n, i, a)))
                          return f.push(e);
                      })
                    ) {
                      h = !1;
                      break;
                    }
                  } else if (d !== p && !r(d, p, n, i, a)) {
                    h = !1;
                    break;
                  }
                }
                return a.delete(t), a.delete(e), h;
              }

              function xn(t) {
                return Yn(Kn(t, Ha, pi), t + "");
              }

              function En(t) {
                return Zt(t, ta, Pn);
              }

              function $n(t) {
                return Zt(t, ea, On);
              }
              var Tn = rt
                ? function (t) {
                    return rt.get(t);
                  }
                : Ia;

              function Dn(t) {
                for (
                  var e = t.name + "",
                    n = at[e],
                    i = C.call(at, e) ? n.length : 0;
                  i--;

                ) {
                  var r = n[i],
                    a = r.func;
                  if (null == a || a == t) return r.name;
                }
                return e;
              }

              function An(t) {
                return (C.call(pt, "placeholder") ? pt : t).placeholder;
              }

              function In() {
                var t = pt.iteratee || $a;
                return (
                  (t = t === $a ? se : t),
                  arguments.length ? t(arguments[0], arguments[1]) : t
                );
              }

              function qn(t, e) {
                var n,
                  i,
                  r = t.__data__;
                return (
                  "string" == (i = typeof (n = e)) ||
                  "number" == i ||
                  "symbol" == i ||
                  "boolean" == i
                    ? "__proto__" !== n
                    : null === n
                )
                  ? r["string" == typeof e ? "string" : "hash"]
                  : r.map;
              }

              function jn(t) {
                for (var e = ta(t), n = e.length; n--; ) {
                  var i = e[n],
                    r = t[i];
                  e[n] = [i, r, Qn(r)];
                }
                return e;
              }

              function zn(t, e) {
                var n = null == t ? Ha : t[e];
                return oe(n) ? n : Ha;
              }
              var Pn = R
                  ? function (e) {
                      return null == e
                        ? []
                        : ((e = k(e)),
                          As(R(e), function (t) {
                            return A.call(e, t);
                          }));
                    }
                  : Ba,
                On = R
                  ? function (t) {
                      for (var e = []; t; ) zs(e, Pn(t)), (t = E(t));
                      return e;
                    }
                  : Ba,
                Ln = Jt;

              function Bn(t, e, n) {
                for (var i = -1, r = (e = Re(e, t)).length, a = !1; ++i < r; ) {
                  var o = oi(e[i]);
                  if (!(a = null != t && n(t, o))) break;
                  t = t[o];
                }
                return a || ++i != r
                  ? a
                  : !!(r = null == t ? 0 : t.length) &&
                      wr(r) &&
                      Rn(o, r) &&
                      (dr(t) || fr(t));
              }

              function Mn(t) {
                return "function" != typeof t.constructor || Gn(t)
                  ? {}
                  : mt(E(t));
              }

              function Fn(t) {
                return dr(t) || fr(t) || !!(q && t && t[q]);
              }

              function Rn(t, e) {
                var n = typeof t;
                return (
                  !!(e = null == e ? Ya : e) &&
                  ("number" == n || ("symbol" != n && rs.test(t))) &&
                  -1 < t &&
                  t % 1 == 0 &&
                  t < e
                );
              }

              function Nn(t, e, n) {
                if (!kr(n)) return !1;
                var i = typeof e;
                return (
                  !!("number" == i
                    ? mr(n) && Rn(e, n.length)
                    : "string" == i && e in n) && ur(n[e], t)
                );
              }

              function Vn(t, e) {
                if (dr(t)) return !1;
                var n = typeof t;
                return (
                  !(
                    "number" != n &&
                    "symbol" != n &&
                    "boolean" != n &&
                    null != t &&
                    !Ir(t)
                  ) ||
                  Fo.test(t) ||
                  !Mo.test(t) ||
                  (null != e && t in k(e))
                );
              }

              function Un(t) {
                var e = Dn(t),
                  n = pt[e];
                if ("function" != typeof n || !(e in yt.prototype)) return !1;
                if (t === n) return !0;
                var i = Tn(n);
                return !!i && t === i[0];
              }
              ((X && Ln(new X(new ArrayBuffer(1))) != bo) ||
                (Y && Ln(new Y()) != uo) ||
                (tt && "[object Promise]" != Ln(tt.resolve())) ||
                (et && Ln(new et()) != po) ||
                (nt && Ln(new nt()) != go)) &&
                (Ln = function (t) {
                  var e = Jt(t),
                    n = e == ho ? t.constructor : Ha,
                    i = n ? si(n) : "";
                  if (i)
                    switch (i) {
                      case ot:
                        return bo;
                      case st:
                        return uo;
                      case lt:
                        return "[object Promise]";
                      case ut:
                        return po;
                      case ct:
                        return go;
                    }
                  return e;
                });
              var Wn = l ? _r : Ma;

              function Gn(t) {
                var e = t && t.constructor;
                return t === (("function" == typeof e && e.prototype) || h);
              }

              function Qn(t) {
                return t == t && !kr(t);
              }

              function Hn(e, n) {
                return function (t) {
                  return null != t && t[e] === n && (n !== Ha || e in k(t));
                };
              }

              function Kn(a, o, s) {
                return (
                  (o = G(o === Ha ? a.length - 1 : o, 0)),
                  function () {
                    for (
                      var t = arguments,
                        e = -1,
                        n = G(t.length - o, 0),
                        i = T(n);
                      ++e < n;

                    )
                      i[e] = t[o + e];
                    e = -1;
                    for (var r = T(o + 1); ++e < o; ) r[e] = t[e];
                    return (r[o] = s(i)), Es(a, this, r);
                  }
                );
              }

              function Zn(t, e) {
                return e.length < 2 ? t : Kt(t, xe(e, 0, -1));
              }
              var Jn = ei(ke),
                Xn =
                  B ||
                  function (t, e) {
                    return ys.setTimeout(t, e);
                  },
                Yn = ei(Ce);

              function ti(t, e, n) {
                var i,
                  r,
                  a,
                  o = e + "";
                return Yn(
                  t,
                  (function (t, e) {
                    var n = e.length;
                    if (!n) return t;
                    var i = n - 1;
                    return (
                      (e[i] = (1 < n ? "& " : "") + e[i]),
                      (e = e.join(2 < n ? ", " : " ")),
                      t.replace(Qo, "{\n/* [wrapped with " + e + "] */\n")
                    );
                  })(
                    o,
                    ((a = o.match(Ho)),
                    (i = a ? a[1].split(Ko) : []),
                    (r = n),
                    Ts(eo, function (t) {
                      var e = "_." + t[0];
                      r & t[1] && !Is(i, e) && i.push(e);
                    }),
                    i.sort())
                  )
                );
              }

              function ei(n) {
                var i = 0,
                  r = 0;
                return function () {
                  var t = H(),
                    e = 16 - (t - r);
                  if (((r = t), 0 < e)) {
                    if (800 <= ++i) return arguments[0];
                  } else i = 0;
                  return n.apply(Ha, arguments);
                };
              }

              function ni(t, e) {
                var n = -1,
                  i = t.length,
                  r = i - 1;
                for (e = e === Ha ? i : e; ++n < e; ) {
                  var a = be(n, r),
                    o = t[a];
                  (t[a] = t[n]), (t[n] = o);
                }
                return (t.length = e), t;
              }
              var ii,
                ri,
                ai =
                  ((ri = (ii = ir(
                    function (t) {
                      var r = [];
                      return (
                        46 === t.charCodeAt(0) && r.push(""),
                        t.replace(Ro, function (t, e, n, i) {
                          r.push(n ? i.replace(Jo, "$1") : e || t);
                        }),
                        r
                      );
                    },
                    function (t) {
                      return 500 === ri.size && ri.clear(), t;
                    }
                  )).cache),
                  ii);

              function oi(t) {
                if ("string" == typeof t || Ir(t)) return t;
                var e = t + "";
                return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
              }

              function si(t) {
                if (null != t) {
                  try {
                    return u.call(t);
                  } catch (t) {}
                  try {
                    return t + "";
                  } catch (t) {}
                }
                return "";
              }

              function li(t) {
                if (t instanceof yt) return t.clone();
                var e = new gt(t.__wrapped__, t.__chain__);
                return (
                  (e.__actions__ = Je(t.__actions__)),
                  (e.__index__ = t.__index__),
                  (e.__values__ = t.__values__),
                  e
                );
              }
              var ui = Se(function (t, e) {
                  return vr(t) ? Lt(t, Vt(e, 1, vr, !0)) : [];
                }),
                ci = Se(function (t, e) {
                  var n = bi(e);
                  return (
                    vr(n) && (n = Ha),
                    vr(t) ? Lt(t, Vt(e, 1, vr, !0), In(n, 2)) : []
                  );
                }),
                hi = Se(function (t, e) {
                  var n = bi(e);
                  return (
                    vr(n) && (n = Ha),
                    vr(t) ? Lt(t, Vt(e, 1, vr, !0), Ha, n) : []
                  );
                });

              function fi(t, e, n) {
                var i = null == t ? 0 : t.length;
                if (!i) return -1;
                var r = null == n ? 0 : Lr(n);
                return r < 0 && (r = G(i + r, 0)), Ms(t, In(e, 3), r);
              }

              function di(t, e, n) {
                var i = null == t ? 0 : t.length;
                if (!i) return -1;
                var r = i - 1;
                return (
                  n !== Ha &&
                    ((r = Lr(n)), (r = n < 0 ? G(i + r, 0) : Q(r, i - 1))),
                  Ms(t, In(e, 3), r, !0)
                );
              }

              function pi(t) {
                return null != t && t.length ? Vt(t, 1) : [];
              }

              function mi(t) {
                return t && t.length ? t[0] : Ha;
              }
              var vi = Se(function (t) {
                  var e = js(t, Me);
                  return e.length && e[0] === t[0] ? ee(e) : [];
                }),
                gi = Se(function (t) {
                  var e = bi(t),
                    n = js(t, Me);
                  return (
                    e === bi(n) ? (e = Ha) : n.pop(),
                    n.length && n[0] === t[0] ? ee(n, In(e, 2)) : []
                  );
                }),
                yi = Se(function (t) {
                  var e = bi(t),
                    n = js(t, Me);
                  return (
                    (e = "function" == typeof e ? e : Ha) && n.pop(),
                    n.length && n[0] === t[0] ? ee(n, Ha, e) : []
                  );
                });

              function bi(t) {
                var e = null == t ? 0 : t.length;
                return e ? t[e - 1] : Ha;
              }
              var _i = Se(Si);

              function Si(t, e) {
                return t && t.length && e && e.length ? ge(t, e) : t;
              }
              var wi = xn(function (t, e) {
                var n = null == t ? 0 : t.length,
                  i = qt(t, e);
                return (
                  ye(
                    t,
                    js(e, function (t) {
                      return Rn(t, n) ? +t : t;
                    }).sort(He)
                  ),
                  i
                );
              });

              function ki(t) {
                return null == t ? t : J.call(t);
              }
              var Ci = Se(function (t) {
                  return qe(Vt(t, 1, vr, !0));
                }),
                xi = Se(function (t) {
                  var e = bi(t);
                  return vr(e) && (e = Ha), qe(Vt(t, 1, vr, !0), In(e, 2));
                }),
                Ei = Se(function (t) {
                  var e = bi(t);
                  return (
                    (e = "function" == typeof e ? e : Ha),
                    qe(Vt(t, 1, vr, !0), Ha, e)
                  );
                });

              function $i(e) {
                if (!e || !e.length) return [];
                var n = 0;
                return (
                  (e = As(e, function (t) {
                    if (vr(t)) return (n = G(t.length, n)), !0;
                  })),
                  Qs(n, function (t) {
                    return js(e, Us(t));
                  })
                );
              }

              function Ti(t, e) {
                if (!t || !t.length) return [];
                var n = $i(t);
                return null == e
                  ? n
                  : js(n, function (t) {
                      return Es(e, Ha, t);
                    });
              }
              var Di = Se(function (t, e) {
                  return vr(t) ? Lt(t, e) : [];
                }),
                Ai = Se(function (t) {
                  return Le(As(t, vr));
                }),
                Ii = Se(function (t) {
                  var e = bi(t);
                  return vr(e) && (e = Ha), Le(As(t, vr), In(e, 2));
                }),
                qi = Se(function (t) {
                  var e = bi(t);
                  return (
                    (e = "function" == typeof e ? e : Ha), Le(As(t, vr), Ha, e)
                  );
                }),
                ji = Se($i),
                zi = Se(function (t) {
                  var e = t.length,
                    n = 1 < e ? t[e - 1] : Ha;
                  return Ti(
                    t,
                    (n = "function" == typeof n ? (t.pop(), n) : Ha)
                  );
                });

              function Pi(t) {
                var e = pt(t);
                return (e.__chain__ = !0), e;
              }

              function Oi(t, e) {
                return e(t);
              }
              var Li = xn(function (e) {
                  var n = e.length,
                    t = n ? e[0] : 0,
                    i = this.__wrapped__,
                    r = function (t) {
                      return qt(t, e);
                    };
                  return !(1 < n || this.__actions__.length) &&
                    i instanceof yt &&
                    Rn(t)
                    ? ((i = i.slice(t, +t + (n ? 1 : 0))).__actions__.push({
                        func: Oi,
                        args: [r],
                        thisArg: Ha,
                      }),
                      new gt(i, this.__chain__).thru(function (t) {
                        return n && !t.length && t.push(Ha), t;
                      }))
                    : this.thru(r);
                }),
                Bi = Ye(function (t, e, n) {
                  C.call(t, n) ? ++t[n] : It(t, n, 1);
                }),
                Mi = sn(fi),
                Fi = sn(di);

              function Ri(t, e) {
                return (dr(t) ? Ts : Bt)(t, In(e, 3));
              }

              function Ni(t, e) {
                return (
                  dr(t)
                    ? function (t, e) {
                        for (
                          var n = null == t ? 0 : t.length;
                          n-- && !1 !== e(t[n], n, t);

                        );
                        return t;
                      }
                    : Mt
                )(t, In(e, 3));
              }
              var Vi = Ye(function (t, e, n) {
                  C.call(t, n) ? t[n].push(e) : It(t, n, [e]);
                }),
                Ui = Se(function (t, e, n) {
                  var i = -1,
                    r = "function" == typeof e,
                    a = mr(t) ? T(t.length) : [];
                  return (
                    Bt(t, function (t) {
                      a[++i] = r ? Es(e, t, n) : ne(t, e, n);
                    }),
                    a
                  );
                }),
                Wi = Ye(function (t, e, n) {
                  It(t, n, e);
                });

              function Gi(t, e) {
                return (dr(t) ? js : ce)(t, In(e, 3));
              }
              var Qi = Ye(
                  function (t, e, n) {
                    t[n ? 0 : 1].push(e);
                  },
                  function () {
                    return [[], []];
                  }
                ),
                Hi = Se(function (t, e) {
                  if (null == t) return [];
                  var n = e.length;
                  return (
                    1 < n && Nn(t, e[0], e[1])
                      ? (e = [])
                      : 2 < n && Nn(e[0], e[1], e[2]) && (e = [e[0]]),
                    me(t, Vt(e, 1), [])
                  );
                }),
                Ki =
                  L ||
                  function () {
                    return ys.Date.now();
                  };

              function Zi(t, e, n) {
                return (
                  (e = n ? Ha : e),
                  (e = t && null == e ? t.length : e),
                  _n(t, Xa, Ha, Ha, Ha, Ha, e)
                );
              }

              function Ji(t, e) {
                var n;
                if ("function" != typeof e) throw new D(Ka);
                return (
                  (t = Lr(t)),
                  function () {
                    return (
                      0 < --t && (n = e.apply(this, arguments)),
                      t <= 1 && (e = Ha),
                      n
                    );
                  }
                );
              }
              var Xi = Se(function (t, e, n) {
                  var i = 1;
                  if (n.length) {
                    var r = al(n, An(Xi));
                    i |= 32;
                  }
                  return _n(t, i, e, n, r);
                }),
                Yi = Se(function (t, e, n) {
                  var i = 3;
                  if (n.length) {
                    var r = al(n, An(Yi));
                    i |= 32;
                  }
                  return _n(e, i, t, n, r);
                });

              function tr(i, r, t) {
                var a,
                  o,
                  n,
                  s,
                  l,
                  u,
                  c = 0,
                  h = !1,
                  f = !1,
                  e = !0;
                if ("function" != typeof i) throw new D(Ka);

                function d(t) {
                  var e = a,
                    n = o;
                  return (a = o = Ha), (c = t), (s = i.apply(n, e));
                }

                function p(t) {
                  var e = t - u;
                  return u === Ha || r <= e || e < 0 || (f && n <= t - c);
                }

                function m() {
                  var t,
                    e = Ki();
                  if (p(e)) return v(e);
                  l = Xn(m, ((t = r - (e - u)), f ? Q(t, n - (e - c)) : t));
                }

                function v(t) {
                  return (l = Ha), e && a ? d(t) : ((a = o = Ha), s);
                }

                function g() {
                  var t,
                    e = Ki(),
                    n = p(e);
                  if (((a = arguments), (o = this), (u = e), n)) {
                    if (l === Ha)
                      return (c = t = u), (l = Xn(m, r)), h ? d(t) : s;
                    if (f) return (l = Xn(m, r)), d(u);
                  }
                  return l === Ha && (l = Xn(m, r)), s;
                }
                return (
                  (r = Mr(r) || 0),
                  kr(t) &&
                    ((h = !!t.leading),
                    (n = (f = "maxWait" in t) ? G(Mr(t.maxWait) || 0, r) : n),
                    (e = "trailing" in t ? !!t.trailing : e)),
                  (g.cancel = function () {
                    l !== Ha && Ue(l), (c = 0), (a = u = o = l = Ha);
                  }),
                  (g.flush = function () {
                    return l === Ha ? s : v(Ki());
                  }),
                  g
                );
              }
              var er = Se(function (t, e) {
                  return Ot(t, 1, e);
                }),
                nr = Se(function (t, e, n) {
                  return Ot(t, Mr(e) || 0, n);
                });

              function ir(r, a) {
                if (
                  "function" != typeof r ||
                  (null != a && "function" != typeof a)
                )
                  throw new D(Ka);
                var o = function () {
                  var t = arguments,
                    e = a ? a.apply(this, t) : t[0],
                    n = o.cache;
                  if (n.has(e)) return n.get(e);
                  var i = r.apply(this, t);
                  return (o.cache = n.set(e, i) || n), i;
                };
                return (o.cache = new (ir.Cache || St)()), o;
              }

              function rr(e) {
                if ("function" != typeof e) throw new D(Ka);
                return function () {
                  var t = arguments;
                  switch (t.length) {
                    case 0:
                      return !e.call(this);
                    case 1:
                      return !e.call(this, t[0]);
                    case 2:
                      return !e.call(this, t[0], t[1]);
                    case 3:
                      return !e.call(this, t[0], t[1], t[2]);
                  }
                  return !e.apply(this, t);
                };
              }
              ir.Cache = St;
              var ar = Ne(function (i, r) {
                  var a = (r =
                    1 == r.length && dr(r[0])
                      ? js(r[0], Hs(In()))
                      : js(Vt(r, 1), Hs(In()))).length;
                  return Se(function (t) {
                    for (var e = -1, n = Q(t.length, a); ++e < n; )
                      t[e] = r[e].call(this, t[e]);
                    return Es(i, this, t);
                  });
                }),
                or = Se(function (t, e) {
                  var n = al(e, An(or));
                  return _n(t, 32, Ha, e, n);
                }),
                sr = Se(function (t, e) {
                  var n = al(e, An(sr));
                  return _n(t, 64, Ha, e, n);
                }),
                lr = xn(function (t, e) {
                  return _n(t, 256, Ha, Ha, Ha, e);
                });

              function ur(t, e) {
                return t === e || (t != t && e != e);
              }
              var cr = mn(Xt),
                hr = mn(function (t, e) {
                  return e <= t;
                }),
                fr = ie(
                  (function () {
                    return arguments;
                  })()
                )
                  ? ie
                  : function (t) {
                      return (
                        Cr(t) && C.call(t, "callee") && !A.call(t, "callee")
                      );
                    },
                dr = T.isArray,
                pr = _s
                  ? Hs(_s)
                  : function (t) {
                      return Cr(t) && Jt(t) == yo;
                    };

              function mr(t) {
                return null != t && wr(t.length) && !_r(t);
              }

              function vr(t) {
                return Cr(t) && mr(t);
              }
              var gr = N || Ma,
                yr = Ss
                  ? Hs(Ss)
                  : function (t) {
                      return Cr(t) && Jt(t) == ao;
                    };

              function br(t) {
                if (!Cr(t)) return !1;
                var e = Jt(t);
                return (
                  e == oo ||
                  "[object DOMException]" == e ||
                  ("string" == typeof t.message &&
                    "string" == typeof t.name &&
                    !$r(t))
                );
              }

              function _r(t) {
                if (!kr(t)) return !1;
                var e = Jt(t);
                return (
                  e == so ||
                  e == lo ||
                  "[object AsyncFunction]" == e ||
                  "[object Proxy]" == e
                );
              }

              function Sr(t) {
                return "number" == typeof t && t == Lr(t);
              }

              function wr(t) {
                return "number" == typeof t && -1 < t && t % 1 == 0 && t <= Ya;
              }

              function kr(t) {
                var e = typeof t;
                return null != t && ("object" == e || "function" == e);
              }

              function Cr(t) {
                return null != t && "object" == typeof t;
              }
              var xr = ws
                ? Hs(ws)
                : function (t) {
                    return Cr(t) && Ln(t) == uo;
                  };

              function Er(t) {
                return "number" == typeof t || (Cr(t) && Jt(t) == co);
              }

              function $r(t) {
                if (!Cr(t) || Jt(t) != ho) return !1;
                var e = E(t);
                if (null === e) return !0;
                var n = C.call(e, "constructor") && e.constructor;
                return (
                  "function" == typeof n && n instanceof n && u.call(n) == m
                );
              }
              var Tr = ks
                  ? Hs(ks)
                  : function (t) {
                      return Cr(t) && Jt(t) == fo;
                    },
                Dr = Cs
                  ? Hs(Cs)
                  : function (t) {
                      return Cr(t) && Ln(t) == po;
                    };

              function Ar(t) {
                return "string" == typeof t || (!dr(t) && Cr(t) && Jt(t) == mo);
              }

              function Ir(t) {
                return "symbol" == typeof t || (Cr(t) && Jt(t) == vo);
              }
              var qr = xs
                  ? Hs(xs)
                  : function (t) {
                      return Cr(t) && wr(t.length) && !!ps[Jt(t)];
                    },
                jr = mn(ue),
                zr = mn(function (t, e) {
                  return t <= e;
                });

              function Pr(t) {
                if (!t) return [];
                if (mr(t)) return Ar(t) ? ul(t) : Je(t);
                if (j && t[j])
                  return (function (t) {
                    for (var e, n = []; !(e = t.next()).done; ) n.push(e.value);
                    return n;
                  })(t[j]());
                var e = Ln(t);
                return (e == uo ? il : e == po ? sl : ua)(t);
              }

              function Or(t) {
                return t
                  ? (t = Mr(t)) === 1 / 0 || t === -1 / 0
                    ? 17976931348623157e292 * (t < 0 ? -1 : 1)
                    : t == t
                    ? t
                    : 0
                  : 0 === t
                  ? t
                  : 0;
              }

              function Lr(t) {
                var e = Or(t),
                  n = e % 1;
                return e == e ? (n ? e - n : e) : 0;
              }

              function Br(t) {
                return t ? jt(Lr(t), 0, to) : 0;
              }

              function Mr(t) {
                if ("number" == typeof t) return t;
                if (Ir(t)) return NaN;
                if (kr(t)) {
                  var e = "function" == typeof t.valueOf ? t.valueOf() : t;
                  t = kr(e) ? e + "" : e;
                }
                if ("string" != typeof t) return 0 === t ? t : +t;
                t = t.replace(Uo, "");
                var n = es.test(t);
                return n || is.test(t)
                  ? gs(t.slice(2), n ? 2 : 8)
                  : ts.test(t)
                  ? NaN
                  : +t;
              }

              function Fr(t) {
                return Xe(t, ea(t));
              }

              function Rr(t) {
                return null == t ? "" : Ie(t);
              }
              var Nr = tn(function (t, e) {
                  if (Gn(e) || mr(e)) Xe(e, ta(e), t);
                  else for (var n in e) C.call(e, n) && $t(t, n, e[n]);
                }),
                Vr = tn(function (t, e) {
                  Xe(e, ea(e), t);
                }),
                Ur = tn(function (t, e, n, i) {
                  Xe(e, ea(e), t, i);
                }),
                Wr = tn(function (t, e, n, i) {
                  Xe(e, ta(e), t, i);
                }),
                Gr = xn(qt),
                Qr = Se(function (t, e) {
                  t = k(t);
                  var n = -1,
                    i = e.length,
                    r = 2 < i ? e[2] : Ha;
                  for (r && Nn(e[0], e[1], r) && (i = 1); ++n < i; )
                    for (
                      var a = e[n], o = ea(a), s = -1, l = o.length;
                      ++s < l;

                    ) {
                      var u = o[s],
                        c = t[u];
                      (c === Ha || (ur(c, h[u]) && !C.call(t, u))) &&
                        (t[u] = a[u]);
                    }
                  return t;
                }),
                Hr = Se(function (t) {
                  return t.push(Ha, wn), Es(ia, Ha, t);
                });

              function Kr(t, e, n) {
                var i = null == t ? Ha : Kt(t, e);
                return i === Ha ? n : i;
              }

              function Zr(t, e) {
                return null != t && Bn(t, e, te);
              }
              var Jr = cn(function (t, e, n) {
                  null != e &&
                    "function" != typeof e.toString &&
                    (e = p.call(e)),
                    (t[e] = n);
                }, ka(Ea)),
                Xr = cn(function (t, e, n) {
                  null != e &&
                    "function" != typeof e.toString &&
                    (e = p.call(e)),
                    C.call(t, e) ? t[e].push(n) : (t[e] = [n]);
                }, In),
                Yr = Se(ne);

              function ta(t) {
                return mr(t) ? Ct(t) : le(t);
              }

              function ea(t) {
                return mr(t)
                  ? Ct(t, !0)
                  : (function (t) {
                      if (!kr(t))
                        return (function (t) {
                          var e = [];
                          if (null != t) for (var n in k(t)) e.push(n);
                          return e;
                        })(t);
                      var e = Gn(t),
                        n = [];
                      for (var i in t)
                        ("constructor" != i || (!e && C.call(t, i))) &&
                          n.push(i);
                      return n;
                    })(t);
              }
              var na = tn(function (t, e, n) {
                  de(t, e, n);
                }),
                ia = tn(function (t, e, n, i) {
                  de(t, e, n, i);
                }),
                ra = xn(function (e, t) {
                  var n = {};
                  if (null == e) return n;
                  var i = !1;
                  (t = js(t, function (t) {
                    return (t = Re(t, e)), i || (i = 1 < t.length), t;
                  })),
                    Xe(e, $n(e), n),
                    i && (n = zt(n, 7, kn));
                  for (var r = t.length; r--; ) je(n, t[r]);
                  return n;
                }),
                aa = xn(function (t, e) {
                  return null == t
                    ? {}
                    : ve((n = t), e, function (t, e) {
                        return Zr(n, e);
                      });
                  var n;
                });

              function oa(t, n) {
                if (null == t) return {};
                var e = js($n(t), function (t) {
                  return [t];
                });
                return (
                  (n = In(n)),
                  ve(t, e, function (t, e) {
                    return n(t, e[0]);
                  })
                );
              }
              var sa = bn(ta),
                la = bn(ea);

              function ua(t) {
                return null == t ? [] : Ks(t, ta(t));
              }
              var ca = an(function (t, e, n) {
                return (e = e.toLowerCase()), t + (n ? ha(e) : e);
              });

              function ha(t) {
                return ba(Rr(t).toLowerCase());
              }

              function fa(t) {
                return (t = Rr(t)) && t.replace(as, Ys).replace(us, "");
              }
              var da = an(function (t, e, n) {
                  return t + (n ? "-" : "") + e.toLowerCase();
                }),
                pa = an(function (t, e, n) {
                  return t + (n ? " " : "") + e.toLowerCase();
                }),
                ma = rn("toLowerCase"),
                va = an(function (t, e, n) {
                  return t + (n ? "_" : "") + e.toLowerCase();
                }),
                ga = an(function (t, e, n) {
                  return t + (n ? " " : "") + ba(e);
                }),
                ya = an(function (t, e, n) {
                  return t + (n ? " " : "") + e.toUpperCase();
                }),
                ba = rn("toUpperCase");

              function _a(t, e, n) {
                return (
                  (t = Rr(t)),
                  (e = n ? Ha : e) === Ha
                    ? ((i = t),
                      hs.test(i) ? t.match(cs) || [] : t.match(Zo) || [])
                    : t.match(e) || []
                );
                var i;
              }
              var Sa = Se(function (t, e) {
                  try {
                    return Es(t, Ha, e);
                  } catch (t) {
                    return br(t) ? t : new r(t);
                  }
                }),
                wa = xn(function (e, t) {
                  return (
                    Ts(t, function (t) {
                      (t = oi(t)), It(e, t, Xi(e[t], e));
                    }),
                    e
                  );
                });

              function ka(t) {
                return function () {
                  return t;
                };
              }
              var Ca = ln(),
                xa = ln(!0);

              function Ea(t) {
                return t;
              }

              function $a(t) {
                return se("function" == typeof t ? t : zt(t, 1));
              }
              var Ta = Se(function (e, n) {
                  return function (t) {
                    return ne(t, e, n);
                  };
                }),
                Da = Se(function (e, n) {
                  return function (t) {
                    return ne(e, t, n);
                  };
                });

              function Aa(i, e, t) {
                var n = ta(e),
                  r = Ht(e, n);
                null != t ||
                  (kr(e) && (r.length || !n.length)) ||
                  ((t = e), (e = i), (i = this), (r = Ht(e, ta(e))));
                var a = !(kr(t) && "chain" in t && !t.chain),
                  o = _r(i);
                return (
                  Ts(r, function (t) {
                    var n = e[t];
                    (i[t] = n),
                      o &&
                        (i.prototype[t] = function () {
                          var t = this.__chain__;
                          if (a || t) {
                            var e = i(this.__wrapped__);
                            return (
                              (e.__actions__ = Je(this.__actions__)).push({
                                func: n,
                                args: arguments,
                                thisArg: i,
                              }),
                              (e.__chain__ = t),
                              e
                            );
                          }
                          return n.apply(i, zs([this.value()], arguments));
                        });
                  }),
                  i
                );
              }

              function Ia() {}
              var qa = fn(js),
                ja = fn(Ds),
                za = fn(Ls);

              function Pa(t) {
                return Vn(t)
                  ? Us(oi(t))
                  : ((e = t),
                    function (t) {
                      return Kt(t, e);
                    });
                var e;
              }
              var Oa = pn(),
                La = pn(!0);

              function Ba() {
                return [];
              }

              function Ma() {
                return !1;
              }
              var Fa,
                Ra = hn(function (t, e) {
                  return t + e;
                }, 0),
                Na = gn("ceil"),
                Va = hn(function (t, e) {
                  return t / e;
                }, 1),
                Ua = gn("floor"),
                Wa = hn(function (t, e) {
                  return t * e;
                }, 1),
                Ga = gn("round"),
                Qa = hn(function (t, e) {
                  return t - e;
                }, 0);
              return (
                (pt.after = function (t, e) {
                  if ("function" != typeof e) throw new D(Ka);
                  return (
                    (t = Lr(t)),
                    function () {
                      if (--t < 1) return e.apply(this, arguments);
                    }
                  );
                }),
                (pt.ary = Zi),
                (pt.assign = Nr),
                (pt.assignIn = Vr),
                (pt.assignInWith = Ur),
                (pt.assignWith = Wr),
                (pt.at = Gr),
                (pt.before = Ji),
                (pt.bind = Xi),
                (pt.bindAll = wa),
                (pt.bindKey = Yi),
                (pt.castArray = function () {
                  if (!arguments.length) return [];
                  var t = arguments[0];
                  return dr(t) ? t : [t];
                }),
                (pt.chain = Pi),
                (pt.chunk = function (t, e, n) {
                  e = (n ? Nn(t, e, n) : e === Ha) ? 1 : G(Lr(e), 0);
                  var i = null == t ? 0 : t.length;
                  if (!i || e < 1) return [];
                  for (var r = 0, a = 0, o = T(M(i / e)); r < i; )
                    o[a++] = xe(t, r, (r += e));
                  return o;
                }),
                (pt.compact = function (t) {
                  for (
                    var e = -1, n = null == t ? 0 : t.length, i = 0, r = [];
                    ++e < n;

                  ) {
                    var a = t[e];
                    a && (r[i++] = a);
                  }
                  return r;
                }),
                (pt.concat = function () {
                  var t = arguments.length;
                  if (!t) return [];
                  for (var e = T(t - 1), n = arguments[0], i = t; i--; )
                    e[i - 1] = arguments[i];
                  return zs(dr(n) ? Je(n) : [n], Vt(e, 1));
                }),
                (pt.cond = function (i) {
                  var r = null == i ? 0 : i.length,
                    e = In();
                  return (
                    (i = r
                      ? js(i, function (t) {
                          if ("function" != typeof t[1]) throw new D(Ka);
                          return [e(t[0]), t[1]];
                        })
                      : []),
                    Se(function (t) {
                      for (var e = -1; ++e < r; ) {
                        var n = i[e];
                        if (Es(n[0], this, t)) return Es(n[1], this, t);
                      }
                    })
                  );
                }),
                (pt.conforms = function (t) {
                  return (
                    (e = zt(t, 1)),
                    (n = ta(e)),
                    function (t) {
                      return Pt(t, e, n);
                    }
                  );
                  var e, n;
                }),
                (pt.constant = ka),
                (pt.countBy = Bi),
                (pt.create = function (t, e) {
                  var n = mt(t);
                  return null == e ? n : At(n, e);
                }),
                (pt.curry = function t(e, n, i) {
                  var r = _n(e, 8, Ha, Ha, Ha, Ha, Ha, (n = i ? Ha : n));
                  return (r.placeholder = t.placeholder), r;
                }),
                (pt.curryRight = function t(e, n, i) {
                  var r = _n(e, 16, Ha, Ha, Ha, Ha, Ha, (n = i ? Ha : n));
                  return (r.placeholder = t.placeholder), r;
                }),
                (pt.debounce = tr),
                (pt.defaults = Qr),
                (pt.defaultsDeep = Hr),
                (pt.defer = er),
                (pt.delay = nr),
                (pt.difference = ui),
                (pt.differenceBy = ci),
                (pt.differenceWith = hi),
                (pt.drop = function (t, e, n) {
                  var i = null == t ? 0 : t.length;
                  return i
                    ? xe(t, (e = n || e === Ha ? 1 : Lr(e)) < 0 ? 0 : e, i)
                    : [];
                }),
                (pt.dropRight = function (t, e, n) {
                  var i = null == t ? 0 : t.length;
                  return i
                    ? xe(
                        t,
                        0,
                        (e = i - (e = n || e === Ha ? 1 : Lr(e))) < 0 ? 0 : e
                      )
                    : [];
                }),
                (pt.dropRightWhile = function (t, e) {
                  return t && t.length ? Pe(t, In(e, 3), !0, !0) : [];
                }),
                (pt.dropWhile = function (t, e) {
                  return t && t.length ? Pe(t, In(e, 3), !0) : [];
                }),
                (pt.fill = function (t, e, n, i) {
                  var r = null == t ? 0 : t.length;
                  return r
                    ? (n &&
                        "number" != typeof n &&
                        Nn(t, e, n) &&
                        ((n = 0), (i = r)),
                      (function (t, e, n, i) {
                        var r = t.length;
                        for (
                          (n = Lr(n)) < 0 && (n = r < -n ? 0 : r + n),
                            (i = i === Ha || r < i ? r : Lr(i)) < 0 && (i += r),
                            i = i < n ? 0 : Br(i);
                          n < i;

                        )
                          t[n++] = e;
                        return t;
                      })(t, e, n, i))
                    : [];
                }),
                (pt.filter = function (t, e) {
                  return (dr(t) ? As : Nt)(t, In(e, 3));
                }),
                (pt.flatMap = function (t, e) {
                  return Vt(Gi(t, e), 1);
                }),
                (pt.flatMapDeep = function (t, e) {
                  return Vt(Gi(t, e), 1 / 0);
                }),
                (pt.flatMapDepth = function (t, e, n) {
                  return (n = n === Ha ? 1 : Lr(n)), Vt(Gi(t, e), n);
                }),
                (pt.flatten = pi),
                (pt.flattenDeep = function (t) {
                  return null != t && t.length ? Vt(t, 1 / 0) : [];
                }),
                (pt.flattenDepth = function (t, e) {
                  return null != t && t.length
                    ? Vt(t, (e = e === Ha ? 1 : Lr(e)))
                    : [];
                }),
                (pt.flip = function (t) {
                  return _n(t, 512);
                }),
                (pt.flow = Ca),
                (pt.flowRight = xa),
                (pt.fromPairs = function (t) {
                  for (
                    var e = -1, n = null == t ? 0 : t.length, i = {};
                    ++e < n;

                  ) {
                    var r = t[e];
                    i[r[0]] = r[1];
                  }
                  return i;
                }),
                (pt.functions = function (t) {
                  return null == t ? [] : Ht(t, ta(t));
                }),
                (pt.functionsIn = function (t) {
                  return null == t ? [] : Ht(t, ea(t));
                }),
                (pt.groupBy = Vi),
                (pt.initial = function (t) {
                  return null != t && t.length ? xe(t, 0, -1) : [];
                }),
                (pt.intersection = vi),
                (pt.intersectionBy = gi),
                (pt.intersectionWith = yi),
                (pt.invert = Jr),
                (pt.invertBy = Xr),
                (pt.invokeMap = Ui),
                (pt.iteratee = $a),
                (pt.keyBy = Wi),
                (pt.keys = ta),
                (pt.keysIn = ea),
                (pt.map = Gi),
                (pt.mapKeys = function (t, i) {
                  var r = {};
                  return (
                    (i = In(i, 3)),
                    Gt(t, function (t, e, n) {
                      It(r, i(t, e, n), t);
                    }),
                    r
                  );
                }),
                (pt.mapValues = function (t, i) {
                  var r = {};
                  return (
                    (i = In(i, 3)),
                    Gt(t, function (t, e, n) {
                      It(r, e, i(t, e, n));
                    }),
                    r
                  );
                }),
                (pt.matches = function (t) {
                  return he(zt(t, 1));
                }),
                (pt.matchesProperty = function (t, e) {
                  return fe(t, zt(e, 1));
                }),
                (pt.memoize = ir),
                (pt.merge = na),
                (pt.mergeWith = ia),
                (pt.method = Ta),
                (pt.methodOf = Da),
                (pt.mixin = Aa),
                (pt.negate = rr),
                (pt.nthArg = function (e) {
                  return (
                    (e = Lr(e)),
                    Se(function (t) {
                      return pe(t, e);
                    })
                  );
                }),
                (pt.omit = ra),
                (pt.omitBy = function (t, e) {
                  return oa(t, rr(In(e)));
                }),
                (pt.once = function (t) {
                  return Ji(2, t);
                }),
                (pt.orderBy = function (t, e, n, i) {
                  return null == t
                    ? []
                    : (dr(e) || (e = null == e ? [] : [e]),
                      dr((n = i ? Ha : n)) || (n = null == n ? [] : [n]),
                      me(t, e, n));
                }),
                (pt.over = qa),
                (pt.overArgs = ar),
                (pt.overEvery = ja),
                (pt.overSome = za),
                (pt.partial = or),
                (pt.partialRight = sr),
                (pt.partition = Qi),
                (pt.pick = aa),
                (pt.pickBy = oa),
                (pt.property = Pa),
                (pt.propertyOf = function (e) {
                  return function (t) {
                    return null == e ? Ha : Kt(e, t);
                  };
                }),
                (pt.pull = _i),
                (pt.pullAll = Si),
                (pt.pullAllBy = function (t, e, n) {
                  return t && t.length && e && e.length
                    ? ge(t, e, In(n, 2))
                    : t;
                }),
                (pt.pullAllWith = function (t, e, n) {
                  return t && t.length && e && e.length ? ge(t, e, Ha, n) : t;
                }),
                (pt.pullAt = wi),
                (pt.range = Oa),
                (pt.rangeRight = La),
                (pt.rearg = lr),
                (pt.reject = function (t, e) {
                  return (dr(t) ? As : Nt)(t, rr(In(e, 3)));
                }),
                (pt.remove = function (t, e) {
                  var n = [];
                  if (!t || !t.length) return n;
                  var i = -1,
                    r = [],
                    a = t.length;
                  for (e = In(e, 3); ++i < a; ) {
                    var o = t[i];
                    e(o, i, t) && (n.push(o), r.push(i));
                  }
                  return ye(t, r), n;
                }),
                (pt.rest = function (t, e) {
                  if ("function" != typeof t) throw new D(Ka);
                  return Se(t, (e = e === Ha ? e : Lr(e)));
                }),
                (pt.reverse = ki),
                (pt.sampleSize = function (t, e, n) {
                  return (
                    (e = (n ? Nn(t, e, n) : e === Ha) ? 1 : Lr(e)),
                    (dr(t)
                      ? function (t, e) {
                          return ni(Je(t), jt(e, 0, t.length));
                        }
                      : function (t, e) {
                          var n = ua(t);
                          return ni(n, jt(e, 0, n.length));
                        })(t, e)
                  );
                }),
                (pt.set = function (t, e, n) {
                  return null == t ? t : we(t, e, n);
                }),
                (pt.setWith = function (t, e, n, i) {
                  return (
                    (i = "function" == typeof i ? i : Ha),
                    null == t ? t : we(t, e, n, i)
                  );
                }),
                (pt.shuffle = function (t) {
                  return (
                    dr(t)
                      ? function (t) {
                          return ni(Je(t));
                        }
                      : function (t) {
                          return ni(ua(t));
                        }
                  )(t);
                }),
                (pt.slice = function (t, e, n) {
                  var i = null == t ? 0 : t.length;
                  return i
                    ? (n && "number" != typeof n && Nn(t, e, n)
                        ? ((e = 0), (n = i))
                        : ((e = null == e ? 0 : Lr(e)),
                          (n = n === Ha ? i : Lr(n))),
                      xe(t, e, n))
                    : [];
                }),
                (pt.sortBy = Hi),
                (pt.sortedUniq = function (t) {
                  return t && t.length ? De(t) : [];
                }),
                (pt.sortedUniqBy = function (t, e) {
                  return t && t.length ? De(t, In(e, 2)) : [];
                }),
                (pt.split = function (t, e, n) {
                  return (
                    n && "number" != typeof n && Nn(t, e, n) && (e = n = Ha),
                    (n = n === Ha ? to : n >>> 0)
                      ? (t = Rr(t)) &&
                        ("string" == typeof e || (null != e && !Tr(e))) &&
                        !(e = Ie(e)) &&
                        nl(t)
                        ? Ve(ul(t), 0, n)
                        : t.split(e, n)
                      : []
                  );
                }),
                (pt.spread = function (i, r) {
                  if ("function" != typeof i) throw new D(Ka);
                  return (
                    (r = null == r ? 0 : G(Lr(r), 0)),
                    Se(function (t) {
                      var e = t[r],
                        n = Ve(t, 0, r);
                      return e && zs(n, e), Es(i, this, n);
                    })
                  );
                }),
                (pt.tail = function (t) {
                  var e = null == t ? 0 : t.length;
                  return e ? xe(t, 1, e) : [];
                }),
                (pt.take = function (t, e, n) {
                  return t && t.length
                    ? xe(t, 0, (e = n || e === Ha ? 1 : Lr(e)) < 0 ? 0 : e)
                    : [];
                }),
                (pt.takeRight = function (t, e, n) {
                  var i = null == t ? 0 : t.length;
                  return i
                    ? xe(
                        t,
                        (e = i - (e = n || e === Ha ? 1 : Lr(e))) < 0 ? 0 : e,
                        i
                      )
                    : [];
                }),
                (pt.takeRightWhile = function (t, e) {
                  return t && t.length ? Pe(t, In(e, 3), !1, !0) : [];
                }),
                (pt.takeWhile = function (t, e) {
                  return t && t.length ? Pe(t, In(e, 3)) : [];
                }),
                (pt.tap = function (t, e) {
                  return e(t), t;
                }),
                (pt.throttle = function (t, e, n) {
                  var i = !0,
                    r = !0;
                  if ("function" != typeof t) throw new D(Ka);
                  return (
                    kr(n) &&
                      ((i = "leading" in n ? !!n.leading : i),
                      (r = "trailing" in n ? !!n.trailing : r)),
                    tr(t, e, {
                      leading: i,
                      maxWait: e,
                      trailing: r,
                    })
                  );
                }),
                (pt.thru = Oi),
                (pt.toArray = Pr),
                (pt.toPairs = sa),
                (pt.toPairsIn = la),
                (pt.toPath = function (t) {
                  return dr(t) ? js(t, oi) : Ir(t) ? [t] : Je(ai(Rr(t)));
                }),
                (pt.toPlainObject = Fr),
                (pt.transform = function (t, i, r) {
                  var e = dr(t),
                    n = e || gr(t) || qr(t);
                  if (((i = In(i, 4)), null == r)) {
                    var a = t && t.constructor;
                    r = n ? (e ? new a() : []) : kr(t) && _r(a) ? mt(E(t)) : {};
                  }
                  return (
                    (n ? Ts : Gt)(t, function (t, e, n) {
                      return i(r, t, e, n);
                    }),
                    r
                  );
                }),
                (pt.unary = function (t) {
                  return Zi(t, 1);
                }),
                (pt.union = Ci),
                (pt.unionBy = xi),
                (pt.unionWith = Ei),
                (pt.uniq = function (t) {
                  return t && t.length ? qe(t) : [];
                }),
                (pt.uniqBy = function (t, e) {
                  return t && t.length ? qe(t, In(e, 2)) : [];
                }),
                (pt.uniqWith = function (t, e) {
                  return (
                    (e = "function" == typeof e ? e : Ha),
                    t && t.length ? qe(t, Ha, e) : []
                  );
                }),
                (pt.unset = function (t, e) {
                  return null == t || je(t, e);
                }),
                (pt.unzip = $i),
                (pt.unzipWith = Ti),
                (pt.update = function (t, e, n) {
                  return null == t ? t : ze(t, e, Fe(n));
                }),
                (pt.updateWith = function (t, e, n, i) {
                  return (
                    (i = "function" == typeof i ? i : Ha),
                    null == t ? t : ze(t, e, Fe(n), i)
                  );
                }),
                (pt.values = ua),
                (pt.valuesIn = function (t) {
                  return null == t ? [] : Ks(t, ea(t));
                }),
                (pt.without = Di),
                (pt.words = _a),
                (pt.wrap = function (t, e) {
                  return or(Fe(e), t);
                }),
                (pt.xor = Ai),
                (pt.xorBy = Ii),
                (pt.xorWith = qi),
                (pt.zip = ji),
                (pt.zipObject = function (t, e) {
                  return Be(t || [], e || [], $t);
                }),
                (pt.zipObjectDeep = function (t, e) {
                  return Be(t || [], e || [], we);
                }),
                (pt.zipWith = zi),
                (pt.entries = sa),
                (pt.entriesIn = la),
                (pt.extend = Vr),
                (pt.extendWith = Ur),
                Aa(pt, pt),
                (pt.add = Ra),
                (pt.attempt = Sa),
                (pt.camelCase = ca),
                (pt.capitalize = ha),
                (pt.ceil = Na),
                (pt.clamp = function (t, e, n) {
                  return (
                    n === Ha && ((n = e), (e = Ha)),
                    n !== Ha && (n = (n = Mr(n)) == n ? n : 0),
                    e !== Ha && (e = (e = Mr(e)) == e ? e : 0),
                    jt(Mr(t), e, n)
                  );
                }),
                (pt.clone = function (t) {
                  return zt(t, 4);
                }),
                (pt.cloneDeep = function (t) {
                  return zt(t, 5);
                }),
                (pt.cloneDeepWith = function (t, e) {
                  return zt(t, 5, (e = "function" == typeof e ? e : Ha));
                }),
                (pt.cloneWith = function (t, e) {
                  return zt(t, 4, (e = "function" == typeof e ? e : Ha));
                }),
                (pt.conformsTo = function (t, e) {
                  return null == e || Pt(t, e, ta(e));
                }),
                (pt.deburr = fa),
                (pt.defaultTo = function (t, e) {
                  return null == t || t != t ? e : t;
                }),
                (pt.divide = Va),
                (pt.endsWith = function (t, e, n) {
                  (t = Rr(t)), (e = Ie(e));
                  var i = t.length,
                    r = (n = n === Ha ? i : jt(Lr(n), 0, i));
                  return 0 <= (n -= e.length) && t.slice(n, r) == e;
                }),
                (pt.eq = ur),
                (pt.escape = function (t) {
                  return (t = Rr(t)) && Po.test(t) ? t.replace(jo, tl) : t;
                }),
                (pt.escapeRegExp = function (t) {
                  return (t = Rr(t)) && Vo.test(t) ? t.replace(No, "\\$&") : t;
                }),
                (pt.every = function (t, e, n) {
                  var i = dr(t) ? Ds : Ft;
                  return n && Nn(t, e, n) && (e = Ha), i(t, In(e, 3));
                }),
                (pt.find = Mi),
                (pt.findIndex = fi),
                (pt.findKey = function (t, e) {
                  return Bs(t, In(e, 3), Gt);
                }),
                (pt.findLast = Fi),
                (pt.findLastIndex = di),
                (pt.findLastKey = function (t, e) {
                  return Bs(t, In(e, 3), Qt);
                }),
                (pt.floor = Ua),
                (pt.forEach = Ri),
                (pt.forEachRight = Ni),
                (pt.forIn = function (t, e) {
                  return null == t ? t : Ut(t, In(e, 3), ea);
                }),
                (pt.forInRight = function (t, e) {
                  return null == t ? t : Wt(t, In(e, 3), ea);
                }),
                (pt.forOwn = function (t, e) {
                  return t && Gt(t, In(e, 3));
                }),
                (pt.forOwnRight = function (t, e) {
                  return t && Qt(t, In(e, 3));
                }),
                (pt.get = Kr),
                (pt.gt = cr),
                (pt.gte = hr),
                (pt.has = function (t, e) {
                  return null != t && Bn(t, e, Yt);
                }),
                (pt.hasIn = Zr),
                (pt.head = mi),
                (pt.identity = Ea),
                (pt.includes = function (t, e, n, i) {
                  (t = mr(t) ? t : ua(t)), (n = n && !i ? Lr(n) : 0);
                  var r = t.length;
                  return (
                    n < 0 && (n = G(r + n, 0)),
                    Ar(t)
                      ? n <= r && -1 < t.indexOf(e, n)
                      : !!r && -1 < Fs(t, e, n)
                  );
                }),
                (pt.indexOf = function (t, e, n) {
                  var i = null == t ? 0 : t.length;
                  if (!i) return -1;
                  var r = null == n ? 0 : Lr(n);
                  return r < 0 && (r = G(i + r, 0)), Fs(t, e, r);
                }),
                (pt.inRange = function (t, e, n) {
                  return (
                    (e = Or(e)),
                    n === Ha ? ((n = e), (e = 0)) : (n = Or(n)),
                    (i = t = Mr(t)) >= Q((r = e), (a = n)) && i < G(r, a)
                  );
                  var i, r, a;
                }),
                (pt.invoke = Yr),
                (pt.isArguments = fr),
                (pt.isArray = dr),
                (pt.isArrayBuffer = pr),
                (pt.isArrayLike = mr),
                (pt.isArrayLikeObject = vr),
                (pt.isBoolean = function (t) {
                  return !0 === t || !1 === t || (Cr(t) && Jt(t) == ro);
                }),
                (pt.isBuffer = gr),
                (pt.isDate = yr),
                (pt.isElement = function (t) {
                  return Cr(t) && 1 === t.nodeType && !$r(t);
                }),
                (pt.isEmpty = function (t) {
                  if (null == t) return !0;
                  if (
                    mr(t) &&
                    (dr(t) ||
                      "string" == typeof t ||
                      "function" == typeof t.splice ||
                      gr(t) ||
                      qr(t) ||
                      fr(t))
                  )
                    return !t.length;
                  var e = Ln(t);
                  if (e == uo || e == po) return !t.size;
                  if (Gn(t)) return !le(t).length;
                  for (var n in t) if (C.call(t, n)) return !1;
                  return !0;
                }),
                (pt.isEqual = function (t, e) {
                  return re(t, e);
                }),
                (pt.isEqualWith = function (t, e, n) {
                  var i = (n = "function" == typeof n ? n : Ha) ? n(t, e) : Ha;
                  return i === Ha ? re(t, e, Ha, n) : !!i;
                }),
                (pt.isError = br),
                (pt.isFinite = function (t) {
                  return "number" == typeof t && V(t);
                }),
                (pt.isFunction = _r),
                (pt.isInteger = Sr),
                (pt.isLength = wr),
                (pt.isMap = xr),
                (pt.isMatch = function (t, e) {
                  return t === e || ae(t, e, jn(e));
                }),
                (pt.isMatchWith = function (t, e, n) {
                  return (
                    (n = "function" == typeof n ? n : Ha), ae(t, e, jn(e), n)
                  );
                }),
                (pt.isNaN = function (t) {
                  return Er(t) && t != +t;
                }),
                (pt.isNative = function (t) {
                  if (Wn(t))
                    throw new r(
                      "Unsupported core-js use. Try https://npms.io/search?q=ponyfill."
                    );
                  return oe(t);
                }),
                (pt.isNil = function (t) {
                  return null == t;
                }),
                (pt.isNull = function (t) {
                  return null === t;
                }),
                (pt.isNumber = Er),
                (pt.isObject = kr),
                (pt.isObjectLike = Cr),
                (pt.isPlainObject = $r),
                (pt.isRegExp = Tr),
                (pt.isSafeInteger = function (t) {
                  return Sr(t) && -Ya <= t && t <= Ya;
                }),
                (pt.isSet = Dr),
                (pt.isString = Ar),
                (pt.isSymbol = Ir),
                (pt.isTypedArray = qr),
                (pt.isUndefined = function (t) {
                  return t === Ha;
                }),
                (pt.isWeakMap = function (t) {
                  return Cr(t) && Ln(t) == go;
                }),
                (pt.isWeakSet = function (t) {
                  return Cr(t) && "[object WeakSet]" == Jt(t);
                }),
                (pt.join = function (t, e) {
                  return null == t ? "" : U.call(t, e);
                }),
                (pt.kebabCase = da),
                (pt.last = bi),
                (pt.lastIndexOf = function (t, e, n) {
                  var i = null == t ? 0 : t.length;
                  if (!i) return -1;
                  var r = i;
                  return (
                    n !== Ha &&
                      (r = (r = Lr(n)) < 0 ? G(i + r, 0) : Q(r, i - 1)),
                    e == e
                      ? (function (t, e, n) {
                          for (var i = r + 1; i--; ) if (t[i] === e) return i;
                          return i;
                        })(t, e)
                      : Ms(t, Ns, r, !0)
                  );
                }),
                (pt.lowerCase = pa),
                (pt.lowerFirst = ma),
                (pt.lt = jr),
                (pt.lte = zr),
                (pt.max = function (t) {
                  return t && t.length ? Rt(t, Ea, Xt) : Ha;
                }),
                (pt.maxBy = function (t, e) {
                  return t && t.length ? Rt(t, In(e, 2), Xt) : Ha;
                }),
                (pt.mean = function (t) {
                  return Vs(t, Ea);
                }),
                (pt.meanBy = function (t, e) {
                  return Vs(t, In(e, 2));
                }),
                (pt.min = function (t) {
                  return t && t.length ? Rt(t, Ea, ue) : Ha;
                }),
                (pt.minBy = function (t, e) {
                  return t && t.length ? Rt(t, In(e, 2), ue) : Ha;
                }),
                (pt.stubArray = Ba),
                (pt.stubFalse = Ma),
                (pt.stubObject = function () {
                  return {};
                }),
                (pt.stubString = function () {
                  return "";
                }),
                (pt.stubTrue = function () {
                  return !0;
                }),
                (pt.multiply = Wa),
                (pt.nth = function (t, e) {
                  return t && t.length ? pe(t, Lr(e)) : Ha;
                }),
                (pt.noConflict = function () {
                  return ys._ === this && (ys._ = y), this;
                }),
                (pt.noop = Ia),
                (pt.now = Ki),
                (pt.pad = function (t, e, n) {
                  t = Rr(t);
                  var i = (e = Lr(e)) ? ll(t) : 0;
                  if (!e || e <= i) return t;
                  var r = (e - i) / 2;
                  return dn(F(r), n) + t + dn(M(r), n);
                }),
                (pt.padEnd = function (t, e, n) {
                  t = Rr(t);
                  var i = (e = Lr(e)) ? ll(t) : 0;
                  return e && i < e ? t + dn(e - i, n) : t;
                }),
                (pt.padStart = function (t, e, n) {
                  t = Rr(t);
                  var i = (e = Lr(e)) ? ll(t) : 0;
                  return e && i < e ? dn(e - i, n) + t : t;
                }),
                (pt.parseInt = function (t, e, n) {
                  return (
                    n || null == e ? (e = 0) : e && (e = +e),
                    K(Rr(t).replace(Wo, ""), e || 0)
                  );
                }),
                (pt.random = function (t, e, n) {
                  if (
                    (n && "boolean" != typeof n && Nn(t, e, n) && (e = n = Ha),
                    n === Ha &&
                      ("boolean" == typeof e
                        ? ((n = e), (e = Ha))
                        : "boolean" == typeof t && ((n = t), (t = Ha))),
                    t === Ha && e === Ha
                      ? ((t = 0), (e = 1))
                      : ((t = Or(t)),
                        e === Ha ? ((e = t), (t = 0)) : (e = Or(e))),
                    e < t)
                  ) {
                    var i = t;
                    (t = e), (e = i);
                  }
                  if (n || t % 1 || e % 1) {
                    var r = Z();
                    return Q(
                      t + r * (e - t + vs("1e-" + ((r + "").length - 1))),
                      e
                    );
                  }
                  return be(t, e);
                }),
                (pt.reduce = function (t, e, n) {
                  var i = dr(t) ? Ps : Ws,
                    r = arguments.length < 3;
                  return i(t, In(e, 4), n, r, Bt);
                }),
                (pt.reduceRight = function (t, e, n) {
                  var i = dr(t) ? Os : Ws,
                    r = arguments.length < 3;
                  return i(t, In(e, 4), n, r, Mt);
                }),
                (pt.repeat = function (t, e, n) {
                  return (
                    (e = (n ? Nn(t, e, n) : e === Ha) ? 1 : Lr(e)), _e(Rr(t), e)
                  );
                }),
                (pt.replace = function () {
                  var t = arguments,
                    e = Rr(t[0]);
                  return t.length < 3 ? e : e.replace(t[1], t[2]);
                }),
                (pt.result = function (t, e, n) {
                  var i = -1,
                    r = (e = Re(e, t)).length;
                  for (r || ((r = 1), (t = Ha)); ++i < r; ) {
                    var a = null == t ? Ha : t[oi(e[i])];
                    a === Ha && ((i = r), (a = n)), (t = _r(a) ? a.call(t) : a);
                  }
                  return t;
                }),
                (pt.round = Ga),
                (pt.runInContext = t),
                (pt.sample = function (t) {
                  return (
                    dr(t)
                      ? xt
                      : function (t) {
                          return xt(ua(t));
                        }
                  )(t);
                }),
                (pt.size = function (t) {
                  if (null == t) return 0;
                  if (mr(t)) return Ar(t) ? ll(t) : t.length;
                  var e = Ln(t);
                  return e == uo || e == po ? t.size : le(t).length;
                }),
                (pt.snakeCase = va),
                (pt.some = function (t, e, n) {
                  var i = dr(t) ? Ls : Ee;
                  return n && Nn(t, e, n) && (e = Ha), i(t, In(e, 3));
                }),
                (pt.sortedIndex = function (t, e) {
                  return $e(t, e);
                }),
                (pt.sortedIndexBy = function (t, e, n) {
                  return Te(t, e, In(n, 2));
                }),
                (pt.sortedIndexOf = function (t, e) {
                  var n = null == t ? 0 : t.length;
                  if (n) {
                    var i = $e(t, e);
                    if (i < n && ur(t[i], e)) return i;
                  }
                  return -1;
                }),
                (pt.sortedLastIndex = function (t, e) {
                  return $e(t, e, !0);
                }),
                (pt.sortedLastIndexBy = function (t, e, n) {
                  return Te(t, e, In(n, 2), !0);
                }),
                (pt.sortedLastIndexOf = function (t, e) {
                  if (null != t && t.length) {
                    var n = $e(t, e, !0) - 1;
                    if (ur(t[n], e)) return n;
                  }
                  return -1;
                }),
                (pt.startCase = ga),
                (pt.startsWith = function (t, e, n) {
                  return (
                    (t = Rr(t)),
                    (n = null == n ? 0 : jt(Lr(n), 0, t.length)),
                    (e = Ie(e)),
                    t.slice(n, n + e.length) == e
                  );
                }),
                (pt.subtract = Qa),
                (pt.sum = function (t) {
                  return t && t.length ? Gs(t, Ea) : 0;
                }),
                (pt.sumBy = function (t, e) {
                  return t && t.length ? Gs(t, In(e, 2)) : 0;
                }),
                (pt.template = function (o, t, e) {
                  var n = pt.templateSettings;
                  e && Nn(o, t, e) && (t = Ha),
                    (o = Rr(o)),
                    (t = Ur({}, t, n, Sn));
                  var s,
                    l,
                    i = Ur({}, t.imports, n.imports, Sn),
                    r = ta(i),
                    a = Ks(i, r),
                    u = 0,
                    c = t.interpolate || os,
                    h = "__p += '",
                    f = g(
                      (t.escape || os).source +
                        "|" +
                        c.source +
                        "|" +
                        (c === Bo ? Xo : os).source +
                        "|" +
                        (t.evaluate || os).source +
                        "|$",
                      "g"
                    ),
                    d =
                      "//# sourceURL=" +
                      ("sourceURL" in t
                        ? t.sourceURL
                        : "lodash.templateSources[" + ++ds + "]") +
                      "\n";
                  o.replace(f, function (t, e, n, i, r, a) {
                    return (
                      n || (n = i),
                      (h += o.slice(u, a).replace(ss, el)),
                      e && ((s = !0), (h += "' +\n__e(" + e + ") +\n'")),
                      r && ((l = !0), (h += "';\n" + r + ";\n__p += '")),
                      n &&
                        (h +=
                          "' +\n((__t = (" + n + ")) == null ? '' : __t) +\n'"),
                      (u = a + t.length),
                      t
                    );
                  }),
                    (h += "';\n");
                  var p = t.variable;
                  p || (h = "with (obj) {\n" + h + "\n}\n"),
                    (h = (l ? h.replace(Do, "") : h)
                      .replace(Ao, "$1")
                      .replace(Io, "$1;")),
                    (h =
                      "function(" +
                      (p || "obj") +
                      ") {\n" +
                      (p ? "" : "obj || (obj = {});\n") +
                      "var __t, __p = ''" +
                      (s ? ", __e = _.escape" : "") +
                      (l
                        ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n"
                        : ";\n") +
                      h +
                      "return __p\n}");
                  var m = Sa(function () {
                    return v(r, d + "return " + h).apply(Ha, a);
                  });
                  if (((m.source = h), br(m))) throw m;
                  return m;
                }),
                (pt.times = function (t, e) {
                  if ((t = Lr(t)) < 1 || Ya < t) return [];
                  var n = to,
                    i = Q(t, to);
                  (e = In(e)), (t -= to);
                  for (var r = Qs(i, e); ++n < t; ) e(n);
                  return r;
                }),
                (pt.toFinite = Or),
                (pt.toInteger = Lr),
                (pt.toLength = Br),
                (pt.toLower = function (t) {
                  return Rr(t).toLowerCase();
                }),
                (pt.toNumber = Mr),
                (pt.toSafeInteger = function (t) {
                  return t ? jt(Lr(t), -Ya, Ya) : 0 === t ? t : 0;
                }),
                (pt.toString = Rr),
                (pt.toUpper = function (t) {
                  return Rr(t).toUpperCase();
                }),
                (pt.trim = function (t, e, n) {
                  if ((t = Rr(t)) && (n || e === Ha)) return t.replace(Uo, "");
                  if (!t || !(e = Ie(e))) return t;
                  var i = ul(t),
                    r = ul(e);
                  return Ve(i, Js(i, r), Xs(i, r) + 1).join("");
                }),
                (pt.trimEnd = function (t, e, n) {
                  if ((t = Rr(t)) && (n || e === Ha)) return t.replace(Go, "");
                  if (!t || !(e = Ie(e))) return t;
                  var i = ul(t);
                  return Ve(i, 0, Xs(i, ul(e)) + 1).join("");
                }),
                (pt.trimStart = function (t, e, n) {
                  if ((t = Rr(t)) && (n || e === Ha)) return t.replace(Wo, "");
                  if (!t || !(e = Ie(e))) return t;
                  var i = ul(t);
                  return Ve(i, Js(i, ul(e))).join("");
                }),
                (pt.truncate = function (t, e) {
                  var n = 30,
                    i = "...";
                  if (kr(e)) {
                    var r = "separator" in e ? e.separator : r;
                    (n = "length" in e ? Lr(e.length) : n),
                      (i = "omission" in e ? Ie(e.omission) : i);
                  }
                  var a = (t = Rr(t)).length;
                  if (nl(t)) {
                    var o = ul(t);
                    a = o.length;
                  }
                  if (a <= n) return t;
                  var s = n - ll(i);
                  if (s < 1) return i;
                  var l = o ? Ve(o, 0, s).join("") : t.slice(0, s);
                  if (r === Ha) return l + i;
                  if ((o && (s += l.length - s), Tr(r))) {
                    if (t.slice(s).search(r)) {
                      var u,
                        c = l;
                      for (
                        r.global || (r = g(r.source, Rr(Yo.exec(r)) + "g")),
                          r.lastIndex = 0;
                        (u = r.exec(c));

                      )
                        var h = u.index;
                      l = l.slice(0, h === Ha ? s : h);
                    }
                  } else if (t.indexOf(Ie(r), s) != s) {
                    var f = l.lastIndexOf(r);
                    -1 < f && (l = l.slice(0, f));
                  }
                  return l + i;
                }),
                (pt.unescape = function (t) {
                  return (t = Rr(t)) && zo.test(t) ? t.replace(qo, cl) : t;
                }),
                (pt.uniqueId = function (t) {
                  var e = ++f;
                  return Rr(t) + e;
                }),
                (pt.upperCase = ya),
                (pt.upperFirst = ba),
                (pt.each = Ri),
                (pt.eachRight = Ni),
                (pt.first = mi),
                Aa(
                  pt,
                  ((Fa = {}),
                  Gt(pt, function (t, e) {
                    C.call(pt.prototype, e) || (Fa[e] = t);
                  }),
                  Fa),
                  {
                    chain: !1,
                  }
                ),
                (pt.VERSION = "4.17.10"),
                Ts(
                  [
                    "bind",
                    "bindKey",
                    "curry",
                    "curryRight",
                    "partial",
                    "partialRight",
                  ],
                  function (t) {
                    pt[t].placeholder = pt;
                  }
                ),
                Ts(["drop", "take"], function (n, i) {
                  (yt.prototype[n] = function (t) {
                    t = t === Ha ? 1 : G(Lr(t), 0);
                    var e =
                      this.__filtered__ && !i ? new yt(this) : this.clone();
                    return (
                      e.__filtered__
                        ? (e.__takeCount__ = Q(t, e.__takeCount__))
                        : e.__views__.push({
                            size: Q(t, to),
                            type: n + (e.__dir__ < 0 ? "Right" : ""),
                          }),
                      e
                    );
                  }),
                    (yt.prototype[n + "Right"] = function (t) {
                      return this.reverse()[n](t).reverse();
                    });
                }),
                Ts(["filter", "map", "takeWhile"], function (t, e) {
                  var n = e + 1,
                    i = 1 == n || 3 == n;
                  yt.prototype[t] = function (t) {
                    var e = this.clone();
                    return (
                      e.__iteratees__.push({
                        iteratee: In(t, 3),
                        type: n,
                      }),
                      (e.__filtered__ = e.__filtered__ || i),
                      e
                    );
                  };
                }),
                Ts(["head", "last"], function (t, e) {
                  var n = "take" + (e ? "Right" : "");
                  yt.prototype[t] = function () {
                    return this[n](1).value()[0];
                  };
                }),
                Ts(["initial", "tail"], function (t, e) {
                  var n = "drop" + (e ? "" : "Right");
                  yt.prototype[t] = function () {
                    return this.__filtered__ ? new yt(this) : this[n](1);
                  };
                }),
                (yt.prototype.compact = function () {
                  return this.filter(Ea);
                }),
                (yt.prototype.find = function (t) {
                  return this.filter(t).head();
                }),
                (yt.prototype.findLast = function (t) {
                  return this.reverse().find(t);
                }),
                (yt.prototype.invokeMap = Se(function (e, n) {
                  return "function" == typeof e
                    ? new yt(this)
                    : this.map(function (t) {
                        return ne(t, e, n);
                      });
                })),
                (yt.prototype.reject = function (t) {
                  return this.filter(rr(In(t)));
                }),
                (yt.prototype.slice = function (t, e) {
                  t = Lr(t);
                  var n = this;
                  return n.__filtered__ && (0 < t || e < 0)
                    ? new yt(n)
                    : (t < 0 ? (n = n.takeRight(-t)) : t && (n = n.drop(t)),
                      e !== Ha &&
                        (n = (e = Lr(e)) < 0 ? n.dropRight(-e) : n.take(e - t)),
                      n);
                }),
                (yt.prototype.takeRightWhile = function (t) {
                  return this.reverse().takeWhile(t).reverse();
                }),
                (yt.prototype.toArray = function () {
                  return this.take(to);
                }),
                Gt(yt.prototype, function (h, t) {
                  var f = /^(?:filter|find|map|reject)|While$/.test(t),
                    d = /^(?:head|last)$/.test(t),
                    p = pt[d ? "take" + ("last" == t ? "Right" : "") : t],
                    m = d || /^find/.test(t);
                  p &&
                    (pt.prototype[t] = function () {
                      var t = this.__wrapped__,
                        n = d ? [1] : arguments,
                        e = t instanceof yt,
                        i = n[0],
                        r = e || dr(t),
                        a = function (t) {
                          var e = p.apply(pt, zs([t], n));
                          return d && o ? e[0] : e;
                        };
                      r &&
                        f &&
                        "function" == typeof i &&
                        1 != i.length &&
                        (e = r = !1);
                      var o = this.__chain__,
                        s = !!this.__actions__.length,
                        l = m && !o,
                        u = e && !s;
                      if (!m && r) {
                        t = u ? t : new yt(this);
                        var c = h.apply(t, n);
                        return (
                          c.__actions__.push({
                            func: Oi,
                            args: [a],
                            thisArg: Ha,
                          }),
                          new gt(c, o)
                        );
                      }
                      return l && u
                        ? h.apply(this, n)
                        : ((c = this.thru(a)),
                          l ? (d ? c.value()[0] : c.value()) : c);
                    });
                }),
                Ts(
                  ["pop", "push", "shift", "sort", "splice", "unshift"],
                  function (t) {
                    var n = o[t],
                      i = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru",
                      r = /^(?:pop|shift)$/.test(t);
                    pt.prototype[t] = function () {
                      var e = arguments;
                      if (r && !this.__chain__) {
                        var t = this.value();
                        return n.apply(dr(t) ? t : [], e);
                      }
                      return this[i](function (t) {
                        return n.apply(dr(t) ? t : [], e);
                      });
                    };
                  }
                ),
                Gt(yt.prototype, function (t, e) {
                  var n = pt[e];
                  if (n) {
                    var i = n.name + "";
                    (at[i] || (at[i] = [])).push({
                      name: e,
                      func: n,
                    });
                  }
                }),
                (at[un(Ha, 2).name] = [
                  {
                    name: "wrapper",
                    func: Ha,
                  },
                ]),
                (yt.prototype.clone = function () {
                  var t = new yt(this.__wrapped__);
                  return (
                    (t.__actions__ = Je(this.__actions__)),
                    (t.__dir__ = this.__dir__),
                    (t.__filtered__ = this.__filtered__),
                    (t.__iteratees__ = Je(this.__iteratees__)),
                    (t.__takeCount__ = this.__takeCount__),
                    (t.__views__ = Je(this.__views__)),
                    t
                  );
                }),
                (yt.prototype.reverse = function () {
                  if (this.__filtered__) {
                    var t = new yt(this);
                    (t.__dir__ = -1), (t.__filtered__ = !0);
                  } else (t = this.clone()).__dir__ *= -1;
                  return t;
                }),
                (yt.prototype.value = function () {
                  var t = this.__wrapped__.value(),
                    e = this.__dir__,
                    n = dr(t),
                    i = e < 0,
                    r = n ? t.length : 0,
                    a = (function (t, e, n) {
                      for (var i = -1, r = n.length; ++i < r; ) {
                        var a = n[i],
                          o = a.size;
                        switch (a.type) {
                          case "drop":
                            t += o;
                            break;
                          case "dropRight":
                            e -= o;
                            break;
                          case "take":
                            e = Q(e, t + o);
                            break;
                          case "takeRight":
                            t = G(t, e - o);
                        }
                      }
                      return {
                        start: t,
                        end: e,
                      };
                    })(0, r, this.__views__),
                    o = a.start,
                    s = a.end,
                    l = s - o,
                    u = i ? s : o - 1,
                    c = this.__iteratees__,
                    h = c.length,
                    f = 0,
                    d = Q(l, this.__takeCount__);
                  if (!n || (!i && r == l && d == l))
                    return Oe(t, this.__actions__);
                  var p = [];
                  t: for (; l-- && f < d; ) {
                    for (var m = -1, v = t[(u += e)]; ++m < h; ) {
                      var g = c[m],
                        y = g.iteratee,
                        b = g.type,
                        _ = y(v);
                      if (2 == b) v = _;
                      else if (!_) {
                        if (1 == b) continue t;
                        break t;
                      }
                    }
                    p[f++] = v;
                  }
                  return p;
                }),
                (pt.prototype.at = Li),
                (pt.prototype.chain = function () {
                  return Pi(this);
                }),
                (pt.prototype.commit = function () {
                  return new gt(this.value(), this.__chain__);
                }),
                (pt.prototype.next = function () {
                  this.__values__ === Ha &&
                    (this.__values__ = Pr(this.value()));
                  var t = this.__index__ >= this.__values__.length;
                  return {
                    done: t,
                    value: t ? Ha : this.__values__[this.__index__++],
                  };
                }),
                (pt.prototype.plant = function (t) {
                  for (var e, n = this; n instanceof vt; ) {
                    var i = li(n);
                    (i.__index__ = 0),
                      (i.__values__ = Ha),
                      e ? (r.__wrapped__ = i) : (e = i);
                    var r = i;
                    n = n.__wrapped__;
                  }
                  return (r.__wrapped__ = t), e;
                }),
                (pt.prototype.reverse = function () {
                  var t = this.__wrapped__;
                  if (t instanceof yt) {
                    var e = t;
                    return (
                      this.__actions__.length && (e = new yt(this)),
                      (e = e.reverse()).__actions__.push({
                        func: Oi,
                        args: [ki],
                        thisArg: Ha,
                      }),
                      new gt(e, this.__chain__)
                    );
                  }
                  return this.thru(ki);
                }),
                (pt.prototype.toJSON =
                  pt.prototype.valueOf =
                  pt.prototype.value =
                    function () {
                      return Oe(this.__wrapped__, this.__actions__);
                    }),
                (pt.prototype.first = pt.prototype.head),
                j &&
                  (pt.prototype[j] = function () {
                    return this;
                  }),
                pt
              );
            })();
          (ys._ = hl),
            (I = function () {
              return hl;
            }.call(q, j, q, A)) === Ha || (A.exports = I);
        }).call(this);
      }).call(q, j(11), j(12)(t));
    },
    function (t, e) {
      t.exports = {
        isFunction: function (t) {
          return "function" == typeof t;
        },
        isArray: function (t) {
          return "[object Array]" === Object.prototype.toString.apply(t);
        },
        each: function (t, e) {
          for (var n = 0, i = t.length; n < i && !1 !== e(t[n], n); n++);
        },
      };
    },
    function (t, e, n) {
      n(16), n(36), (t.exports = n(37));
    },
    function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", {
        value: !0,
      });
      var i = n(0),
        l = n.n(i),
        r = (n(17), n(18)),
        a = n.n(r),
        o = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var s = (function () {
        function n(t) {
          !(function (t, e) {
            if (!(t instanceof n))
              throw new TypeError("Cannot call a class as a function");
          })(this),
            (this.carousel = t.carouselSelector),
            (this.cells = t.cellSelector || l()(t.container).find(this.cells)),
            (this.cellAlign = t.cellAlign || "left"),
            (this.prevNextButtons = t.prevNextButtons || !1),
            (this.pageDots = t.pageDots || !1),
            (this.autoPlay = t.autoPlay || !1),
            (this.limit = t.limit || 1),
            (this.callback = t.callback),
            (this.flkty = {}),
            this.init();
        }
        return (
          o(n, [
            {
              key: "init",
              value: function () {
                this.constructCarouselEvents(),
                  this.executeCallback(this.callback);
              },
            },
            {
              key: "constructCarouselEvents",
              value: function () {
                var autoPlayVar = 0;
                if (document.getElementById("autoPlay") !== null) {
                  autoPlayVar = 1;
                }
                if (!(l()(this.cells).length <= this.limit)) {
                  var t = document.querySelector(this.carousel);
                  var el = $(t);
                  this.flkty = new a.a(t, {
                    cellSelector: this.cells,
                    imagesLoaded: !0,
                    wrapAround: !0,
                    cellAlign: this.cellAlign,
                    prevNextButtons: this.prevNextButtons,
                    pageDots: this.pageDots,
                    autoPlay:
                      el.hasClass("usp-bar__carousel") ||
                      el.hasClass("slideshow__carousel") ||
                      autoPlayVar,
                    arrowShape:
                      "M39.8 10.1L3 48.8l36.8 41.1 10.1-10-18.7-22.4H97V40.7H31.2l18.7-20.6z",
                  });
                }
              },
            },
            {
              key: "executeCallback",
              value: function (t) {
                t && t(this);
              },
            },
            {
              key: "destroy",
              value: function () {
                // this.flkty && this.flkty.destroy()
              },
            },
          ]),
          n
        );
      })();
      l()(document).ready(function () {
        if (
          document.querySelectorAll('[data-section-type="slideshow-section"]')
        ) {
          var t = document.querySelectorAll(
              '[data-section-type="slideshow-section"]'
            ),
            n = {};
          !(function () {
            if ("function" == typeof NodeList.prototype.forEach) return;
            NodeList.prototype.forEach = Array.prototype.forEach;
          })(),
            t.forEach(function (t, e) {
              n[e] = new s({
                carouselSelector: "#" + t.id + " .slideshow__carousel",
                cellSelector: ".slideshow__slide",
                prevNextButtons: !0,
                pageDots: !0,
              });
            });
        }
      }),
        l()(document).ready(function () {
          var t = l()("#AddressNewForm");
          t.length &&
            (Shopify &&
              new Shopify.CountryProvinceSelector(
                "AddressCountryNew",
                "AddressProvinceNew",
                {
                  hideElement: "AddressProvinceContainerNew",
                }
              ),
            l()(".address-country-option").each(function () {
              var t = l()(this).data("form-id"),
                e = "AddressCountry_" + t,
                n = "AddressProvince_" + t,
                i = "AddressProvinceContainer_" + t;
              new Shopify.CountryProvinceSelector(e, n, {
                hideElement: i,
              });
            }),
            l()(".address-new-toggle").on("click", function () {
              t.toggleClass("is-hidden");
            }),
            l()(".address-edit-toggle").on("click", function (t) {
              t.preventDefault();
              var e = l()(this).data("form-id");
              l()("#EditAddress_" + e).toggleClass("is-hidden");
            }),
            l()(".address-delete").on("click", function () {
              var t = l()(this),
                e = t.data("form-id"),
                n = t.data("confirm-message");
              window.confirm(
                n || "Are you sure you wish to delete this address?"
              ) &&
                Shopify.postLink("/account/addresses/" + e, {
                  parameters: {
                    _method: "delete",
                  },
                });
            }));
        });
      var u = "#RecoverPassword";

      function c(t) {
        t.preventDefault(), h();
      }

      function h() {
        l()("#RecoverPasswordForm").toggleClass("hide"),
          l()("#CustomerLoginForm").toggleClass("hide");
      }
      l()(u).length &&
        ("#recover" === window.location.hash && h(),
        l()(".reset-password-success").length &&
          l()("#ResetSuccess").removeClass("hide"),
        l()(u).on("click", c),
        l()("#HideRecoverPasswordLink").on("click", c));
      var f = n(9),
        d = n.n(f),
        p = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();

      function m(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      var v = (function () {
          function t() {
            m(this, t), (this.listeners = new Map());
          }
          return (
            p(t, [
              {
                key: "addListener",
                value: function (t, e) {
                  this.listeners.has(t) || this.listeners.set(t, []),
                    this.listeners.get(t).push(e);
                },
              },
              {
                key: "removeListener",
                value: function (t, i) {
                  var e = this.listeners.get(t),
                    n = void 0;
                  return (
                    !!(
                      e &&
                      e.length &&
                      -1 <
                        (n = e.reduce(function (t, e, n) {
                          return "function" == typeof e && e === i
                            ? (t = n)
                            : t;
                        }, -1))
                    ) && (e.splice(n, 1), this.listeners.set(t, e), !0)
                  );
                },
              },
              {
                key: "emit",
                value: function (t) {
                  for (
                    var e = arguments.length,
                      n = Array(1 < e ? e - 1 : 0),
                      i = 1;
                    i < e;
                    i++
                  )
                    n[i - 1] = arguments[i];
                  var r = this.listeners.get(t);
                  return !(
                    !r ||
                    !r.length ||
                    (r.forEach(function (t) {
                      t.apply(void 0, n);
                    }),
                    0)
                  );
                },
              },
            ]),
            t
          );
        })(),
        g =
          (p(
            function t(e, n) {
              var i = this;
              m(this, t),
                (this.id = e),
                (this.subject = n),
                this.subject.addListener("change", function (t) {
                  return i.onChange(t);
                });
            },
            [
              {
                key: "onChange",
                value: function (t) {},
              },
            ]
          ),
          new v()),
        y = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var b = (function () {
        function n(t) {
          !(function (t, e) {
            if (!(t instanceof n))
              throw new TypeError("Cannot call a class as a function");
          })(this),
            (this.target = l()(t.targetSelector)),
            (this.close = this.target.find("[data-toggle='modal-close']")),
            (this.activeClass = "is-active"),
            (this.overlayClass = ".window-overlay"),
            (this.cookie = !1),
            (this.popup = !1),
            (this.delay = 5e3),
            t.toggleSelector && (this.toggle = l()(t.toggleSelector)),
            t.popup && (this.popup = !0),
            t.delay && (this.delay = t.delay),
            t.cookie && (this.cookie_name = t.cookie.name),
            this.init();
        }
        return (
          y(n, [
            {
              key: "init",
              value: function () {
                this.setCloseEvents(),
                  this.toggle && this.setTriggerEvent(this.toggle, this.target),
                  this.popup && this.setPopupEvents();
              },
            },
            {
              key: "executeCallback",
              value: function () {
                this.getCallback();
              },
            },
            {
              key: "setCloseEvents",
              value: function () {
                var e = this;
                this.close.on("click", function (t) {
                  t.preventDefault(),
                    e.closeModal(),
                    e.setCookieEvents(e.cookie_name, "temporary");
                }),
                  l()(window).on("click", function (t) {
                    l()(t.target).hasClass("window-overlay") &&
                      (l()(".window-overlay").remove(),
                      e.closeModal(),
                      e.setCookieEvents(e.cookie_name, "temporary"));
                  });
              },
            },
            {
              key: "setTriggerEvent",
              value: function (e, n) {
                var i = this;
                this.toggle.on("click", function (t) {
                  t.preventDefault(),
                    i.setCurrentToggleAndTarget(e, n),
                    i.setCloseEvents(),
                    i.toggleState();
                });
              },
            },
            {
              key: "setPopupEvents",
              value: function () {
                var t = this;
                if (d.a.get(this.cookie_name)) return !1;
                l()(document).ready(function () {
                  setTimeout(function () {
                    t.target.toggleClass(t.activeClass);
                  }, t.delay);
                });
              },
            },
            {
              key: "setCookieEvents",
              value: function (t, e) {
                var n = this;
                d.a.remove(t),
                  setTimeout(function () {
                    d.a.set(t, e, n.getCookieType(e));
                  }, 1500);
              },
            },
            {
              key: "setCurrentToggleAndTarget",
              value: function (t, e) {
                (this.toggle = l()(t)), (this.target = l()(e));
              },
            },
            {
              key: "getCookieType",
              value: function (t) {
                var e = {
                  expires: 30,
                  path: "/",
                };
                return "permanent" == t
                  ? (e = {
                      expires: 365,
                      path: "/",
                    })
                  : e;
              },
            },
            {
              key: "closeModal",
              value: function () {
                this.target.removeClass(this.activeClass),
                  l()(".window-overlay").hide(),
                  this.destroyCloseEvents();
              },
            },
            {
              key: "toggleClass",
              value: function () {
                this.isToggleActive()
                  ? (this.target.removeClass(this.activeClass),
                    this.destroyCloseEvents())
                  : this.target.addClass(this.activeClass);
              },
            },
            {
              key: "toggleWindowOverlay",
              value: function () {
                if (this.isToggleActive())
                  return (
                    l()("body").append('<div class="window-overlay"></div>'),
                    void l()(".window-overlay").show()
                  );
                l()(".window-overlay").remove();
              },
            },
            {
              key: "getToggleClass",
              value: function () {
                return this.target.hasClass(this.activeClass);
              },
            },
            {
              key: "toggleState",
              value: function () {
                this.toggleClass(),
                  this.toggleWindowOverlay(),
                  this.setCloseEvents(),
                  this.setEscEvent(),
                  this.executeCallback();
              },
            },
            {
              key: "getCallback",
              value: function () {
                this.callback && this.callback(this);
              },
            },
            {
              key: "setEscEvent",
              value: function () {
                this.isToggleActive()
                  ? this.setKeyDownToggleEvent()
                  : this.removeKeyDownToggleEvent();
              },
            },
            {
              key: "isToggleActive",
              value: function () {
                return this.getToggleClass();
              },
            },
            {
              key: "isKeyPressIsEsc",
              value: function (t) {
                return 27 == t.keyCode;
              },
            },
            {
              key: "setKeyDownToggleEvent",
              value: function () {
                l()(document).on(
                  "keydown.toggle",
                  function (t) {
                    this.isKeyPressIsEsc(t) && this.toggleState();
                  }.bind(this)
                );
              },
            },
            {
              key: "removeKeyDownToggleEvent",
              value: function () {
                l()(document).off("keydown.toggle");
              },
            },
            {
              key: "destroyCloseEvents",
              value: function () {
                this.close.off("click"),
                  l()(window).off("click"),
                  l()(document).off("keydown.toggle");
              },
            },
          ]),
          n
        );
      })();
      l()(document).ready(function () {
        var t = ".errors";
        (0 < l()('[action="/account/recover"]').find(t).length ||
          0 < l()(".reset-password-success").length) &&
          (l()(t).addClass("hide"),
          l()('[js-modal="forgot-password-container"]').addClass("is-active")),
          new b({
            targetSelector: '[js-modal="forgot-password-container"]',
            toggleSelector: '[js-modal="forgot-password-toggle"]',
          }),
          new b({
            targetSelector: '[js-modal="new-address-container"]',
            toggleSelector: '[js-modal="new-address-toggle"]',
          });
      });
      var S = (function () {
        function i(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function (t, e, n) {
          return e && i(t.prototype, e), n && i(t, n), t;
        };
      })();
      window.$ = window.jQuery = l.a;
      var w = (function () {
          function n(t) {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.toggle = l()(t.toggleSelector)),
              (this.toggleClass = "is-active"),
              // (this.showInitialPanel = t.showInitialPanel || !1),
              (this.showInitialPanel = t.showInitialPanel || true),
              this.init();
          }
          return (
            S(n, [
              {
                key: "init",
                value: function () {
                  this.setInitialStates(), this.setTriggerEvents();
                },
              },
              {
                key: "setTriggerEvents",
                value: function () {
                  var e = this;
                  this.toggle.on("click", function (t) {
                    t.preventDefault(), e.togglePanel(l()(this));
                  });
                },
              },
              // {
              //   key: "setInitialStates",
              //   value: function () {
              //     var t = this,
              //       e = this;

              //     if (t.toggle.length < 4) {
              //       var initialReveal = 0;
              //     } else {
              //       var initialReveal = 1;
              //     }

              //     this.hidePanels().then(function () {
              //       e.showInitialPanel &&
              //         e.togglePanel(t.toggle.eq(initialReveal));
              //     });
              //   },
              // },              
              {
                  key: "setInitialStates",
                  value: function () {
                      var t = this,
                          e = this;
                      
                      this.hidePanels().then(function () {
                          if (e.showInitialPanel) {
                              var whyWeLoveGroup = l()('.accordion__group.why-we-love');
                              if (whyWeLoveGroup.length) {
                                  var tab = whyWeLoveGroup.find('.accordion__tab').first();                                
                                  tab.find(".icon").addClass(e.toggleClass);
                                  tab.next().slideDown(250);
                              } else {
                                  e.togglePanel(t.toggle.eq(0));
                              }
                          }
                      });
                  }
              },
              {
                key: "hidePanels",
                value: function () {
                  var i = this;
                  return new Promise(function (t, e) {
                    var n = l()(i.toggle).next();
                    l.a.each(n, function () {
                      l()(this).hide();
                    }),
                      t();
                  });
                },
              },
              {
                key: "togglePanel",
                value: function (t) {
                  t.find(".icon").toggleClass(this.toggleClass),
                    t.next().slideToggle(250);
                },
              },
              {
                key: "destroy",
                value: function () {
                  this.toggle.off("click");
                },
              },
            ]),
            n
          );
        })(),
        k = n(10),
        C = n.n(k),
        x = n(2),
        E = n.n(x),
        T = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var D = (function () {
          function n(t) {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.$data = window.productJSON),
              (this.$productInventory = window.productInventory),
              (this.$container = l()(t.container)),
              (this.$quantitySelector = l()(t.quantitySelector)),
              (this.$master = l()(t.masterSelector)),
              (this.$quantityMaster = l()(t.container).find("input#Quantity")),
              (this.$priceSelector = l()(t.container).find(
                "[data-product-price]"
              )),
              (this.$notification = l()(t.container).find(
                '[js-option-selector="note"]'
              )),
              (this.$submit = l()(t.container).find('button[name="add"]')),
              this.init();
          }
          return (
            T(n, [
              {
                key: "init",
                value: function () {
                  this.renderView(),
                    this.setInitState(),
                    this.disableUnavailableOptions(),
                    this.setTriggerEvents(),
                    this.setListeners();
                },
              },
              {
                key: "setInitState",
                value: function () {
                  if ($(".option-selector__listing").length) {
                    this.isAllOptionsSelected() ||
                      ("Gift Card" == this.$container.data("product-type")
                        ? (this.unsetSubmitEvents("Add to cart"),
                          this.$submit.attr("disabled", !1))
                        : 0 <
                            this.$container.find("[data-options-id]").children()
                              .length &&
                          (this.$container
                            .find('[js-ajax-cart="addToCart"]')
                            .is("[disabled]") ||
                            this.unsetSubmitEvents("Add to Bag")),
                      this.updateQuantityLimit());
                  }
                },
              },
              {
                key: "setTriggerEvents",
                value: function () {
                  this.setOptionEvents();
                },
              },
              {
                key: "setOptionEvents",
                value: function () {
                  var e = this;
                  l()("[data-option-available=true]").on("click", function (t) {
                    t.preventDefault(),
                      e.updateOption(l()(this)),
                      e.updateStateOfSelectedOptions(l()(this)),
                      e.updateFormState(),
                      e.resetQuantityState();
                  });
                },
              },
              {
                key: "setQuantityEvents",
                value: function () {
                  this.$quantitySelector.on("change", function (t) {
                    var e = l()(this).find('option[selected="selected"]').val();
                    l()(this).attr("data-option-quantity", e),
                      l()('[name="quantity"]').attr("value", e);
                  });
                },
              },
              {
                key: "setListeners",
                value: function () {
                  var t = this;
                  g.addListener("pdp.disableOptions", function () {
                    t.destroyTriggerEvents();
                  });
                },
              },
              {
                key: "unsetSubmitEvents",
                value: function () {
                  $(".fake").remove();
                  $(".addButton")
                    .hide()
                    .after(
                      '<div class="addButton fake"><button class="btn btn--primary btn--large btn--full" type="button" onclick="sizeMsg();">Please select a size</button></div>'
                    );
                  var t =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : theme.strings.soldOut;
                  this.$submit.attr("disabled", !0), this.$submit.text(t);
                },
              },
              {
                key: "setSubmitEvents",
                value: function (displayPrice) {
                  $(".fake").remove();
                  $(".addButton").show();
                  this.$submit.removeAttr("disabled");
                  this.$submit.text(
                    theme.strings.addToCart +
                      (displayPrice ? " – " + displayPrice : "")
                  );
                },
              },
              {
                key: "getVariants",
                value: function () {
                  for (
                    var t = this.$data.variants,
                      e = this.$productInventory,
                      n = {},
                      i = 0;
                    i < t.length;
                    i++
                  )
                    n[i] = {
                      id: t[i].id,
                      title: t[i].title,
                      available: t[i].available,
                      compareAtPrice: t[i].compare_at_price,
                      inventory_management: t[i].inventory_management,
                      inventory_quantity: e[t[i].id],
                      price: t[i].price,
                      options: {
                        0: t[i].option1,
                        1: t[i].option2,
                        2: t[i].option3,
                      },
                    };

                  return n;
                },
              },
              {
                key: "getUniqueOptionValues",
                value: function (e) {
                  var t = C.a.map(this.getVariants(), function (t) {
                    return t.options[e];
                  });
                  return new Set(
                    t.sort(function (t, e) {
                      return t - e;
                    })
                  );
                },
              },
              {
                key: "getUniqueOptionValues",
                value: function (e) {
                  var t = C.a.map(this.getVariants(), function (t) {
                    return {
                      title: t.options[e],
                      available: t.available,
                    };
                  });
                  return new Set(t);
                },
              },
              {
                key: "getVariantByOptions",
                value: function () {
                  for (
                    var e = this, t = arguments.length, n = Array(t), i = 0;
                    i < t;
                    i++
                  )
                    n[i] = arguments[i];
                  var r = this.getVariants(),
                    a = n[0];
                  return C.a.filter(r, function (t) {
                    return e.isAllOptionsSelected.apply(e, n)
                      ? a[0] == t.options[0]
                        ? a[1]
                          ? a[0] == t.options[0] && a[1] == t.options[1] && t
                          : t
                        : void 0
                      : a[1]
                      ? (("null" == a[0] && a[1] == t.options[1]) ||
                          (a[0] == t.options[0] && "null" == a[1])) &&
                        t
                      : t;
                  });
                },
              },
              {
                key: "getVariantAvailabilityById",
                value: function (e) {
                  var t = this.getVariants();
                  return C.a.filter(t, function (t) {
                    if (t.id == e) return t;
                  })[0].available;
                },
              },
              {
                key: "getFirstAvailableVariant",
                value: function () {
                  var e = this;
                  return this.$data.variants
                    .map(function (t) {
                      if (e.getVariantAvailabilityById(t.id)) return t;
                    })
                    .filter(function (t) {
                      return null != t;
                    })[0].id;
                },
              },
              {
                key: "getOptionById",
                value: function (t) {
                  for (
                    var e = this.getVariants(), n = 0;
                    n < Object.keys(e).length;
                    n++
                  ) {
                    var i = e[n];
                    if (i.id == t) return i.options;
                  }
                },
              },
              {
                key: "getSelectedOptionValue",
                value: function (t) {
                  return l()(t).children("input").attr("value");
                },
              },
              {
                key: "getUniqueValues",
                value: function (t) {
                  return C.a.filter(t, function (t, e, n) {
                    return e == n.indexOf(t);
                  });
                },
              },
              {
                key: "getCurrentValidOptions",
                value: function () {
                  return C.a.map(this.getCurrentOptions(), function (t) {
                    if ("null" != t) return t;
                  });
                },
              },
              {
                key: "getCurrentValidOptionsValue",
                value: function () {
                  return C.a.filter(
                    this.getCurrentValidOptions(),
                    function (t) {
                      if (void 0 !== t) return t;
                    }
                  );
                },
              },
              {
                key: "getCurrentOptions",
                value: function () {
                  for (
                    var t = {},
                      e = this.$container.find("[data-options-id]"),
                      n = 0;
                    n < e.length;
                    n++
                  )
                    t[n] = l()(e[n]).attr("data-options-value");
                  return t;
                },
              },
              {
                key: "getCurrentVariant",
                value: function () {
                  return (
                    void 0 !==
                      this.getVariantByOptions(this.getCurrentOptions())[0] &&
                    this.getVariantByOptions(this.getCurrentOptions())[0]
                  );
                },
              },
              {
                key: "getVariantById",
                value: function (e) {
                  return C.a.filter(this.getVariants(), function (t) {
                    if (t.id == e) return t;
                  });
                },
              },
              {
                key: "getVariantsByOption",
                value: function (e, n) {
                  return C.a.filter(this.getVariants(), function (t) {
                    if (e.options[n] == t.options[n]) return t;
                  });
                },
              },
              {
                key: "getOptionValues",
                value: function (t) {
                  var e =
                      1 < arguments.length && void 0 !== arguments[1]
                        ? arguments[1]
                        : 0,
                    n = [];
                  return (
                    t.forEach(function (t) {
                      n.push(t.options[e]);
                    }),
                    this.getUniqueValues(n)
                  );
                },
              },
              {
                key: "getMasterOptionById",
                value: function (t) {
                  for (
                    var e = this.$master.children(), n = 0;
                    n < e.length;
                    n++
                  )
                    if (l()(e[n]).attr("value") == t) return e[n];
                },
              },
              {
                key: "updateFormState",
                value: function () {
                  this.updateMasterOption(),
                    this.destroyTriggerEvents(),
                    this.setTriggerEvents(),
                    this.updateSubmitState(),
                    this.isAllOptionsSelected() &&
                      (this.updateInventoryState(),
                      g.emit("pdp.optionSelected", this.getCurrentVariant()));
                },
              },
              {
                key: "updateOption",
                value: function (t) {
                  if (!t.hasClass("unavailable")) {
                    var e = l()(t),
                      n = e.closest("[data-options-id]"),
                      i = e.closest("[data-option-available]"),
                      r = l()(n).find("[data-options-value]"),
                      a = this.getSelectedOptionValue(i);
                    n.attr("data-options-value", a),
                      /* r.text(a),*/ this.toggleOptionStates(i);
                  }
                },
              },
              {
                key: "setInitVariants",
                value: function () {
                  for (
                    var t = this.getOptionById(this.getFirstAvailableVariant()),
                      e = this.$container.find("[data-options-id]"),
                      n = 0;
                    n < e.length;
                    n++
                  ) {
                    var i = l()(e[n]),
                      r = i.find("input");
                    i.attr("data-options-value", t[n]);
                    for (var a = 0; a < r.length; a++)
                      t[n] == l()(r[a]).val() && this.updateOption(l()(r[a]));
                  }
                },
              },
              {
                key: "updateMasterOption",
                value: function () {
                  var t = this.getFirstAvailableVariant();
                  var price = this.getCurrentVariant().price;
                  if (price) {
                    // var get_currency = $(".template-product__body").attr(
                    //   "data-currency"
                    // );
                    // var formatString = get_currency + "{{amount}}";
                    // var displayPrice = Shopify.formatMoney(price, formatString);
                    var displayPrice = E.a.format(theme.currency, price / 100);
                  } else {
                    var displayPrice = "";
                  }
                  this.isAllOptionsSelected()
                    ? ((t = this.getCurrentVariant().id),
                      this.setSubmitEvents(displayPrice))
                    : (this.unsetSubmitEvents(), this.$notification.hide());
                  var e = this.getMasterOptionById(t);
                  this.unsetMasterOptionStates(),
                    l()(e).attr("selected", "selected");
                },
              },
              {
                key: "unsetMasterOptionStates",
                value: function () {
                  for (
                    var t = this.$master.children(), e = 0;
                    e < t.length;
                    e++
                  )
                    l()(t[e]).removeAttr("selected");
                },
              },
              {
                key: "toggleOptionStates",
                value: function (t) {
                  this.unsetActiveStates(t), this.setActiveStates(t);
                },
              },
              {
                key: "setActiveStates",
                value: function (t) {
                  if (!t.hasClass("unavailable")) {
                    $(".size-alert").remove();
                    t.addClass("is-active"),
                      t.find("input").attr("checked", !0);
                  } else {
                    return false;
                  }
                },
              },
              {
                key: "unsetActiveStates",
                value: function (t) {
                  for (var e = l()(t).siblings(), n = 0; n < e.length; n++) {
                    var i = e[n];
                    l()(i).removeClass("is-active"),
                      e.find("input").attr("checked", !1);
                  }
                },
              },
              {
                key: "updateSubmitState",
                value: function () {
                  var price = this.getCurrentVariant().price;
                  if (price) {
                    var get_currency = $(".template-product__body").attr(
                      "data-currency"
                    );
                    var formatString = get_currency + "{{amount}}";
                    var displayPrice = Shopify.formatMoney(price, formatString);
                    // var displayPrice = E.a.format(theme.currency, price / 100);
                  } else {
                    var displayPrice = "";
                  }
                  if (!this.isAllOptionsSelected())
                    return this.unsetSubmitEvents("Add to Bag"), !1;
                  this.getCurrentStock() <= 0 && this.getInventoryStatus()
                    ? this.unsetSubmitEvents()
                    : (this.unsetSubmitEvents(),
                      this.setSubmitEvents(displayPrice));
                },
              },
              {
                key: "updateQuantityLimit",
                value: function () {
                  var t =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : 20;
                  if (
                    (this.$quantitySelector.empty(),
                    "Gift Card" != this.$container.data("product-type"))
                  )
                    if (0 < this.getCurrentStock())
                      for (e = 1; e < this.getCurrentStock() + 1 && e < t; e++)
                        this.$quantitySelector.append(
                          '<option value="' + e + '">' + e + "</option>"
                        );
                    else
                      this.$quantitySelector.append(
                        '<option value="0" selected disabled>0</option>'
                      );
                  else
                    for (var e = 1; e < 6; e++)
                      this.$quantitySelector.append(
                        '<option value="' + e + '">' + e + "</option>"
                      );
                },
              },
              {
                key: "getOptionByValue",
                value: function (t, e) {
                  return l()('[data-options-id="' + t + '"]').find(
                    '[data-option-label="' + e + '"]'
                  );
                },
              },
              {
                key: "disableOption",
                value: function (t, e) {
                  var n = this.getOptionByValue(t, e);
                  n.attr("disabled", !0),
                    n
                      .closest("[data-option-available]")
                      .attr("data-option-available", !1),
                    n.closest("[data-option-available]").off("click");
                },
              },
              {
                key: "enableOption",
                value: function (t, e) {
                  var n = this.getOptionByValue(t, e);
                  n.attr("disabled", !1),
                    n
                      .closest("[data-option-available]")
                      .attr("data-option-available", !0),
                    n.closest("[data-option-available]").on("click");
                },
              },
              {
                key: "resetQuantityState",
                value: function () {
                  0 < this.getCurrentStock() ||
                  "Gift Card" == this.$container.data("product-type")
                    ? (this.$quantitySelector.attr("data-option-quantity", 1),
                      this.$quantityMaster.attr("value", 1))
                    : (this.$quantitySelector.attr("data-option-quantity", 0),
                      this.$quantityMaster.attr("value", 0),
                      this.unsetSubmitEvents());
                },
              },
              {
                key: "updateInventoryState",
                value: function () {
                  this.updateQuantityLimit(), this.updateNotification();
                },
              },
              {
                key: "getInventoryStatus",
                value: function () {
                  return (
                    !!this.getCurrentVariant() &&
                    this.getCurrentVariant().inventory_management
                  );
                },
              },
              {
                key: "getCurrentStock",
                value: function () {
                  return this.getCurrentVariant()
                    ? this.getCurrentVariant().inventory_quantity
                    : 0;
                },
              },
              {
                key: "getInventoryStock",
                value: function () {
                  var e = this.$master
                    .find('option[selected="selected"]')
                    .val();
                  return C.a.find(this.getVariants(), function (t) {
                    if (t.id == e) return t;
                  }).inventory_quantity;
                },
              },
              {
                key: "updateInventoryNotification",
                value: function (t) {
                  this.$notification.html(
                    "<p>There are only " + t + " units left in this size</p>"
                  ),
                    1 == t &&
                      this.$notification.html(
                        "<p>There is only 1 unit left in this size</p>"
                      );
                },
              },
              {
                key: "updateNotification",
                value: function () {
                  if (!(this.getCurrentStock() <= 0))
                    return this.checkInventoryStock()
                      ? (this.$notification.show(),
                        this.$notification.removeClass("is-hidden"),
                        void this.updateInventoryNotification(
                          this.getInventoryStock()
                        ))
                      : void this.$notification.hide();
                  this.$notification.hide();
                },
              },
              {
                key: "checkInventoryStock",
                value: function () {
                  if (this.getCurrentStock() <= this.getLowStockThreshold())
                    return !0;
                },
              },
              {
                key: "getLowStockThreshold",
                value: function () {
                  return this.$notification.attr("data-option-threshold");
                },
              },
              {
                key: "getUnavailableVariants",
                value: function () {
                  var t =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : this.getVariants();
                  return C.a.filter(t, function (t) {
                    if (!t.available) return t;
                  });
                },
              },
              {
                key: "getAvailableOptionsByValue",
                value: function () {
                  var e =
                      0 < arguments.length && void 0 !== arguments[0]
                        ? arguments[0]
                        : 0,
                    n = arguments[1];
                  return C.a.filter(this.getVariants(), function (t) {
                    if (t.options[e] == n) return t;
                  });
                },
              },
              {
                key: "getAvailabilityOfOption",
                value: function (t, e) {
                  var n = !1;
                  return (
                    this.getAvailableOptionsByValue(t, e).forEach(function (t) {
                      t.available && (n = !0);
                    }),
                    n
                  );
                },
              },
              {
                key: "disableUnavailableOptions",
                value: function () {
                  var n = this;
                  C.a.map(this.getCurrentOptions(), function (t, e) {
                    n.getOptionValues(n.getUnavailableVariants(), e).forEach(
                      function (t) {
                        n.getAvailabilityOfOption(e, t) ||
                          n.disableOption(e, t);
                      }
                    );
                  });
                },
              },
              {
                key: "updateStateOfSelectedOptions",
                value: function (t) {
                  this.disableUnavailablePairedOptions(t);
                },
              },
              {
                key: "getOptionIdByTarget",
                value: function (t) {
                  return t.closest("[data-options-id]").data("options-id");
                },
              },
              {
                key: "getPairedOptionIdByTarget",
                value: function (t) {
                  for (
                    var e = l()("[data-options-id]"),
                      n = t.closest("[data-options-id]").data("options-id"),
                      i = C.a.map(e, function (t) {
                        var e = l()(t).data("options-id");
                        if (!n == e) return e;
                      }),
                      r = [],
                      a = 0,
                      o = 0;
                    o < i.length;
                    o++
                  ) {
                    var s = i[o];
                    void 0 !== s && ((r[a] = s), a++);
                  }
                  return r;
                },
              },
              {
                key: "disableUnavailablePairedOptions",
                value: function (t) {
                  var n = this,
                    e = this.getPairedOptionIdByTarget(t),
                    i = this.getVariantByOptions(this.getCurrentOptions()),
                    r = this.getOptionValues(this.getUnavailableVariants(i), e),
                    a = this.getAllValuesOfOption(e);
                  this.resetOptionsState(e),
                    this.disableUnavailableOptions(),
                    this.isAllOptionsSelected() &&
                      (C.a.map(this.getUnavailableVariants(), function (t) {
                        n.getCurrentOptions()[0] == t.options[0] &&
                          n.disableOption(1, t.options[1]);
                      }),
                      C.a.map(this.getUnavailableVariants(), function (t) {
                        n.getCurrentOptions()[1] == t.options[1] &&
                          n.disableOption(0, t.options[0]);
                      }));
                  var o = this.getOptionIdByTarget(t),
                    s = this.getCurrentOptions()[o],
                    l = C.a
                      .filter(a, function (t) {
                        var e = n.getOptionsByValue(t, s);
                        if (
                          (0 == o && (e = n.getOptionsByValue(s, t)),
                          n.getVariantByOptions(e).length <= 0)
                        )
                          return t;
                      })
                      .concat(r);
                  C.a.map(l, function (t) {
                    n.disableOption(e, t);
                  });
                },
              },
              {
                key: "getValueOfTarget",
                value: function (t) {
                  return t.find("input").val();
                },
              },
              {
                key: "getAllValuesOfOption",
                value: function (t) {
                  var e = C.a.filter(this.getVariants(), function (t) {
                    return t;
                  });
                  return this.getOptionValues(e, t);
                },
              },
              {
                key: "getPairedVariants",
                value: function (t) {
                  return this.getVariantByOptions(this.getCurrentOptions());
                },
              },
              {
                key: "resetOptionsState",
                value: function (e) {
                  var n = this,
                    t = C.a.filter(this.getVariants(), function (t) {
                      return t;
                    });
                  this.getOptionValues(t, e).forEach(function (t) {
                    n.enableOption(e, t);
                  });
                },
              },
              {
                key: "setOptionsState",
                value: function (t, n) {
                  var i = this;
                  t.forEach(function (t) {
                    var e = t.options[n];
                    i.disableOption(n, e);
                  });
                },
              },
              {
                key: "getOptionsByValue",
                value: function () {
                  for (
                    var t = {}, e = arguments.length, n = Array(e), i = 0;
                    i < e;
                    i++
                  )
                    n[i] = arguments[i];
                  for (var r = 0; r < n.length; r++) t[r] = n[r];
                  return t;
                },
              },
              {
                key: "isAllOptionsSelected",
                value: function () {
                  var t =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : this.getCurrentOptions();
                  return C.a.every(
                    C.a.map(t, function (t) {
                      if ("null" != t) return !0;
                    })
                  );
                },
              },
              {
                key: "isTrailingZeros",
                value: function (t, e) {
                  return !!E.a
                    .format(t, e / 100)
                    .toString()
                    .includes(".00");
                },
              },
              {
                key: "getFormattedCurrency",
                value: function (t, e) {
                  return isTrailingZeros(t, e)
                    ? E.a.format(t, e / 100, 0)
                    : E.a.format(t, e / 100);
                },
              },
              {
                key: "updatePrice",
                value: function () {
                  this.$priceSelector.html(""),
                    this.$priceSelector.html(this.getVariantPrice()),
                    this.getVariantSalePrice() &&
                      this.$priceSelector.append(
                        " <s>" + this.getVariantSalePrice() + "</s>"
                      );
                },
              },
              {
                key: "getVariantPrice",
                value: function () {
                  return void 0 !== this.getCurrentVariant()
                    ? this.getFormattedCurrency(
                        "USD",
                        this.getCurrentVariant().price
                      )
                    : this.getFormattedCurrency(
                        "USD",
                        this.$priceSelector.data("product-price")
                      );
                },
              },
              {
                key: "getVariantSalePrice",
                value: function () {
                  var t = this.getCurrentVariant();
                  if (void 0 !== this.getCurrentVariant() && t.compareAtPrice)
                    return this.getFormattedCurrency("USD", t.compareAtPrice);
                },
              },
              {
                key: "destroyQuantityEvents",
                value: function () {
                  this.$quantitySelector.off("change");
                },
              },
              {
                key: "destroyTriggerEvents",
                value: function () {
                  l()("[data-option-available]").off("click");
                },
              },
              {
                key: "getOptionTemplate",
                value: function (t) {
                  for (
                    var i = this,
                      e = this.$container.find("[data-options-id]"),
                      r = [],
                      n = 0;
                    n < e.length;
                    n++
                  )
                    return (
                      this.getUniqueOptionValues(t).forEach(function (t) {
                        var e = t;
                        i.$container.data("product-type");
                        var n =
                          '\n          <li class="option-selector ' +
                          (t.available ? "available" : "unavailable") +
                          '" data-option-available="true">\n<input class="option-selector__input" type="radio" value="' +
                          t.title +
                          '">\n            <label class="option-selector__label">\n              <div class="option-selector__button" data-option-label="' +
                          t.title +
                          '">' +
                          e.title +
                          "</div>\n            </label>\n          </li>\n        ";
                        if (!theOptions.includes(t.title)) {
                          r.push(n);
                        }
                        theOptions.push(t.title);
                      }),
                      r.join("")
                    );
                },
              },
              {
                key: "renderView",
                value: function () {
                  for (
                    var t = this.$container.find("[data-options-id]"), e = 0;
                    e < t.length;
                    e++
                  ) {
                    var n = l()(t[e]).find(".product-form__option-selector"),
                      i =
                        '\n        <label class="h4 visually-hidden">Size</label>\n        <ul class="option-selector__listing">\n          ' +
                        this.getOptionTemplate(e) +
                        "\n        </ul>\n      ";
                    n.html(i);
                  }
                },
              },
            ]),
            n
          );
        })(),
        A = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var I = (function () {
          function n() {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.container = l()('[js-product-swatches="container"]')),
              (this.swatches = l()('[js-product-swatches="swatches"]')),
              this.init();
          }
          return (
            A(n, [
              {
                key: "init",
                value: function () {
                  this.fetchItemsByHandle(this.getSearchQuery());
                },
              },
              {
                key: "fetchItemsByHandle",
                value: function (t) {
                  var e = this;
                  l.a.ajax({
                    url: "/search?type=product&q=title:" + t + "&view=swatches",
                    success: function (t) {
                      e.renderTemplate(t),
                        e.setActiveSwatchState(),
                        e.removeUnrelatedSwatches();
                    },
                    error: function (t) {
                      console.error(t);
                    },
                  });
                },
              },
              {
                key: "removeUnrelatedSwatches",
                value: function () {
                  var e = this;
                  /*
                  	var swatches = $("[data-collections]")
                    
                    swatches.each(function() {
                      	var matchedCollection = false
                        var collections = $(this).data("collections")
                        for(i in collections) {
                          	console.log(collections[i].handle + ' => ' + e.getGroupQuery() )
                           
                            if(collections[i].handle == e.getGroupQuery()) {
                            	console.log('match')
                            }
                        }
                    })
                    
                    */
                  _.map(l()("[data-search-group]"), function (t) {
                    for (i in l()(t).data("collections")) {
                      //console.log(l()(t).data("collections")[i].handle)
                    }
                    //  l()(t).data("search-group") !== e.getGroupQuery() && l()(t).remove()
                  });
                },
              },
              {
                key: "getGroupQuery",
                value: function () {
                  return this.container.data("search-group");
                },
              },
              {
                key: "getSearchQuery",
                value: function () {
                  return this.container.data("search-query");
                },
              },
              {
                key: "setActiveSwatchState",
                value: function () {
                  var t = this.container.data("active-swatch");
                  l()('.swatch[data-swatch-title="' + t + '"').addClass(
                    "is-active"
                  );
                },
              },
              {
                key: "renderTemplate",
                value: function (t) {
                  this.swatches.html(t);
                },
              },
            ]),
            n
          );
        })(),
        q = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var j = (function () {
          function n(t) {
            !function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            };
            this,
              (this.container = l()(t.container)),
              (this.decrease = l()(t.container).find(
                '[js-quantity-selector="decrement"]'
              )),
              (this.increase = l()(t.container).find(
                '[js-quantity-selector="increment"]'
              )),
              (this.input = l()(t.container).find(
                '[js-quantity-selector="input"]'
              )),
              (this.min = l()(t.container).find("input").attr("min")),
              (this.tooltip = l()(t.container).find(".tooltip")),
              (this.cartResponse = l()('[js-ajax-cart="cartResponse"]')),
              (this.reload = t.reload),
              (this.timer = {}),
              (this.callback = t.callback),
              this.init();
          }
          return (
            q(n, [
              {
                key: "init",
                value: function () {
                  console.log(t.container,'t.containert.containert.container')
                  this.setTriggerEvents(), this.setInitState();
                 
                },
              },
              {
                key: "setInitState",
                value: function () {
                  this.verifyValue(this.input.val());
                },
              },
              {
                key: "setTriggerEvents",
                value: function () {
                  var e = this;
                
                        
                        $('body').off("click", '[js-quantity-selector="increment"]').on("click",'[js-quantity-selector="increment"]',function () {
                          var qty = $(this).parents(".qty-selector").find(".qty-selector__input");
                          qty.val(parseInt(qty.val()) + 1);
                          
                          const isAddButtonValid = !$(".addButton").hasClass("fake");
                          const basePriceMatch = document
                            .querySelector(".product-form__price-inner")
                            .getAttribute("data-product-price");
                          if (isAddButtonValid && parseInt(qty.val()) >= 1) {
                            const newPrice = parseInt(qty.val()) * basePriceMatch;
                            var displayPrice = E.a.format($("body").attr("data-currency"), newPrice / 100);
                            $(".atc-cart-btn").text(
                              theme.strings.addToCart +
                                (displayPrice ? " – " + displayPrice : "")
                            );
                          }
                        });
                        
                          $('body').off("click", '[js-quantity-selector="decrement"]').on("click",'[js-quantity-selector="decrement"]',function () {
                          var qty = $(this).parents(".qty-selector").find(".qty-selector__input");
                          if (parseInt(qty.val()) > 1) {
                            qty.val(parseInt(qty.val()) - 1);
                            
                            const isAddButtonValid = !$(".addButton").hasClass("fake");
                          const basePriceMatch = document
                            .querySelector(".product-form__price-inner")
                            .getAttribute("data-product-price");
                          if (isAddButtonValid && parseInt(qty.val()) >= 1) {
                            const newPrice = parseInt(qty.val()) * basePriceMatch;
                            var displayPrice = E.a.format($("body").attr("data-currency"), newPrice / 100);
                            $(".atc-cart-btn").text(
                              theme.strings.addToCart +
                                (displayPrice ? " – " + displayPrice : "")
                            );
                          }
                          }
                        });
                        
                        
                                        
                  this.decrease.on("click", function (t) {
                    t.preventDefault(),
                      console.log(e.decrementValue(e.input),'e.decrementValue(e.input)e.decrementValue(e.input)e.decrementValue(e.input)')
                      // e.updateValue(e.decrementValue(e.input)),
                      e.hideMaxResponse();
                  }),
                    this.increase.on("click", function (t) {
                      t.preventDefault(),
                        // e.updateValue(e.incrementValue(e.input)),
                        e.hideMaxResponse();
                    });
                },
              },
              {
                key: "setInputEvents",
                value: function () {
                  var t = this;
                  this.container.on("blur", function () {
                    t.updateValue(l()(this).val());
                  });
                },
              },
              {
                key: "decrementValue",
                value: function (t) {
                  return parseInt(l()(t).val()) - 1;
                },
              },
              {
                key: "incrementValue",
                value: function (t) {
                  return parseInt(l()(t).val()) + 1;
                },
              },
              {
                key: "verifyValue",
                value: function (t) {
                  var e = parseInt(t, 10);
                  return (
                    e === this.getMaximumQuantity()
                      ? (g.emit("item.maxQuantityHit"),
                        this.increase.addClass("is-disabled"),
                        this.toggleTooltip())
                      : this.increase.hasClass("is-disabled") &&
                        (this.increase.removeClass("is-disabled"),
                        this.tooltip.addClass("is-hidden"),
                        this.cartResponse.addClass("is-hidden")),
                    e <= this.getMaximumQuantity() && 0 < e && e
                  );
                },
              },
              {
                key: "toggleTooltip",
                value: function () {
                  var t = this;
                  this.tooltip.removeClass("is-hidden"),
                    setTimeout(function () {
                      t.tooltip.addClass("is-hidden");
                    }, 2e3);
                },
              },
              {
                key: "getMaximumQuantity",
                value: function () {
                  return parseInt(this.container.attr("data-max"));
                },
              },
              {
                key: "hideMaxResponse",
                value: function () {
                  this.cartResponse.addClass("is-hidden");
                },
              },
              {
                key: "updateValue",
                value: function (t) {

                  
                  const isAddButtonValid = !$(".addButton").hasClass("fake");
                  const basePriceMatch = document
                    .querySelector(".product-form__price-inner")
                    .getAttribute("data-product-price");
                  if (isAddButtonValid && t >= 1) {
                    const newPrice = t * basePriceMatch;
                    // var get_currency = $("body").attr(
                    //   "data-currency"
                    // );
                    // var formatString = get_currency + "{{amount}}";
                    // var displayPrice = Shopify.formatMoney(
                    //   newPrice,
                    //   formatString
                    // );
                    console.log(t,'newPricenewPricenewPrice');
                    var displayPrice = E.a.format($("body").attr("data-currency"), newPrice / 100);
                    $(".atc-cart-btn").text(
                      theme.strings.addToCart +
                        (displayPrice ? " – " + displayPrice.replace('₹', 'Rs. ') : "")
                    );
                  }
                  t <= this.min &&
                    (this.input.val(this.min),
                    this.input.attr("value", this.min),
                    this.input
                      .closest("[data-qty]")
                      .attr("data-qty", this.min)),
                    this.verifyValue(t) &&
                      (this.input.val(t),
                      this.input.attr("value", t),
                      this.input.closest("[data-qty]").attr("data-qty", t)),
                    this.executeCallback(this.callback);
                },
              },
              {
                key: "destroy",
                value: function () {
                  this.decrease.off("click"),
                    this.increase.off("click"),
                    this.input.closest("[data-qty]").attr("data-qty", this.min),
                    this.input.attr("value", this.min),
                    this.input.val(this.min);
                },
              },
              {
                key: "reinit",
                value: function () {
                  this.destroy(), this.init();
                },
              },
              {
                key: "executeCallback",
                value: function (t) {
                  t && t();
                },
              },
            ]),
            n
          );
        })(),
        z = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })(),
        P = (function () {
          function n(t) {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.container =
                $('[js-quick-add="container"]') || $(t.container)),
              (this.optionSelector = '[js-quick-add="option"]'),
              (this.option =
                $('[js-quick-add="option"]') || $(t.optionSelector)),
              (this.addToCartSelector = '[js-quick-add="add-to-cart"]'),
              this.init();
          }
          return (
            z(n, [
              {
                key: "init",
                value: function () {
                  this.container.length &&
                    (this.setTriggerEvents(),
                    this.setToggleEvents(),
                    this.setContainerHeights());
                },
              },
              {
                key: "destroy",
                value: function () {
                  this.destroyTriggerEvents(),
                    this.destroyToggleEvents(),
                    this.destroyContainerHeights();
                },
              },
              {
                key: "setTriggerEvents",
                value: function () {
                  var e = this;
                  $(this.optionSelector).on("click", function (t) {
                    t.preventDefault(),
                      e.addVariantToCart(e.getVariantId(this), 1, $(this));
                  }),
                    $(this.addToCartSelector).on("click", function (t) {
                      t.preventDefault(),
                        e.addVariantToCart(e.getVariantId(this), 1, $(this));
                    });
                },
              },
              {
                key: "destroyTriggerEvents",
                value: function () {
                  $(this.optionSelector).off("click"),
                    $(this.addToCartSelector).off("click");
                },
              },
              {
                key: "resetTriggerEvents",
                value: function () {
                  this.destroyTriggerEvents(), this.setTriggerEvents();
                },
              },
              {
                key: "setToggleEvents",
                value: function () {
                  this.container.on("mouseover", function () {
                    $(this).removeClass("is-inactive");
                  }),
                    this.container.on("mouseout", function () {
                      $(this).addClass("is-inactive");
                    });
                },
              },
              {
                key: "destroyToggleEvents",
                value: function () {
                  this.option.off("mouseover mouseout");
                },
              },
              {
                key: "setContainerHeights",
                value: function () {
                  Array.from(this.container).forEach(function (t) {
                    $(t).css("max-height", t.offsetHeight),
                      $(t).addClass("is-inactive");
                  });
                },
              },
              {
                key: "destroyContainerHeights",
                value: function () {
                  this.container.forEach(function (t) {
                    $(t).removeAttr("style"), $(t).removeClass("is-inactive");
                  });
                },
              },
              {
                key: "addVariantToCart",
                value: function (t, e, n) {
                  var i = this;
                  $.ajax({
                    method: "POST",
                    url: "/cart/add.js",
                    dataType: "json",
                    data: {
                      id: t,
                      quantity: e,
                    },
                    success: function (t) {
                      i.setStatusState(n, t, "success");
                      window.updateJellycatShippingAttribute();
                    },
                    error: function (t) {
                      i.setStatusState(n, t, "error");
                    },
                  });
                },
              },
              {
                key: "getVariantId",
                value: function (t) {
                  return $(t).data("variant-id");
                },
              },
              {
                key: "setStatusState",
                value: function (t, e, n) {
                  var i = $(t.parents('[js-quick-add="container"]')),
                    r = t.text(),
                    a = i.html(),
                    o = this;
                  "error" == n &&
                    (i.addClass("is-error"),
                    i.html(
                      '<div class="btn btn--secondary btn--large btn--full">' +
                        r +
                        " is currently sold out</div>"
                    )),
                    "success" == n &&
                      (i.addClass("is-success"),
                      i.html(
                        '<div class="btn btn--secondary btn--large btn--full">Added to bag</div>'
                      )),
                    setTimeout(function () {
                      i.removeClass("is-error"),
                        i.removeClass("is-success"),
                        i.html(a),
                        o.resetTriggerEvents(),
                        g.emit("cart.focus");
                    }, 1500);
                },
              },
            ]),
            n
          );
        })(),
        O = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var L = (function () {
          function n(t) {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.containerSelector = '[js-free-gift="container"]'),
              (this.addToCartSelector = '[js-free-gift="addToCart"]'),
              (this.modalSelector =
                l()('[js-modal="free-gift"]') || t.modalSelector),
              (this.formSelector = '[js-free-gift="form"]'),
              (this.template = {}),
              (this.modal = {}),
              this.init();
          }
          return (
            O(n, [
              {
                key: "init",
                value: function () {
                  this.cacheTemplate(), this.setEventListeners();
                },
              },
              {
                key: "setEventListeners",
                value: function () {
                  var n = this;
                  g.addListener("cart.freeItemAdded", function (e) {
                    n.isFreeGiftInCart(n.getFreeGiftParentId()).then(function (
                      t
                    ) {
                      return t
                        ? console.log("Free gift is already in cart")
                        : n.toggleModal(e);
                    });
                  });
                },
              },
              {
                key: "updateFreeGiftParentId",
                value: function (t) {
                  var e = this.getVariantIdFromResponse(t);
                  l()('[js-free-gift="container"]').attr("data-product-id", e);
                },
              },
              {
                key: "getFreeGiftParentId",
                value: function () {
                  return l()('[js-free-gift="container"]').data("product-id");
                },
              },
              {
                key: "getVariantIdFromResponse",
                value: function (t) {
                  return _.filter(t, function (t) {
                    return "id" === t.name ? t : null;
                  })[0].value;
                },
              },
              {
                key: "setFormEvents",
                value: function () {
                  var n = this;
                  l()(this.addToCartSelector).on("click", function (t) {
                    t.preventDefault();
                    var e = l()(this).closest("form");
                    n.submitForm(e, l()(this));
                  });
                },
              },
              {
                key: "setChangeEvents",
                value: function () {
                  var n = this;
                  l()(this.formSelector)
                    .find('[js-option-selector="option"]')
                    .on("click", function (t) {
                      t.preventDefault();
                      var e = l()(this).closest("[data-option-available]");
                      l()(n.formSelector).attr(
                        "data-variant-id",
                        l()(this).data("variant-id")
                      ),
                        n.toggleOptionStates(e);
                      
                    });
                },
              },
              {
                key: "toggleOptionStates",
                value: function (t) {
                  this.unsetActiveStates(t), this.setActiveStates(t);
                },
              },
              {
                key: "setActiveStates",
                value: function (t) {
                  t.addClass("is-active"), t.find("input").attr("checked", !0);
                },
              },
              {
                key: "unsetActiveStates",
                value: function (t) {
                  for (var e = l()(t).siblings(), n = 0; n < e.length; n++) {
                    var i = e[n];
                    l()(i).removeClass("is-active"),
                      e.find("input").attr("checked", !1);
                  }
                },
              },
              {
                key: "submitForm",
                value: function (e, n) {
                  var i = this;
                  this.isFreeGiftInCart(this.getFreeGiftParentId()).then(
                    function (t) {
                      t
                        ? (g.emit("cart.freeGiftAlreadyInCart"),
                          console.log("Free gift is already in cart"))
                        : l.a.ajax({
                            method: "POST",
                            url: "/cart/add.js",
                            dataType: "json",
                            data: {
                              id: l()(e).data("variant-id"),
                              quantity: 1,
                              properties: {
                                "free-gift": !0,
                                "free-gift-parent": i.getFreeGiftParentId(),
                              },
                            },
                            success: function (t) {
                              i.setSuccessState(n), i.destroySubmitEvents();
                              window.updateJellycatShippingAttribute();
                            },
                          });
                    }
                  );
                },
              },
              {
                key: "setSuccessState",
                value: function (t) {
                  var e = this,
                    n =
                      1 < arguments.length && void 0 !== arguments[1]
                        ? arguments[1]
                        : 1500,
                    i = t.find("#AddToCartText");
                  i.html("Added to cart"),
                    setTimeout(function () {
                      g.emit("cart.focus"),
                        e.modal.toggleState(),
                        i.html("Add to cart");
                    }, n);
                },
              },
              {
                key: "cacheTemplate",
                value: function () {
                  (this.template = this.modalSelector),
                    this.modalSelector.remove();
                },
              },
              {
                key: "render",
                value: function () {
                  var n = this;
                  return new Promise(function (t, e) {
                    l()("body").append(n.template),
                      (n.modal = new b({
                        targetSelector: '[js-modal="free-gift"]',
                      })),
                      t();
                  });
                },
              },
              {
                key: "toggleModal",
                value: function (t) {
                  var e = this;
                  this.render().then(function () {
                    setTimeout(function () {
                      e.modal.toggleState(),
                        e.setFormEvents(),
                        e.updateFreeGiftParentId(t),
                        e.setChangeEvents();
                    }, 2e3);
                  });
                },
              },
              {
                key: "isFreeGiftInCart",
                value: function (n) {
                  return new Promise(function (e, t) {
                    l.a.ajax({
                      url: "/cart.js",
                      dataType: "json",
                      success: function (t) {
                        e(
                          0 <
                            _.filter(t.items, function (t) {
                              return (
                                Number(t.properties["free-gift-parent"]) === n
                              );
                            }).length
                        );
                      },
                      error: function (t) {
                        console.error("Could not retrieve items from cart");
                      },
                    });
                  });
                },
              },
              {
                key: "destroySubmitEvents",
                value: function () {
                  l()(this.addToCartSelector).off("click");
                },
              },
            ]),
            n
          );
        })(),
        B = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })(),
        M = (function () {
          function n(t) {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.selectors = {}),
              (this.carousel = {}),
              (this.productContainer =
                $('[js-product="container"]') || $(t.productContainer)),
              (this.container =
                $('[js-product-bundle="container"]') || $(t.container)),
              this.setSelectors(t),
              this.init();
          }
          return (
            B(n, [
              {
                key: "init",
                value: function () {
                  this.fetchItemsByTag(this.getSearchQuery());
                },
              },
              {
                key: "setSelectors",
                value: function (t) {
                  this.selectors = {
                    container: '[js-product-bundle="container"]',
                    product: '[js-product-bundle="product"]',
                  };
                },
              },
              {
                key: "fetchItemsByTag",
                value: function (t) {
                  var e = this;
                  $.ajax({
                    url: "/search?type=product&q=tag:" + t + "&view=bundles",
                    success: function (t) {
                      e.renderTemplate(t), e.constructCarouselEvents();
                    },
                    error: function (t) {
                      console.error(t);
                    },
                  });
                },
              },
              {
                key: "getSearchQuery",
                value: function () {
                  return this.container.data("search-query");
                },
              },
              {
                key: "getDiscountValue",
                value: function () {
                  return this.container.data("discount-value");
                },
              },
              {
                key: "getCurrentProductId",
                value: function () {
                  return this.productContainer.data("product-id");
                },
              },
              {
                key: "getDiscountBadgeTemplate",
                value: function (t) {
                  return (
                    '\n      <div class="badge badge--secondary ' +
                    (t <= 1 ? "badge--left" : "") +
                    '">\n        ' +
                    this.getDiscountValue() +
                    "% off with purchase\n      </div>\n    "
                  );
                },
              },
              {
                key: "getProductBundleCount",
                value: function () {
                  return $('[js-product-bundle="product"]').length;
                },
              },
              {
                key: "constructCarouselEvents",
                value: function () {
                  this.carousel = new s({
                    carouselSelector: this.selectors.container,
                    cellSelector: this.selectors.product,
                    prevNextButtons: !0,
                    pageDots: !0,
                    cellAlign: "center",
                  });
                },
              },
              {
                key: "removeCurrentProductFromTemplate",
                value: function () {
                  this.container
                    .find(
                      '[data-product-id="' + this.getCurrentProductId() + '"]'
                    )
                    .remove();
                },
              },
              {
                key: "renderTemplate",
                value: function (t) {
                  this.container.html(t),
                    this.removeCurrentProductFromTemplate(),
                    this.getProductBundleCount() &&
                      this.renderDiscountBadge(this.getProductBundleCount());
                },
              },
              {
                key: "renderDiscountBadge",
                value: function (t) {
                  this.container.before(this.getDiscountBadgeTemplate(t));
                },
              },
            ]),
            n
          );
        })();
      n(32),
        l()(document).ready(function () {
          if (l()("body").hasClass("template-product")) {
            var i = function (t) {
              return (
                (e = t),
                E.a
                  .format(theme.currency, e / 100)
                  .toString()
                  .includes(".00")
                  ? E.a.format(theme.currency, t / 100, 0)
                  : E.a.format(theme.currency, t / 100)
              );
              var e;
            };
            new P(),
              new I(),
              new D({
                container: '[js-product-form="container"]',
                optionSelector: '[js-option-selector="selectors"]',
                quantitySelector: "#Quantity",
                masterSelector: ".product-form__master-select",
              });
            var r = new j({
              container: '[js-quantity-selector="container"]',
            });
            if (
              (new w({
                toggleSelector: ".product-accordion__tab",
                showInitialPanel: false,
              }),
              new L(),
              new M(),
              document.querySelector(".featured-collection__carousel"))
            ) {
              var n = {};
              Array.from(l()(".featured-collection__carousel")).forEach(
                function (t, e) {
                  n[e] = new s({
                    carouselSelector: "#" + t.id,
                    cellSelector: ".featured-collection__slide",
                    prevNextButtons: !0,
                  });
                }
              );
            }
            g.addListener("cart.freeGiftAdded", function (t) {
              console.log(t),
                l.a.ajax({
                  method: "POST",
                  url: "/cart/add.js",
                  dataType: "json",
                  data: {
                    id: t,
                    quantity: 1,
                    properties: {
                      "free-gift": !0,
                    },
                  },
                  success: function (t) {
                    console.log("response", t);
                    window.updateJellycatShippingAttribute();
                  },
                });
            }),
              g.addListener("pdp.optionSelected", function (t) {
                // --- Dropdown handling ---
                var dropdownTrigger = document.querySelector(
                  ".custom-dropdown-name"
                );
                var dropdownList = document.querySelector(
                  ".custom-dropdown__list"
                );
                if (t.available) {
                  dropdownTrigger.textContent = t.title;
                }
   dropdownList.classList.remove("open");
                document
                  .querySelector(".custom-dropdown")
                  .classList.remove("activated");


                       // dropdownList.classList.toggle("open");  
                
                var variantId = t.id;
                var productUrl = document.querySelector('.product-form__price').getAttribute('data-url');
                var section_id = document.querySelector('.product-form__price').getAttribute('data-section');                
                fetch(`${productUrl}?variant=${variantId}&section_id=${section_id}`)
                  .then((response) => response.text())
                  .then((responseText) => {  
                    const html = new DOMParser().parseFromString(responseText, 'text/html')
                    const destination = document.getElementById("price-new");
                    const source = html.getElementById("price-new");
                    if (source && destination) destination.innerHTML = source.innerHTML;        
                    document.querySelectorAll(".product-price__sale-label").forEach(label => label.remove());                    
                  })
                  .catch(error => {
                    console.error('Error fetching variant data:', error);
                  });
               
                var price = t.price / 100;
                var compare_price = t.compareAtPrice / 100;
                var e = 20 <= t.inventory_quantity ? 20 : t.inventory_quantity;
                if (
                  (l()('[js-quantity-selector="container"]').attr(
                    "data-max",
                    e
                  ),
                  t.compareAtPrice > t.price)
                ) {
                  var n =
                    '\n                  <span class="product-price__price product-price__sale product-price__sale--single">\n                    <span>' +
                    $("#currency_symbol").val() +
                    price +
                    '</span>\n                  </span>\n                  <span class="product-price__sale-label"></span>\n                  <s>' +
                    $("#currency_symbol").val() +
                    compare_price +
                    "</s>";
                  
                  l()(".product-form__price_old").html(n);
                  
                } else l()(".product-form__price_old").html($("#currency_symbol").val() + price);
                return 0 < t.inventory_quantity
                  ? (l()('[js-quantity-selector="container"]').hasClass(
                      "is-disabled"
                    ) &&
                      l()('[js-quantity-selector="container"]').removeClass(
                        "is-disabled"
                      ),
                    r.reinit())
                  : l()('[js-quantity-selector="container"]').addClass(
                      "is-disabled"
                    );
              }),
              l()(".text-link").modaal(),
              l()(".site-nav__subnav, .site-nav__sub-subnav")
                .find(".site-nav__subnav-item, site-nav__sub-subnav-item")
                .each(function () {
                  var t = l()(this).find("a");
                  -1 === t.attr("href").indexOf("/collections") &&
                    t.addClass("product--nav");
                }),
              l()(".product--nav").on("click", function () {
                Cookies.set("collection", "");
              });
            var t = Cookies.get("collection");
            null != t &&
              "" != t &&
              ((a = (e = t.split(","))[1]),
              (o = e[0]),
              l()("#active-collection").append(
                '<a href="' + a + '">' + o + "</a> &rsaquo;"
              )),
              l()(".breadcrumbs").css("visibility", "visible");
          }
          var e, a, o;
        });
      var F = (function () {
        function i(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        return function (t, e, n) {
          return e && i(t.prototype, e), n && i(t, n), t;
        };
      })();
      window.$ = window.jQuery = l.a;
      var R = (function () {
          function n(t) {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.container = l()(t.container)),
              (this.text = l()(t.container).find('[js-free-shipping="text"]')),
              (this.currency = theme.currency),
              (this.messages = t.messages),
              (this.threshold = t.threshold),
              this.init();
          }
          return (
            F(n, [
              {
                key: "init",
                value: function () {
                  this.updateValues();
                },
              },
              {
                key: "updateValues",
                value: function () {
                  var e = this;
                  l.a.ajax({
                    url: "/cart.js",
                    dataType: "json",
                    success: function (t) {
                      e.render(t);
                    },
                  });
                },
              },
              {
                key: "render",
                value: function (t) {
                  var e = t.total_price,
                    n = this.threshold - e;
                  return n <= 0
                    ? this.text.text(this.messages.ideal)
                    : e < this.threshold && 0 < e
                    ? this.text.text(
                        this.messages.partial.replace(
                          "#value#",
                          this.getFormattedCurrency(n)
                        )
                      )
                    : this.text.text(
                        this.messages.blank.replace(
                          "#value#",
                          this.getFormattedCurrency(this.threshold)
                        )
                      );
                },
              },
              {
                key: "getFormattedCurrency",
                value: function (t) {
                  return E.a.format(this.currency, t / 100);
                },
              },
            ]),
            n
          );
        })(),
        N = n(13),
        V = n.n(N),
        U = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var W = (function () {
          function n(t) {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.container =
                l()('[js-gift-wrapping="container"]') || l()(t.container)),
              (this.toggleSelector =
                l()('[js-gift-wrapping="toggle"]') || l()(t.toggleSelector)),
              (this.note = l()('[js-gift-wrapping="note"]') || l()(t.note)),
              (this.variantId = l()('[js-gift-wrapping="container"]').data(
                "variant-id"
              )),
              this.init();
          }
          return (
            U(n, [
              {
                key: "init",
                value: function () {
                  var e = this;
                  this.setToggleEvents(),
                    this.setKeyInputEvents(),
                    this.isGiftWrappingInCart().then(function (t) {
                      t && e.setFormStateActive();
                    });
                },
              },
              {
                key: "setToggleEvents",
                value: function () {
                  var e = this;
                  this.toggleSelector.on("click", function (t) {
                    t.preventDefault(), e.toggleFormState();
                  });
                },
              },
              {
                key: "setKeyInputEvents",
                value: function () {
                  var n = this;
                  this.note.on(
                    "keydown",
                    V.a.debounce(function (t) {
                      var e = n.sanitizeNoteMessage(l()(this).val());
                      n.updateGiftMessageNote(e);
                    }, 500)
                  );
                },
              },
              {
                key: "updateGiftMessageNote",
                value: function (t) {
                  l.a.post("/cart/update.js", "note=" + t, null, "json");
                },
              },
              {
                key: "sanitizeNoteMessage",
                value: function (t) {
                  return (
                    "string" != typeof t &&
                      "undefined" == (t += "") &&
                      (t = ""),
                    l.a.trim(t)
                  );
                },
              },
              {
                key: "toggleFormState",
                value: function () {
                  this.container.hasClass("is-active")
                    ? (this.removeFormState(), this.removeGiftWrapping())
                    : (this.setFormStateActive(), this.addGiftWrapping());
                },
              },
              {
                key: "setFormStateActive",
                value: function () {
                  this.container.addClass("is-active"), this.toggleSelector.find(".choice-box").addClass("is-active"), this.note.parent().addClass("is-active")
                },
              },
              {
                key: "removeFormState",
                value: function () {
                  this.container.removeClass("is-active"), this.toggleSelector.find(".choice-box").removeClass("is-active"), this.note.parent().removeClass("is-active")
                },
              },
              {
                key: "isGiftWrappingInCart",
                value: function () {
                  return new Promise(function (n, t) {
                    l.a.get(
                      "/cart.js",
                      {},
                      function (t) {
                        var e = V.a.some(t.items, function (t) {
                          return !!t.product_type.includes("Gift wrapping");
                        });
                        n(e);
                      },
                      "json"
                    );
                  });
                },
              },
              {
                key: "addGiftWrapping",
                value: function () {
                  l.a.post(
                    "/cart/add.js",
                    {
                      id: this.variantId,
                      quantity: 1,
                    },
                    function (t) {
                      g.emit("cart.giftWrappingAdded", t);
                    },
                    "json"
                  );
                },
              },
              {
                key: "removeGiftWrapping",
                value: function () {
                  var e = this;
                  l.a.post(
                    "/cart/update.js",
                    "updates[" + this.variantId + "]=0",
                    function (t) {
                      g.emit("cart.giftWrappingRemoved", t),
                        e.updateGiftMessageNote("");
                    },
                    "json"
                  );
                },
              },
              {
                key: "getPrice",
                value: function () {
                  return this.container.data("price");
                },
              },
            ]),
            n
          );
        })(),
        G = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      (window.$ = window.jQuery = l.a),
        new ((function () {
          function n() {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this);
            var t = this;
            l()(document).ready(function () {
              t.isCartTemplate() &&
                ((t.qtySelectors = l()('[js-quantity-selector="container"]')),
                (t.subtotal = l()('[js-cart="subtotal"]')),
                (t.discountTotal = l()('[js-cart="cart-discount"]')),
                (t.removeSelectors = l()('[js-cart-form="removeItem"]')),
                (t.container = l()('[js-cart="container"]')),
                (t.selectors = {
                  row: '[js-cart="line-item-row"]',
                  price: '[js-cart="line-item-price"]',
                  discount: '[js-cart="line-item-discount"]',
                }),
                (t.currency = theme.currency),
                (t.updateTimer = {}),
                (t.giftWrapping = new W()),
                (t.freeShipping = new R({
                  container: '[js-free-shipping="container"]',
                  messages: window.freeShipping.messages,
                  threshold: window.freeShipping.threshold,
                })),
                t.init());
            });
          }
          return (
            G(n, [
              {
                key: "isCartTemplate",
                value: function () {
                  return l()("body").hasClass("template-cart-done");
                },
              },
              {
                key: "init",
                value: function () {
                  this.setGiftWrappingEvents()
                },
              },
              {
                key: "setQuantitySelectors",
                value: function () {
                  var n = this,
                    i = {};
                  Array.from(this.qtySelectors).forEach(function (e, t) {
                    i[t] = new j({
                      container: e,
                      callback: function () {
                        clearTimeout(n.updateTimer),
                          (n.updateTimer = setTimeout(function () {
                            n.updateLineItemQuantity(e).then(function (t) {
                              n.updateLineItemTotal(e, t), n.updateCartTotal();
                            });
                          }, 250));
                      },
                    });
                  });
                },
              },
              {
                key: "setGiftWrappingEvents",
                value: function () {
                  var e = this;
                  g.addListener("cart.giftWrappingAdded", function (t) {
                    e.updateCartTotal();
                  }),
                    g.addListener("cart.giftWrappingRemoved", function (t) {
                      e.updateCartTotal();
                    });
                },
              },
              {
                key: "getVariantData",
                value: function (t) {
                  var e = l()(t).closest(this.selectors.row);
                  return {
                    id: e.data("variant-id"),
                    line: e.data("line"),
                    quantity: e.attr("data-qty"),
                  };
                },
              },
              {
                key: "updateLineItemQuantity",
                value: function (t) {
                  var n = this.getVariantData(t);
                  return new Promise(function (e, t) {
                    l.a.ajax({
                      url: "/cart/change.js",
                      type: "POST",
                      dataType: "json",
                      data: {
                        line: n.line,
                        quantity: n.quantity,
                      },
                      success: function (t) {
                        e(t);
                        window.updateJellycatShippingAttribute();
                      },
                    });
                  });
                },
              },
              {
                key: "updateLineItemTotal",
                value: function (t, e) {
                  var n = l()(t).closest(this.selectors.row),
                    i = n.find(this.selectors.price),
                    r = this.getLineItemById(n.data("variant-id"), e);
                  this.updateLineItemDiscountTotal(n, r),
                    i.html(
                      this.getFormattedCurrency(this.currency, r.line_price)
                    );
                },
              },
              {
                key: "updateLineItemDiscountTotal",
                value: function (t, e) {
                  var n = t.find(this.selectors.discount),
                    i = e.discounts.length
                      ? this.getDiscountTextTemplate(e.discounts[0].amount)
                      : "";
                  n.html(i);
                },
              },
              {
                key: "getDiscountTextTemplate",
                value: function (t) {
                  return (
                    1 < arguments.length &&
                      void 0 !== arguments[1] &&
                      arguments[1],
                    '\n      <sup class="line-item__sup" js-cart="line-item-discount">Saving ' +
                      this.getFormattedCurrency(this.currency, t) +
                      "</sup>\n    "
                  );
                },
              },
              {
                key: "updateCartTotal",
                value: function () {
                  var e = this;
                  l.a.get(
                    "/cart.js",
                    {},
                    function (t) {
                      e.subtotal.html(
                        e.getFormattedCurrency(e.currency, t.total_price)
                      ),
                        e.updateCartDiscountTotal(t.total_discount),
                        e.freeShipping.updateValues(),
                        g.emit("cart.cartTotalUpdate", t);
                    },
                    "json"
                  );
                },
              },
              {
                key: "updateCartDiscountTotal",
                value: function (t) {
                  var e =
                    0 < t
                      ? this.getDiscountTextTemplate(t, theme.cart.savings)
                      : "";
                  this.discountTotal.html(e);
                },
              },
              {
                key: "getLineItemById",
                value: function (e, t) {
                  return _.filter(t.items, function (t) {
                    return t.id === e;
                  })[0];
                },
              },
              {
                key: "isTrailingZeros",
                value: function (t, e) {
                  return !!E.a
                    .format(t, e / 100)
                    .toString()
                    .includes(".00");
                },
              },
              {
                key: "getFormattedCurrency",
                value: function (t, e) {
                  return this.isTrailingZeros(t, e)
                    ? E.a.format(t, e / 100, 0)
                    : E.a.format(t, e / 100);
                },
              },
            ]),
            n
          );
        })())(),
        l()(document).ready(function () {
          var t = l()("#BlogTagFilter");
          t.length &&
            t.on("change", function () {
              location.href = l()(this).val();
            });
        });
      var Q = n(5),
        H = n.n(Q),
        K = {
          tiny: "screen and (min-width: 320px)",
          small: "screen and (min-width: 420px)",
          medium: "screen and (min-width: 768px)",
          large: "screen and (min-width: 1024px)",
          huge: "screen and (min-width: 1440px)",
          wide: "screen and (min-width: 1920px)",
        },
        Z = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var J = (function () {
          function n() {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              this.setup();
          }
          return (
            Z(n, [
              {
                key: "setup",
                value: function () {
                  (this.$window = l()(window)),
                    (this.previousScrollTop = 0),
                    (this.currentScrollDirection = ""),
                    (this.newScrollDirection = ""),
                    (this.scrollingThreshold = 5),
                    this.init();
                },
              },
              {
                key: "init",
                value: function () {
                  this.setScrollingEvent();
                },
              },
              {
                key: "setScrollingEvent",
                value: function () {
                  var e = this;
                  e.$window.on("scroll", function () {
                    var t = e.$window.scrollTop();
                    e.setScrollState(t);
                  });
                },
              },
              {
                key: "setScrollState",
                value: function (t) {
                  var e = this.detectScrollDirection(t);
                  void 0 !== e &&
                    e !== this.currentScrollDirection &&
                    ((this.currentScrollDirection = this.newScrollDirection),
                    this.$window.trigger("scrollDirection/directionChanged"));
                },
              },
              {
                key: "detectScrollDirection",
                value: function (t) {
                  if (
                    !(
                      Math.abs(this.previousScrollTop - t) <=
                      this.scrollingThreshold
                    )
                  )
                    return (
                      t > this.previousScrollTop && 100 < t
                        ? (this.newScrollDirection = "down")
                        : (this.newScrollDirection = "up"),
                      t < 100 && (this.newScrollDirection = "at-top"),
                      (this.previousScrollTop = t),
                      this.newScrollDirection
                    );
                },
              },
              {
                key: "getScrollDirection",
                value: function () {
                  return this.currentScrollDirection;
                },
              },
            ]),
            n
          );
        })(),
        X = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var Y = (function () {
          function n() {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.container = l()('[js-announcement="container"]')),
              (this.closeButton = l()('[js-announcement="closeButton"]')),
              this.init();
          }
          return (
            X(n, [
              {
                key: "init",
                value: function () {
                  this.setTriggerEvents(),
                    this.setCookieEvents(),
                    this.setResizeEvents();
                },
              },
              {
                key: "setTriggerEvents",
                value: function () {
                  var e = this;
                  this.closeButton.on("click", function (t) {
                    t.preventDefault(),
                      e.container.slideUp("fast"),
                      d.a.set("_trotters_announcement", "session", {
                        expires: 1,
                        path: "/",
                      });
                  });
                },
              },
              {
                key: "setCookieEvents",
                value: function () {
                  var t = this;
                  d.a.get("_trotters_announcement")
                    ? this.container.remove()
                    : setTimeout(function () {
                        t.container.slideDown();
                      }, 1500);
                },
              },
              {
                key: "setResizeEvents",
                value: function () {
                  var t = this;
                  l()(window).on(
                    "resize",
                    V.a.debounce(function () {
                      t.container.css(
                        "height",
                        l()(".announcement__body").height() + 20
                      );
                    }, 250)
                  );
                },
              },
            ]),
            n
          );
        })(),
        tt = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var et = (function () {
          function n(t) {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.container = l()(t.container)),
              (this.toggle = l()(t.toggle)),
              (this.activeClass = "is-active"),
              this.init();
          }
          return (
            tt(n, [
              {
                key: "init",
                value: function () {
                  this.toggle &&
                    (this.setToggleEvents(),
                    this.setCloseEvents(),
                    this.setFormSubmitEvents());
                },
              },
              {
                key: "setToggleEvents",
                value: function () {
                  var e = this;
                  this.toggle.on("click", function (t) {
                    t.preventDefault(), e.toggleDrawerState();
                  });
                },
              },
              {
                key: "toggleDrawerState",
                value: function () {
                  this.container.toggleClass(this.activeClass),
                    this.toggleWindowOverlay();
                },
              },
              {
                key: "destroyToggleEvents",
                value: function () {
                  this.toggle.off("click");
                },
              },
              {
                key: "setFormSubmitEvents",
                value: function () {
                  var e = l()("#search-form"),
                    t = e.find("button");
                  e.on("keydown", function (t) {
                    13 == t.keyCode && e.submit();
                  }),
                    l()(t).on("click", function (t) {
                      e.submit();
                    });
                },
              },
              {
                key: "getToggleClass",
                value: function () {
                  if (this.container.hasClass(this.activeClass))
                    return this.activeClass;
                },
              },
              {
                key: "setWindowEvents",
                value: function () {
                  var e = this;
                  l()(window).on("click", function (t) {
                    l()(t.target).hasClass("window-overlay") &&
                      e.isToggleActive() &&
                      e.toggleDrawerState();
                  });
                },
              },
              {
                key: "toggleWindowOverlay",
                value: function () {
                  if (this.isToggleActive())
                    return (
                      l()("body").append('<div class="window-overlay"></div>'),
                      void l()(".window-overlay").show()
                    );
                  l()(".window-overlay").remove();
                },
              },
              {
                key: "getToggleClass",
                value: function () {
                  if (this.container.hasClass(this.activeClass))
                    return this.activeClass;
                },
              },
              {
                key: "destroyCloseEvents",
                value: function () {
                  l()(window).off("click"), l()(document).off("keydown.toggle");
                },
              },
              {
                key: "setCloseEvents",
                value: function () {
                  this.setEscEvents(), this.setWindowEvents();
                },
              },
              {
                key: "setEscEvents",
                value: function () {
                  this.isToggleActive()
                    ? this.removeKeyDownToggleEvent()
                    : this.setKeyDownToggleEvent();
                },
              },
              {
                key: "isToggleActive",
                value: function () {
                  return this.getToggleClass();
                },
              },
              {
                key: "isKeyPressIsEsc",
                value: function (t) {
                  return 27 == t.keyCode;
                },
              },
              {
                key: "setKeyDownToggleEvent",
                value: function () {
                  l()(document).on(
                    "keydown.toggle",
                    function (t) {
                      this.isKeyPressIsEsc(t) &&
                        (this.container.removeClass(this.activeClass),
                        this.toggleWindowOverlay());
                    }.bind(this)
                  );
                },
              },
              {
                key: "removeKeyDownToggleEvent",
                value: function () {
                  l()(document).off("keydown.toggle");
                },
              },
            ]),
            n
          );
        })(),
        nt = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var it = (function () {
          function n() {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.container = l()('[js-store-switcher="container"]')),
              (this.selector = l()('[js-store-switcher="selector"]')),
              (this.icon = l()('[js-store-switcher="icon"]')),
              this.init();
          }
          return (
            nt(n, [
              {
                key: "init",
                value: function () {
                  this.setTriggerEvents();
                },
              },
              {
                key: "setTriggerEvents",
                value: function () {
                  var e = this;
                  this.selector.on("change", function (t) {
                    t.preventDefault(),
                      e.updateStoreIcon(this.options[this.selectedIndex]);
                  });
                },
              },
              {
                key: "updateStoreIcon",
                value: function (t) {
                  this.icon.attr("src", l()(t).data("image-src"));
                },
              },
            ]),
            n
          );
        })(),
        rt = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var at = (function () {
          function n(t) {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.announcement = new Y()),
              (this.storeSwitcher = new it()),
              (this.scrollDirection = new J()),
              (this.body = l()("body")),
              (this.container = l()(t.container)),
              (this.containerSelector = t.container),
              (this.content = l()(t.pushContainer)),
              (this.mediaQueries = K),
              (this.drawer = {
                container: t.drawer.container,
                toggle: t.drawer.toggle,
              }),
              this.init();
          }
          return (
            rt(n, [
              {
                key: "init",
                value: function () {
                  this.container &&
                    (this.setHeaderEvents(), this.setMobileDrawerEvents());
                },
              },
              {
                key: "setMobileDrawerEvents",
                value: function () {
                  (this.drawer = new et({
                    container: this.drawer.container,
                    toggle: this.drawer.toggle,
                  })),
                    new w({
                      toggleSelector: ".site-drawer__nav-item button",
                    });
                },
              },
              {
                key: "setHeaderEvents",
                value: function () {
                  this.setBreakpointEvents(),
                    this.setResizeEvents(),
                    this.menuHover();
                },
              },
              {
                key: "setBreakpointEvents",
                value: function () {
                  var t = this;
                  H.a.register(this.mediaQueries.medium, {
                    match: function () {
                      t.container.removeClass("is-fixed"),
                        t.destroyScrollEvents(),
                        t.removeOffsetBody();
                    },
                    unmatch: function () {
                      t.container.addClass("is-fixed"),
                        t.setScrollEvents(),
                        t.setOffsetBody();
                    },
                    setup: function () {
                      t.container.addClass("is-fixed"),
                        t.setScrollEvents(),
                        t.setOffsetBody();
                    },
                  });
                },
              },
              {
                key: "setResizeEvents",
                value: function () {
                  var t = this;
                  l()(window).on(
                    "resize",
                    _.debounce(function () {
                      window.matchMedia(t.mediaQueries.medium).matches
                        ? t.removeOffsetBody()
                        : t.setOffsetBody();
                    }, 250)
                  );
                },
              },
              {
                key: "setOffsetBody",
                value: function () {
                  this.body.css("padding-top", "116px");
                },
              },
              {
                key: "removeOffsetBody",
                value: function () {
                  this.body.removeAttr("style");
                },
              },
              {
                key: "menuHover",
                value: function () {
                  l()(".site-nav__subnav").each(function () {
                    var t = this,
                      e = l()(this).parent(".site-nav__item");
                    e.on("mouseenter", function () {
                      l()(".usp-bar").addClass("nav__overlay"),
                        l()(".main-content").addClass("menu__overlay"),
                        l()(t).parent().siblings().stop().fadeTo("fast", 0.3);
                    }),
                      e.on("mouseleave", function () {
                        l()(".usp-bar").removeClass("nav__overlay"),
                          l()(".main-content").removeClass("menu__overlay"),
                          l()(t).parent().siblings().stop().fadeTo("fast", 1);
                      });
                  });
                },
              },
              {
                key: "getScrollDirection",
                value: function () {
                  return this.scrollDirection.getScrollDirection();
                },
              },
              {
                key: "setScrollEvents",
                value: function () {
                  var t = this,
                    e = this;
                  l()(window).on(
                    "scrollDirection/directionChanged",
                    this.setScrollingState.bind(this)
                  ),
                    l()(window).on(
                      "scroll",
                      _.throttle(function () {
                        e.setScrollState(l()(t).scrollTop());
                      }, 500)
                    );
                },
              },
              {
                key: "setScrollingState",
                value: function () {
                  (this.newScrollingDirection = this.getScrollDirection()),
                    this.setScrollingClasses(),
                    (this.oldScrollingDirection = this.newScrollingDirection);
                },
              },
              {
                key: "setScrollingClasses",
                value: function () {
                  this.container.removeClass(
                    "is-scrolling-" + this.oldScrollingDirection
                  ),
                    this.container.addClass(
                      "is-scrolling-" + this.newScrollingDirection
                    );
                },
              },
              {
                key: "setScrollState",
                value: function (t) {
                  this.container.hasClass("is-scrolling-down")
                    ? this.container.addClass("is-hidden")
                    : this.container.removeClass("is-hidden");
                },
              },
              {
                key: "destroyScrollEvents",
                value: function () {
                  l()(window).off("scroll"),
                    l()(window).off("scrollDirection/directionChanged");
                },
              },
            ]),
            n
          );
        })(),
        ot = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var st = (function () {
          function n() {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.temp = {}),
              (this.container = l()('[js-ajax-cart="container"]')),
              (this.trigger = l()('[js-ajax-cart="triggerKill"]')),
              (this.target = l()('[js-ajax-cart="body"]')),
              (this.addToCart = l()('[js-ajax-cart="addToCart"]')),
              (this.form = l()('[js-product-form="container"]')),
              (this.activeClass = "isnot-active"),
              (this.toggleClass = "isnot-toggled"),
              (this.cartCount = l()('[js-ajax-cart="cartCount"]')),
              (this.cartResponse = l()('[js-ajax-cart="cartResponse"]')),
              (this.currency = theme.currency),
              (this.timer = {}),
              this.init(),
              (this.freeShipping = new R({
                container: '[js-free-shipping="container"]',
                messages: window.freeShipping.messages,
                threshold: window.freeShipping.threshold,
              }));
          }
          return (
            ot(n, [
              {
                key: "init",
                value: function () {
                  this.setMouseEvents(),
                    this.setAddToCartEvents(),
                    this.setListeners();
                },
              },
              {
                key: "setListeners",
                value: function () {
                  var e = this,
                    n = this;
                  g.addListener("cart.cartTotalUpdate", function (t) {
                    e.updateCartBubble(e.getCartItemCount(e.getCartItems(t)));
                  }),
                    g.addListener("cart.freeGiftsRemoved", function () {
                      l.a.ajax({
                        url: "/cart.js",
                        dataType: "json",
                        success: function (t) {
                          n.render(t);
                        },
                      });
                    }),
                    g.addListener("cart.focus", function () {
                      n.open().then(function () {
                        n.scrollToTop();
                      });
                    }),
                    this.setRemoveEvents();
                },
              },
              {
                key: "toggleClass",
                value: function () {
                  this.target.toggleClass(this.activeClass);
                },
              },
              {
                key: "getToggleClass",
                value: function () {
                  return this.target.hasClass(this.activeClass);
                },
              },
              {
                key: "toggleState",
                value: function () {
                  this.removeActiveState();
                },
              },
              {
                key: "getCallback",
                value: function () {
                  this.callback && this.callback(this);
                },
              },
              {
                key: "isTrailingZeros",
                value: function (t, e) {
                  return !!E.a
                    .format(t, e / 100)
                    .toString()
                    .includes(".00");
                },
              },
              {
                key: "getFormattedCurrency",
                value: function (t, e) {
                  return this.isTrailingZeros(t, e)
                    ? E.a.format(t, e / 100, 0)
                    : E.a.format(t, e / 100);
                },
              },
              {
                key: "setMouseEvents",
                value: function () {
                  this.setHoverEvents();
                },
              },
              {
                key: "setCloseEvents",
                value: function () {
                  var e = this,
                    n = this.container.attr("class").split(" ")[0];
                  l()(window).on("click", function (t) {
                    l()(t.target).attr("class").includes(n) ||
                      (e.container.removeClass(this.activeClass),
                      e.destroyWindowEvents());
                  });
                },
              },
              {
                key: "destroyWindowEvents",
                value: function () {
                  l()(window).off("click");
                },
              },
              {
                key: "scrollToTop",
                value: function () {
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                },
              },
              {
                key: "setHoverEvents",
                value: function () {
                  var e = this,
                    n = {};
                  this.trigger.on("mouseenter", function () {
                    l.a.ajax({
                      url: "/cart.js",
                      dataType: "json",
                      success: function (t) {
                        e.render(t), e.setActiveState(), clearTimeout(n);
                      },
                    });
                  }),
                    this.trigger.on("mouseleave", function () {
                      n = setTimeout(function () {
                        e.removeActiveState();
                      }, 250);
                    }),
                    this.container.on("mouseenter", function () {
                      clearTimeout(n);
                    }),
                    this.container.on("mouseleave", function () {
                      n = setTimeout(function () {
                        e.removeActiveState();
                      }, 250);
                    });
                },
              },
              {
                key: "setAddToCartEvents",
                value: function () {
                  var e = this;
                  this.addToCart.on("click", function (t) {
                    t.preventDefault(), e.submitForm(this);
                  });
                },
              },
              {
                key: "submitForm",
                value: function (t) {
                  var e = this,
                    n = document.getElementById("personalise"),
                    n2 = document.getElementById("personalise-2"),
                    n3 = document.getElementById("personalise-3"),
                    n4 = document.getElementById("personalise-4"),
                    i = document.getElementById("personalise_options"),
                    r = document.getElementById("personalisation_error"),
                    r2 = document.getElementById("personalisation_error-2"),
                    r3 = document.getElementById("personalisation_error-3"),
                    r4 = document.getElementById("personalisation_error-4"),
                    a = document.getElementById(
                      "personalisation_options_error"
                    );
                  /*
                    if (r && (r.innerHTML = ""), a && (a.innerHTML = ""), n && !n.value) {
                        var o = !0;
                        r && (r.innerHTML = "This field is required.<br>")
                    }
                    */
                  /*
                  	if (r2 && (r2.innerHTML = ""), a && (a.innerHTML = ""), n2 && !n2.value) {
                        var o = !0;
                        r && (r2.innerHTML = "This field is required.<br>")
                    }
                    */
                  /*
                  	if (r3 && (r3.innerHTML = ""), a && (a.innerHTML = ""), n3 && !n3.value) {
                        var o = !0;
                        r3 && (r3.innerHTML = "This field is required.<br>")
                    }
                    */
                  if (
                    (r4 && (r4.innerHTML = ""),
                    a && (a.innerHTML = ""),
                    n4 && !n4.value)
                  ) {
                    var o = !0;
                    r4 && (r4.innerHTML = "This field is required.<br>");
                  }
                  /*
                    if (i && "0" == i.options[i.selectedIndex].value) {
                        o = !0;
                        a && (a.innerHTML = "This field is required.<br>")
                    }
                    */
                  // console.log(window.productJSON)

                  var selectedOption = "";
                  $(".single-option-selector").each(function () {
                    selectedOption = selectedOption + $(this).val() + " / ";
                  });

                  selectedOption = selectedOption.substring(
                    0,
                    selectedOption.length - 3
                  );

                  if (selectedOption.length) {
                    var compareString = selectedOption;

                    $(window.productJSON.variants).each(function () {
                      if ($(this)[0].title == compareString) {
                        console.log("hit @ " + $(this)[0].title);
                       l()('form[action="/cart/add"]').find('.product-form__master-select').val($(this)[0].id);
                      }
                    });
                  }

                  o ||
                    l.a.ajax({
                      method: "post",
                      url: "/cart/add.js",
                      data: l()('form[action="/cart/add"]').serialize(),
                      dataType: "json",
                      success: function (t) {
                        l.a.ajax({
                          url: "/cart.js",
                          dataType: "json",
                          success: function (t) {
                            e.render(t),
                              e.setFocusState(),
                              e.dispatchEvents(
                                l()('form[action="/cart/add"]').serializeArray()
                              ),
                              e.cartResponse.addClass("is-hidden");
                              var added = JSON.parse($('#ProductJson-product-template').text());
                            console.log(added);
                              // Size selection (only set if size exists)
                              var size = $('.option-selector.is-active').find('.option-selector__button .option-selector__value').text();
                              if (size) {
                                  $('#cart-product-size').text(size);
                                  $('.cart-product-size').show();
                              } else {
                                  $('.cart-product-size').hide();
                              }
                              // Extract color from the product title if it contains ' in '
                              var color = '';
                              if (added.title.includes(' in ')) {
                                var titleParts = added.title.split(' in ');
                                color = titleParts[1];
                              }
                              if (color) {
                                $('#cart-product-color').text(color);
                                $('.cart-product-color').show();
                              } else {
                                $('.cart-product-color').hide();
                              }
                              // Update cart drawer content
                              $('#cart-product-image').attr('src', added.images[0]);
                              $('#cart-product-name').text(added.title);
                              const comparePrice = added.compare_at_price / 100;
                              if (comparePrice > 0) {
                                $('#cart-product-price').text($('#currency_symbol').val() + (added.compare_at_price / 100));
                                $('#cart-product-compare-price').text($('#currency_symbol').val() + (added.price / 100));
                              }else {
                               $('#cart-product-main-price').text($('#currency_symbol').val() + (added.price / 100)); 
                              }                             
                              
                              // Show cart drawer
                              $('.product-added-cart-drawer-overlay').addClass('active');
                              $('.product-added-cart-drawer').addClass('active');
                              $('body').addClass('overflow-hidden'); 

                              if(size){
                                setTimeout(function () {
                                  var newProductId = added.id;
                                  var sameProductDifferentSize = false;
                                
                                  t.items.forEach(function(item) {
                                    if (item.handle === added.handle && item.variant_id !== newProductId) {
                                      var cartSize = "";
                                      item.options_with_values.forEach(function(opt) {
                                        if (opt.name.toLowerCase().includes('size')) {
                                          cartSize = opt.value.trim();
                                        }
                                      });
                                
                                      if (cartSize && cartSize !== size) {
                                        sameProductDifferentSize = true;
                                      }
                                    }
                                  });
                                
                                  if (sameProductDifferentSize) {
                                    $('.product-size-error-overlay').addClass('active');
                                    $('.product-size-error-drawer').addClass('active');
                                    $('.product-added-cart-drawer-overlay').removeClass('active');
                                    $('.product-added-cart-drawer').removeClass('active');                                  
                                  }          
                                },1600);
                              }                              
                              
                          },
                        });
                        window.updateJellycatShippingAttribute();
                      },
                      error: function (t) {
                        e.cartResponse
                          .removeClass("is-hidden")
                          .find("p")
                          .html(t.responseJSON.description),
                          setTimeout(function () {
                            e.cartResponse.addClass("is-hidden");
                          }, 2e3);
                      },
                    });
                },
              },
              {
                key: "isFreeGiftEnabled",
                value: function () {
                  return !0 === this.form.data("enable-free-gift");
                },
              },
              {
                key: "isItemFreeGift",
                value: function (t) {
                  return (
                    null !== t.properties &&
                    void 0 !== t.properties["free-gift"]
                  );
                },
              },
              {
                key: "dispatchEvents",
                value: function (t) {
                  this.isFreeGiftEnabled()
                    ? g.emit("cart.freeItemAdded", t)
                    : g.emit("cart.itemAdded", t);
                },
              },
              {
                key: "setBlankState",
                value: function (t) {
                  if (0 < t) return this.target.html("");
                  this.target.html(
                    '<p class="lead">Your cart is currently empty</p>'
                  );
                },
              },
              {
                key: "updateCartBubble",
                value: function (t) {
                  if (t > 0) {
                    $(".site-header__bag").addClass("packed");
                  } else {
                    $(".site-header__bag").removeClass("packed");
                  }
                  this.cartCount.text(t);
                },
              },
              {
                key: "setFocusState",
                value: function () {
                  var t = this;
                  this.setActiveState(),
                    l()("html, body").animate(
                      {
                        scrollTop: 0,
                      },
                      "fast"
                    ),
                    clearTimeout(this.timer),
                    (this.timer = setTimeout(function () {
                      t.removeActiveState();
                    }, 3e3));
                },
              },
              {
                key: "setOverflowState",
                value: function (t) {
                  if (2 < t) return this.target.addClass("is-overflow");
                  this.target.removeClass("is-overflow");
                },
              },
              {
                key: "setActiveState",
                value: function () {
                  this.container.addClass(this.activeClass);
                },
              },
              {
                key: "removeActiveState",
                value: function () {
                  if (this.target[0].className != "ajax-cart__body") {
                    this.container.removeClass(this.activeClass);
                  }
                },
              },
              {
                key: "destroyHoverEvents",
                value: function () {
                  this.trigger.off("mouseenter"),
                    this.trigger.off("mouseleave"),
                    this.container.off("mouseenter"),
                    this.container.off("mouseleave");
                },
              },
              {
                key: "getSanitizedPriceFromItem",
                value: function (t) {
                  this.currency = $("#currency_symbol").val();

                  var price =
                    this.currency +
                    (t.price / 100).toString().replace(".00", "");

                  // var e = this.getFormattedCurrency(this.currency, t.price);

                  return this.isItemFreeGift(t)
                    ? '<span class="ajax-cart__badge badge badge--tertiary badge--small">Free gift</span>'
                    : 0 === t.discounted_price
                    ? '<span class="ajax-cart__badge badge badge--small">Free</span>'
                    : price;
                },
              },
              {
                key: "getLineItemTitle",
                value: function (t) {
                  return 0 === t.discounted_price
                    ? '<span class="h5 ajax-cart__product-title">' +
                        t.product_title +
                        "</span>"
                    : '<a href="' +
                        t.url +
                        '" class="h5 ajax-cart__product-title">' +
                        t.product_title +
                        "</a>";
                },
              },
              {
                key: "render",
                value: function (t) {
                  var i = this;
                  this.setBlankState(t.item_count);
                  var e = this.getCartItems(t);
                  _.map(e, function (t, e) {
                    var n = i.getLineItemTemplate(t, e + 1);
                    //i.target.append(n)
                  }),
                    this.setOverflowState(e.length),
                    this.updateSubtotal(t.total_price),
                    this.updateCartBubble(this.getCartItemCount(e)),
                    this.setRemoveEvents(),
                    this.freeShipping.updateValues();
                },
              },
              {
                key: "getCartItems",
                value: function (t) {
                  return _.filter(t.items, function (t) {
                    var was = $("#was-" + t.id);
                    if (was.data("was")) {
                      was.text(
                        $("#currency_symbol").val() +
                          (was.data("was") / 100) * t.quantity
                      );
                    }

                    if ("Gift wrapping" !== t.product_type) return t;
                  });
                },
              },
              {
                key: "getCartItemCount",
                value: function (t) {
                  return _.reduce(
                    t,
                    function (t, e) {
                      return t + e.quantity;
                    },
                    0
                  );
                },
              },
              {
                key: "getLineItemTemplate",
                value: function (t, e) {
                  if (typeof t.properties.bundle_name != "undefined") {
                    return (
                      '\n<div class="ajax-cart__item"><div class="ajax-cart__item-image">\n<img src="' +
                      t.image +
                      '">\n</div>\n\n<div class="ajax-cart__item-description">\n<h5 class="ajax-cart__item-title"><a href="' +
                      t.url +
                      '">' +
                      this.getSanitizedProductTitle(t.product_title) +
                      '</a></h5>\n\n\n<span class="ajax-cart__item-meta">\n            ' +
                      this.getVariantTitle(t) +
                      "\n            " +
                      (this.isItemFreeGift(t)
                        ? ""
                        : "Quantity: " + t.quantity) +
                      '\n          </span>\n\n          <p class="ajax-cart__item-price">' +
                      this.getSanitizedPriceFromItem(t) +
                      '</p>\n        </div>\n\n        <a href="#" class="ajax-cart__remove" js-ajax-cart="removeBtn" data-variant-id="' +
                      t.id +
                      '" data-line="' +
                      e +
                      '">×</a>\n      </div>\n      '
                    );
                  }
                },
              },
              {
                key: "getVariantTitle",
                value: function (t) {
                  return t.variant_title ? t.variant_title + "<br>" : "";
                },
              },
              {
                key: "getSanitizedProductTitle",
                value: function (t) {
                  if (t.includes(" in ")) {
                    var e = t.split(" in ");
                    return e[1] + " " + e[0];
                  }
                  return t;
                },
              },
              {
                key: "updateSubtotal",
                value: function (t) {
                  $.get("/cart.json", function (r) {
                    var bundles = {};
                    var bundle_product_count = 0;
                    var bundle_count = 0;
                    $.each(r.items, function (k, v) {
                      if (v.properties.bundle_name) {
                        bundle_product_count += v.quantity;
                        var bundle_name = v.properties.bundle_name;
                        if (!bundles[bundle_name]) {
                          bundles[bundle_name] = {
                            product_count: v.quantity,
                            total: v.line_price,
                            product_list: v.title + "<br>",
                            qty: v.quantity,
                            bundle_ids: v.variant_id + ",",
                          };
                        } else {
                          bundles[bundle_name].product_count += v.quantity;
                          bundles[bundle_name].total += v.line_price;
                          bundles[bundle_name].product_list =
                            bundles[bundle_name].product_list +
                            v.title +
                            "<br>";
                          bundles[bundle_name].bundle_ids =
                            bundles[bundle_name].bundle_ids +
                            v.variant_id +
                            ",";
                        }
                      }
                    });

                    $.each(bundles, function (k, v) {
                      bundle_count++;
                      /*
                        var k = k
                        var v = v

                        var bundleTitle = k.split('#')
                        var bundleHandle = bundleTitle['0'].replace(/ /g, '-')
                        bundleHandle = bundleHandle.split('---')
                        bundleHandle = bundleHandle[0]

                        $.get('/collections/' + bundleHandle + '.json', function(r) {

                            console.log(v.unique_products)
                           
                            var bundle_row = '<div class="ajax-cart__item"><div class="ajax-cart__item-image"><img src="'+r.collection.image.src+'"></div>'
                         +'<div class="ajax-cart__item-description">'
                         +'<h5 class="ajax-cart__item-title"><a href="/collections/'+bundleHandle+'">'+bundleTitle[0]+'</a></h5>'
                         +'<span class="ajax-cart__item-meta">'+v.product_list+'Quantity: '+v.qty+'</span>'
                         +'<p class="ajax-cart__item-price">'+$('#currency_symbol').val()+((v.total/100))+'</p>'
                         +'</div>'
                        +'<a href="#" class="ajax-cart__remove remove-bundle" js-ajax-cart="removeBtn" data-variant-ids="'+v.bundle_ids+'" data-line="1">×</a></div>'

                        $('.ajax-cart__body').append(bundle_row)
                        })

                        */
                    });

                    if (typeof r != "object") {
                      var r = JSON.parse(r);
                    }

                    var added = JSON.parse(
                      $("#ProductJson-product-template").text()
                    );

                    var relatedCol = null;
                    var relatedCollection = "";
                    $.each(added.tags, function (k, v) {
                      if (v.substring(0, 10) == "related-ca") {
                        relatedCol = v.split(" ");
                        relatedCollection = relatedCol[1];
                      } else if (v.substring(0, 10) == "related-co") {
                        relatedCol = v.split(" ");
                        relatedCollection = relatedCol[1];
                      }
                    });
                    if (!relatedCol) {
                      relatedCollection = "";
                    }

                    var size = $(".option-selector.is-active")
                      .find(".option-selector__button")
                      .text();

                    // var slimCart =
                    //   '<div class="slimCart"><div class="slimCartContent">' +
                    //   '<div class="slimCartLeft"><div><img src="' +
                    //   added.images[0] +
                    //   '" height="100"><img src="https://cdn.shopify.com/s/files/1/0597/2112/1980/files/tick-icon.png" class="tick-icon"/><h4>Added To Bag</h4>' +
                    //   '<p style="font-size: 12px;">' +
                    //   added.title +
                    //   "<br>";

                    // if (size) {
                    //   slimCart =
                    //     slimCart +
                    //     "Size: " +
                    //     $(".option-selector.is-active")
                    //       .find(".option-selector__button")
                    //       .text() +
                    //     " - ";
                    // }

                    // slimCart =
                    //   slimCart +
                    //   $("#currency_symbol").val() +
                    //   added.price / 100 +
                    //   "</p></div></div>" +
                    //   '<div class="slimCartRight">' +
                    //   '<a href="/cart" class="btn btn--primary btn-block">CHECKOUT SECURELY &gt;</a>' +
                    //   '<a href="/collections/' +
                    //   relatedCollection +
                    //   '" class="btn btn--primary btn-continue btn-block">CONTINUE SHOPPING &gt;</a>' +
                    //   "</div></div></div>";

                    // $("body").prepend(slimCart);
                    // $(".slimCart").fadeIn();

                    // $("html, body").animate(
                    //   {
                    //     scrollTop: $("#recommendations").offset().top - 110,
                    //   },
                    //   1
                    // );

                    // var total_with_bundles =
                    //   r.item_count - bundle_product_count + bundle_count;

                    // $(".site-header__cart-count").text(total_with_bundles);
                    //  $('.ajax-cart__subtotal').text($('#currency_symbol').val()+(r.total_price/100).toString())
                  });
                  /*
                    var e = this.container.find(".ajax-cart__subtotal");
                    if (0 < t) {
                        // var n = this.getFormattedCurrency(this.currency, t);
                        return e.html("Subtotal: " + $('#cart-subtotal').val())
                    }
                    e.text("")
                    */
                },
              },
              {
                key: "open",
                value: function () {
                  var n = this;
                  return new Promise(function (e, t) {
                    l.a.ajax({
                      url: "/cart.js",
                      dataType: "json",
                      success: function (t) {
                        n.render(t), n.setActiveState(), e();
                      },
                      error: function (t) {
                        console.error(t);
                      },
                    });
                  });
                },
              },
              {
                key: "setRemoveEvents",
                value: function () {
                  var n = this;
                  l()('[js-ajax-cart="removeBtn"]').off("click"),
                    l()('[js-ajax-cart="removeBtn"]').on("click", function (t) {
                      t.preventDefault(),
                        n.setLoadingState(),
                        (n.temp = this.dataset.variantId),
                        l.a.ajax({
                          method: "POST",
                          url: "/cart/change.js",
                          dataType: "json",
                          data: {
                            line: this.dataset.line,
                            quantity: 0,
                          },
                          success: function (e) {
                            n.getChildItemsByVariantId(n.temp).then(function (
                              t
                            ) {
                              n.removeItemsFromCart(t), n.render(e);
                            });
                            window.updateJellycatShippingAttribute();
                          },
                          error: function (t) {
                            n.removeLoadingState();
                          },
                        });
                    });
                },
              },
              {
                key: "removeItemsFromCart",
                value: function (t) {
                  var n = this;
                  t.length
                    ? l.a.ajax({
                        url: "/cart/change.js",
                        dataType: "json",
                        method: "POST",
                        data: {
                          line: t[0].line,
                          quantity: 0,
                        },
                        success: function (e) {
                          n.getChildItemsByVariantId().then(function (t) {
                            n.removeItemsFromCart(t), n.render(e);
                          });
                          window.updateJellycatShippingAttribute();
                        },
                      })
                    : (this.removeLoadingState(),
                      document.querySelector(".template-cart") &&
                        window.location.reload());
                },
              },
              {
                key: "getChildItemsByVariantId",
                value: function () {
                  var i =
                      0 < arguments.length && void 0 !== arguments[0]
                        ? arguments[0]
                        : this.temp,
                    r = this;
                  return new Promise(function (e, n) {
                    l.a.getJSON({
                      url: "/cart.js",
                      success: function (t) {
                        e(
                          _.map(t.items, function (t, e) {
                            if (r.isItemFreeGift(t))
                              return t.properties["free-gift-parent"].includes(
                                i
                              )
                                ? {
                                    line: e + 1,
                                    item: t,
                                  }
                                : null;
                          }).filter(Boolean)
                        );
                      },
                      error: function (t) {
                        n(t);
                      },
                    });
                  });
                },
              },
              {
                key: "getLoaderTemplate",
                value: function () {
                  return '\n      <div class="loader">\n        <div class="ball-pulse">\n          <div></div>\n          <div></div>\n          <div></div>\n        </div>\n      </div>\n    ';
                },
              },
              {
                key: "setLoadingState",
                value: function () {
                  this.container.addClass("is-updating"),
                    this.container.append(this.getLoaderTemplate());
                },
              },
              {
                key: "removeLoadingState",
                value: function () {
                  this.container.removeClass("is-updating"),
                    l()(".loader").remove();
                },
              },
            ]),
            n
          );
        })(),
        lt = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })();
      window.$ = window.jQuery = l.a;
      var ut = (function () {
          function n(t) {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.carousel = {}),
              (this.selectors = {
                container: t.container,
                cell: t.items,
              }),
              (this.mediaQueries = K),
              this.init();
          }
          return (
            lt(n, [
              {
                key: "init",
                value: function () {
                  this.constructCarouselEvents(), this.setBreakpointEvents();
                },
              },
              {
                key: "constructCarouselEvents",
                value: function () {
                  this.carousel = new s({
                    carouselSelector: this.selectors.container,
                    cellSelector: this.selectors.cell,
                    prevNextButtons: !0,
                    pageDots: !1,
                  });
                },
              },
              {
                key: "setBreakpointEvents",
                value: function () {
                  var t = this;
                  H.a.register(this.mediaQueries.large, {
                    match: function () {
                      l()(t.selectors.container).addClass("flex"),
                        t.carousel.destroy();
                    },
                    unmatch: function () {
                      l()(t.selectors.container).removeClass("flex"),
                        (t.carousel = new s({
                          carouselSelector: t.selectors.container,
                          cellSelector: t.selectors.cell,
                          prevNextButtons: !0,
                          pageDots: !1,
                        }));
                    },
                  });
                },
              },
            ]),
            n
          );
        })(),
        ct = (function () {
          function i(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), t;
          };
        })(),
        ht = (function () {
          function n() {
            !(function (t, e) {
              if (!(t instanceof n))
                throw new TypeError("Cannot call a class as a function");
            })(this),
              (this.queue = []),
              (this.selectors = {
                quantitySelector: '[js-quantity-selector="container"]',
                quantityInput: '[js-quantity-selector="input"]',
                optionSelector: ".option-selector",
                product: '[js-shop-the-look="product"]',
                note: '[js-option-selector="note"]',
              }),
              (this.products = l()('[js-shop-the-look="product"]')),
              (this.addToCart = l()('[js-shop-the-look="addToCart"]')),
              (this.optionSelectors = l()(
                '[js-shop-the-look="optionSelector"]'
              )),
              (this.note = l()('[js-shop-the-look="note"]')),
              (this.total = l()('[js-shop-the-look="totalPrice"]')),
              (this.qtySelectors = {}),
              this.init();
          }
          return (
            ct(n, [
              {
                key: "init",
                value: function () {
                  console.log("Initiating Shop the look"),
                    this.setQuantitySelectors(),
                    this.setOptionSelectors(),
                    this.setInitState();
                },
              },
              {
                key: "setInitState",
                value: function () {
                  this.updateFormState();
                },
              },
              {
                key: "setQuantitySelectors",
                value: function () {
                  var n = this,
                    i = this;
                  Array.from(l()(this.selectors.quantitySelector)).forEach(
                    function (t, e) {
                      n.qtySelectors[e] = new j({
                        container: t,
                        callback: function () {
                          i.updateFormState();
                        },
                      });
                    }
                  );
                },
              },
              {
                key: "setOptionSelectors",
                value: function () {
                  var e = this;
                  this.optionSelectors.on("click", function (t) {
                    t.preventDefault(),
                      e.updateOptionState(l()(this)),
                      e.updateQuantityState(l()(this)),
                      e.updateInventoryNotification(l()(this)),
                      e.updateFormState();
                  });
                },
              },
              {
                key: "updateOptionState",
                value: function (t) {
                  var e = this.getOptionData(t);
                  t
                    .closest(this.selectors.product)
                    .attr("data-variant-price", e.price),
                    t
                      .closest(this.selectors.product)
                      .attr("data-variant-id", e.id),
                    t
                      .closest(this.selectors.product)
                      .attr("data-inventory-quantity", e.quantity),
                    t
                      .closest(".option-selector__listing")
                      .find(this.selectors.optionSelector)
                      .removeClass("is-active"),
                    t.closest(".option-selector").addClass("is-active");
                },
              },
              {
                key: "getOptionData",
                value: function (t) {
                  return {
                    price: t.data("variant-price"),
                    id: t.data("variant-id"),
                    quantity: t.data("inventory-quantity"),
                  };
                },
              },
              {
                key: "updateFormState",
                value: function () {
                  this.updateAddToCartState(),
                    this.updateTotal(),
                    this.removeFormNote();
                },
              },
              {
                key: "updateQuantityState",
                value: function (t) {
                  var e = t.closest(this.selectors.product),
                    n = t.closest(this.selectors.product).data("id");
                  e
                    .find(this.selectors.quantitySelector)
                    .attr("data-max", t.data("inventory-quantity")),
                    this.qtySelectors[n].reinit();
                },
              },
              {
                key: "updateAddToCartState",
                value: function () {
                  this.isItemInQueue()
                    ? this.setAddToCartActive()
                    : this.setAddToCartInactive();
                },
              },
              {
                key: "setAddToCartActive",
                value: function () {
                  this.addToCart.removeClass("btn--disabled"),
                    this.addToCart.text("Add selected to bag"),
                    this.setAddToCartEvents();
                },
              },
              {
                key: "setAddToCartInactive",
                value: function () {
                  var t =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : theme.strings.addToCartBlank;
                  this.addToCart.addClass("btn--disabled"),
                    this.addToCart.text(t),
                    this.removeAddToCartEvents();
                },
              },
              {
                key: "setAddToCartEvents",
                value: function () {
                  var e = this;
                  this.removeAddToCartEvents(),
                    this.addToCart.on("click", function (t) {
                      t.preventDefault(), e.setQueue(), e.addQueueToCart();
                    });
                },
              },
              {
                key: "setFormNote",
                value: function (t) {
                  this.note.removeClass("is-hidden"), this.note.text(t);
                },
              },
              {
                key: "removeFormNote",
                value: function () {
                  this.note.addClass("is-hidden"), this.note.text("");
                },
              },
              {
                key: "removeAddToCartEvents",
                value: function () {
                  this.addToCart.off("click");
                },
              },
              {
                key: "isItemInQueue",
                value: function () {
                  return 0 < this.getTotalQuantity();
                },
              },
              {
                key: "getTotalQuantity",
                value: function () {
                  return _.reduce(
                    this.qtySelectors,
                    function (t, e) {
                      return t + parseInt(e.input.val());
                    },
                    0
                  );
                },
              },
              {
                key: "getTotalPrice",
                value: function () {
                  return _.reduce(
                    this.getQueuedItems(),
                    function (t, e) {
                      return 0 < e.quantity
                        ? t + e.total_price * e.quantity
                        : 0;
                    },
                    0
                  );
                },
              },
              {
                key: "getFormattedPrice",
                value: function (t) {
                  return E.a.format(theme.currency, t / 100);
                },
              },
              {
                key: "setQueue",
                value: function () {
                  console.log("Init queue:", this.queue),
                    (this.queue = []),
                    this.queue.push(this.getQueuedItems()),
                    console.log("Setting queue:", this.queue),
                    console.log("- - -");
                },
              },
              {
                key: "getQueuedItems",
                value: function () {
                  var e = this;
                  return _.chain(this.products)
                    .filter(function (t) {
                      return 0 < e.getInputValueFromItem(t);
                    })
                    .map(function (t) {
                      return {
                        id: l()(t).attr("data-variant-id"),
                        total_price: l()(t).attr("data-variant-price"),
                        quantity: e.getInputValueFromItem(t),
                      };
                    })
                    .value();
                },
              },
              {
                key: "getInputValueFromItem",
                value: function (t) {
                  return parseInt(
                    l()(t).find(this.selectors.quantityInput).val()
                  );
                },
              },
              {
                key: "addQueueToCart",
                value: function () {
                  Shopify.queue = this.queue[0];
                  /*
                    for (var product of this.queue) {
                      console.log('product id')
                      console.log(product)
                      Shopify.queue.push({
                        variantId: product.id,
                      });
                    }
                  */
                  Shopify.moveAlong = function () {
                    // If we still have requests in the queue, let's process the next one.
                    if (Shopify.queue.length) {
                      var request = Shopify.queue.shift();
                      var data = { id: request.id, quantity: request.quantity };
                      if (typeof uuid != "undefined") {
                        data.properties = {
                          bundle_name:
                            $(".shop-the-look__header p").text() + "#" + uuid,
                        };
                      }
                      $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        dataType: "json",
                        data: data,
                        success: function (res) {
                          Shopify.moveAlong();
                          window.updateJellycatShippingAttribute();
                        },
                        error: function () {
                          // if it's not last one Move Along else update the cart number with the current quantity
                          if (Shopify.queue.length) {
                            Shopify.moveAlong();
                          } else {
                            window.location = "/cart";
                          }
                        },
                      });
                    }
                    // If the queue is empty, we add 1 to cart
                    else {
                      window.location = "/cart";
                    }
                  };
                  Shopify.moveAlong();

                  /*
                    var e = this;
                    console.log("Current queue: ", this.queue), this.queue[0].length ? (console.log("Before:", this.queue), this.setAddToCartInactive(theme.strings.addToCartLoading), this.addItemToCart(this.queue[0].shift()).then(function(t) {
                        return e.addQueueToCart()
                    })) : (this.setAddToCartActive(), g.emit("cart.focus"), console.log("Done: ", this.queue))

                    
                    if($('.shop-the-look').length) {
                       // window.location = '/cart'
                    }
    				*/
                },
              },
              {
                key: "addItemToCart",
                value: function (n, t) {
                  var i = this;

                  var lineData = {
                    id: n.id,
                    quantity: n.quantity,
                  };

                  if (typeof uuid != "undefined") {
                    lineData.properties = {
                      bundle_name:
                        $(".shop-the-look__header p").text() + "#" + uuid,
                    };
                  }

                  return new Promise(function (e, t) {
                    l.a.ajax({
                      type: "POST",
                      url: "/cart/add.js",
                      dataType: "json",
                      data: lineData,
                      success: function (t) {
                        window.updateJellycatShippingAttribute();
                      },
                      error: function (t) {
                        console.error(t),
                          422 === t.status &&
                            (i.setFormNote(
                              t.responseJSON.description +
                                " Please adjust quantity and try again."
                            ),
                            i.setAddToCartInactive(theme.strings.addToCart));
                      },
                    });
                  });
                },
              },
              {
                key: "updateTotal",
                value: function () {
                  this.total.text([
                    0 < this.getTotalPrice()
                      ? this.getFormattedPrice(this.getTotalPrice())
                      : "—",
                  ]);
                },
              },
              {
                key: "updateInventoryNotification",
                value: function (t) {
                  var e = parseInt(t.data("inventory-quantity")),
                    n = t
                      .closest(this.selectors.product)
                      .find(this.selectors.note);
                  n.removeClass("is-hidden"),
                    1 === e
                      ? n.html("<p>There is only 1 unit left in this size</p>")
                      : e <= 5
                      ? n.html(
                          "<p>There are only " + e + " left in this size</p>"
                        )
                      : n.addClass("is-hidden");
                },
              },
            ]),
            n
          );
        })();
      (window.$ = window.jQuery = l.a),
        (window.Frame = window.Frame || {}),
        l()(document).ready(function () {
          (Frame.Carousel = s),
            (Frame.AjaxCart = new st()),
            new at({
              container: '[js-site-header="container"]',
              drawer: {
                container: '[js-drawer="site-menu-container"]',
                toggle: '[js-drawer="site-menu-toggle"]',
              },
            }),
            new ut({
              container: ".usp-bar__carousel",
              items: ".usp-bar__slide",
              autoPlay: true,
            }),
            document.querySelector(".shop-the-look__body") && new ht();
        });
    },
    function (t, e) {
      var n = loadCSS("../../../critical.css");
      onloadCSS(n, function () {
        console.log("Stylesheet has loaded.");
      });
    },
    function (t, e, n) {
      var i, r;
      window,
        (i = [n(19), n(31)]),
        void 0 ===
          (r = function (t, e) {
            return (function (t, e, n) {
              "use strict";
              e.createMethods.push("_createImagesLoaded");
              var i = e.prototype;
              return (
                (i._createImagesLoaded = function () {
                  this.on("activate", this.imagesLoaded);
                }),
                (i.imagesLoaded = function () {
                  if (this.options.imagesLoaded) {
                    var i = this;
                    n(this.slider).on("progress", function (t, e) {
                      var n = i.getParentCell(e.img);
                      i.cellSizeChange(n && n.element),
                        i.options.freeScroll || i.positionSliderAtSelected();
                    });
                  }
                }),
                e
              );
            })(0, t, e);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r, a, o;
      window,
        (o = function (t) {
          return t;
        }),
        (r = [n(3), n(24), n(26), n(27), n(28), n(29), n(30)]),
        void 0 === (a = "function" == typeof (i = o) ? i.apply(e, r) : i) ||
          (t.exports = a);
    },
    function (n, i, r) {
      var a, o;
      !(function (t, e) {
        "use strict";
        void 0 ===
          (o =
            "function" ==
            typeof (a = function () {
              var n = (function () {
                var t = window.Element.prototype;
                if (t.matches) return "matches";
                if (t.matchesSelector) return "matchesSelector";
                for (
                  var e = ["webkit", "moz", "ms", "o"], n = 0;
                  n < e.length;
                  n++
                ) {
                  var i = e[n] + "MatchesSelector";
                  if (t[i]) return i;
                }
              })();
              return function (t, e) {
                return t[n](e);
              };
            })
              ? a.call(i, r, i, n)
              : a) || (n.exports = o);
      })(window);
    },
    function (t, e, n) {
      var i, r;
      window,
        (i = [n(6)]),
        void 0 ===
          (r = function (t) {
            return (function (t, e) {
              "use strict";

              function n(t, e) {
                (this.element = t), (this.parent = e), this.create();
              }
              var i = n.prototype;
              return (
                (i.create = function () {
                  (this.element.style.position = "absolute"),
                    this.element.setAttribute("aria-selected", "false"),
                    (this.x = 0),
                    (this.shift = 0);
                }),
                (i.destroy = function () {
                  this.element.style.position = "";
                  var t = this.parent.originSide;
                  this.element.removeAttribute("aria-selected"),
                    (this.element.style[t] = "");
                }),
                (i.getSize = function () {
                  this.size = e(this.element);
                }),
                (i.setPosition = function (t) {
                  (this.x = t), this.updateTarget(), this.renderPosition(t);
                }),
                (i.updateTarget = i.setDefaultTarget =
                  function () {
                    var t =
                      "left" == this.parent.originSide
                        ? "marginLeft"
                        : "marginRight";
                    this.target =
                      this.x +
                      this.size[t] +
                      this.size.width * this.parent.cellAlign;
                  }),
                (i.renderPosition = function (t) {
                  var e = this.parent.originSide;
                  this.element.style[e] = this.parent.getPositionValue(t);
                }),
                (i.wrapShift = function (t) {
                  (this.shift = t),
                    this.renderPosition(
                      this.x + this.parent.slideableWidth * t
                    );
                }),
                (i.remove = function () {
                  this.element.parentNode.removeChild(this.element);
                }),
                n
              );
            })(0, t);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r;
      window,
        void 0 ===
          (r =
            "function" ==
            typeof (i = function () {
              "use strict";

              function t(t) {
                (this.parent = t),
                  (this.isOriginLeft = "left" == t.originSide),
                  (this.cells = []),
                  (this.outerWidth = 0),
                  (this.height = 0);
              }
              var e = t.prototype;
              return (
                (e.addCell = function (t) {
                  if (
                    (this.cells.push(t),
                    (this.outerWidth += t.size.outerWidth),
                    (this.height = Math.max(t.size.outerHeight, this.height)),
                    1 == this.cells.length)
                  ) {
                    this.x = t.x;
                    var e = this.isOriginLeft ? "marginLeft" : "marginRight";
                    this.firstMargin = t.size[e];
                  }
                }),
                (e.updateTarget = function () {
                  var t = this.isOriginLeft ? "marginRight" : "marginLeft",
                    e = this.getLastCell(),
                    n = e ? e.size[t] : 0,
                    i = this.outerWidth - (this.firstMargin + n);
                  this.target =
                    this.x + this.firstMargin + i * this.parent.cellAlign;
                }),
                (e.getLastCell = function () {
                  return this.cells[this.cells.length - 1];
                }),
                (e.select = function () {
                  this.changeSelected(!0);
                }),
                (e.unselect = function () {
                  this.changeSelected(!1);
                }),
                (e.changeSelected = function (e) {
                  var n = e ? "add" : "remove";
                  this.cells.forEach(function (t) {
                    t.element.classList[n]("is-selected"),
                      t.element.setAttribute("aria-selected", e.toString());
                  });
                }),
                (e.getCellElements = function () {
                  return this.cells.map(function (t) {
                    return t.element;
                  });
                }),
                t
              );
            })
              ? i.call(e, n, e, t)
              : i) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r;
      window,
        (i = [n(1)]),
        void 0 ===
          (r = function (t) {
            return (function (t, a) {
              "use strict";
              return {
                startAnimation: function () {
                  this.isAnimating ||
                    ((this.isAnimating = !0),
                    (this.restingFrames = 0),
                    this.animate());
                },
                animate: function () {
                  this.applyDragForce(), this.applySelectedAttraction();
                  var t = this.x;
                  if (
                    (this.integratePhysics(),
                    this.positionSlider(),
                    this.settle(t),
                    this.isAnimating)
                  ) {
                    var e = this;
                    requestAnimationFrame(function () {
                      e.animate();
                    });
                  }
                },
                positionSlider: function () {
                  var t = this.x;
                  this.options.wrapAround &&
                    1 < this.cells.length &&
                    ((t = a.modulo(t, this.slideableWidth)),
                    (t -= this.slideableWidth),
                    this.shiftWrapCells(t)),
                    (t += this.cursorPosition),
                    (t = this.options.rightToLeft ? -t : t);
                  var e = this.getPositionValue(t);
                  this.slider.style.transform = this.isAnimating
                    ? "translate3d(" + e + ",0,0)"
                    : "translateX(" + e + ")";
                  var n = this.slides[0];
                  if (n) {
                    var i = -this.x - n.target,
                      r = i / this.slidesWidth;
                    this.dispatchEvent("scroll", null, [r, i]);
                  }
                },
                positionSliderAtSelected: function () {
                  this.cells.length &&
                    ((this.x = -this.selectedSlide.target),
                    (this.velocity = 0),
                    this.positionSlider());
                },
                getPositionValue: function (t) {
                  return this.options.percentPosition
                    ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%"
                    : Math.round(t) + "px";
                },
                settle: function (t) {
                  this.isPointerDown ||
                    Math.round(100 * this.x) != Math.round(100 * t) ||
                    this.restingFrames++,
                    2 < this.restingFrames &&
                      ((this.isAnimating = !1),
                      delete this.isFreeScrolling,
                      this.positionSlider(),
                      this.dispatchEvent("settle", null, [this.selectedIndex]));
                },
                shiftWrapCells: function (t) {
                  var e = this.cursorPosition + t;
                  this._shiftCells(this.beforeShiftCells, e, -1);
                  var n =
                    this.size.innerWidth -
                    (t + this.slideableWidth + this.cursorPosition);
                  this._shiftCells(this.afterShiftCells, n, 1);
                },
                _shiftCells: function (t, e, n) {
                  for (var i = 0; i < t.length; i++) {
                    var r = t[i],
                      a = 0 < e ? n : 0;
                    r.wrapShift(a), (e -= r.size.outerWidth);
                  }
                },
                _unshiftCells: function (t) {
                  if (t && t.length)
                    for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
                },
                integratePhysics: function () {
                  (this.x += this.velocity),
                    (this.velocity *= this.getFrictionFactor());
                },
                applyForce: function (t) {
                  this.velocity += t;
                },
                getFrictionFactor: function () {
                  return (
                    1 -
                    this.options[
                      this.isFreeScrolling ? "freeScrollFriction" : "friction"
                    ]
                  );
                },
                getRestingPosition: function () {
                  return (
                    this.x + this.velocity / (1 - this.getFrictionFactor())
                  );
                },
                applyDragForce: function () {
                  if (this.isDraggable && this.isPointerDown) {
                    var t = this.dragX - this.x - this.velocity;
                    this.applyForce(t);
                  }
                },
                applySelectedAttraction: function () {
                  if (
                    (!this.isDraggable || !this.isPointerDown) &&
                    !this.isFreeScrolling &&
                    this.slides.length
                  ) {
                    var t =
                      (-1 * this.selectedSlide.target - this.x) *
                      this.options.selectedAttraction;
                    this.applyForce(t);
                  }
                },
              };
            })(0, t);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r, a;
      (a = window),
        (i = [n(3), n(25), n(1)]),
        void 0 ===
          (r = function (t, e, n) {
            return (function (n, t, e, s) {
              "use strict";
              s.extend(t.defaults, {
                draggable: ">1",
                dragThreshold: 3,
              }),
                t.createMethods.push("_createDrag");
              var i = t.prototype;
              s.extend(i, e.prototype), (i._touchActionValue = "pan-y");
              var r = "createTouch" in document,
                a = !1;
              (i._createDrag = function () {
                this.on("activate", this.onActivateDrag),
                  this.on("uiChange", this._uiChangeDrag),
                  this.on("childUIPointerDown", this._childUIPointerDownDrag),
                  this.on("deactivate", this.unbindDrag),
                  this.on("cellChange", this.updateDraggable),
                  r &&
                    !a &&
                    (n.addEventListener("touchmove", function () {}), (a = !0));
              }),
                (i.onActivateDrag = function () {
                  (this.handles = [this.viewport]),
                    this.bindHandles(),
                    this.updateDraggable();
                }),
                (i.onDeactivateDrag = function () {
                  this.unbindHandles(),
                    this.element.classList.remove("is-draggable");
                }),
                (i.updateDraggable = function () {
                  ">1" == this.options.draggable
                    ? (this.isDraggable = 1 < this.slides.length)
                    : (this.isDraggable = this.options.draggable),
                    this.isDraggable
                      ? this.element.classList.add("is-draggable")
                      : this.element.classList.remove("is-draggable");
                }),
                (i.bindDrag = function () {
                  (this.options.draggable = !0), this.updateDraggable();
                }),
                (i.unbindDrag = function () {
                  (this.options.draggable = !1), this.updateDraggable();
                }),
                (i._uiChangeDrag = function () {
                  delete this.isFreeScrolling;
                }),
                (i._childUIPointerDownDrag = function (t) {
                  t.preventDefault(), this.pointerDownFocus(t);
                }),
                (i.pointerDown = function (t, e) {
                  this.isDraggable
                    ? this.okayPointerDown(t) &&
                      (this._pointerDownPreventDefault(t),
                      this.pointerDownFocus(t),
                      document.activeElement != this.element &&
                        this.pointerDownBlur(),
                      (this.dragX = this.x),
                      this.viewport.classList.add("is-pointer-down"),
                      (this.pointerDownScroll = l()),
                      n.addEventListener("scroll", this),
                      this._pointerDownDefault(t, e))
                    : this._pointerDownDefault(t, e);
                }),
                (i._pointerDownDefault = function (t, e) {
                  (this.pointerDownPointer = e),
                    this._bindPostStartEvents(t),
                    this.dispatchEvent("pointerDown", t, [e]);
                });
              var o = {
                INPUT: !0,
                TEXTAREA: !0,
                SELECT: !0,
              };

              function l() {
                return {
                  x: n.pageXOffset,
                  y: n.pageYOffset,
                };
              }
              return (
                (i.pointerDownFocus = function (t) {
                  o[t.target.nodeName] || this.focus();
                }),
                (i._pointerDownPreventDefault = function (t) {
                  var e = "touchstart" == t.type,
                    n = "touch" == t.pointerType,
                    i = o[t.target.nodeName];
                  e || n || i || t.preventDefault();
                }),
                (i.hasDragStarted = function (t) {
                  return Math.abs(t.x) > this.options.dragThreshold;
                }),
                (i.pointerUp = function (t, e) {
                  delete this.isTouchScrolling,
                    this.viewport.classList.remove("is-pointer-down"),
                    this.dispatchEvent("pointerUp", t, [e]),
                    this._dragPointerUp(t, e);
                }),
                (i.pointerDone = function () {
                  n.removeEventListener("scroll", this),
                    delete this.pointerDownScroll;
                }),
                (i.dragStart = function (t, e) {
                  this.isDraggable &&
                    ((this.dragStartPosition = this.x),
                    this.startAnimation(),
                    n.removeEventListener("scroll", this),
                    this.dispatchEvent("dragStart", t, [e]));
                }),
                (i.pointerMove = function (t, e) {
                  var n = this._dragPointerMove(t, e);
                  this.dispatchEvent("pointerMove", t, [e, n]),
                    this._dragMove(t, e, n);
                }),
                (i.dragMove = function (t, e, n) {
                  if (this.isDraggable) {
                    t.preventDefault(), (this.previousDragX = this.dragX);
                    var i = this.options.rightToLeft ? -1 : 1;
                    this.options.wrapAround &&
                      (n.x = n.x % this.slideableWidth);
                    var r = this.dragStartPosition + n.x * i;
                    if (!this.options.wrapAround && this.slides.length) {
                      var a = Math.max(
                        -this.slides[0].target,
                        this.dragStartPosition
                      );
                      r = a < r ? 0.5 * (r + a) : r;
                      var o = Math.min(
                        -this.getLastSlide().target,
                        this.dragStartPosition
                      );
                      r = r < o ? 0.5 * (r + o) : r;
                    }
                    (this.dragX = r),
                      (this.dragMoveTime = new Date()),
                      this.dispatchEvent("dragMove", t, [e, n]);
                  }
                }),
                (i.dragEnd = function (t, e) {
                  if (this.isDraggable) {
                    this.options.freeScroll && (this.isFreeScrolling = !0);
                    var n = this.dragEndRestingSelect();
                    if (this.options.freeScroll && !this.options.wrapAround) {
                      var i = this.getRestingPosition();
                      this.isFreeScrolling =
                        -i > this.slides[0].target &&
                        -i < this.getLastSlide().target;
                    } else
                      this.options.freeScroll ||
                        n != this.selectedIndex ||
                        (n += this.dragEndBoostSelect());
                    delete this.previousDragX,
                      (this.isDragSelect = this.options.wrapAround),
                      this.select(n),
                      delete this.isDragSelect,
                      this.dispatchEvent("dragEnd", t, [e]);
                  }
                }),
                (i.dragEndRestingSelect = function () {
                  var t = this.getRestingPosition(),
                    e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
                    n = this._getClosestResting(t, e, 1),
                    i = this._getClosestResting(t, e, -1);
                  return n.distance < i.distance ? n.index : i.index;
                }),
                (i._getClosestResting = function (t, e, n) {
                  for (
                    var i = this.selectedIndex,
                      r = 1 / 0,
                      a =
                        this.options.contain && !this.options.wrapAround
                          ? function (t, e) {
                              return t <= e;
                            }
                          : function (t, e) {
                              return t < e;
                            };
                    a(e, r) &&
                    ((i += n),
                    (r = e),
                    null !== (e = this.getSlideDistance(-t, i)));

                  )
                    e = Math.abs(e);
                  return {
                    distance: r,
                    index: i - n,
                  };
                }),
                (i.getSlideDistance = function (t, e) {
                  var n = this.slides.length,
                    i = this.options.wrapAround && 1 < n,
                    r = i ? s.modulo(e, n) : e,
                    a = this.slides[r];
                  if (!a) return null;
                  var o = i ? this.slideableWidth * Math.floor(e / n) : 0;
                  return t - (a.target + o);
                }),
                (i.dragEndBoostSelect = function () {
                  if (
                    void 0 === this.previousDragX ||
                    !this.dragMoveTime ||
                    100 < new Date() - this.dragMoveTime
                  )
                    return 0;
                  var t = this.getSlideDistance(
                      -this.dragX,
                      this.selectedIndex
                    ),
                    e = this.previousDragX - this.dragX;
                  return 0 < t && 0 < e ? 1 : t < 0 && e < 0 ? -1 : 0;
                }),
                (i.staticClick = function (t, e) {
                  var n = this.getParentCell(t.target),
                    i = n && n.element,
                    r = n && this.cells.indexOf(n);
                  this.dispatchEvent("staticClick", t, [e, i, r]);
                }),
                (i.onscroll = function () {
                  var t = l(),
                    e = this.pointerDownScroll.x - t.x,
                    n = this.pointerDownScroll.y - t.y;
                  (3 < Math.abs(e) || 3 < Math.abs(n)) && this._pointerDone();
                }),
                t
              );
            })(a, t, e, n);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r, a;
      (a = window),
        (i = [n(7)]),
        void 0 ===
          (r = function (t) {
            return (function (a, t) {
              "use strict";

              function e() {}
              var n = (e.prototype = Object.create(t.prototype));
              (n.bindHandles = function () {
                this._bindHandles(!0);
              }),
                (n.unbindHandles = function () {
                  this._bindHandles(!1);
                }),
                (n._bindHandles = function (t) {
                  for (
                    var e = (t = void 0 === t || t)
                        ? "addEventListener"
                        : "removeEventListener",
                      n = t ? this._touchActionValue : "",
                      i = 0;
                    i < this.handles.length;
                    i++
                  ) {
                    var r = this.handles[i];
                    this._bindStartEvent(r, t),
                      r[e]("click", this),
                      a.PointerEvent && (r.style.touchAction = n);
                  }
                }),
                (n._touchActionValue = "none"),
                (n.pointerDown = function (t, e) {
                  this.okayPointerDown(t) &&
                    ((this.pointerDownPointer = e),
                    t.preventDefault(),
                    this.pointerDownBlur(),
                    this._bindPostStartEvents(t),
                    this.emitEvent("pointerDown", [t, e]));
                });
              var r = {
                  TEXTAREA: !0,
                  INPUT: !0,
                  SELECT: !0,
                  OPTION: !0,
                },
                o = {
                  radio: !0,
                  checkbox: !0,
                  button: !0,
                  submit: !0,
                  image: !0,
                  file: !0,
                };
              return (
                (n.okayPointerDown = function (t) {
                  var e = r[t.target.nodeName],
                    n = o[t.target.type],
                    i = !e || n;
                  return i || this._pointerReset(), i;
                }),
                (n.pointerDownBlur = function () {
                  var t = document.activeElement;
                  t && t.blur && t != document.body && t.blur();
                }),
                (n.pointerMove = function (t, e) {
                  var n = this._dragPointerMove(t, e);
                  this.emitEvent("pointerMove", [t, e, n]),
                    this._dragMove(t, e, n);
                }),
                (n._dragPointerMove = function (t, e) {
                  var n = {
                    x: e.pageX - this.pointerDownPointer.pageX,
                    y: e.pageY - this.pointerDownPointer.pageY,
                  };
                  return (
                    !this.isDragging &&
                      this.hasDragStarted(n) &&
                      this._dragStart(t, e),
                    n
                  );
                }),
                (n.hasDragStarted = function (t) {
                  return 3 < Math.abs(t.x) || 3 < Math.abs(t.y);
                }),
                (n.pointerUp = function (t, e) {
                  this.emitEvent("pointerUp", [t, e]),
                    this._dragPointerUp(t, e);
                }),
                (n._dragPointerUp = function (t, e) {
                  this.isDragging
                    ? this._dragEnd(t, e)
                    : this._staticClick(t, e);
                }),
                (n._dragStart = function (t, e) {
                  (this.isDragging = !0),
                    (this.isPreventingClicks = !0),
                    this.dragStart(t, e);
                }),
                (n.dragStart = function (t, e) {
                  this.emitEvent("dragStart", [t, e]);
                }),
                (n._dragMove = function (t, e, n) {
                  this.isDragging && this.dragMove(t, e, n);
                }),
                (n.dragMove = function (t, e, n) {
                  t.preventDefault(), this.emitEvent("dragMove", [t, e, n]);
                }),
                (n._dragEnd = function (t, e) {
                  (this.isDragging = !1),
                    setTimeout(
                      function () {
                        delete this.isPreventingClicks;
                      }.bind(this)
                    ),
                    this.dragEnd(t, e);
                }),
                (n.dragEnd = function (t, e) {
                  this.emitEvent("dragEnd", [t, e]);
                }),
                (n.onclick = function (t) {
                  this.isPreventingClicks && t.preventDefault();
                }),
                (n._staticClick = function (t, e) {
                  (this.isIgnoringMouseUp && "mouseup" == t.type) ||
                    (this.staticClick(t, e),
                    "mouseup" != t.type &&
                      ((this.isIgnoringMouseUp = !0),
                      setTimeout(
                        function () {
                          delete this.isIgnoringMouseUp;
                        }.bind(this),
                        400
                      )));
                }),
                (n.staticClick = function (t, e) {
                  this.emitEvent("staticClick", [t, e]);
                }),
                (e.getPointerPoint = t.getPointerPoint),
                e
              );
            })(a, t);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r;
      window,
        (i = [n(3), n(8), n(1)]),
        void 0 ===
          (r = function (t, e, n) {
            return (function (t, e, n, i) {
              "use strict";
              var r = "http://www.w3.org/2000/svg";

              function a(t, e) {
                (this.direction = t), (this.parent = e), this._create();
              }
              ((a.prototype = Object.create(n.prototype))._create =
                function () {
                  (this.isEnabled = !0),
                    (this.isPrevious = -1 == this.direction);
                  var t = this.parent.options.rightToLeft ? 1 : -1;
                  this.isLeft = this.direction == t;
                  var e = (this.element = document.createElement("button"));
                  (e.className = "flickity-button flickity-prev-next-button"),
                    (e.className += this.isPrevious ? " previous" : " next"),
                    e.setAttribute("type", "button"),
                    this.disable(),
                    e.setAttribute(
                      "aria-label",
                      this.isPrevious ? "Previous" : "Next"
                    );
                  var n = this.createSVG();
                  e.appendChild(n),
                    this.on("tap", this.onTap),
                    this.parent.on("select", this.update.bind(this)),
                    this.on(
                      "pointerDown",
                      this.parent.childUIPointerDown.bind(this.parent)
                    );
                }),
                (a.prototype.activate = function () {
                  this.bindTap(this.element),
                    this.element.addEventListener("click", this),
                    this.parent.element.appendChild(this.element);
                }),
                (a.prototype.deactivate = function () {
                  this.parent.element.removeChild(this.element),
                    n.prototype.destroy.call(this),
                    this.element.removeEventListener("click", this);
                }),
                (a.prototype.createSVG = function () {
                  var t = document.createElementNS(r, "svg");
                  t.setAttribute("class", "flickity-button-icon"),
                    t.setAttribute("viewBox", "0 0 100 100");
                  var e,
                    n = document.createElementNS(r, "path"),
                    i =
                      "string" == typeof (e = this.parent.options.arrowShape)
                        ? e
                        : "M " +
                          e.x0 +
                          ",50 L " +
                          e.x1 +
                          "," +
                          (e.y1 + 50) +
                          " L " +
                          e.x2 +
                          "," +
                          (e.y2 + 50) +
                          " L " +
                          e.x3 +
                          ",50  L " +
                          e.x2 +
                          "," +
                          (50 - e.y2) +
                          " L " +
                          e.x1 +
                          "," +
                          (50 - e.y1) +
                          " Z";
                  return (
                    n.setAttribute("d", i),
                    n.setAttribute("class", "arrow"),
                    this.isLeft ||
                      n.setAttribute(
                        "transform",
                        "translate(100, 100) rotate(180) "
                      ),
                    t.appendChild(n),
                    t
                  );
                }),
                (a.prototype.onTap = function () {
                  if (this.isEnabled) {
                    this.parent.uiChange();
                    var t = this.isPrevious ? "previous" : "next";
                    this.parent[t]();
                  }
                }),
                (a.prototype.handleEvent = i.handleEvent),
                (a.prototype.onclick = function (t) {
                  var e = document.activeElement;
                  e && e == this.element && this.onTap(t, t);
                }),
                (a.prototype.enable = function () {
                  this.isEnabled ||
                    ((this.element.disabled = !1), (this.isEnabled = !0));
                }),
                (a.prototype.disable = function () {
                  this.isEnabled &&
                    ((this.element.disabled = !0), (this.isEnabled = !1));
                }),
                (a.prototype.update = function () {
                  var t = this.parent.slides;
                  if (this.parent.options.wrapAround && 1 < t.length)
                    this.enable();
                  else {
                    var e = t.length ? t.length - 1 : 0,
                      n = this.isPrevious ? 0 : e;
                    this[
                      this.parent.selectedIndex == n ? "disable" : "enable"
                    ]();
                  }
                }),
                (a.prototype.destroy = function () {
                  this.deactivate();
                }),
                i.extend(e.defaults, {
                  prevNextButtons: !0,
                  arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 70,
                    y2: 40,
                    x3: 30,
                  },
                }),
                e.createMethods.push("_createPrevNextButtons");
              var o = e.prototype;
              return (
                (o._createPrevNextButtons = function () {
                  this.options.prevNextButtons &&
                    ((this.prevButton = new a(-1, this)),
                    (this.nextButton = new a(1, this)),
                    this.on("activate", this.activatePrevNextButtons));
                }),
                (o.activatePrevNextButtons = function () {
                  this.prevButton.activate(),
                    this.nextButton.activate(),
                    this.on("deactivate", this.deactivatePrevNextButtons);
                }),
                (o.deactivatePrevNextButtons = function () {
                  this.prevButton.deactivate(),
                    this.nextButton.deactivate(),
                    this.off("deactivate", this.deactivatePrevNextButtons);
                }),
                (e.PrevNextButton = a),
                e
              );
            })(0, t, e, n);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r;
      window,
        (i = [n(3), n(8), n(1)]),
        void 0 ===
          (r = function (t, e, n) {
            return (function (t, e, n, i) {
              "use strict";

              function r(t) {
                (this.parent = t), this._create();
              }
              ((r.prototype = new n())._create = function () {
                (this.holder = document.createElement("ol")),
                  (this.holder.className = "flickity-page-dots"),
                  (this.dots = []),
                  this.on("tap", this.onTap),
                  this.on(
                    "pointerDown",
                    this.parent.childUIPointerDown.bind(this.parent)
                  );
              }),
                (r.prototype.activate = function () {
                  this.setDots(),
                    this.bindTap(this.holder),
                    this.parent.element.appendChild(this.holder);
                }),
                (r.prototype.deactivate = function () {
                  this.parent.element.removeChild(this.holder),
                    n.prototype.destroy.call(this);
                }),
                (r.prototype.setDots = function () {
                  var t = this.parent.slides.length - this.dots.length;
                  0 < t ? this.addDots(t) : t < 0 && this.removeDots(-t);
                }),
                (r.prototype.addDots = function (t) {
                  for (
                    var e = document.createDocumentFragment(),
                      n = [],
                      i = this.dots.length,
                      r = i + t,
                      a = i;
                    a < r;
                    a++
                  ) {
                    var o = document.createElement("li");
                    (o.className = "dot"),
                      o.setAttribute("aria-label", "Page dot " + (a + 1)),
                      e.appendChild(o),
                      n.push(o);
                  }
                  this.holder.appendChild(e), (this.dots = this.dots.concat(n));
                }),
                (r.prototype.removeDots = function (t) {
                  this.dots
                    .splice(this.dots.length - t, t)
                    .forEach(function (t) {
                      this.holder.removeChild(t);
                    }, this);
                }),
                (r.prototype.updateSelected = function () {
                  this.selectedDot &&
                    ((this.selectedDot.className = "dot"),
                    this.selectedDot.removeAttribute("aria-current")),
                    this.dots.length &&
                      ((this.selectedDot =
                        this.dots[this.parent.selectedIndex]),
                      (this.selectedDot.className = "dot is-selected"),
                      this.selectedDot.setAttribute("aria-current", "step"));
                }),
                (r.prototype.onTap = function (t) {
                  var e = t.target;
                  if ("LI" == e.nodeName) {
                    this.parent.uiChange();
                    var n = this.dots.indexOf(e);
                    this.parent.select(n);
                  }
                }),
                (r.prototype.destroy = function () {
                  this.deactivate();
                }),
                (e.PageDots = r),
                i.extend(e.defaults, {
                  pageDots: !0,
                }),
                e.createMethods.push("_createPageDots");
              var a = e.prototype;
              return (
                (a._createPageDots = function () {
                  this.options.pageDots &&
                    ((this.pageDots = new r(this)),
                    this.on("activate", this.activatePageDots),
                    this.on("select", this.updateSelectedPageDots),
                    this.on("cellChange", this.updatePageDots),
                    this.on("resize", this.updatePageDots),
                    this.on("deactivate", this.deactivatePageDots));
                }),
                (a.activatePageDots = function () {
                  this.pageDots.activate();
                }),
                (a.updateSelectedPageDots = function () {
                  this.pageDots.updateSelected();
                }),
                (a.updatePageDots = function () {
                  this.pageDots.setDots();
                }),
                (a.deactivatePageDots = function () {
                  this.pageDots.deactivate();
                }),
                (e.PageDots = r),
                e
              );
            })(0, t, e, n);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r, a;
      window,
        (a = function (t, e, n) {
          "use strict";

          function i(t) {
            (this.parent = t),
              (this.state = "stopped"),
              (this.onVisibilityChange = this.visibilityChange.bind(this)),
              (this.onVisibilityPlay = this.visibilityPlay.bind(this));
          }
          ((i.prototype = Object.create(t.prototype)).play = function () {
            "playing" != this.state &&
              (document.hidden
                ? document.addEventListener(
                    "visibilitychange",
                    this.onVisibilityPlay
                  )
                : ((this.state = "playing"),
                  document.addEventListener(
                    "visibilitychange",
                    this.onVisibilityChange
                  ),
                  this.tick()));
          }),
            (i.prototype.tick = function () {
              if ("playing" == this.state) {
                var t = this.parent.options.autoPlay;
                t = "number" == typeof t ? t : 3e3;
                var e = this;
                this.clear(),
                  (this.timeout = setTimeout(function () {
                    e.parent.next(!0), e.tick();
                  }, t));
              }
            }),
            (i.prototype.stop = function () {
              (this.state = "stopped"),
                this.clear(),
                document.removeEventListener(
                  "visibilitychange",
                  this.onVisibilityChange
                );
            }),
            (i.prototype.clear = function () {
              clearTimeout(this.timeout);
            }),
            (i.prototype.pause = function () {
              "playing" == this.state &&
                ((this.state = "paused"), this.clear());
            }),
            (i.prototype.unpause = function () {
              "paused" == this.state && this.play();
            }),
            (i.prototype.visibilityChange = function () {
              this[document.hidden ? "pause" : "unpause"]();
            }),
            (i.prototype.visibilityPlay = function () {
              this.play(),
                document.removeEventListener(
                  "visibilitychange",
                  this.onVisibilityPlay
                );
            }),
            e.extend(n.defaults, {
              pauseAutoPlayOnHover: !0,
            }),
            n.createMethods.push("_createPlayer");
          var r = n.prototype;
          return (
            (r._createPlayer = function () {
              (this.player = new i(this)),
                this.on("activate", this.activatePlayer),
                this.on("uiChange", this.stopPlayer),
                this.on("pointerDown", this.stopPlayer),
                this.on("deactivate", this.deactivatePlayer);
            }),
            (r.activatePlayer = function () {
              this.options.autoPlay &&
                (this.player.play(),
                this.element.addEventListener("mouseenter", this));
            }),
            (r.playPlayer = function () {
              this.player.play();
            }),
            (r.stopPlayer = function () {
              this.player.stop();
            }),
            (r.pausePlayer = function () {
              this.player.pause();
            }),
            (r.unpausePlayer = function () {
              this.player.unpause();
            }),
            (r.deactivatePlayer = function () {
              this.player.stop(),
                this.element.removeEventListener("mouseenter", this);
            }),
            (r.onmouseenter = function () {
              this.options.pauseAutoPlayOnHover &&
                (this.player.pause(),
                this.element.addEventListener("mouseleave", this));
            }),
            (r.onmouseleave = function () {
              this.player.unpause(),
                this.element.removeEventListener("mouseleave", this);
            }),
            (n.Player = i),
            n
          );
        }),
        (i = [n(4), n(1), n(3)]),
        void 0 ===
          (r = function (t, e, n) {
            return a(t, e, n);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r;
      window,
        (i = [n(3), n(1)]),
        void 0 ===
          (r = function (t, e) {
            return (function (t, e, i) {
              "use strict";
              var n = e.prototype;
              return (
                (n.insert = function (t, e) {
                  var n,
                    i,
                    r = this._makeCells(t);
                  if (r && r.length) {
                    var a = this.cells.length;
                    e = void 0 === e ? a : e;
                    var o =
                        ((n = r),
                        (i = document.createDocumentFragment()),
                        n.forEach(function (t) {
                          i.appendChild(t.element);
                        }),
                        i),
                      s = e == a;
                    if (s) this.slider.appendChild(o);
                    else {
                      var l = this.cells[e].element;
                      this.slider.insertBefore(o, l);
                    }
                    if (0 === e) this.cells = r.concat(this.cells);
                    else if (s) this.cells = this.cells.concat(r);
                    else {
                      var u = this.cells.splice(e, a - e);
                      this.cells = this.cells.concat(r).concat(u);
                    }
                    this._sizeCells(r), this.cellChange(e, !0);
                  }
                }),
                (n.append = function (t) {
                  this.insert(t, this.cells.length);
                }),
                (n.prepend = function (t) {
                  this.insert(t, 0);
                }),
                (n.remove = function (t) {
                  var e = this.getCells(t);
                  if (e && e.length) {
                    var n = this.cells.length - 1;
                    e.forEach(function (t) {
                      t.remove();
                      var e = this.cells.indexOf(t);
                      (n = Math.min(e, n)), i.removeFrom(this.cells, t);
                    }, this),
                      this.cellChange(n, !0);
                  }
                }),
                (n.cellSizeChange = function (t) {
                  var e = this.getCell(t);
                  if (e) {
                    e.getSize();
                    var n = this.cells.indexOf(e);
                    this.cellChange(n);
                  }
                }),
                (n.cellChange = function (t, e) {
                  var n = this.selectedElement;
                  this._positionCells(t),
                    this._getWrapShiftCells(),
                    this.setGallerySize();
                  var i = this.getCell(n);
                  i && (this.selectedIndex = this.getCellSlideIndex(i)),
                    (this.selectedIndex = Math.min(
                      this.slides.length - 1,
                      this.selectedIndex
                    )),
                    this.emitEvent("cellChange", [t]),
                    this.select(this.selectedIndex),
                    e && this.positionSliderAtSelected();
                }),
                e
              );
            })(0, t, e);
          }.apply(e, i)) || (t.exports = r);
    },
    function (t, e, n) {
      var i, r;
      window,
        (i = [n(3), n(1)]),
        void 0 ===
          (r = function (t, e) {
            return (function (t, e, a) {
              "use strict";
              e.createMethods.push("_createLazyload");
              var n = e.prototype;

              function i(t, e) {
                (this.img = t), (this.flickity = e), this.load();
              }
              return (
                (n._createLazyload = function () {
                  this.on("select", this.lazyLoad);
                }),
                (n.lazyLoad = function () {
                  var t = this.options.lazyLoad;
                  if (t) {
                    var e = "number" == typeof t ? t : 0,
                      n = [];
                    this.getAdjacentCellElements(e).forEach(function (t) {
                      var e = (function (t) {
                        console.log(t);
                        if ("IMG" == t.nodeName) {
                          var e = t.getAttribute("data-flickity-lazyload"),
                            n = t.getAttribute("data-flickity-lazyload-src"),
                            i = t.getAttribute("data-flickity-lazyload-srcset");
                          if (e || n || i) return [t];
                        }
                        var r = t.querySelectorAll(
                          "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]"
                        );
                        return a.makeArray(r);
                      })(t);
                      n = n.concat(e);
                    }),
                      n.forEach(function (t) {
                        new i(t, this);
                      }, this);
                  }
                }),
                (i.prototype.handleEvent = a.handleEvent),
                (i.prototype.load = function () {
                  this.img.addEventListener("load", this),
                    this.img.addEventListener("error", this);
                  var t =
                      this.img.getAttribute("data-flickity-lazyload") ||
                      this.img.getAttribute("data-flickity-lazyload-src"),
                    e = this.img.getAttribute("data-flickity-lazyload-srcset");
                  (this.img.src = t),
                    e && this.img.setAttribute("srcset", e),
                    this.img.removeAttribute("data-flickity-lazyload"),
                    this.img.removeAttribute("data-flickity-lazyload-src"),
                    this.img.removeAttribute("data-flickity-lazyload-srcset");
                }),
                (i.prototype.onload = function (t) {
                  this.complete(t, "flickity-lazyloaded");
                }),
                (i.prototype.onerror = function (t) {
                  this.complete(t, "flickity-lazyerror");
                }),
                (i.prototype.complete = function (t, e) {
                  this.img.removeEventListener("load", this),
                    this.img.removeEventListener("error", this);
                  var n = this.flickity.getParentCell(this.img),
                    i = n && n.element;
                  this.flickity.cellSizeChange(i),
                    this.img.classList.add(e),
                    this.flickity.dispatchEvent("lazyLoad", t, i);
                }),
                (e.LazyLoader = i),
                e
              );
            })(0, t, e);
          }.apply(e, i)) || (t.exports = r);
    },
    function (n, i, r) {
      var a, o;
      !(function (e, t) {
        "use strict";
        (a = [r(4)]),
          void 0 ===
            (o = function (t) {
              return (function (e, t) {
                var a = e.jQuery,
                  o = e.console;

                function s(t, e) {
                  for (var n in e) t[n] = e[n];
                  return t;
                }
                var l = Array.prototype.slice;

                function u(t, e, n) {
                  if (!(this instanceof u)) return new u(t, e, n);
                  var i,
                    r = t;
                  "string" == typeof t && (r = document.querySelectorAll(t)),
                    r
                      ? ((this.elements =
                          ((i = r),
                          Array.isArray(i)
                            ? i
                            : "object" == typeof i &&
                              "number" == typeof i.length
                            ? l.call(i)
                            : [i])),
                        (this.options = s({}, this.options)),
                        "function" == typeof e ? (n = e) : s(this.options, e),
                        n && this.on("always", n),
                        this.getImages(),
                        a && (this.jqDeferred = new a.Deferred()),
                        setTimeout(this.check.bind(this)))
                      : o.error("Bad element for imagesLoaded " + (r || t));
                }
                ((u.prototype = Object.create(t.prototype)).options = {}),
                  (u.prototype.getImages = function () {
                    (this.images = []),
                      this.elements.forEach(this.addElementImages, this);
                  }),
                  (u.prototype.addElementImages = function (t) {
                    "IMG" == t.nodeName && this.addImage(t),
                      !0 === this.options.background &&
                        this.addElementBackgroundImages(t);
                    var e = t.nodeType;
                    if (e && c[e]) {
                      for (
                        var n = t.querySelectorAll("img"), i = 0;
                        i < n.length;
                        i++
                      ) {
                        var r = n[i];
                        this.addImage(r);
                      }
                      if ("string" == typeof this.options.background) {
                        var a = t.querySelectorAll(this.options.background);
                        for (i = 0; i < a.length; i++) {
                          var o = a[i];
                          this.addElementBackgroundImages(o);
                        }
                      }
                    }
                  });
                var c = {
                  1: !0,
                  9: !0,
                  11: !0,
                };

                function n(t) {
                  this.img = t;
                }

                function i(t, e) {
                  (this.url = t), (this.element = e), (this.img = new Image());
                }
                return (
                  (u.prototype.addElementBackgroundImages = function (t) {
                    var e = getComputedStyle(t);
                    if (e)
                      for (
                        var n = /url\((['"])?(.*?)\1\)/gi,
                          i = n.exec(e.backgroundImage);
                        null !== i;

                      ) {
                        var r = i && i[2];
                        r && this.addBackground(r, t),
                          (i = n.exec(e.backgroundImage));
                      }
                  }),
                  (u.prototype.addImage = function (t) {
                    var e = new n(t);
                    this.images.push(e);
                  }),
                  (u.prototype.addBackground = function (t, e) {
                    var n = new i(t, e);
                    this.images.push(n);
                  }),
                  (u.prototype.check = function () {
                    var i = this;

                    function e(t, e, n) {
                      setTimeout(function () {
                        i.progress(t, e, n);
                      });
                    }
                    (this.progressedCount = 0),
                      (this.hasAnyBroken = !1),
                      this.images.length
                        ? this.images.forEach(function (t) {
                            t.once("progress", e), t.check();
                          })
                        : this.complete();
                  }),
                  (u.prototype.progress = function (t, e, n) {
                    this.progressedCount++,
                      (this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded),
                      this.emitEvent("progress", [this, t, e]),
                      this.jqDeferred &&
                        this.jqDeferred.notify &&
                        this.jqDeferred.notify(this, t),
                      this.progressedCount == this.images.length &&
                        this.complete(),
                      this.options.debug && o && o.log("progress: " + n, t, e);
                  }),
                  (u.prototype.complete = function () {
                    var t = this.hasAnyBroken ? "fail" : "done";
                    if (
                      ((this.isComplete = !0),
                      this.emitEvent(t, [this]),
                      this.emitEvent("always", [this]),
                      this.jqDeferred)
                    ) {
                      var e = this.hasAnyBroken ? "reject" : "resolve";
                      this.jqDeferred[e](this);
                    }
                  }),
                  ((n.prototype = Object.create(t.prototype)).check =
                    function () {
                      this.getIsImageComplete()
                        ? this.confirm(
                            0 !== this.img.naturalWidth,
                            "naturalWidth"
                          )
                        : ((this.proxyImage = new Image()),
                          this.proxyImage.addEventListener("load", this),
                          this.proxyImage.addEventListener("error", this),
                          this.img.addEventListener("load", this),
                          this.img.addEventListener("error", this),
                          (this.proxyImage.src = this.img.src));
                    }),
                  (n.prototype.getIsImageComplete = function () {
                    return this.img.complete && this.img.naturalWidth;
                  }),
                  (n.prototype.confirm = function (t, e) {
                    (this.isLoaded = t),
                      this.emitEvent("progress", [this, this.img, e]);
                  }),
                  (n.prototype.handleEvent = function (t) {
                    var e = "on" + t.type;
                    this[e] && this[e](t);
                  }),
                  (n.prototype.onload = function () {
                    this.confirm(!0, "onload"), this.unbindEvents();
                  }),
                  (n.prototype.onerror = function () {
                    this.confirm(!1, "onerror"), this.unbindEvents();
                  }),
                  (n.prototype.unbindEvents = function () {
                    this.proxyImage.removeEventListener("load", this),
                      this.proxyImage.removeEventListener("error", this),
                      this.img.removeEventListener("load", this),
                      this.img.removeEventListener("error", this);
                  }),
                  ((i.prototype = Object.create(n.prototype)).check =
                    function () {
                      this.img.addEventListener("load", this),
                        this.img.addEventListener("error", this),
                        (this.img.src = this.url),
                        this.getIsImageComplete() &&
                          (this.confirm(
                            0 !== this.img.naturalWidth,
                            "naturalWidth"
                          ),
                          this.unbindEvents());
                    }),
                  (i.prototype.unbindEvents = function () {
                    this.img.removeEventListener("load", this),
                      this.img.removeEventListener("error", this);
                  }),
                  (i.prototype.confirm = function (t, e) {
                    (this.isLoaded = t),
                      this.emitEvent("progress", [this, this.element, e]);
                  }),
                  (u.makeJQueryPlugin = function (t) {
                    (t = t || e.jQuery) &&
                      ((a = t).fn.imagesLoaded = function (t, e) {
                        return new u(this, t, e).jqDeferred.promise(a(this));
                      });
                  }),
                  u.makeJQueryPlugin(),
                  u
                );
              })(e, t);
            }.apply(i, a)) || (n.exports = o);
      })("undefined" != typeof window ? window : this);
    },
    function (t, e) {
      !(function (d) {
        var r = {
            init: function (t, e) {
              var n = this;
              if (
                ((n.dom = d("body")),
                (n.$elem = d(e)),
                (n.options = d.extend(
                  {},
                  d.fn.modaal.options,
                  n.$elem.data(),
                  t
                )),
                (n.xhr = null),
                (n.scope = {
                  is_open: !1,
                  id:
                    "modaal_" +
                    new Date().getTime() +
                    Math.random().toString(16).substring(2),
                  source: n.options.content_source
                    ? n.options.content_source
                    : n.$elem.attr("href"),
                }),
                n.$elem.attr("data-modaal-scope", n.scope.id),
                (n.private_options = {
                  active_class: "is_active",
                }),
                (n.lastFocus = null),
                n.options.is_locked ||
                "confirm" == n.options.type ||
                n.options.hide_close
                  ? (n.scope.close_btn = "")
                  : (n.scope.close_btn =
                      '<button type="button" class="modaal-close" id="modaal-close" aria-label="' +
                      n.options.close_aria_label +
                      '"><span>' +
                      n.options.close_text +
                      "</span></button>"),
                "none" === n.options.animation &&
                  ((n.options.animation_speed = 0),
                  (n.options.after_callback_delay = 0)),
                d(e).on("click.Modaal", function (t) {
                  t.preventDefault(), n.create_modaal(n, t);
                }),
                !0 === n.options.outer_controls)
              )
                var i = "outer";
              else i = "inner";
              (n.scope.prev_btn =
                '<button type="button" class="modaal-gallery-control modaal-gallery-prev modaal-gallery-prev-' +
                i +
                '" id="modaal-gallery-prev" aria-label="Previous image (use left arrow to change)"><span>Previous Image</span></button>'),
                (n.scope.next_btn =
                  '<button type="button" class="modaal-gallery-control modaal-gallery-next modaal-gallery-next-' +
                  i +
                  '" id="modaal-gallery-next" aria-label="Next image (use right arrow to change)"><span>Next Image</span></button>'),
                !0 === n.options.start_open && n.create_modaal(n);
            },
            create_modaal: function (t, e) {
              var n;
              if (
                (((t = this).lastFocus = t.$elem),
                !1 !== t.options.should_open &&
                  ("function" != typeof t.options.should_open ||
                    !1 !== t.options.should_open()))
              ) {
                switch ((t.options.before_open.call(t, e), t.options.type)) {
                  case "inline":
                    t.create_basic();
                    break;
                  case "ajax":
                    (n = t.options.source(t.$elem, t.scope.source)),
                      t.fetch_ajax(n);
                    break;
                  case "confirm":
                    (t.options.is_locked = !0), t.create_confirm();
                    break;
                  case "image":
                    t.create_image();
                    break;
                  case "iframe":
                    (n = t.options.source(t.$elem, t.scope.source)),
                      t.create_iframe(n);
                    break;
                  case "video":
                    t.create_video(t.scope.source);
                    break;
                  case "instagram":
                    t.create_instagram();
                }
                t.watch_events();
              }
            },
            watch_events: function () {
              var i = this;
              i.dom.off("click.Modaal keyup.Modaal keydown.Modaal"),
                i.dom.on("keydown.Modaal", function (t) {
                  var e = t.keyCode,
                    n = t.target;
                  9 == e &&
                    i.scope.is_open &&
                    (d.contains(document.getElementById(i.scope.id), n) ||
                      d("#" + i.scope.id)
                        .find('*[tabindex="0"]')
                        .focus());
                }),
                i.dom.on("keyup.Modaal", function (t) {
                  var e = t.keyCode,
                    n = t.target;
                  return (
                    t.shiftKey &&
                      9 == t.keyCode &&
                      i.scope.is_open &&
                      (d.contains(document.getElementById(i.scope.id), n) ||
                        d("#" + i.scope.id)
                          .find(".modaal-close")
                          .focus()),
                    !i.options.is_locked && 27 == e && i.scope.is_open
                      ? !d(document.activeElement).is(
                          "input:not(:checkbox):not(:radio)"
                        ) && void i.modaal_close()
                      : "image" == i.options.type
                      ? (37 == e &&
                          i.scope.is_open &&
                          !d(
                            "#" + i.scope.id + " .modaal-gallery-prev"
                          ).hasClass("is_hidden") &&
                          i.gallery_update("prev"),
                        void (
                          39 == e &&
                          i.scope.is_open &&
                          !d(
                            "#" + i.scope.id + " .modaal-gallery-next"
                          ).hasClass("is_hidden") &&
                          i.gallery_update("next")
                        ))
                      : void 0
                  );
                }),
                i.dom.on("click.Modaal", function (t) {
                  var e = d(t.target);
                  if (
                    i.options.is_locked ||
                    !(
                      (i.options.overlay_close &&
                        e.is(".modaal-inner-wrapper")) ||
                      e.is(".modaal-close") ||
                      e.closest(".modaal-close").length
                    )
                  ) {
                    if (e.is(".modaal-confirm-btn"))
                      return (
                        e.is(".modaal-ok") &&
                          i.options.confirm_callback.call(i, i.lastFocus),
                        e.is(".modaal-cancel") &&
                          i.options.confirm_cancel_callback.call(
                            i,
                            i.lastFocus
                          ),
                        void i.modaal_close()
                      );
                    if (e.is(".modaal-gallery-control")) {
                      if (e.hasClass("is_hidden")) return;
                      return (
                        e.is(".modaal-gallery-prev") &&
                          i.gallery_update("prev"),
                        void (
                          e.is(".modaal-gallery-next") &&
                          i.gallery_update("next")
                        )
                      );
                    }
                  } else i.modaal_close();
                });
            },
            build_modal: function (t) {
              var e = "";
              "instagram" == this.options.type && (e = " modaal-instagram");
              var n,
                i =
                  "video" == this.options.type
                    ? "modaal-video-wrap"
                    : "modaal-content";
              switch (this.options.animation) {
                case "fade":
                  n = " modaal-start_fade";
                  break;
                case "slide-down":
                  n = " modaal-start_slidedown";
                  break;
                default:
                  n = " modaal-start_none";
              }
              var r = "";
              this.options.fullscreen && (r = " modaal-fullscreen"),
                ("" === this.options.custom_class &&
                  void 0 === this.options.custom_class) ||
                  (this.options.custom_class = " " + this.options.custom_class);
              var a = "";
              this.options.width &&
              this.options.height &&
              "number" == typeof this.options.width &&
              "number" == typeof this.options.height
                ? (a =
                    ' style="max-width:' +
                    this.options.width +
                    "px;height:" +
                    this.options.height +
                    'px;overflow:auto;"')
                : this.options.width && "number" == typeof this.options.width
                ? (a = ' style="max-width:' + this.options.width + 'px;"')
                : this.options.height &&
                  "number" == typeof this.options.height &&
                  (a =
                    ' style="height:' +
                    this.options.height +
                    'px;overflow:auto;"'),
                ("image" == this.options.type ||
                  "video" == this.options.type ||
                  "instagram" == this.options.type ||
                  this.options.fullscreen) &&
                  (a = "");
              var o = "";
              this.is_touch() && (o = ' style="cursor:pointer;"');
              var s =
                '<div class="modaal-wrapper modaal-' +
                this.options.type +
                n +
                e +
                r +
                this.options.custom_class +
                '" id="' +
                this.scope.id +
                '"><div class="modaal-outer-wrapper"><div class="modaal-inner-wrapper"' +
                o +
                ">";
              "video" != this.options.type &&
                (s += '<div class="modaal-container"' + a + ">"),
                (s +=
                  '<div class="' +
                  i +
                  ' modaal-focus" aria-hidden="false" aria-label="' +
                  this.options.accessible_title +
                  " - " +
                  this.options.close_aria_label +
                  '" role="dialog">'),
                "inline" == this.options.type
                  ? (s +=
                      '<div class="modaal-content-container" role="document"></div>')
                  : (s += t),
                (s += "</div>" + this.scope.close_btn),
                "video" != this.options.type && (s += "</div>"),
                (s += "</div>"),
                "image" == this.options.type &&
                  !0 === this.options.outer_controls &&
                  (s += this.scope.prev_btn + this.scope.next_btn),
                (s += "</div></div>"),
                d("#" + this.scope.id + "_overlay").length < 1 &&
                  this.dom.append(s),
                "inline" == this.options.type &&
                  t.appendTo(
                    "#" + this.scope.id + " .modaal-content-container"
                  ),
                this.modaal_overlay("show");
            },
            create_basic: function () {
              var t = d(this.scope.source),
                e = "";
              t.length
                ? ((e = t.contents().detach()), t.empty())
                : (e =
                    "Content could not be loaded. Please check the source and try again."),
                this.build_modal(e);
            },
            create_instagram: function () {
              var n = this,
                t = n.options.instagram_id,
                e = "",
                i =
                  "Instagram photo couldn't be loaded, please check the embed code and try again.";
              if (
                (n.build_modal(
                  '<div class="modaal-content-container' +
                    ("" != n.options.loading_class
                      ? " " + n.options.loading_class
                      : "") +
                    '">' +
                    n.options.loading_content +
                    "</div>"
                ),
                "" != t && null != t)
              ) {
                var r =
                  "https://api.instagram.com/oembed?url=http://instagr.am/p/" +
                  t +
                  "/";
                d.ajax({
                  url: r,
                  dataType: "jsonp",
                  cache: !1,
                  success: function (t) {
                    n.dom.append(
                      '<div id="temp-ig" style="width:0;height:0;overflow:hidden;">' +
                        t.html +
                        "</div>"
                    ),
                      n.dom.attr("data-igloaded")
                        ? window.instgrm.Embeds.process()
                        : n.dom.attr("data-igloaded", "true");
                    var e = "#" + n.scope.id + " .modaal-content-container";
                    0 < d(e).length &&
                      setTimeout(function () {
                        d("#temp-ig").contents().clone().appendTo(e),
                          d("#temp-ig").remove();
                      }, 1e3);
                  },
                  error: function () {
                    e = i;
                    var t = d("#" + n.scope.id + " .modaal-content-container");
                    0 < t.length &&
                      (t
                        .removeClass(n.options.loading_class)
                        .addClass(n.options.ajax_error_class),
                      t.html(e));
                  },
                });
              } else e = i;
              return !1;
            },
            fetch_ajax: function (t) {
              var n = this;
              null == n.options.accessible_title &&
                (n.options.accessible_title = "Dialog Window"),
                null !== n.xhr && (n.xhr.abort(), (n.xhr = null)),
                n.build_modal(
                  '<div class="modaal-content-container' +
                    ("" != n.options.loading_class
                      ? " " + n.options.loading_class
                      : "") +
                    '">' +
                    n.options.loading_content +
                    "</div>"
                ),
                (n.xhr = d.ajax(t, {
                  success: function (t) {
                    var e = d("#" + n.scope.id).find(
                      ".modaal-content-container"
                    );
                    0 < e.length &&
                      (e.removeClass(n.options.loading_class),
                      e.html(t),
                      n.options.ajax_success.call(n, e));
                  },
                  error: function (t) {
                    if ("abort" != t.statusText) {
                      var e = d(
                        "#" + n.scope.id + " .modaal-content-container"
                      );
                      0 < e.length &&
                        (e
                          .removeClass(n.options.loading_class)
                          .addClass(n.options.ajax_error_class),
                        e.html(
                          "Content could not be loaded. Please check the source and try again."
                        ));
                    }
                  },
                }));
            },
            create_confirm: function () {
              var t;
              (t =
                '<div class="modaal-content-container"><h1 id="modaal-title">' +
                this.options.confirm_title +
                '</h1><div class="modaal-confirm-content">' +
                this.options.confirm_content +
                '</div><div class="modaal-confirm-wrap"><button type="button" class="modaal-confirm-btn modaal-ok" aria-label="Confirm">' +
                this.options.confirm_button_text +
                '</button><button type="button" class="modaal-confirm-btn modaal-cancel" aria-label="Cancel">' +
                this.options.confirm_cancel_button_text +
                "</button></div></div></div>"),
                this.build_modal(t);
            },
            create_image: function () {
              var t,
                e,
                n = "";
              if (this.$elem.is("[data-group]") || this.$elem.is("[rel]")) {
                var i = this.$elem.is("[data-group]"),
                  r = i
                    ? this.$elem.attr("data-group")
                    : this.$elem.attr("rel"),
                  a = d(i ? '[data-group="' + r + '"]' : '[rel="' + r + '"]');
                a.removeAttr("data-gallery-active", "is_active"),
                  this.$elem.attr("data-gallery-active", "is_active"),
                  (e = a.length - 1);
                var c = [];
                (n = '<div class="modaal-gallery-item-wrap">'),
                  a.each(function (t, e) {
                    var n = "",
                      i = "",
                      r = "",
                      a = !1,
                      o = !1,
                      s = e.getAttribute("data-modaal-desc"),
                      l = e.getAttribute("data-gallery-active");
                    d(e).attr("data-modaal-content-source")
                      ? (n = d(e).attr("data-modaal-content-source"))
                      : d(e).attr("href")
                      ? (n = d(e).attr("href"))
                      : d(e).attr("src")
                      ? (n = d(e).attr("src"))
                      : ((n =
                          "trigger requires href or data-modaal-content-source attribute"),
                        (o = !0)),
                      "" != s && null != s
                        ? (r =
                            '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image ' +
                            (t + 1) +
                            " - </span>" +
                            (i = s) +
                            "</div>")
                        : (r =
                            '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image ' +
                            (t + 1) +
                            "</span></div>"),
                      l && (a = !0);
                    var u = {
                      url: n,
                      alt: i,
                      rawdesc: s,
                      desc: r,
                      active: a,
                      src_error: o,
                    };
                    c.push(u);
                  });
                for (var o = 0; o < c.length; o++) {
                  var s = "",
                    l = c[o].rawdesc
                      ? "Image: " + c[o].rawdesc
                      : "Image " + o + " no description";
                  c[o].active && (s = " " + this.private_options.active_class),
                    (n +=
                      '<div class="modaal-gallery-item gallery-item-' +
                      o +
                      s +
                      '" aria-label="' +
                      l +
                      '">' +
                      (c[o].src_error
                        ? c[o].url
                        : '<img src="' +
                          c[o].url +
                          '" alt=" " style="width:100%">') +
                      c[o].desc +
                      "</div>");
                }
                (n += "</div>"),
                  1 != this.options.outer_controls &&
                    (n += this.scope.prev_btn + this.scope.next_btn);
              } else {
                var u,
                  h = !1;
                this.$elem.attr("data-modaal-content-source")
                  ? (u = this.$elem.attr("data-modaal-content-source"))
                  : this.$elem.attr("href")
                  ? (u = this.$elem.attr("href"))
                  : this.$elem.attr("src")
                  ? (u = this.$elem.attr("src"))
                  : ((u =
                      "trigger requires href or data-modaal-content-source attribute"),
                    (h = !0));
                var f = "";
                (l = ""),
                  this.$elem.attr("data-modaal-desc")
                    ? ((l = this.$elem.attr("data-modaal-desc")),
                      (f =
                        '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image - </span>' +
                        this.$elem.attr("data-modaal-desc") +
                        "</div>"))
                    : (l = "Image with no description"),
                  (n =
                    '<div class="modaal-gallery-item is_active" aria-label="' +
                    l +
                    '">' +
                    (h
                      ? u
                      : '<img src="' + u + '" alt=" " style="width:100%">') +
                    f +
                    "</div>");
              }
              (t = n),
                this.build_modal(t),
                d(".modaal-gallery-item.is_active").is(".gallery-item-0") &&
                  d(".modaal-gallery-prev").hide(),
                d(".modaal-gallery-item.is_active").is(".gallery-item-" + e) &&
                  d(".modaal-gallery-next").hide();
            },
            gallery_update: function (t) {
              var r = this,
                a = d("#" + r.scope.id),
                o = a.find(".modaal-gallery-item").length - 1;
              if (0 == o) return !1;
              var s = a.find(".modaal-gallery-prev"),
                l = a.find(".modaal-gallery-next"),
                u = 0,
                c = 0,
                h = a.find(
                  ".modaal-gallery-item." + r.private_options.active_class
                ),
                f =
                  "next" == t
                    ? h.next(".modaal-gallery-item")
                    : h.prev(".modaal-gallery-item");
              return (
                r.options.before_image_change.call(r, h, f),
                ("prev" != t ||
                  !a.find(".gallery-item-0").hasClass("is_active")) &&
                  ("next" != t ||
                    !a.find(".gallery-item-" + o).hasClass("is_active")) &&
                  void h.stop().animate(
                    {
                      opacity: 0,
                    },
                    250,
                    function () {
                      f.addClass("is_next").css({
                        position: "absolute",
                        display: "block",
                        opacity: 0,
                      });
                      var t = d(document).width(),
                        e = 1140 < t ? 280 : 50;
                      (u = a.find(".modaal-gallery-item.is_next").width()),
                        (c = a.find(".modaal-gallery-item.is_next").height());
                      var n = a
                          .find(".modaal-gallery-item.is_next img")
                          .prop("naturalWidth"),
                        i = a
                          .find(".modaal-gallery-item.is_next img")
                          .prop("naturalHeight");
                      t - e < n
                        ? ((u = t - e),
                          a.find(".modaal-gallery-item.is_next").css({
                            width: u,
                          }),
                          a.find(".modaal-gallery-item.is_next img").css({
                            width: u,
                          }),
                          (c = a
                            .find(".modaal-gallery-item.is_next")
                            .find("img")
                            .height()))
                        : ((u = n), (c = i)),
                        a
                          .find(".modaal-gallery-item-wrap")
                          .stop()
                          .animate(
                            {
                              width: u,
                              height: c,
                            },
                            250,
                            function () {
                              h
                                .removeClass(
                                  r.private_options.active_class +
                                    " " +
                                    r.options.gallery_active_class
                                )
                                .removeAttr("style"),
                                h.find("img").removeAttr("style"),
                                f
                                  .addClass(
                                    r.private_options.active_class +
                                      " " +
                                      r.options.gallery_active_class
                                  )
                                  .removeClass("is_next")
                                  .css("position", ""),
                                f.stop().animate(
                                  {
                                    opacity: 1,
                                  },
                                  250,
                                  function () {
                                    d(this).removeAttr("style").css({
                                      width: "100%",
                                    }),
                                      d(this).find("img").css("width", "100%"),
                                      a
                                        .find(".modaal-gallery-item-wrap")
                                        .removeAttr("style"),
                                      r.options.after_image_change.call(r, f);
                                  }
                                ),
                                a
                                  .find(".modaal-gallery-item")
                                  .removeAttr("tabindex"),
                                a
                                  .find(
                                    ".modaal-gallery-item." +
                                      r.private_options.active_class
                                  )
                                  .attr("tabindex", "0")
                                  .focus(),
                                a
                                  .find(
                                    ".modaal-gallery-item." +
                                      r.private_options.active_class
                                  )
                                  .is(".gallery-item-0")
                                  ? s.stop().animate(
                                      {
                                        opacity: 0,
                                      },
                                      150,
                                      function () {
                                        d(this).hide();
                                      }
                                    )
                                  : s
                                      .stop()
                                      .css({
                                        display: "block",
                                        opacity: s.css("opacity"),
                                      })
                                      .animate(
                                        {
                                          opacity: 1,
                                        },
                                        150
                                      ),
                                a
                                  .find(
                                    ".modaal-gallery-item." +
                                      r.private_options.active_class
                                  )
                                  .is(".gallery-item-" + o)
                                  ? l.stop().animate(
                                      {
                                        opacity: 0,
                                      },
                                      150,
                                      function () {
                                        d(this).hide();
                                      }
                                    )
                                  : l
                                      .stop()
                                      .css({
                                        display: "block",
                                        opacity: s.css("opacity"),
                                      })
                                      .animate(
                                        {
                                          opacity: 1,
                                        },
                                        150
                                      );
                            }
                          );
                    }
                  )
              );
            },
            create_video: function (t) {
              var e;
              (e =
                '<iframe src="' +
                t +
                '" class="modaal-video-frame" frameborder="0" allowfullscreen></iframe>'),
                this.build_modal(
                  '<div class="modaal-video-container">' + e + "</div>"
                );
            },
            create_iframe: function (t) {
              var e;
              (e =
                null !== this.options.width ||
                void 0 !== this.options.width ||
                null !== this.options.height ||
                void 0 !== this.options.height
                  ? '<iframe src="' +
                    t +
                    '" class="modaal-iframe-elem" frameborder="0" allowfullscreen></iframe>'
                  : '<div class="modaal-content-container">Please specify a width and height for your iframe</div>'),
                this.build_modal(e);
            },
            modaal_open: function () {
              var t = this,
                e = d("#" + t.scope.id),
                n = t.options.animation;
              "none" === n &&
                (e.removeClass("modaal-start_none"),
                t.options.after_open.call(t, e)),
                "fade" === n && e.removeClass("modaal-start_fade"),
                "slide-down" === n && e.removeClass("modaal-start_slide_down"),
                d(".modaal-wrapper *[tabindex=0]").removeAttr("tabindex"),
                ("image" == t.options.type
                  ? d("#" + t.scope.id).find(
                      ".modaal-gallery-item." + t.private_options.active_class
                    )
                  : e.find(".modaal-iframe-elem").length
                  ? e.find(".modaal-iframe-elem")
                  : e.find(".modaal-video-wrap").length
                  ? e.find(".modaal-video-wrap")
                  : e.find(".modaal-focus")
                )
                  .attr("tabindex", "0")
                  .focus(),
                "none" !== n &&
                  setTimeout(function () {
                    t.options.after_open.call(t, e);
                  }, t.options.after_callback_delay);
            },
            modaal_close: function () {
              var t = this,
                e = d("#" + t.scope.id);
              t.options.before_close.call(t, e),
                null !== t.xhr && (t.xhr.abort(), (t.xhr = null)),
                "none" === t.options.animation &&
                  e.addClass("modaal-start_none"),
                "fade" === t.options.animation &&
                  e.addClass("modaal-start_fade"),
                "slide-down" === t.options.animation &&
                  e.addClass("modaal-start_slide_down"),
                setTimeout(function () {
                  "inline" == t.options.type &&
                    d("#" + t.scope.id + " .modaal-content-container")
                      .contents()
                      .detach()
                      .appendTo(t.scope.source),
                    e.remove(),
                    t.options.after_close.call(t),
                    (t.scope.is_open = !1);
                }, t.options.after_callback_delay),
                t.modaal_overlay("hide"),
                null != t.lastFocus && t.lastFocus.focus();
            },
            modaal_overlay: function (t) {
              var e = this;
              "show" == t
                ? ((e.scope.is_open = !0),
                  e.options.background_scroll ||
                    e.dom.addClass("modaal-noscroll"),
                  d("#" + e.scope.id + "_overlay").length < 1 &&
                    e.dom.append(
                      '<div class="modaal-overlay" id="' +
                        e.scope.id +
                        '_overlay"></div>'
                    ),
                  d("#" + e.scope.id + "_overlay")
                    .css("background", e.options.background)
                    .stop()
                    .animate(
                      {
                        opacity: e.options.overlay_opacity,
                      },
                      e.options.animation_speed,
                      function () {
                        e.modaal_open();
                      }
                    ))
                : "hide" == t &&
                  d("#" + e.scope.id + "_overlay")
                    .stop()
                    .animate(
                      {
                        opacity: 0,
                      },
                      e.options.animation_speed,
                      function () {
                        d(this).remove(), e.dom.removeClass("modaal-noscroll");
                      }
                    );
            },
            is_touch: function () {
              return "ontouchstart" in window || navigator.maxTouchPoints;
            },
          },
          a = [];

        function i(t) {
          var e = {},
            n = !1;
          t.attr("data-modaal-type") &&
            ((n = !0), (e.type = t.attr("data-modaal-type"))),
            t.attr("data-modaal-content-source") &&
              ((n = !0),
              (e.content_source = t.attr("data-modaal-content-source"))),
            t.attr("data-modaal-animation") &&
              ((n = !0), (e.animation = t.attr("data-modaal-animation"))),
            t.attr("data-modaal-animation-speed") &&
              ((n = !0),
              (e.animation_speed = t.attr("data-modaal-animation-speed"))),
            t.attr("data-modaal-after-callback-delay") &&
              ((n = !0),
              (e.after_callback_delay = t.attr(
                "data-modaal-after-callback-delay"
              ))),
            t.attr("data-modaal-is-locked") &&
              ((n = !0),
              (e.is_locked = "true" === t.attr("data-modaal-is-locked"))),
            t.attr("data-modaal-hide-close") &&
              ((n = !0),
              (e.hide_close = "true" === t.attr("data-modaal-hide-close"))),
            t.attr("data-modaal-background") &&
              ((n = !0), (e.background = t.attr("data-modaal-background"))),
            t.attr("data-modaal-overlay-opacity") &&
              ((n = !0),
              (e.overlay_opacity = t.attr("data-modaal-overlay-opacity"))),
            t.attr("data-modaal-overlay-close") &&
              ((n = !0),
              (e.overlay_close =
                "false" !== t.attr("data-modaal-overlay-close"))),
            t.attr("data-modaal-accessible-title") &&
              ((n = !0),
              (e.accessible_title = t.attr("data-modaal-accessible-title"))),
            t.attr("data-modaal-start-open") &&
              ((n = !0),
              (e.start_open = "true" === t.attr("data-modaal-start-open"))),
            t.attr("data-modaal-fullscreen") &&
              ((n = !0),
              (e.fullscreen = "true" === t.attr("data-modaal-fullscreen"))),
            t.attr("data-modaal-custom-class") &&
              ((n = !0), (e.custom_class = t.attr("data-modaal-custom-class"))),
            t.attr("data-modaal-close-text") &&
              ((n = !0), (e.close_text = t.attr("data-modaal-close-text"))),
            t.attr("data-modaal-close-aria-label") &&
              ((n = !0),
              (e.close_aria_label = t.attr("data-modaal-close-aria-label"))),
            t.attr("data-modaal-background-scroll") &&
              ((n = !0),
              (e.background_scroll =
                "true" === t.attr("data-modaal-background-scroll"))),
            t.attr("data-modaal-width") &&
              ((n = !0), (e.width = parseInt(t.attr("data-modaal-width")))),
            t.attr("data-modaal-height") &&
              ((n = !0), (e.height = parseInt(t.attr("data-modaal-height")))),
            t.attr("data-modaal-confirm-button-text") &&
              ((n = !0),
              (e.confirm_button_text = t.attr(
                "data-modaal-confirm-button-text"
              ))),
            t.attr("data-modaal-confirm-cancel-button-text") &&
              ((n = !0),
              (e.confirm_cancel_button_text = t.attr(
                "data-modaal-confirm-cancel-button-text"
              ))),
            t.attr("data-modaal-confirm-title") &&
              ((n = !0),
              (e.confirm_title = t.attr("data-modaal-confirm-title"))),
            t.attr("data-modaal-confirm-content") &&
              ((n = !0),
              (e.confirm_content = t.attr("data-modaal-confirm-content"))),
            t.attr("data-modaal-gallery-active-class") &&
              ((n = !0),
              (e.gallery_active_class = t.attr(
                "data-modaal-gallery-active-class"
              ))),
            t.attr("data-modaal-loading-content") &&
              ((n = !0),
              (e.loading_content = t.attr("data-modaal-loading-content"))),
            t.attr("data-modaal-loading-class") &&
              ((n = !0),
              (e.loading_class = t.attr("data-modaal-loading-class"))),
            t.attr("data-modaal-ajax-error-class") &&
              ((n = !0),
              (e.ajax_error_class = t.attr("data-modaal-ajax-error-class"))),
            t.attr("data-modaal-instagram-id") &&
              ((n = !0), (e.instagram_id = t.attr("data-modaal-instagram-id"))),
            n && t.modaal(e);
        }
        (d.fn.modaal = function (i) {
          return this.each(function (t) {
            var e = d(this).data("modaal");
            if (e) {
              if ("string" == typeof i)
                switch (i) {
                  case "open":
                    e.create_modaal(e);
                    break;
                  case "close":
                    e.modaal_close();
                }
            } else {
              var n = Object.create(r);
              n.init(i, this),
                d.data(this, "modaal", n),
                a.push({
                  element: d(this).attr("class"),
                  options: i,
                });
            }
          });
        }),
          (d.fn.modaal.options = {
            type: "inline",
            content_source: null,
            animation: "fade",
            animation_speed: 300,
            after_callback_delay: 350,
            is_locked: !1,
            hide_close: !1,
            background: "#000",
            overlay_opacity: "0.8",
            overlay_close: !0,
            accessible_title: "Dialog Window",
            start_open: !1,
            fullscreen: !1,
            custom_class: "",
            background_scroll: !1,
            should_open: !0,
            close_text: "Close",
            close_aria_label: "Close (Press escape to close)",
            width: null,
            height: null,
            before_open: function () {},
            after_open: function () {},
            before_close: function () {},
            after_close: function () {},
            source: function (t, e) {
              return e;
            },
            confirm_button_text: "Confirm",
            confirm_cancel_button_text: "Cancel",
            confirm_title: "Confirm Title",
            confirm_content:
              "<p>This is the default confirm dialog content. Replace me through the options</p>",
            confirm_callback: function () {},
            confirm_cancel_callback: function () {},
            gallery_active_class: "gallery_active_item",
            outer_controls: !1,
            before_image_change: function (t, e) {},
            after_image_change: function (t) {},
            loading_content:
              '<div class="modaal-loading-spinner"><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div>',
            loading_class: "is_loading",
            ajax_error_class: "modaal-error",
            ajax_success: function () {},
            instagram_id: null,
          }),
          d(function () {
            var t = d(".modaal");
            t.length &&
              t.each(function () {
                i(d(this));
              });
            var e = new MutationObserver(function (t) {
                t.forEach(function (t) {
                  t.addedNodes &&
                    0 < t.addedNodes.length &&
                    [].some.call(t.addedNodes, function (t) {
                      var e = d(t);
                      (e.is("a") || e.is("button")) &&
                        (e.hasClass("modaal")
                          ? i(e)
                          : a.forEach(function (t) {
                              if (t.element == e.attr("class"))
                                return d(e).modaal(t.options), !1;
                            }));
                    });
                });
              }),
              n = {
                subtree: !0,
                attributes: !0,
                childList: !0,
                characterData: !0,
              };
            setTimeout(function () {
              e.observe(document.body, n);
            }, 500);
          });
      })(jQuery, window, document);
    },
    function (t, e, n) {
      var a = n(34),
        i = n(14),
        o = i.each,
        s = i.isFunction,
        l = i.isArray;

      function r() {
        if (!window.matchMedia)
          throw new Error(
            "matchMedia not present, legacy browsers require a polyfill"
          );
        (this.queries = {}),
          (this.browserIsIncapable = !window.matchMedia("only all").matches);
      }
      (r.prototype = {
        constructor: r,
        register: function (e, t, n) {
          var i = this.queries,
            r = n && this.browserIsIncapable;
          return (
            i[e] || (i[e] = new a(e, r)),
            s(t) &&
              (t = {
                match: t,
              }),
            l(t) || (t = [t]),
            o(t, function (t) {
              s(t) &&
                (t = {
                  match: t,
                }),
                i[e].addHandler(t);
            }),
            this
          );
        },
        unregister: function (t, e) {
          var n = this.queries[t];
          return (
            n && (e ? n.removeHandler(e) : (n.clear(), delete this.queries[t])),
            this
          );
        },
      }),
        (t.exports = r);
    },
    function (t, e, n) {
      var i = n(35),
        r = n(14).each;

      function a(t, e) {
        (this.query = t),
          (this.isUnconditional = e),
          (this.handlers = []),
          (this.mql = window.matchMedia(t));
        var n = this;
        (this.listener = function (t) {
          (n.mql = t.currentTarget || t), n.assess();
        }),
          this.mql.addListener(this.listener);
      }
      (a.prototype = {
        constuctor: a,
        addHandler: function (t) {
          var e = new i(t);
          this.handlers.push(e), this.matches() && e.on();
        },
        removeHandler: function (n) {
          var i = this.handlers;
          r(i, function (t, e) {
            if (t.equals(n)) return t.destroy(), !i.splice(e, 1);
          });
        },
        matches: function () {
          return this.mql.matches || this.isUnconditional;
        },
        clear: function () {
          r(this.handlers, function (t) {
            t.destroy();
          }),
            this.mql.removeListener(this.listener),
            (this.handlers.length = 0);
        },
        assess: function () {
          var e = this.matches() ? "on" : "off";
          r(this.handlers, function (t) {
            t[e]();
          });
        },
      }),
        (t.exports = a);
    },
    function (t, e) {
      function n(t) {
        !(this.options = t).deferSetup && this.setup();
      }
      (n.prototype = {
        constructor: n,
        setup: function () {
          this.options.setup && this.options.setup(), (this.initialised = !0);
        },
        on: function () {
          !this.initialised && this.setup(),
            this.options.match && this.options.match();
        },
        off: function () {
          this.options.unmatch && this.options.unmatch();
        },
        destroy: function () {
          this.options.destroy ? this.options.destroy() : this.off();
        },
        equals: function (t) {
          return this.options === t || this.options.match === t;
        },
      }),
        (t.exports = n);
    },
    function (t, e) {},
    function (t, e) {},
  ],
  [15]
);

geoloc = null;

$(document).ready(function () {
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  if (!getCookie("geoloc")) {
    $.get(
      "https://api.ipgeolocation.io/ipgeo?apiKey=07b2c22395c74eff80b6bafe0ca6a13d",
      function (r) {
        setCookie("geoloc", true, 30);
        if (!r.country_code2 == "GB") {
          $(".currency-selector-overlay").fadeIn();
        }
      }
    );
  }

  $(".addButton").click(function (e) {
    if ($(this).find("button").attr("disabled") == "disabled") {
      $(this).find("button").text("Please select a size");
      e.stopPropagation();
      return false;
    }
  });

  currPrice = 0;

  $(".choice-box.ajaxian").click(function (e) {
    boxPrice = $(".choice-box.ajaxian").data("price") / 100;

    $(this).toggleClass("is-active");
    if ($(this).hasClass("is-active")) {
      $(".modal-overlay").find("h3").text($(this).data("title"));
      $(".modal-overlay").find("img").attr("src", $(this).data("img"));
      $(".modal-overlay").fadeIn();

      if ($("#ProductPrice-product-template").length) {
        currPrice = $("#ProductPrice-product-template").text().replace("£", "");
        currPrice = currPrice.replace("$", "");
        currPrice = currPrice.replace("€", "");
      } else {
        currPrice = $(".product-mobile__price").text().replace("£", "");
        currPrice = currPrice.replace("$", "");
        currPrice = currPrice.replace("€", "");
      }

      currPrice = parseInt(boxPrice) + parseInt(currPrice);

      $.ajax({
        method: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          id: $(this).data("variant"),
          quantity: 1,
        },
        success: function(){
          window.updateJellycatShippingAttribute();
        },
      });
    } else {
      $(".modal-overlay").fadeOut();
      currPrice = parseInt(currPrice) - parseInt(boxPrice);
      $.post(
        "/cart/update.js",
        "updates[" + $(".choice-box.ajaxian").data("variant") + "]=0"
      );
    }

    $(".product-mobile__price").text(
      $("#currency_symbol").val() + currPrice.toString()
    );
  });

  $(".modal-box-close, .modal-overlay").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(".modal-overlay").fadeOut();
  });
  $(".more-info").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(".modal-overlay").find("h3").text($(this).data("title"));
    $(".modal-overlay").find("img").attr("src", $(this).data("img"));
    $($(this).attr("href")).fadeIn();
  });

  $("*[data-yt]").click(function () {
    if ($(window).width() > 1024) {
      className = "videoDesktop";
    } else {
      className = "videoWrapper";
    }

    $(".mz-zoom-window").hide();
    $(".mz-hover-zoom")
      .html(
        '<div class="' +
          className +
          '"> <iframe width="560" height="349" src="https://www.youtube.com/embed/' +
          $(this).data("yt") +
          '?autoplay=1&rel=1" frameborder="0" allowfullscreen></iframe></div>'
      )
      .removeClass("mz-figure")
      .addClass("hide-img");
  });

  $(".mz-thumb")
    .not("*[data-yt]")
    .click(function () {
      $(".mz-hover-zoom").find(".videoWrapper, .videoDesktop").remove();
      $(".mz-hover-zoom").addClass("mz-figure").removeClass("hide-img");
      $(".mz-zoom-window").show();
    });

  /*
 
  $('.site-header__cart-count').bind('DOMSubtreeModified', function(e) {
      if($('.ajax-cart').hasClass('is-active')) {
        $('html, body').animate({
            scrollTop: $("#recommendations").offset().top
        }, 1000);
      }
    // urgency()
  });

  */

  storage = window.localStorage;
  freeShipping = false;
  countdownMinutes = 20;
  /*

  function urgency() {
    // get current cart count
    cartCount = parseInt($('[js-ajax-cart="cartCount"]').text().
                  trim().replace('(','').replace(')',''))
    if(cartCount === 0) {
    	resetTimer()
    } else if(cartCount >= 1){
    	showTimer()
    }
  }
  
  function resetTimer() {
  	storage.removeItem('cartTimer')
    if(freeShipping) {
    	removeFreeShipping()
    }
    $('.timer').hide();
    $('.ajax-cart__footer .note--secondary').show()
  }
  
  function showTimer() {
    timer = storage.getItem('cartTimer') || createTimer()
    timeLeft = timeLeftOn(timer)
    if(timeLeft < 0) {
        hideTimerMessage()
        if(freeShipping) {
          	freeShipping = false
        	removeFreeShipping()
        }
    } else {
      	showTimerMessage()
        if(!freeShipping) {
          addFreeShipping()
          freeShipping = true
        }
      	// still in free delivery window
        var x = setInterval(function() { 
          distance = timeLeftOn(timer)
          var mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var secs = Math.floor((distance % (1000 * 60)) / 1000);
          setTimerMessage(mins, secs)
          
          if(distance < 1) {
          	hideTimerMessage()
            if(freeShipping) {
            	removeFreeShipping()
            }
          }
          
        }, 1000);
    }
    
  }
  
  function createTimer() {
    var dt = new Date()
    dt.setMinutes( dt.getMinutes() + countdownMinutes )
    timer = dt.getTime()
    storage.setItem('cartTimer', timer)
    return timer
  }
  
  function timeLeftOn(timer) {
    var now = new Date().getTime();   
    var distance = timer - now;
    return distance
  } 
  
  function setTimerMessage(mins, secs) {
  	$('.timer-countdown em').html('' + mins + ":" + ("0" + secs).slice(-2))
  }
  
  function hideTimerMessage() {
  	$('.timer').hide();
    $('.ajax-cart__footer .note--secondary, .cart-overview__item .note--secondary').show()
  }
  
  function showTimerMessage() {
  	$('.timer').show();
    $('.ajax-cart__footer .note--secondary, .cart-overview__item .note--secondary').hide()
  }
  
  function removeFreeShipping() {
    freeShipping = false
    $.post('/cart/update.js', {note: ""}, function(res) {
    	console.log(res)
    })
  }
  
  function addFreeShipping() {
    	freeShipping = true
        $.post('/cart/update.js', {note: "free-shipping-window"}, function(res) {
    	console.log(res)
    })
  }
  
   urgency()

   */

  var slideLinkMap = $(
    '.slideshow__slide a[href="/collections/petit-breton-collection"] img'
  );
  if (slideLinkMap.length) {
    slideLinkMap.click(function (e) {
      e.preventDefault();
      var imgWidth = $(this).width();
      var offset = $(this).offset();
      var offsetLeft = e.pageX - offset.left;
      if (offsetLeft < imgWidth / 2) {
        window.location =
          "https://www.trotters.co.uk/collections/petit-breton-collection";
      } else {
        window.location =
          "https://www.trotters.co.uk/collections/petit-breton-collection";
      }
    });
  }

  $("body").click(function (e) {
    if (e.target != $(".ajax-cart")[0]) {
      $(".ajax-cart").removeClass("is-active");
    }
  });

  $("body").on("click", ".window-overlay", function (e) {
    if (e.target != this) return;
    $(".site-header__drawer").removeClass("is-active");
    $(".window-overlay").remove();
  });

  $("#countdown")
    .countdown($("#countdown").data("endDate"), function (event) {
      $("#countdown").css("display", "none");
      $("body").removeClass("hasCountdown");
      endDate = new Date($("#countdown").data("endDate"));
      endTS = endDate.getTime();
      startDate = new Date($("#countdown").data("startDate"));
      startTS = startDate.getTime();
      $(this).html(
        event.strftime(
          "<span>DAYS<em>%D</em></span>:<span>HRS<em>%H</em></span>:<span>MINS<em>%M</em></span>:<span>SECS<em>%S</em></span>"
        )
      );
    })
    .on("update.countdown", function (e) {
      $("body").addClass("hasCountdown");
      var currDate = new Date();
      var currTS = currDate.getTime();
      if (currDate > startDate) {
        $("#countdown").css("display", "inline-block");
        $("body").addClass("hasCountdown");
      }
    })
    .on("finish.countdown", function () {
      $("#countdown").css("display", "none");
      $("body").removeClass("hasCountdown");
    });

  $("#love-tab").trigger("click");

  $("body").on(
    "DOMSubtreeModified",
    ".feefo-review-badge-wrapper-product",
    function () {
      $("feefowidget-logo-small").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("#review-tab").trigger("click");
        $("html,body").animate(
          { scrollTop: $("#review-tab").offset().top - 50 },
          "slow"
        );
      });
    }
  );

  /*
  $('body').on('mouseenter', '.template-collection__grid .flexbox__item', function(e) {
      $(this).append('<div class="quick-view-toggle"><a>Quick View</a></div>')
  })
  .on('mouseleave', '.template-collection__grid .flexbox__item', function(e) {
      $('.quick-view-toggle').remove()
  })



  $("body").on('click', '.quick-view-toggle', function(e) {
      var date = new Date()
      var link = $(this).parents('.flexbox__item').find('a').attr('href')+'?type='+date
      window.frames["quick-view"].location = link
      $('.quick-view-overlay').show()
  })
  */

  /** multiple gift wrap options */
  $("body").on("click",".col-choice-box",function (e) {
    e.preventDefault();
    $(this).parents('.col-choice-box-textarea-wrapper').toggleClass('is-active');
    
    $input = $(this).find('input');
    if ($input.prop("checked")) {
      $input.prop("checked", false);
      $(this).removeClass("is-active");
      removeOneFromCart($input.val());
      $('.gift-wrap-item').hide();
    } else {
      $input.prop("checked", true);

      switchThis = false;

      $(".gift-wrapping__selection .col-choice-box")
        .not(this)
        .each(function () {
          if ($(this).hasClass("is-active")) {
            $(this).find('input').prop("checked", false);
            switchThis = $(this).find('input').val();
            $(this).removeClass("is-active");
          }
        });

      $(this).addClass("is-active");
      addOneToCart($input.val(), switchThis);
      $('.gift-wrap-item').show();
    }

    // show notes?
    showNotes = false;
    $(".gift-wrapping__selection .col-choice-box").each(function () {
      if ($(this).hasClass("is-active")) {
        showNotes = true;
      }
    });

    if (showNotes) {
      $(".gift-wrapping__note").addClass("is-active");
    } else {
      $(".gift-wrapping__note").removeClass("is-active");
    }
  });

function doUpdateCartTotal() {
   $.get("/cart.json", function (r) {
    const currencySymbol = $("#currency_symbol").val() || "$";  
    const subtotal = (r.total_price / 100).toFixed(2);
      const finalPrice = r.total_price / 100;

    $('[js-cart="subtotal"]').text(currencySymbol + subtotal);
    $('[js-cart="final-price"]').text(currencySymbol + finalPrice.toFixed(2));

    const $cartCount = $('.site-header__cart-count');
    $cartCount.text(r.item_count);
   });
window.updateJellycatShippingAttribute();
  } 

  function addOneToCart(id, switchThis) {
    $.ajax({
      method: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        id: id,
        quantity: 1,
      },
      success: function (t) {
        if (switchThis) {
          removeOneFromCart(switchThis);
        } else {
          doUpdateCartTotal();
        }    
        window.updateJellycatShippingAttribute();
      },
      error: function (t) {
        doUpdateCartTotal();
      },
    });
  }

  function removeOneFromCart(id) {
    $.post("/cart/update.js", "updates[" + id + "]=0", function (t) {
      doUpdateCartTotal();
    });
  }

  $('body').on("click",'[js-quantity-selector="increment-bundle"]',function () {
    var me = $(this);
    updates = {};
    qty = $(this).parents(".product-table__col").find(".qty-selector__input");
    qty.val(parseInt(qty.val()) + 1);
    variant_ids = $(this).data("variantIds").split(",");
    $.each(variant_ids, function (k, v) {
      updates[v] = parseInt(qty.val());
    });
    $.post(
      "/cart/update.js",
      {
        updates: updates,
      },
      function (r) {
        doUpdateCartTotal();
        updateBundleLine(parseInt(qty.val()), me);
      }
    );
  });

    $('body').on("click",'[js-quantity-selector="decrement-bundle"]',function () {
    var me = $(this);
    updates = {};
    qty = $(this).parents(".product-table__col").find(".qty-selector__input");
    if (parseInt(qty.val()) > 1) {
      qty.val(parseInt(qty.val()) - 1);
      console.log(qty);
      variant_ids = $(this).data("variantIds").split(",");
      $.each(variant_ids, function (k, v) {
        updates[v] = parseInt(qty.val());
      });
      $.post(
        "/cart/update.js",
        {
          updates: updates,
        },
        function (r) {
          doUpdateCartTotal();
          updateBundleLine(parseInt(qty.val()), me);
        }
      );
    }
  });


  
  function updateBundleLine(qty, target) {
    console.log(target);
    target
      .parents(".product-table__row")
      .find('[js-cart="line-item-price"]')
      .html(
        $("#currency_symbol").val() +
          ((parseFloat(target.data("bundlePrice")) * qty) / 100).toFixed(2)
      );
  }

  $("body").on(
    "click",
    '[js-ajax-cart="removeBundleBtn"], .remove-bundle',
    function () {
      variant_ids = $(this).data("variantIds").split(",");
      updates = {};
      $.each(variant_ids, function (k, v) {
        if (v) {
          updates[v] = 0;
        }
      });
      $.post(
        "/cart/update.js",
        {
          updates: updates,
        },
        function (r) {
          window.location.reload(true);
        }
      );
      return false;
    }
  );
});

$.get("/cart.json", function (r) {
  var bundles = {};
  var bundle_product_count = 0;
  var bundle_count = 0;
  $.each(r.items, function (k, v) {
    if (v.properties.bundle_name) {
      bundle_product_count += v.quantity;
      var bundle_name = v.properties.bundle_name;
      if (!bundles[bundle_name]) {
        bundles[bundle_name] = {
          product_count: v.quantity,
          total: v.line_price,
          product_list: v.title + "<br>",
          qty: v.quantity,
          bundle_ids: v.variant_id + ",",
        };
      } else {
        bundles[bundle_name].product_count += v.quantity;
        bundles[bundle_name].total += v.line_price;
        bundles[bundle_name].product_list =
          bundles[bundle_name].product_list + v.title + "<br>";
        bundles[bundle_name].bundle_ids =
          bundles[bundle_name].bundle_ids + v.variant_id + ",";
      }
    }
  });

  $.each(bundles, function (k, v) {
    bundle_count++;
    /*
        var k = k
        var v = v

        var bundleTitle = k.split('#')
        var bundleHandle = bundleTitle['0'].replace(/ /g, '-')

        bundleHandle = bundleHandle.split('---')
        bundleHandle = bundleHandle[0]

      
        $.get('/collections/' + bundleHandle + '.json', function(r) {

           
            var bundle_row = '<div class="ajax-cart__item"><div class="ajax-cart__item-image"><img src="'+r.collection.image.src+'"></div>'
         +'<div class="ajax-cart__item-description">'
         +'<h5 class="ajax-cart__item-title"><a href="/collections/'+bundleHandle+'">'+bundleTitle[0]+'</a></h5>'
         +'<span class="ajax-cart__item-meta">'+v.product_list+'Quantity: '+v.qty+'</span>'
         +'<p class="ajax-cart__item-price">'+$('#currency_symbol').val()+((v.total/100))+'</p>'
         +'</div>'
        +'<a href="#" class="ajax-cart__remove remove-bundle" js-ajax-cart="removeBtn" data-variant-ids="'+v.bundle_ids+'" data-line="1">×</a></div>'
        console.log('appending row')
        $('.ajax-cart__body').append(bundle_row)
       
        })
        */
  });

  if (typeof r != "object") {
    var r = JSON.parse(r);
  }

  var total_with_bundles = r.item_count - bundle_product_count + bundle_count;

  $(".site-header__cart-count").text(total_with_bundles);
});

// $(window).scroll(function (e) {
//   if ($(".is-scrolling-up").length || $(document).scrollTop() == 0) {
//     $(".slimCart").addClass("nudgeDown");
//   } else {
//     $(".slimCart").removeClass("nudgeDown");
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   var dropdownTrigger = document.querySelector(".custom-dropdown__trigger");
//   var dropdownList = document.querySelector(".custom-dropdown__list");

//   dropdownTrigger.addEventListener("click", function () {
//     dropdownList.classList.toggle("open");
//     document.querySelector(".custom-dropdown").classList.toggle("activated");
//   });

  // Optional: Close the dropdown when clicking outside
  // document.addEventListener("click", function (event) {
  //   if (
  //     !dropdownTrigger.contains(event.target) &&
  //     !dropdownList.contains(event.target)
  //   ) {
  //     dropdownList.classList.remove("open");
  //   }
  // });
// });

  $("body").on("click",".custom-dropdown__trigger", function () {
    $(".custom-dropdown__list").toggleClass("open");
    $(".custom-dropdown").toggleClass("activated");
  });


// Color swatches in the product grid
var ProductSwatches = (function () {
  function ProductSwatches(container) {
    if (!(this instanceof ProductSwatches)) {
      throw new TypeError("Cannot call a class as a function");
    }

    this.container = $(container);
    this.swatches = this.container.find('[js-product-swatches="swatches"]');
    this.searchQuery = this.getSearchQuery();

    if (this.searchQuery) {
      this.fetchItemsByHandle();
    }
  }

  return (
    ProductSwatches.prototype = {
      fetchItemsByHandle: function () {
        var self = this;
        var query = encodeURIComponent(self.searchQuery);
        var cacheBuster = new Date().getTime();        
        console.log(query);
        $.ajax({
          url: `/search?type=product&q=title:${query}&view=product-card-swatches&_=${cacheBuster}`,
          dataType: "html",
          success: function (response) {
            if (response.trim()) {              
              self.renderTemplate(response);
            }
          },
          error: function (error) {
            console.error("Swatch fetch error:", error);
          }
        });
      },

      getSearchQuery: function () {
        return this.container.attr("data-search-query") || "";
      },

      renderTemplate: function (html) {
        this.swatches.html(html);
      },
    },
    ProductSwatches
  );
})();

$(document).ready(function () {
  $('.product-discover-section [js-product-swatches="container"]').each(function (index, element) {
    setTimeout(() => {
      new ProductSwatches(element);
    }, index * 100);
  });
});
// Color swatches in the product grid
